(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  // @ts-ignore TODO: fix noImplicitAny error here
var $5b6d63e9acfc1c05$exports = {};
/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $5b6d63e9acfc1c05$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket #14549 for more info.
    $5b6d63e9acfc1c05$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $5b6d63e9acfc1c05$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.6.0", // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var Sizzle = /*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */ function(window1) {
        var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, // Local document vars
        setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, // Instance-specific data
        expando = "sizzle" + 1 * new Date(), preferredDoc = window1.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, // Instance methods
        hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, pushNative = arr.push, push = arr.push, slice = arr.slice, // Use a stripped-down indexOf as it's faster than native
        // https://jsperf.com/thor-indexof-vs-for/5
        indexOf = function(list, elem) {
            var i = 0, len = list.length;
            for(; i < len; i++){
                if (list[i] === elem) return i;
            }
            return -1;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // http://www.w3.org/TR/css3-selectors/#whitespace
        whitespace = "[\\x20\\t\\r\\n\\f]", // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5]
        // or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            "ID": new RegExp("^#(" + identifier + ")"),
            "CLASS": new RegExp("^\\.(" + identifier + ")"),
            "TAG": new RegExp("^(" + identifier + "|[*])"),
            "ATTR": new RegExp("^" + attributes),
            "PSEUDO": new RegExp("^" + pseudos),
            "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            "bool": new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rhtml = /HTML$/i, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            return nonHex ? // Strip the backslash prefix from a non-hex escape sequence
            nonHex : // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // CSS string/identifier serialization
        // https://drafts.csswg.org/cssom/#common-serializing-idioms
        rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, fcssescape = function(ch, asCodePoint) {
            if (asCodePoint) {
                // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                if (ch === "\x00") return "\uFFFD";
                // Control characters and (dependent upon position) numbers get escaped as code points
                return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
            }
            // Other potentially-special ASCII characters get backslash-escaped
            return "\\" + ch;
        }, // Used for iframes
        // See setDocument()
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android<4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: arr.length ? // Leverage slice if possible
                function(target, els) {
                    pushNative.apply(target, slice.call(els));
                } : // Support: IE<9
                // Otherwise append directly
                function(target, els) {
                    var j = target.length, i = 0;
                    // Can't trust NodeList.length
                    while(target[j++] = els[i++]);
                    target.length = j - 1;
                }
            };
        }
        function Sizzle(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE, Opera, Webkit
                                // TODO: identify versions
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        results.push(elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                                results.push(elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && // Support: IE 8 only
                    // Exclude object elements
                    (nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rcombinators.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            if (newContext !== context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = nid.replace(rcssescape, fcssescape);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrim, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */ function addHandle(attrs, handler) {
            var arr = attrs.split("|"), i = arr.length;
            while(i--)Expr.attrHandle[arr[i]] = handler;
        }
        /**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */ function siblingCheck(a, b) {
            var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
            // Use IE sourceIndex if available on both nodes
            if (diff) return diff;
            // Check if b follows a
            if (cur) while(cur = cur.nextSibling){
                if (cur === b) return -1;
            }
            return a ? 1 : -1;
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return name === "input" && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return (name === "input" || name === "button") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        /* jshint -W018 */ elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        // Expose support vars for convenience
        support = Sizzle.support = {};
        /**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */ isXML = Sizzle.isXML = function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Support: IE <=8
            // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
            // https://bugs.jquery.com/ticket/4833
            return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
        };
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ setDocument = Sizzle.setDocument = function(node) {
            var hasCompare, subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            docElem = document.documentElement;
            documentIsHTML = !isXML(document);
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                // Support: IE 11, Edge
                if (subWindow.addEventListener) subWindow.addEventListener("unload", unloadHandler, false);
                else if (subWindow.attachEvent) subWindow.attachEvent("onunload", unloadHandler);
            }
            // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
            // Safari 4 - 5 only, Opera <=11.6 - 12.x only
            // IE/Edge & older browsers don't support the :scope pseudo-class.
            // Support: Safari 6.0 only
            // Safari 6.0 supports :scope but it's an alias of :root there.
            support.scope = assert(function(el) {
                docElem.appendChild(el).appendChild(document.createElement("div"));
                return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
            });
            /* Attributes
	---------------------------------------------------------------------- */ // Support: IE<8
            // Verify that getAttribute really returns attributes and not properties
            // (excepting IE8 booleans)
            support.attributes = assert(function(el) {
                el.className = "i";
                return !el.getAttribute("className");
            });
            /* getElement(s)By*
	---------------------------------------------------------------------- */ // Check if getElementsByTagName("*") returns only elements
            support.getElementsByTagName = assert(function(el) {
                el.appendChild(document.createComment(""));
                return !el.getElementsByTagName("*").length;
            });
            // Support: IE<9
            support.getElementsByClassName = rnative.test(document.getElementsByClassName);
            // Support: IE<10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                docElem.appendChild(el).id = expando;
                return !document.getElementsByName || !document.getElementsByName(expando).length;
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else if (support.qsa) return context.querySelectorAll(tag);
            } : function(tag, context) {
                var elem, tmp = [], i = 0, // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                results = context.getElementsByTagName(tag);
                // Filter out possible comments
                if (tag === "*") {
                    while(elem = results[i++])if (elem.nodeType === 1) tmp.push(elem);
                    return tmp;
                }
                return results;
            };
            // Class
            Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
            rbuggyMatches = [];
            // qSa(:focus) reports false when true (Chrome 21)
            // We allow this because of a bug in IE8/9 that throws an error
            // whenever `document.activeElement` is accessed on an iframe
            // So, we allow :focus to pass through QSA all the time to avoid the IE error
            // See https://bugs.jquery.com/ticket/13378
            rbuggyQSA = [];
            if (support.qsa = rnative.test(document.querySelectorAll)) {
                // Build QSA regex
                // Regex strategy adopted from Diego Perini
                assert(function(el) {
                    var input;
                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                    // Support: IE 11+, Edge 15 - 18+
                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                    // Adding a temporary attribute to the document before the selection works
                    // around the issue.
                    // Interestingly, IE 10 & older don't seem to have the issue.
                    input = document.createElement("input");
                    input.setAttribute("name", "");
                    el.appendChild(input);
                    if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                    // Support: Firefox <=3.6 - 5 only
                    // Old Firefox doesn't throw on a badly-escaped identifier.
                    el.querySelectorAll("\\\f");
                    rbuggyQSA.push("[\\r\\n\\f]");
                });
                assert(function(el) {
                    el.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");
                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: Opera 10 - 11 only
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                });
            }
            if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) assert(function(el) {
                // Check to see if it's possible to do matchesSelector
                // on a disconnected node (IE 9)
                support.disconnectedMatch = matches.call(el, "*");
                // This should fail with an exception
                // Gecko does not error, returns false instead
                matches.call(el, "[s!='']:x");
                rbuggyMatches.push("!=", pseudos);
            });
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
            /* Contains
	---------------------------------------------------------------------- */ hasCompare = rnative.test(docElem.compareDocumentPosition);
            // Element contains another
            // Purposefully self-exclusive
            // As in, an element does not contain itself
            contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
                var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
                return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
            } : function(a, b) {
                if (b) while(b = b.parentNode){
                    if (b === a) return true;
                }
                return false;
            };
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = hasCompare ? function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            } : function(a, b) {
                // Exit early if the nodes are identical
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [
                    a
                ], bp = [
                    b
                ];
                // Parentless nodes are either documents or disconnected
                if (!aup || !bup) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ return a == document ? -1 : b == document ? 1 : /* eslint-enable eqeqeq */ aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                else if (aup === bup) return siblingCheck(a, b);
                // Otherwise we need full lists of their ancestors for comparison
                cur = a;
                while(cur = cur.parentNode)ap.unshift(cur);
                cur = b;
                while(cur = cur.parentNode)bp.unshift(cur);
                // Walk down the tree looking for a discrepancy
                while(ap[i] === bp[i])i++;
                return i ? // Do a sibling check if the nodes have a common ancestor
                siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 : /* eslint-enable eqeqeq */ 0;
            };
            return document;
        };
        Sizzle.matches = function(expr, elements) {
            return Sizzle(expr, null, null, elements);
        };
        Sizzle.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return Sizzle(expr, document, null, [
                elem
            ]).length > 0;
        };
        Sizzle.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return contains(context, elem);
        };
        Sizzle.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (jQuery #13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        };
        Sizzle.escape = function(sel) {
            return (sel + "").replace(rcssescape, fcssescape);
        };
        Sizzle.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ Sizzle.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            hasDuplicate = !support.detectDuplicates;
            sortInput = !support.sortStable && results.slice(0);
            results.sort(sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)results.splice(duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        /**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */ getText = Sizzle.getText = function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += getText(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                // Use textContent for elements
                // innerText usage removed for consistency of new lines (jQuery #11153)
                if (typeof elem.textContent === "string") return elem.textContent;
                else // Traverse its children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling)ret += getText(elem);
            } else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        };
        Expr = Sizzle.selectors = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                "ATTR": function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                "CHILD": function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) Sizzle.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) Sizzle.error(match[0]);
                    return match;
                },
                "PSEUDO": function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr["CHILD"].test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                "TAG": function(nodeNameSelector) {
                    var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                    };
                },
                "CLASS": function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                "ATTR": function(name, operator, check) {
                    return function(elem) {
                        var result = Sizzle.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        /* eslint-disable max-len */ return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
                    /* eslint-enable max-len */ };
                },
                "CHILD": function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                // ...in a gzip-friendly way
                                node = parent;
                                outerCache = node[expando] || (node[expando] = {});
                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    uniqueCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    // ...in a gzip-friendly way
                                    node = elem;
                                    outerCache = node[expando] || (node[expando] = {});
                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                    cache = uniqueCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                            uniqueCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                "PSEUDO": function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                "not": markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrim, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element (issue #299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                "has": markFunction(function(selector) {
                    return function(elem) {
                        return Sizzle(selector, elem).length > 0;
                    };
                }),
                "contains": markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || getText(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                "lang": markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) Sizzle.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                "target": function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                "root": function(elem) {
                    return elem === docElem;
                },
                "focus": function(elem) {
                    return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                "enabled": createDisabledPseudo(false),
                "disabled": createDisabledPseudo(true),
                "checked": function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
                },
                "selected": function(elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                "empty": function(elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                "parent": function(elem) {
                    return !Expr.pseudos["empty"](elem);
                },
                // Element/input types
                "header": function(elem) {
                    return rheader.test(elem.nodeName);
                },
                "input": function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                "button": function(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === "button" || name === "button";
                },
                "text": function(elem) {
                    var attr;
                    return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && // Support: IE<8
                    // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                "first": createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                "last": createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                "eq": createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                "even": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "odd": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument > length ? length : argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos["nth"] = Expr.pseudos["eq"];
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        tokenize = Sizzle.tokenize = function(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rcombinators.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrim, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        };
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, uniqueCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)
                        uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                        if (skip && skip === elem.nodeName.toLowerCase()) elem = elem[dir] || elem;
                        else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            uniqueCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)Sizzle(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results : matcherIn;
                // Find primary matches
                if (matcher) matcher(matcherIn, matcherOut, context, xml);
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element (issue #299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find["TAG"]("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: IE<9, Safari
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) Sizzle.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        compile = Sizzle.compile = function(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        };
        /**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ select = Sizzle.select = function(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        };
        // One-time assignments
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Support: Chrome 14-35+
        // Always assume duplicates if they aren't passed to the comparison function
        support.detectDuplicates = !!hasDuplicate;
        // Initialize against the default document
        setDocument();
        // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        // Support: IE<8
        // Prevent attribute/property "interpolation"
        // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
        if (!assert(function(el) {
            el.innerHTML = "<a href='#'></a>";
            return el.firstChild.getAttribute("href") === "#";
        })) addHandle("type|href|height|width", function(elem, name, isXML) {
            if (!isXML) return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        });
        // Support: IE<9
        // Use defaultValue in place of getAttribute("value")
        if (!support.attributes || !assert(function(el) {
            el.innerHTML = "<input/>";
            el.firstChild.setAttribute("value", "");
            return el.firstChild.getAttribute("value") === "";
        })) addHandle("value", function(elem, _name, isXML) {
            if (!isXML && elem.nodeName.toLowerCase() === "input") return elem.defaultValue;
        });
        // Support: IE<9
        // Use getAttributeNode to fetch booleans when getAttribute lies
        if (!assert(function(el) {
            return el.getAttribute("disabled") == null;
        })) addHandle(booleans, function(elem, name, isXML) {
            var val;
            if (!isXML) return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        });
        return Sizzle;
    }(window1);
    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;
    // Deprecated
    jQuery.expr[":"] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    jQuery.escapeSelector = Sizzle.escape;
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
    // Strict HTML recognition (#11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to Sizzle
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.stackTrace);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the stack, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getStackHook) process.stackTrace = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    jQuery.Deferred.exceptionHook = function(error, stack) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See #6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (#9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see #8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (#14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (#11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (#14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (#13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (#15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (#12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Support: IE <=9 - 11+
    // focus() and blur() are asynchronous, except when they are no-op.
    // So expect focus to be synchronous when the element is already active,
    // and blur to be synchronous when the element is not already active.
    // (focus and blur are always synchronous in other supported browsers,
    // this just defines when we can count on it).
    function expectSync(elem, type) {
        return elem === safeActiveElement() === (type === "focus");
    }
    // Support: IE <=9 only
    // Accessing document.activeElement can throw unexpectedly
    // https://bugs.jquery.com/ticket/13393
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {}
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (#13208)
                // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (#13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", returnTrue);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, expectSync) {
        // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
        if (!expectSync) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var notAsync, result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    // Saved data should be false in such cases, but might be a leftover capture object
                    // from an async native handler (gh-4350)
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        // Support: IE <=9 - 11+
                        // focus() and blur() are asynchronous
                        notAsync = expectSync(this, type);
                        this[type]();
                        result = dataPriv.get(this, type);
                        if (saved !== result || notAsync) dataPriv.set(this, type, false);
                        else result = {};
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            // Support: Chrome 86+
                            // In Chrome, if an element having a focusout handler is blurred by
                            // clicking outside of it, it invokes the handler synchronously. If
                            // that handler calls `.remove()` on the element, the data is cleared,
                            // leaving `result` undefined. We need to guard against this.
                            return result && result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering the
                    // native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(// Support: IE <=9 - 11+
                        // Extend with the prototype to reset the above stopImmediatePropagation()
                        jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
                    });
                    // Abort handling of the native event
                    event.stopImmediatePropagation();
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (#504, #13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, expectSync);
                // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            // Suppress native focus or blur as it's already being fired
            // in leverageNative.
            _default: function() {
                return true;
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (#8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (#8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is display: block
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, #12537)
        //   .css('--customProperty) (#3144)
        if (computed) {
            ret = computed.getPropertyValue(name) || computed[name];
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, rcustomProp = /^--/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            if (box === "margin") delta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "gridArea": true,
            "gridColumn": true,
            "gridColumnEnd": true,
            "gridColumnStart": true,
            "gridRow": true,
            "gridRowEnd": true,
            "gridRowStart": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (#7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug #9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (#7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                    // Use proper attribute retrieval(#12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classes = classesToArray(value);
            if (classes.length) while(elem = this[i++]){
                curValue = getClass(elem);
                cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    j = 0;
                    while(clazz = classes[j++])if (cur.indexOf(" " + clazz + " ") < 0) cur += clazz + " ";
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) elem.setAttribute("class", finalValue);
                }
            }
            return this;
        },
        removeClass: function(value) {
            var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classes = classesToArray(value);
            if (classes.length) while(elem = this[i++]){
                curValue = getClass(elem);
                // This expression is here for better compressibility (see addClass)
                cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    j = 0;
                    while(clazz = classes[j++])// Remove *all* instances
                    while(cur.indexOf(" " + clazz + " ") > -1)cur = cur.replace(" " + clazz + " ", " ");
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) elem.setAttribute("class", finalValue);
                }
            }
            return this;
        },
        toggleClass: function(value, stateVal) {
            var type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            return this.each(function() {
                var className, i, self, classNames;
                if (isValidValue) {
                    // Toggle individual class names
                    i = 0;
                    self = jQuery(this);
                    classNames = classesToArray(value);
                    while(className = classNames[i++])// Check each className given, space separated list
                    if (self.hasClass(className)) self.removeClass(className);
                    else self.addClass(className);
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (#14686, #14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (#2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    support.focusin = "onfocusin" in window1;
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (#9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (#6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    // Support: Firefox <=44
    // Firefox doesn't have focus(in | out) events
    // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
    //
    // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
    // focus(in | out) events fire after focus & blur events,
    // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
    // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
    if (!support.focusin) jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(orig, fix) {
        // Attach a single capturing handler on the document while someone wants focusin/focusout
        var handler = function(event) {
            jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
        };
        jQuery.event.special[fix] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix);
                if (!attaches) doc.addEventListener(orig, handler, true);
                dataPriv.access(doc, fix, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix) - 1;
                if (!attaches) {
                    doc.removeEventListener(orig, handler, true);
                    dataPriv.remove(doc, fix);
                } else dataPriv.access(doc, fix, attaches);
            }
        };
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // #7653, #8125, #8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes #9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (#10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket #12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // #9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (#11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // #1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see #8605, #14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // #14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (#13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


// FIXME remove this when atlassian-connect-js addresses this.
// atlassian-connect-js has a dependency on AUI and a global jquery, which is a
// dependency of bitbucket-connect-js
// ACJS-807
window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($5b6d63e9acfc1c05$exports)));
var $4159b701ce296ce4$exports = {};
/*!!
 * @atlassian/aui - Atlassian User Interface Framework
 * @version v7.9.9
 * @link https://docs.atlassian.com/aui/latest/
 * @license SEE LICENSE IN LICENSE.md
 * @author Atlassian Pty Ltd.
 */ // src/js/aui/jquery.js
(typeof window === "undefined" ? $parcel$global : window).__700a145ba3db9966cc95664c892049f8 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = window.jQuery || window.Zepto;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/create-element.js
(typeof window === "undefined" ? $parcel$global : window).__bc7785911e746c80e8029c2e254e3b9c = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function createElement() {
        var res = null;
        if (arguments.length && typeof arguments[0] === "string") {
            res = (0, _jquery2.default)(document.createElement(arguments[0]));
            if (arguments.length === 2) res.html(arguments[1]);
        }
        //We can't use the deprecate module or we will introduce a circular dependency
        if (typeof console !== "undefined" && console.warn) console.warn("AJS's create element functionality has been deprecated since 5.9.0.\nNo alternative will be provided.\nUse document.createElement() or jQuery.parseHTML(), or preferably use a templating library.");
        return res;
    }
    exports.default = createElement;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/object-assign/index.js
(typeof window === "undefined" ? $parcel$global : window).__dd206a36bdd8311f4bbdc75033adb612 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    /* eslint-disable no-unused-vars */ var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
        if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(val);
    }
    module.exports = Object.assign || function(target, source) {
        var from;
        var to = toObject(target);
        var symbols;
        for(var s = 1; s < arguments.length; s++){
            from = Object(arguments[s]);
            for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
            if (Object.getOwnPropertySymbols) {
                symbols = Object.getOwnPropertySymbols(from);
                for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
            }
        }
        return to;
    };
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/globalize.js
(typeof window === "undefined" ? $parcel$global : window).__28c84e7bb75f6c3b0ba124d57bd69571 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = globalize;
    var _createElement = __bc7785911e746c80e8029c2e254e3b9c;
    var _createElement2 = _interopRequireDefault(_createElement);
    var _objectAssign = __dd206a36bdd8311f4bbdc75033adb612;
    var _objectAssign2 = _interopRequireDefault(_objectAssign);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function auiNamespace() {
        return _createElement2.default.apply(undefined, arguments);
    }
    var NAMESPACE = "AJS";
    function globalize(name, value1) {
        if (window[NAMESPACE] !== auiNamespace) window[NAMESPACE] = (0, _objectAssign2.default)(auiNamespace, window[NAMESPACE]);
        return window[NAMESPACE][name] = value1;
    }
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/deprecation.js
(typeof window === "undefined" ? $parcel$global : window).__921ad9514d56376fef992861d9ec0f51 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getMessageLogger = exports.propertyDeprecationSupported = exports.obj = exports.prop = exports.css = exports.construct = exports.fn = undefined;
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var has = Object.prototype.hasOwnProperty;
    var deprecationCalls = [];
    var deprecatedSelectorMap = [];
    function toSentenceCase(str) {
        str += "";
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.substring(1);
    }
    function getDeprecatedLocation(printFrameOffset) {
        var err = new Error();
        var stack = err.stack || err.stacktrace;
        var stackMessage = stack && stack.replace(/^Error\n/, "") || "";
        if (stackMessage) {
            stackMessage = stackMessage.split("\n");
            return stackMessage[printFrameOffset + 2];
        }
        return stackMessage;
    }
    function logger() {
        if (typeof console !== "undefined" && console.warn) Function.prototype.apply.call(console.warn, console, arguments);
    }
    /**
   * Return a function that logs a deprecation warning to the console the first time it is called from a certain location.
   * It will also print the stack frame of the calling function.
   *
   * @param {string} displayName the name of the thing being deprecated
   * @param {object} options
   * @param {string} options.removeInVersion the version this will be removed in
   * @param {string} options.alternativeName the name of an alternative to use
   * @param {string} options.sinceVersion the version this has been deprecated since
   * @param {string} options.extraInfo extra information to be printed at the end of the deprecation log
   * @param {string} options.extraObject an extra object that will be printed at the end
   * @param {string} options.deprecationType type of the deprecation to append to the start of the deprecation message. e.g. JS or CSS
   * @return {Function} that logs the warning and stack frame of the calling function. Takes in an optional parameter for the offset of
   * the stack frame to print, the default is 0. For example, 0 will log it for the line of the calling function,
   * -1 will print the location the logger was called from
   */ function getShowDeprecationMessage(displayName, options) {
        // This can be used internally to pas in a showmessage fn
        if (typeof displayName === "function") return displayName;
        var called = false;
        options = options || {};
        return function(printFrameOffset) {
            var deprecatedLocation = getDeprecatedLocation(printFrameOffset ? printFrameOffset : 1) || "";
            // Only log once if the stack frame doesn't exist to avoid spamming the console/test output
            if (!called || deprecationCalls.indexOf(deprecatedLocation) === -1) {
                deprecationCalls.push(deprecatedLocation);
                called = true;
                var deprecationType = options.deprecationType + " ";
                var message = "DEPRECATED " + deprecationType + "- " + toSentenceCase(displayName) + " has been deprecated" + (options.sinceVersion ? " since " + options.sinceVersion : "") + " and will be removed in " + (options.removeInVersion || "a future release") + ".";
                if (options.alternativeName) message += " Use " + options.alternativeName + " instead. ";
                if (options.extraInfo) message += " " + options.extraInfo;
                if (deprecatedLocation === "") deprecatedLocation = " \n No stack trace of the deprecated usage is available in your current browser.";
                else deprecatedLocation = " \n " + deprecatedLocation;
                if (options.extraObject) {
                    message += "\n";
                    logger(message, options.extraObject, deprecatedLocation);
                } else logger(message, deprecatedLocation);
            }
        };
    }
    function logCssDeprecation(selectorMap, newNode) {
        var displayName = selectorMap.options.displayName;
        displayName = displayName ? " (" + displayName + ")" : "";
        var options = _jquery2.default.extend({
            deprecationType: "CSS",
            extraObject: newNode
        }, selectorMap.options);
        getShowDeprecationMessage("'" + selectorMap.selector + "' pattern" + displayName, options)();
    }
    /**
  * Returns a wrapped version of the function that logs a deprecation warning when the function is used.
  * @param {Function} fn the fn to wrap
  * @param {string} displayName the name of the fn to be displayed in the message
  * @param {string} options.removeInVersion the version this will be removed in
  * @param {string} options.alternativeName the name of an alternative to use
  * @param {string} options.sinceVersion the version this has been deprecated since
  * @param {string} options.extraInfo extra information to be printed at the end of the deprecation log
  * @return {Function} wrapping the original function
  */ function deprecateFunctionExpression(fn, displayName, options) {
        options = options || {};
        options.deprecationType = options.deprecationType || "JS";
        var showDeprecationMessage = getShowDeprecationMessage(displayName || fn.name || "this function", options);
        return function() {
            showDeprecationMessage();
            return fn.apply(this, arguments);
        };
    }
    /**
  * Returns a wrapped version of the constructor that logs a deprecation warning when the constructor is instantiated.
  * @param {Function} constructorFn the constructor function to wrap
  * @param {string} displayName the name of the fn to be displayed in the message
  * @param {string} options.removeInVersion the version this will be removed in
  * @param {string} options.alternativeName the name of an alternative to use
  * @param {string} options.sinceVersion the version this has been deprecated since
  * @param {string} options.extraInfo extra information to be printed at the end of the deprecation log
  * @return {Function} wrapping the original function
  */ function deprecateConstructor(constructorFn, displayName, options) {
        options = options || {};
        options.deprecationType = options.deprecationType || "JS";
        var deprecatedConstructor = deprecateFunctionExpression(constructorFn, displayName, options);
        deprecatedConstructor.prototype = constructorFn.prototype;
        _jquery2.default.extend(deprecatedConstructor, constructorFn); //copy static methods across;
        return deprecatedConstructor;
    }
    var supportsProperties = false;
    try {
        if (Object.defineProperty) {
            Object.defineProperty({}, "blam", {
                get: function get() {},
                set: function set() {}
            });
            exports.propertyDeprecationSupported = supportsProperties = true;
        }
    } catch (e) {}
    /* IE8 doesn't support on non-DOM elements */ /**
  * Wraps a "value" object property in a deprecation warning in browsers supporting Object.defineProperty
  * @param {Object} obj the object containing the property
  * @param {string} prop the name of the property to deprecate
  * @param {string} options.removeInVersion the version this will be removed in
  * @param {string} options.displayName the display name of the property to deprecate (optional, will fall back to the property name)
  * @param {string} options.alternativeName the name of an alternative to use
  * @param {string} options.sinceVersion the version this has been deprecated since
  * @param {string} options.extraInfo extra information to be printed at the end of the deprecation log
  */ function deprecateValueProperty(obj, prop, options) {
        if (supportsProperties) {
            var oldVal = obj[prop];
            options = options || {};
            options.deprecationType = options.deprecationType || "JS";
            var displayNameOrShowMessageFn = options.displayName || prop;
            var showDeprecationMessage = getShowDeprecationMessage(displayNameOrShowMessageFn, options);
            Object.defineProperty(obj, prop, {
                get: function get() {
                    showDeprecationMessage();
                    return oldVal;
                },
                set: function set(val) {
                    oldVal = val;
                    showDeprecationMessage();
                    return val;
                }
            });
        }
    }
    /**
  * Wraps an object property in a deprecation warning, if possible. functions will always log warnings, but other
  * types of properties will only log in browsers supporting Object.defineProperty
  * @param {Object} obj the object containing the property
  * @param {string} prop the name of the property to deprecate
  * @param {string} options.removeInVersion the version this will be removed in
  * @param {string} options.displayName the display name of the property to deprecate (optional, will fall back to the property name)
  * @param {string} options.alternativeName the name of an alternative to use
  * @param {string} options.sinceVersion the version this has been deprecated since
  * @param {string} options.extraInfo extra information to be printed at the end of the deprecation log
  */ function deprecateObjectProperty(obj, prop, options) {
        if (typeof obj[prop] === "function") {
            options = options || {};
            options.deprecationType = options.deprecationType || "JS";
            var displayNameOrShowMessageFn = options.displayName || prop;
            obj[prop] = deprecateFunctionExpression(obj[prop], displayNameOrShowMessageFn, options);
        } else deprecateValueProperty(obj, prop, options);
    }
    /**
  * Wraps all an objects properties in a deprecation warning, if possible. functions will always log warnings, but other
  * types of properties will only log in browsers supporting Object.defineProperty
  * @param {Object} obj the object to be wrapped
  * @param {string} objDisplayPrefix the object's prefix to be used in logs
  * @param {string} options.removeInVersion the version this will be removed in
  * @param {string} options.alternativeNamePrefix the name of another object to prefix the deprecated objects properties with
  * @param {string} options.sinceVersion the version this has been deprecated since
  * @param {string} options.extraInfo extra information to be printed at the end of the deprecation log
  */ function deprecateAllProperties(obj, objDisplayPrefix, options) {
        options = options || {};
        for(var attr in obj)if (has.call(obj, attr)) {
            options.deprecationType = options.deprecationType || "JS";
            options.displayName = objDisplayPrefix + attr;
            options.alternativeName = options.alternativeNamePrefix && options.alternativeNamePrefix + attr;
            deprecateObjectProperty(obj, attr, _jquery2.default.extend({}, options));
        }
    }
    function matchesSelector(el, selector) {
        return (el.matches || el.msMatchesSelector || el.webkitMatchesSelector || el.mozMatchesSelector || el.oMatchesSelector).call(el, selector);
    }
    function handleAddingSelector(options) {
        return function(selector) {
            var selectorMap = {
                selector: selector,
                options: options || {}
            };
            deprecatedSelectorMap.push(selectorMap);
            // Search if matches have already been added
            var matches = document.querySelectorAll(selector);
            for(var i = 0; i < matches.length; i++)logCssDeprecation(selectorMap, matches[i]);
        };
    }
    /**
  * Return a function that logs a deprecation warning to the console the first time it is called from a certain location.
  * It will also print the stack frame of the calling function.
  *
  * @param {string|Array} selectors a selector or list of selectors that match deprecated markup
  * @param {object} options
  * @param {string} options.displayName a name describing these selectors
  * @param {string} options.alternativeName the name of an alternative to use
  * @param {string} options.removeInVersion the version these will be removed in
  * @param {string} options.sinceVersion the version these have been deprecated since
  * @param {string} options.extraInfo extra information to be printed at the end of the deprecation log
  */ function deprecateCSS(selectors, options) {
        if (!window.MutationObserver) {
            logger("CSS could not be deprecated as Mutation Observer was not found.");
            return;
        }
        if (typeof selectors === "string") selectors = [
            selectors
        ];
        selectors.forEach(handleAddingSelector(options));
    }
    function testAndHandleDeprecation(newNode) {
        return function(selectorMap) {
            if (matchesSelector(newNode, selectorMap.selector)) logCssDeprecation(selectorMap, newNode);
        };
    }
    if (window.MutationObserver) {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                // TODO - should this also look at class changes, if possible?
                var addedNodes = mutation.addedNodes;
                for(var i = 0; i < addedNodes.length; i++){
                    var newNode = addedNodes[i];
                    if (newNode.nodeType === 1) deprecatedSelectorMap.forEach(testAndHandleDeprecation(newNode));
                }
            });
        });
        var config = {
            childList: true,
            subtree: true
        };
        observer.observe(document, config);
    }
    var deprecate = {
        fn: deprecateFunctionExpression,
        construct: deprecateConstructor,
        css: deprecateCSS,
        prop: deprecateObjectProperty,
        obj: deprecateAllProperties,
        propertyDeprecationSupported: supportsProperties,
        getMessageLogger: getShowDeprecationMessage
    };
    (0, _globalize2.default)("deprecate", deprecate);
    exports.fn = deprecateFunctionExpression;
    exports.construct = deprecateConstructor;
    exports.css = deprecateCSS;
    exports.prop = deprecateObjectProperty;
    exports.obj = deprecateAllProperties;
    exports.propertyDeprecationSupported = supportsProperties;
    exports.getMessageLogger = getShowDeprecationMessage;
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/amdify.js
(typeof window === "undefined" ? $parcel$global : window).__65ca28a9d6b0f244027266ff8e6a6d1c = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = function(name, fn) {
        if (window.define) {
            var alias = window.define;
            alias(name, [], function() {
                return fn;
            });
        }
        return fn;
    };
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/log.js
(typeof window === "undefined" ? $parcel$global : window).__c1e961001275c079e48525ad3a48c8c2 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.error = exports.warn = exports.log = undefined;
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function polyfillConsole(prop) {
        return function() {
            if (typeof console !== "undefined" && console[prop]) Function.prototype.apply.call(console[prop], console, arguments);
        };
    }
    var log = polyfillConsole("log");
    var warn = polyfillConsole("warn");
    var error = polyfillConsole("error");
    (0, _globalize2.default)("error", error);
    (0, _globalize2.default)("log", log);
    (0, _globalize2.default)("warn", warn);
    exports.log = log;
    exports.warn = warn;
    exports.error = error;
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/browser.js
(typeof window === "undefined" ? $parcel$global : window).__7a2976c482edfafd9b5879a49ffe0535 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.needsLayeringShim = needsLayeringShim;
    exports.supportsCalc = supportsCalc;
    exports.supportsRequestAnimationFrame = supportsRequestAnimationFrame;
    exports.supportsCssTransition = supportsCssTransition;
    exports.supportsVoiceOver = supportsVoiceOver;
    exports.supportsDateField = supportsDateField;
    exports.supportsNewMouseEvent = supportsNewMouseEvent;
    var ua = navigator.userAgent.toLowerCase();
    var isIE = /msie/.test(ua);
    var isWinXP = /windows nt 5.1/.test(ua);
    var isWinVista = /windows nt 6.0/.test(ua);
    var isWin7 = /windows nt 6.1/.test(ua);
    var isMacOSX = /mac os x/.test(ua);
    var doesSupportCalc;
    var doesSupportCssTransition;
    var doesSupportHtml5DateInput;
    /**
   * Layered elements can get obscured by <object>, <embed>, <select> or sometimes even <iframe>
   * on older versions of Windows + Internet Explorer.
   * From manual testing, all IE versions on Windows 7 appear to have the bug,
   * but no IE versions on Windows 8 have it.
   */ function needsLayeringShim() {
        return isIE && (isWinXP || isWinVista || isWin7);
    }
    function supportsCalc() {
        if (typeof doesSupportCalc === "undefined") {
            var d = document.createElement("div");
            d.style.cssText = "height: -webkit-calc(20px + 0); height: calc(20px);";
            // browsers will cull the rules they don't understand, so we can check whether
            // any were added at all to confirm presence of the calc() behaviour.
            doesSupportCalc = d.style.cssText.length > 0;
        }
        return doesSupportCalc;
    }
    function supportsRequestAnimationFrame() {
        return !!window.requestAnimationFrame;
    }
    function supportsCssTransition() {
        if (typeof doesSupportCssTransition === "undefined") {
            var documentBody = document.body || document.documentElement;
            var style = documentBody.style;
            doesSupportCssTransition = typeof style.transition === "string" || typeof style.WebkitTransition === "string";
        }
        return doesSupportCssTransition;
    }
    function supportsVoiceOver() {
        return isMacOSX;
    }
    function supportsDateField() {
        if (typeof doesSupportHtml5DateInput === "undefined") {
            var el = document.createElement("input");
            el.setAttribute("type", "date");
            doesSupportHtml5DateInput = el.type === "date";
        }
        return doesSupportHtml5DateInput;
    }
    // This is supported everywhere except Chrome 22, but we needed to support this use case due to
    // https://bitbucket.org/atlassian/aui/pull-requests/1920/aui-4380-fix-shortcut-not-work-in-old/diff .
    function supportsNewMouseEvent() {
        try {
            new MouseEvent("click");
        } catch (e) {
            return false;
        }
        return true;
    }
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/key-code.js
(typeof window === "undefined" ? $parcel$global : window).__e246bf93af36eb4453f35afeb1c302d9 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var keyCode = {
        ALT: 18,
        BACKSPACE: 8,
        CAPS_LOCK: 20,
        COMMA: 188,
        COMMAND: 91,
        // cmd
        COMMAND_LEFT: 91,
        COMMAND_RIGHT: 93,
        LEFT_SQUARE_BRACKET: 91,
        CONTROL: 17,
        DELETE: 46,
        DOWN: 40,
        END: 35,
        ENTER: 13,
        ESCAPE: 27,
        HOME: 36,
        INSERT: 45,
        LEFT: 37,
        // right cmd
        MENU: 93,
        NUMPAD_ADD: 107,
        NUMPAD_DECIMAL: 110,
        NUMPAD_DIVIDE: 111,
        NUMPAD_ENTER: 108,
        NUMPAD_MULTIPLY: 106,
        NUMPAD_SUBTRACT: 109,
        PAGE_DOWN: 34,
        PAGE_UP: 33,
        PERIOD: 190,
        RIGHT: 39,
        SHIFT: 16,
        SPACE: 32,
        TAB: 9,
        UP: 38,
        // cmd
        WINDOWS: 91
    };
    (0, _globalize2.default)("keyCode", keyCode);
    exports.default = keyCode;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/css.escape/css.escape.js
(typeof window === "undefined" ? $parcel$global : window).__fc40a64c1c6f1a1eb4dbe5afd5a88a17 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__fc40a64c1c6f1a1eb4dbe5afd5a88a17");
    define.amd = true; /*! https://mths.be/cssescape v1.5.0 by @mathias | MIT license */ 
    (function(root, factory) {
        // https://github.com/umdjs/umd/blob/master/returnExports.js
        if (typeof exports == "object") // For Node.js.
        module.exports = factory(root);
        else if (typeof define == "function" && define.amd) // For AMD. Register as an anonymous module.
        define([], factory.bind(root, root));
        else // For browser globals (not exposing the function separately).
        factory(root);
    })(typeof $parcel$global != "undefined" ? $parcel$global : this, function(root) {
        if (root.CSS && root.CSS.escape) return root.CSS.escape;
        // https://drafts.csswg.org/cssom/#serialize-an-identifier
        var cssEscape = function(value1) {
            var string = String(value1);
            var length = string.length;
            var index = -1;
            var codeUnit;
            var result = "";
            var firstCodeUnit = string.charCodeAt(0);
            while(++index < length){
                codeUnit = string.charCodeAt(index);
                // Note: there’s no need to special-case astral symbols, surrogate
                // pairs, or lone surrogates.
                // If the character is NULL (U+0000), then the REPLACEMENT CHARACTER
                // (U+FFFD).
                if (codeUnit == 0x0000) {
                    result += "\uFFFD";
                    continue;
                }
                if (// If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
                // U+007F, […]
                codeUnit >= 0x0001 && codeUnit <= 0x001F || codeUnit == 0x007F || // If the character is the first character and is in the range [0-9]
                // (U+0030 to U+0039), […]
                index == 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039 || // If the character is the second character and is in the range [0-9]
                // (U+0030 to U+0039) and the first character is a `-` (U+002D), […]
                index == 1 && codeUnit >= 0x0030 && codeUnit <= 0x0039 && firstCodeUnit == 0x002D) {
                    // https://drafts.csswg.org/cssom/#escape-a-character-as-code-point
                    result += "\\" + codeUnit.toString(16) + " ";
                    continue;
                }
                if (// If the character is the first character and is a `-` (U+002D), and
                // there is no second character, […]
                index == 0 && length == 1 && codeUnit == 0x002D) {
                    result += "\\" + string.charAt(index);
                    continue;
                }
                // If the character is not handled by one of the above rules and is
                // greater than or equal to U+0080, is `-` (U+002D) or `_` (U+005F), or
                // is in one of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to
                // U+005A), or [a-z] (U+0061 to U+007A), […]
                if (codeUnit >= 0x0080 || codeUnit == 0x002D || codeUnit == 0x005F || codeUnit >= 0x0030 && codeUnit <= 0x0039 || codeUnit >= 0x0041 && codeUnit <= 0x005A || codeUnit >= 0x0061 && codeUnit <= 0x007A) {
                    // the character itself
                    result += string.charAt(index);
                    continue;
                }
                // Otherwise, the escaped character.
                // https://drafts.csswg.org/cssom/#escape-a-character
                result += "\\" + string.charAt(index);
            }
            return result;
        };
        if (!root.CSS) root.CSS = {};
        root.CSS.escape = cssEscape;
        return cssEscape;
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/inline-dialog.js
(typeof window === "undefined" ? $parcel$global : window).__b25d88f7d8f364347fd8fafd71054d2b = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    /* eslint quotmark:off, eqeqeq:off, strict:off, complexity:off */ Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _browser = __7a2976c482edfafd9b5879a49ffe0535;
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var deprecate = _interopRequireWildcard(_deprecation);
    var _log = __c1e961001275c079e48525ad3a48c8c2;
    var logger = _interopRequireWildcard(_log);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _keyCode = __e246bf93af36eb4453f35afeb1c302d9;
    var _keyCode2 = _interopRequireDefault(_keyCode);
    var _css = __fc40a64c1c6f1a1eb4dbe5afd5a88a17;
    var _css2 = _interopRequireDefault(_css);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Creates a new inline dialog.
   *
   * @param items jQuery object - the items that trigger the display of this popup when the user mouses over.
   * @param identifier A unique identifier for this popup. This should be unique across all popups on the page and a valid CSS class.
   * @param url The URL to retrieve popup contents.
   * @param options Custom options to change default behaviour. See InlineDialog.opts for default values and valid options.
   */ function InlineDialog(items, identifier, url, options) {
        options = options || [];
        if (options.hasOwnProperty("onTop")) {
            onTopDeprecationLogger();
            if (options.onTop && options.gravity === undefined) options.gravity = "s";
        }
        // attempt to generate a random identifier if it doesn't exist
        if (typeof identifier === "undefined") {
            identifier = String(Math.random()).replace(".", "");
            // if the generated supplied identifier already exists when combined with the prefixes we'll be using, then bail
            if ((0, _jquery2.default)("#inline-dialog-" + identifier + ", #arrow-" + identifier + ", #inline-dialog-shim-" + identifier).length) throw "GENERATED_IDENTIFIER_NOT_UNIQUE";
        }
        var escapedIdentifier = (0, _css2.default)(identifier);
        var opts = _jquery2.default.extend(false, InlineDialog.opts, options);
        if (opts.gravity === "w") {
            // TODO Once support for gravity: 'e' is added, it should also
            //      transpose the defaults for offsetX and offsetY.
            opts.offsetX = options.offsetX === undefined ? 10 : options.offsetX;
            opts.offsetY = options.offsetY === undefined ? 0 : options.offsetY;
        }
        var hash;
        var hideDelayTimer;
        var showTimer;
        var beingShown = false;
        var shouldShow = false;
        var contentLoaded = false;
        var mousePosition;
        var targetPosition;
        var popup = (0, _jquery2.default)('<div id="inline-dialog-' + identifier + '" class="aui-inline-dialog"><div class="aui-inline-dialog-contents contents"></div><div id="arrow-' + identifier + '" class="aui-inline-dialog-arrow arrow aui-css-arrow"></div></div>');
        var arrow = (0, _jquery2.default)("#arrow-" + escapedIdentifier, popup);
        var contents = popup.find(".contents");
        if (!opts.displayShadow) contents.addClass("aui-inline-dialog-no-shadow");
        if (opts.autoWidth) contents.addClass("aui-inline-dialog-auto-width");
        else contents.width(opts.width);
        contents.on({
            mouseenter: function mouseenter() {
                clearTimeout(hideDelayTimer);
                popup.unbind("mouseenter");
            },
            mouseleave: function mouseleave() {
                hidePopup();
            }
        });
        var getHash = function getHash() {
            if (!hash) hash = {
                popup: popup,
                hide: function hide() {
                    hidePopup(0);
                },
                id: identifier,
                show: function show() {
                    showPopup();
                },
                persistent: opts.persistent ? true : false,
                reset: function reset() {
                    function drawPopup(popup, positions) {
                        //Position the popup using the left and right parameters
                        popup.css(positions.popupCss);
                        arrow.removeClass("aui-bottom-arrow aui-left-arrow aui-right-arrow");
                        if (positions.gravity === "s" && !arrow.hasClass("aui-bottom-arrow")) arrow.addClass("aui-bottom-arrow");
                        else if (positions.gravity === "w") arrow.addClass("aui-left-arrow");
                        else if (positions.gravity === "e") arrow.addClass("aui-right-arrow");
                        // Default styles are for 'n' gravity.
                        arrow.css(positions.arrowCss);
                    }
                    //DRAW POPUP
                    var viewportHeight = (0, _jquery2.default)(window).height();
                    var popupMaxHeight = Math.round(viewportHeight * 0.75);
                    popup.children(".aui-inline-dialog-contents").css("max-height", popupMaxHeight);
                    var positions = opts.calculatePositions(popup, targetPosition, mousePosition, opts);
                    if (positions.hasOwnProperty("displayAbove")) {
                        displayAboveDeprecationLogger();
                        positions.gravity = positions.displayAbove ? "s" : "n";
                    }
                    drawPopup(popup, positions);
                    // reset position of popup box
                    popup.fadeIn(opts.fadeTime, function() {
                    // once the animation is complete, set the tracker variables
                    // beingShown = false; // is this necessary? Maybe only the shouldShow will have to be reset?
                    });
                    if ((0, _browser.needsLayeringShim)()) {
                        // iframeShim, prepend if it doesnt exist
                        var jQueryCache = (0, _jquery2.default)("#inline-dialog-shim-" + escapedIdentifier);
                        if (!jQueryCache.length) (0, _jquery2.default)(popup).prepend((0, _jquery2.default)('<iframe class = "inline-dialog-shim" id="inline-dialog-shim-' + identifier + '" frameBorder="0" src="javascript:false;"></iframe>'));
                        // adjust height and width of shim according to the popup
                        jQueryCache.css({
                            width: contents.outerWidth(),
                            height: contents.outerHeight()
                        });
                    }
                }
            };
            return hash;
        };
        var showPopup = function showPopup() {
            if (popup.is(":visible")) return;
            showTimer = setTimeout(function() {
                if (!contentLoaded || !shouldShow) return;
                opts.addActiveClass && (0, _jquery2.default)(items).addClass("active");
                beingShown = true;
                if (!opts.persistent) bindHideEvents();
                InlineDialog.current = getHash();
                (0, _jquery2.default)(document).trigger("showLayer", [
                    "inlineDialog",
                    getHash()
                ]);
                // retrieve the position of the click target. The offsets might be different for different types of targets and therefore
                // either have to be customisable or we will have to be smarter about calculating the padding and elements around it
                getHash().reset();
            }, opts.showDelay);
        };
        var hidePopup = function hidePopup(delay) {
            // do not auto hide the popup if persistent is set as true
            if (typeof delay === "undefined" && opts.persistent) return;
            if (typeof popup.get(0)._datePickerPopup !== "undefined") // AUI-2696 - This inline dialog is host to a date picker... so we shouldn't close it.
            return;
            shouldShow = false;
            // only exectute the below if the popup is currently being shown
            // and the arbitrator callback gives us the green light
            if (beingShown && opts.preHideCallback.call(popup[0].popup)) {
                delay = delay == null ? opts.hideDelay : delay;
                clearTimeout(hideDelayTimer);
                clearTimeout(showTimer);
                // store the timer so that it can be cleared in the mouseenter if required
                //disable auto-hide if user passes null for hideDelay
                if (delay != null) hideDelayTimer = setTimeout(function() {
                    unbindHideEvents();
                    opts.addActiveClass && (0, _jquery2.default)(items).removeClass("active");
                    popup.fadeOut(opts.fadeTime, function() {
                        opts.hideCallback.call(popup[0].popup);
                    });
                    beingShown = false;
                    shouldShow = false;
                    (0, _jquery2.default)(document).trigger("hideLayer", [
                        "inlineDialog",
                        getHash()
                    ]);
                    InlineDialog.current = null;
                    if (!opts.cacheContent) {
                        //if not caching the content, then reset the
                        //flags to false so as to reload the content
                        //on next mouse hover.
                        contentLoaded = false;
                        contentLoading = false;
                    }
                }, delay);
            }
        };
        // the trigger is the jquery element that is triggering the popup (i.e., the element that the mousemove event is bound to)
        var initPopup = function initPopup(e, trigger) {
            var $trigger = (0, _jquery2.default)(trigger);
            opts.upfrontCallback.call({
                popup: popup,
                hide: function hide() {
                    hidePopup(0);
                },
                id: identifier,
                show: function show() {
                    showPopup();
                }
            });
            popup.each(function() {
                if (typeof this.popup !== "undefined") this.popup.hide();
            });
            //Close all other popups if neccessary
            if (opts.closeOthers) (0, _jquery2.default)(".aui-inline-dialog").each(function() {
                !this.popup.persistent && this.popup.hide();
            });
            //handle programmatic showing where there is no event
            targetPosition = {
                target: $trigger
            };
            if (!e) mousePosition = {
                x: $trigger.offset().left,
                y: $trigger.offset().top
            };
            else mousePosition = {
                x: e.pageX,
                y: e.pageY
            };
            if (!beingShown) clearTimeout(showTimer);
            shouldShow = true;
            var doShowPopup = function doShowPopup() {
                contentLoading = false;
                contentLoaded = true;
                opts.initCallback.call({
                    popup: popup,
                    hide: function hide() {
                        hidePopup(0);
                    },
                    id: identifier,
                    show: function show() {
                        showPopup();
                    }
                });
                showPopup();
            };
            // lazy load popup contents
            if (!contentLoading) {
                contentLoading = true;
                if (_jquery2.default.isFunction(url)) // If the passed in URL is a function, execute it. Otherwise simply load the content.
                url(contents, trigger, doShowPopup);
                else //Retrive response from server
                _jquery2.default.get(url, function(data1, status, xhr) {
                    //Load HTML contents into the popup
                    contents.html(opts.responseHandler(data1, status, xhr));
                    //Show the popup
                    contentLoaded = true;
                    opts.initCallback.call({
                        popup: popup,
                        hide: function hide() {
                            hidePopup(0);
                        },
                        id: identifier,
                        show: function show() {
                            showPopup();
                        }
                    });
                    showPopup();
                });
            }
            // stops the hide event if we move from the trigger to the popup element
            clearTimeout(hideDelayTimer);
            // don't trigger the animation again if we're being shown
            if (!beingShown) showPopup();
            return false;
        };
        popup[0].popup = getHash();
        var contentLoading = false;
        var added = false;
        var appendPopup = function appendPopup() {
            if (!added) {
                (0, _jquery2.default)(opts.container).append(popup);
                added = true;
            }
        };
        var $items = (0, _jquery2.default)(items);
        if (opts.onHover) {
            if (opts.useLiveEvents) {
                // We're using .on() to emulate the behaviour of .live() here. on() requires the jQuery object to have
                // a selector - this is actually how .live() is implemented in jQuery 1.7+.
                // Note that .selector is deleted in jQuery 1.9+.
                // This means that jQuery objects created by selection eg $(".my-class-selector") will work, but
                // object created by DOM parsing eg $("<div class='.my-class'></div>") will not work.
                // Ideally we should throw an error if the $items has no selector but that is backwards incompatible,
                // so we warn and do a no-op - this emulates the behaviour of live() but has the added warning.
                if ($items.selector) (0, _jquery2.default)(document).on("mouseenter", $items.selector, function(e) {
                    appendPopup();
                    initPopup(e, this);
                }).on("mouseleave", $items.selector, function() {
                    hidePopup();
                });
                else logger.log("Warning: inline dialog trigger elements must have a jQuery selector when the useLiveEvents option is enabled.");
            } else $items.on({
                mouseenter: function mouseenter(e) {
                    appendPopup();
                    initPopup(e, this);
                },
                mouseleave: function mouseleave() {
                    hidePopup();
                }
            });
        } else if (!opts.noBind) {
            //Check if the noBind option is turned on
            if (opts.useLiveEvents) {
                // See above for why we filter by .selector
                if ($items.selector) (0, _jquery2.default)(document).on("click", $items.selector, function(e) {
                    appendPopup();
                    if (shouldCloseOnTriggerClick()) popup.hide();
                    else initPopup(e, this);
                    return false;
                }).on("mouseleave", $items.selector, function() {
                    hidePopup();
                });
                else logger.log("Warning: inline dialog trigger elements must have a jQuery selector when the useLiveEvents option is enabled.");
            } else $items.on("click", function(e) {
                appendPopup();
                if (shouldCloseOnTriggerClick()) popup.hide();
                else initPopup(e, this);
                return false;
            }).on("mouseleave", function() {
                hidePopup();
            });
        }
        var shouldCloseOnTriggerClick = function shouldCloseOnTriggerClick() {
            return beingShown && opts.closeOnTriggerClick;
        };
        var bindHideEvents = function bindHideEvents() {
            bindHideOnExternalClick();
            bindHideOnEscPressed();
        };
        var unbindHideEvents = function unbindHideEvents() {
            unbindHideOnExternalClick();
            unbindHideOnEscPressed();
        };
        // Be defensive and make sure that we haven't already bound the event
        var hasBoundOnExternalClick = false;
        var externalClickNamespace = identifier + ".inline-dialog-check";
        /**
       * Catch click events on the body to see if the click target occurs outside of this popup
       * If it does, the popup will be hidden
       */ var bindHideOnExternalClick = function bindHideOnExternalClick() {
            if (!hasBoundOnExternalClick) {
                (0, _jquery2.default)("body").bind("click." + externalClickNamespace, function(e) {
                    var $target = (0, _jquery2.default)(e.target);
                    // hide the popup if the target of the event is not in the dialog
                    if ($target.closest("#inline-dialog-" + escapedIdentifier + " .contents").length === 0) hidePopup(0);
                });
                hasBoundOnExternalClick = true;
            }
        };
        var unbindHideOnExternalClick = function unbindHideOnExternalClick() {
            if (hasBoundOnExternalClick) (0, _jquery2.default)("body").unbind("click." + externalClickNamespace);
            hasBoundOnExternalClick = false;
        };
        var onKeydown = function onKeydown(e) {
            if (e.keyCode === _keyCode2.default.ESCAPE) hidePopup(0);
        };
        var bindHideOnEscPressed = function bindHideOnEscPressed() {
            (0, _jquery2.default)(document).on("keydown", onKeydown);
        };
        var unbindHideOnEscPressed = function unbindHideOnEscPressed() {
            (0, _jquery2.default)(document).off("keydown", onKeydown);
        };
        /**
       * Show the inline dialog.
       * @method show
       */ popup.show = function(e, trigger) {
            if (e) e.stopPropagation();
            appendPopup();
            if (opts.noBind && !(items && items.length)) initPopup(e, trigger === undefined ? e.target : trigger);
            else initPopup(e, items);
        };
        /**
       * Hide the inline dialog.
       * @method hide
       */ popup.hide = function() {
            hidePopup(0);
        };
        /**
       * Repositions the inline dialog if being shown.
       * @method refresh
       */ popup.refresh = function() {
            if (beingShown) getHash().reset();
        };
        popup.getOptions = function() {
            return opts;
        };
        return popup;
    }
    function dimensionsOf(el) {
        var $el = (0, _jquery2.default)(el);
        var offset = _jquery2.default.extend({
            left: 0,
            top: 0
        }, $el.offset());
        return {
            left: offset.left,
            top: offset.top,
            width: $el.outerWidth(),
            height: $el.outerHeight()
        };
    }
    function getDimensions(popup, targetPosition, mousePosition, opts) {
        var offsetX = _jquery2.default.isFunction(opts.offsetX) ? opts.offsetX(popup, targetPosition, mousePosition, opts) : opts.offsetX;
        var offsetY = _jquery2.default.isFunction(opts.offsetY) ? opts.offsetY(popup, targetPosition, mousePosition, opts) : opts.offsetY;
        var arrowOffsetX = _jquery2.default.isFunction(opts.arrowOffsetX) ? opts.arrowOffsetX(popup, targetPosition, mousePosition, opts) : opts.arrowOffsetX;
        var arrowOffsetY = _jquery2.default.isFunction(opts.arrowOffsetY) ? opts.arrowOffsetY(popup, targetPosition, mousePosition, opts) : opts.arrowOffsetY;
        // Support positioning inside a scroll container other than <body>
        var isConstrainedScroll = opts.container.toLowerCase() !== "body";
        var $scrollContainer = (0, _jquery2.default)(opts.container);
        var $scrollWindow = isConstrainedScroll ? (0, _jquery2.default)(opts.container).parent() : (0, _jquery2.default)(window);
        var scrollContainerOffset = isConstrainedScroll ? $scrollContainer.offset() : {
            left: 0,
            top: 0
        };
        var scrollWindowOffset = isConstrainedScroll ? $scrollWindow.offset() : {
            left: 0,
            top: 0
        };
        var trigger = targetPosition.target;
        var triggerOffset = trigger.offset();
        // Support SVG elements as triggers
        // TODO Should calculateNorthSouthPositions also try getBBox()?
        var triggerBBox = trigger[0].getBBox && trigger[0].getBBox();
        return {
            // determines how close to the edge the dialog needs to be before it is considered offscreen
            screenPadding: 10,
            // Min distance arrow needs to be from the edge of the dialog
            arrowMargin: 5,
            window: {
                top: scrollWindowOffset.top,
                left: scrollWindowOffset.left,
                scrollTop: $scrollWindow.scrollTop(),
                scrollLeft: $scrollWindow.scrollLeft(),
                width: $scrollWindow.width(),
                height: $scrollWindow.height()
            },
            scrollContainer: {
                width: $scrollContainer.width(),
                height: $scrollContainer.height()
            },
            // Position of the trigger is relative to the scroll container
            trigger: {
                top: triggerOffset.top - scrollContainerOffset.top,
                left: triggerOffset.left - scrollContainerOffset.left,
                width: triggerBBox ? triggerBBox.width : trigger.outerWidth(),
                height: triggerBBox ? triggerBBox.height : trigger.outerHeight()
            },
            dialog: {
                width: popup.width(),
                height: popup.height(),
                offset: {
                    top: offsetY,
                    left: offsetX
                }
            },
            arrow: {
                height: popup.find(".arrow").outerHeight(),
                offset: {
                    top: arrowOffsetY,
                    left: arrowOffsetX
                }
            }
        };
    }
    function calculateWestPositions(popup, targetPosition, mousePosition, opts) {
        var dimensions = getDimensions(popup, targetPosition, mousePosition, opts);
        var screenPadding = dimensions.screenPadding;
        var win = dimensions.window;
        var trigger = dimensions.trigger;
        var dialog = dimensions.dialog;
        var arrow = dimensions.arrow;
        var scrollContainer = dimensions.scrollContainer;
        var triggerScrollOffset = {
            top: trigger.top - win.scrollTop,
            left: trigger.left - win.scrollLeft
        };
        // Halves - because the browser doesn't do sub-pixel positioning, we need to consistently floor
        // all decimal values or you can get 1px jumps in arrow positioning when the dialog's height changes.
        var halfTriggerHeight = Math.floor(trigger.height / 2);
        var halfPopupHeight = Math.floor(dialog.height / 2);
        var halfArrowHeight = Math.floor(arrow.height / 2);
        // Figure out where to position the dialog, preferring the right (gravity: 'w').
        var spaceOnLeft = triggerScrollOffset.left - dialog.offset.left - screenPadding;
        // This implementation may not be suitable for horizontally scrolling containers
        var spaceOnRight = scrollContainer.width - triggerScrollOffset.left - trigger.width - dialog.offset.left - screenPadding;
        var enoughSpaceOnLeft = spaceOnLeft >= dialog.width;
        var enoughSpaceOnRight = spaceOnRight >= dialog.width;
        var gravity = !enoughSpaceOnRight && enoughSpaceOnLeft ? "e" : "w";
        // Screen padding needs to be adjusted if the arrow would extend into it
        var arrowScreenTop = triggerScrollOffset.top + halfTriggerHeight - halfArrowHeight;
        var arrowScreenBottom = win.height - arrowScreenTop - arrow.height;
        screenPadding = Math.min(screenPadding, arrowScreenTop - dimensions.arrowMargin);
        screenPadding = Math.min(screenPadding, arrowScreenBottom - dimensions.arrowMargin);
        // Figure out if the dialog needs to be adjusted up or down to fit on the screen
        var middleOfTrigger = triggerScrollOffset.top + halfTriggerHeight;
        var spaceAboveMiddleOfTrigger = Math.max(middleOfTrigger - screenPadding, 0);
        var spaceBelowMiddleOfTrigger = Math.max(win.height - middleOfTrigger - screenPadding, 0);
        var isOverflowingAbove = halfPopupHeight - dialog.offset.top > spaceAboveMiddleOfTrigger;
        var isOverflowingBelow = halfPopupHeight + dialog.offset.top > spaceBelowMiddleOfTrigger;
        var popupCss;
        var arrowCss;
        if (isOverflowingAbove) {
            popupCss = {
                top: win.scrollTop + screenPadding,
                left: gravity === "w" ? trigger.left + trigger.width + dialog.offset.left : trigger.left - dialog.width - dialog.offset.left
            };
            arrowCss = {
                top: trigger.top + halfTriggerHeight - (popupCss.top + halfArrowHeight)
            };
        } else if (isOverflowingBelow) {
            popupCss = {
                top: win.scrollTop + win.height - dialog.height - screenPadding,
                left: gravity === "w" ? trigger.left + trigger.width + dialog.offset.left : trigger.left - dialog.width - dialog.offset.left
            };
            arrowCss = {
                top: trigger.top + halfTriggerHeight - (popupCss.top + halfArrowHeight)
            };
        } else {
            popupCss = {
                top: trigger.top + halfTriggerHeight - halfPopupHeight + dialog.offset.top,
                left: gravity === "w" ? trigger.left + trigger.width + dialog.offset.left : trigger.left - dialog.width - dialog.offset.left
            };
            arrowCss = {
                top: halfPopupHeight - halfArrowHeight + arrow.offset.top
            };
        }
        return {
            gravity: gravity,
            popupCss: popupCss,
            arrowCss: arrowCss
        };
    }
    function calculateNorthSouthPositions(popup, targetPosition, mousePosition, opts) {
        var offsetX = _jquery2.default.isFunction(opts.offsetX) ? opts.offsetX(popup, targetPosition, mousePosition, opts) : opts.offsetX;
        var offsetY = _jquery2.default.isFunction(opts.offsetY) ? opts.offsetY(popup, targetPosition, mousePosition, opts) : opts.offsetY;
        var arrowOffsetX = _jquery2.default.isFunction(opts.arrowOffsetX) ? opts.arrowOffsetX(popup, targetPosition, mousePosition, opts) : opts.arrowOffsetX;
        var viewportDimensions = dimensionsOf(window);
        var targetDimensions = dimensionsOf(targetPosition.target);
        var popupDimensions = dimensionsOf(popup);
        var arrowDimensions = dimensionsOf(popup.find(".aui-inline-dialog-arrow"));
        var middleOfTrigger = targetDimensions.left + targetDimensions.width / 2; //The absolute x position of the middle of the Trigger
        var bottomOfViewablePage = (window.pageYOffset || document.documentElement.scrollTop) + viewportDimensions.height;
        var SCREEN_PADDING = 10; //determines how close to the edge the dialog needs to be before it is considered offscreen
        // Set popup's position (within the viewport)
        popupDimensions.top = targetDimensions.top + targetDimensions.height + ~~offsetY;
        popupDimensions.left = targetDimensions.left + ~~offsetX;
        // Calculate if the popup would render off the side of the viewport
        var diff = viewportDimensions.width - (popupDimensions.left + popupDimensions.width + SCREEN_PADDING);
        // Set arrow's position (within the popup)
        arrowDimensions.left = middleOfTrigger - popupDimensions.left + ~~arrowOffsetX;
        // TODO arrowDimensions.top should also use arrowOffsetY.
        arrowDimensions.top = -(arrowDimensions.height / 2);
        // Check whether the popup should display above or below the trigger
        var enoughRoomAbove = targetDimensions.top > popupDimensions.height;
        var enoughRoomBelow = popupDimensions.top + popupDimensions.height < bottomOfViewablePage;
        var displayAbove = !enoughRoomBelow && enoughRoomAbove || enoughRoomAbove && opts.gravity === "s";
        if (displayAbove) {
            popupDimensions.top = targetDimensions.top - popupDimensions.height - arrowDimensions.height / 2;
            arrowDimensions.top = popupDimensions.height;
        }
        // Check if the popup should show up relative to the mouse
        if (opts.isRelativeToMouse) {
            if (diff < 0) {
                popupDimensions.right = SCREEN_PADDING;
                popupDimensions.left = "auto";
                // TODO Why doesn't arrowDimentions.left here use arrowOffsetX?
                arrowDimensions.left = mousePosition.x - (viewportDimensions.width - popupDimensions.width);
            } else {
                popupDimensions.left = mousePosition.x - 20;
                // TODO Why doesn't arrowDimentions.left here use arrowOffsetX?
                arrowDimensions.left = mousePosition.x - popupDimensions.left;
            }
        } else {
            if (diff < 0) {
                popupDimensions.right = SCREEN_PADDING;
                popupDimensions.left = "auto";
                var popupRightEdge = viewportDimensions.width - popupDimensions.right;
                var popupLeftEdge = popupRightEdge - popupDimensions.width;
                //arrow's position must be relative to the popup's position and not of the screen.
                arrowDimensions.right = "auto";
                // TODO Why doesn't arrowDimentions.left here use arrowOffsetX?
                arrowDimensions.left = middleOfTrigger - popupLeftEdge - arrowDimensions.width / 2;
            } else if (popupDimensions.width <= targetDimensions.width / 2) {
                // TODO Why doesn't arrowDimentions.left here use arrowOffsetX?
                arrowDimensions.left = popupDimensions.width / 2;
                popupDimensions.left = middleOfTrigger - popupDimensions.width / 2;
            }
        }
        return {
            gravity: displayAbove ? "s" : "n",
            displayAbove: displayAbove,
            popupCss: {
                left: popupDimensions.left,
                top: popupDimensions.top,
                right: popupDimensions.right
            },
            arrowCss: {
                left: arrowDimensions.left,
                top: arrowDimensions.top,
                right: arrowDimensions.right
            }
        };
    }
    InlineDialog.opts = {
        onTop: false,
        responseHandler: function responseHandler(data1) {
            //assume data is html
            return data1;
        },
        closeOthers: true,
        isRelativeToMouse: false,
        addActiveClass: true,
        onHover: false,
        useLiveEvents: false,
        noBind: false,
        fadeTime: 100,
        persistent: false,
        hideDelay: 10000,
        showDelay: 0,
        width: 300,
        offsetX: 0,
        offsetY: 10,
        arrowOffsetX: 0,
        arrowOffsetY: 0,
        container: "body",
        cacheContent: true,
        displayShadow: true,
        autoWidth: false,
        gravity: "n",
        closeOnTriggerClick: false,
        preHideCallback: function preHideCallback() {
            return true;
        },
        hideCallback: function hideCallback() {},
        initCallback: function initCallback() {},
        upfrontCallback: function upfrontCallback() {},
        /**
       * Returns an object with the following attributes:
       *      popupCss css attributes to apply on the popup element
       *      arrowCss css attributes to apply on the arrow element
       *
       * @param popup
       * @param targetPosition position of the target element
       * @param mousePosition current mouse position
       * @param opts options
       */ calculatePositions: function calculatePositions(popup, targetPosition, mousePosition, opts) {
            opts = opts || {};
            var algorithm = opts.gravity === "w" ? calculateWestPositions : calculateNorthSouthPositions;
            return algorithm(popup, targetPosition, mousePosition, opts);
        }
    };
    // Deprecations
    // ------------
    InlineDialog = deprecate.construct(InlineDialog, "Inline dialog constructor", {
        alternativeName: "inline dialog 2"
    });
    var displayAboveDeprecationLogger = deprecate.getMessageLogger("displayAbove", "[remove version]", {
        alternativeName: "gravity",
        extraInfo: "See https://ecosystem.atlassian.net/browse/AUI-2197."
    });
    var onTopDeprecationLogger = deprecate.getMessageLogger("onTop", "[remove version]", {
        alternativeName: "gravity",
        extraInfo: "See https://ecosystem.atlassian.net/browse/AUI-2197."
    });
    // Exporting
    // ---------
    (0, _globalize2.default)("InlineDialog", InlineDialog);
    exports.default = InlineDialog;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/format.js
(typeof window === "undefined" ? $parcel$global : window).__d31562b45156ec0db003c1af006240d5 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    /* eslint no-cond-assign: off */ Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Replaces tokens in a string with arguments, similar to Java's MessageFormat.
   * Tokens are in the form {0}, {1}, {2}, etc.
   *
   * This version also provides support for simple choice formats (excluding floating point numbers) of the form
   * {0,choice,0#0 issues|1#1 issue|1<{0,number} issues}
   *
   * Number format is currently not implemented, tokens of the form {0,number} will simply be printed as {0}
   *
   * @method format
   * @param message the message to replace tokens in
   * @param arg (optional) replacement value for token {0}, with subsequent arguments being {1}, etc.
   * @return {String} the message with the tokens replaced
   * @usage formatString("This is a {0} test", "simple");
   */ function formatString(message) {
        var apos = /'(?!')/g; // founds "'", but not "''" // TODO: does not work for floating point numbers!
        var simpleFormat = /^\d+$/;
        var numberFormat = /^(\d+),number$/; // TODO: incomplete, as doesn't support floating point numbers
        var choiceFormat = /^(\d+)\,choice\,(.+)/;
        var choicePart = /^(\d+)([#<])(.+)/;
        // we are caching RegExps, so will not spend time on recreating them on each call
        // formats a value, currently choice and simple replacement are implemented, proper
        var getParamValue = function getParamValue(format, args) {
            // simple substitute
            var res = "";
            var match;
            if (match = format.match(simpleFormat)) // TODO: heavy guns for checking whether format is a simple number...
            res = args.length > ++format ? args[format] : ""; // use the argument as is, or use '' if not found
            else if (match = format.match(numberFormat)) // TODO: doesn't actually format the number...
            res = args.length > ++match[1] ? args[match[1]] : "";
            else if (match = format.match(choiceFormat)) {
                // format: "0,choice,0#0 issues|1#1 issue|1<{0,number} issues"
                // match[0]: "0,choice,0#0 issues|1#1 issue|1<{0,number} issues"
                // match[1]: "0"
                // match[2]: "0#0 issues|1#1 issue|1<{0,number} issues"
                // get the argument value we base the choice on
                var value1 = args.length > ++match[1] ? args[match[1]] : null;
                if (value1 !== null) {
                    // go through all options, checking against the number, according to following formula,
                    // if X < the first entry then the first entry is returned, if X > last entry, the last entry is returned
                    //
                    //    X matches j if and only if limit[j] <= X < limit[j+1]
                    //
                    var options = match[2].split("|");
                    var prevOptionValue = null; // holds last passed option
                    for(var i = 0; i < options.length; i++){
                        // option: "0#0 issues"
                        // part[0]: "0#0 issues"
                        // part[1]: "0"
                        // part[2]: "#"
                        // part[3]" "0 issues";
                        var parts = options[i].match(choicePart);
                        // if value is smaller, we take the previous value, or the current if no previous exists
                        var argValue = parseInt(parts[1], 10);
                        if (value1 < argValue) {
                            if (prevOptionValue) {
                                res = prevOptionValue;
                                break;
                            } else {
                                res = parts[3];
                                break;
                            }
                        }
                        // if value is equal the condition, and the match is equality match we accept it
                        if (value1 == argValue && parts[2] == "#") {
                            res = parts[3];
                            break;
                        }
                        // value is greater the condition, fall through to next iteration
                        // check whether we are the last option, in which case accept it even if the option does not match
                        if (i == options.length - 1) res = parts[3];
                        // retain current option
                        prevOptionValue = parts[3];
                    }
                    // run result through format, as the parts might contain substitutes themselves
                    var formatArgs = [
                        res
                    ].concat(Array.prototype.slice.call(args, 1));
                    res = formatString.apply(null, formatArgs);
                }
            }
            return res;
        };
        // drop in replacement for the token regex
        // splits the message to return the next accurance of a i18n placeholder.
        // Does not use regexps as we need to support nested placeholders
        // text between single ticks ' are ignored
        var _performTokenRegex = function _performTokenRegex(message) {
            var tick = false;
            var openIndex = -1;
            var openCount = 0;
            for(var i = 0; i < message.length; i++){
                // handle ticks
                var c = message.charAt(i);
                if (c == "'") // toggle
                tick = !tick;
                // skip if we are between ticks
                if (tick) continue;
                // check open brackets
                if (c === "{") {
                    if (openCount === 0) openIndex = i;
                    openCount++;
                } else if (c === "}") {
                    if (openCount > 0) {
                        openCount--;
                        if (openCount === 0) {
                            // we found a bracket match - generate the result array (
                            var match = [];
                            match.push(message.substring(0, i + 1)); // from begin to match
                            match.push(message.substring(0, openIndex)); // everything until match start
                            match.push(message.substring(openIndex + 1, i)); // matched content
                            return match;
                        }
                    }
                }
            }
            return null;
        };
        var _formatString = function _formatString(message) {
            var args = arguments;
            var res = "";
            if (!message) return res;
            var match = _performTokenRegex(message);
            while(match){
                // reduce message to string after match
                message = message.substring(match[0].length);
                // add value before match to result
                res += match[1].replace(apos, "");
                // add formatted parameter
                res += getParamValue(match[2], args);
                // check for next match
                match = _performTokenRegex(message); //message.match(token);
            }
            // add remaining message to result
            res += message.replace(apos, "");
            return res;
        };
        return _formatString.apply(null, arguments);
    }
    (0, _globalize2.default)("format", formatString);
    exports.default = formatString;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/i18n/aui.js
(typeof window === "undefined" ? $parcel$global : window).__7200bf779bc91779c4bd25c87402f30d = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = {
        "aui.dropdown.async.error": "Error loading dropdown",
        "aui.dropdown.async.loading": "Loading dropdown",
        "aui.words.add": "Add",
        "aui.words.update": "Update",
        "aui.words.delete": "Delete",
        "aui.words.remove": "Remove",
        "aui.words.cancel": "Cancel",
        "aui.words.loading": "Loading",
        "aui.words.close": "Close",
        "aui.enter.value": "Enter value",
        "aui.words.more": "More",
        "aui.words.moreitem": "More\u2026",
        "aui.keyboard.shortcut.type.x": "Type ''{0}''",
        "aui.keyboard.shortcut.then.x": "then ''{0}''",
        "aui.keyboard.shortcut.or.x": "OR ''{0}''",
        "aui.sidebar.expand.tooltip": "Expand sidebar ( [ )",
        "aui.sidebar.collapse.tooltip": "Collapse sidebar ( [ )",
        "aui.validation.message.maxlength": "Must be fewer than or equal to {0} characters",
        "aui.validation.message.minlength": "Must be greater than or equal to {0} characters",
        "aui.validation.message.exactlength": "Must be exactly {0} characters",
        "aui.validation.message.matchingfield": "{0} and {1} do not match.",
        "aui.validation.message.matchingfield-novalue": "These fields do not match.",
        "aui.validation.message.doesnotcontain": "Do not include the phrase {0} in this field",
        "aui.validation.message.pattern": "This field does not match the required format",
        "aui.validation.message.required": "This is a required field",
        "aui.validation.message.validnumber": "Please enter a valid number",
        "aui.validation.message.min": "Enter a value greater than {0}",
        "aui.validation.message.max": "Enter a value less than {0}",
        "aui.validation.message.dateformat": "Enter a valid date",
        "aui.validation.message.minchecked": "Tick at least {0,choice,0#0 checkboxes|1#1 checkbox|1<{0,number} checkboxes}.",
        "aui.validation.message.maxchecked": "Tick at most {0,choice,0#0 checkboxes|1#1 checkbox|1<{0,number} checkboxes}.",
        "aui.checkboxmultiselect.clear.selected": "Clear selected items",
        "aui.select.no.suggestions": "No suggestions",
        "aui.select.new.suggestions": "New suggestions added. Please use the up and down arrows to select.",
        "aui.select.new.value": "new value",
        "aui.toggle.on": "On",
        "aui.toggle.off": "Off",
        "ajs.datepicker.localisations.day-names.sunday": "Sunday",
        "ajs.datepicker.localisations.day-names.monday": "Monday",
        "ajs.datepicker.localisations.day-names.tuesday": "Tuesday",
        "ajs.datepicker.localisations.day-names.wednesday": "Wednesday",
        "ajs.datepicker.localisations.day-names.thursday": "Thursday",
        "ajs.datepicker.localisations.day-names.friday": "Friday",
        "ajs.datepicker.localisations.day-names.saturday": "Saturday",
        "ajs.datepicker.localisations.day-names-min.sunday": "Sun",
        "ajs.datepicker.localisations.day-names-min.monday": "Mon",
        "ajs.datepicker.localisations.day-names-min.tuesday": "Tue",
        "ajs.datepicker.localisations.day-names-min.wednesday": "Wed",
        "ajs.datepicker.localisations.day-names-min.thursday": "Thu",
        "ajs.datepicker.localisations.day-names-min.friday": "Fri",
        "ajs.datepicker.localisations.day-names-min.saturday": "Sat",
        "ajs.datepicker.localisations.first-day": 0,
        "ajs.datepicker.localisations.is-RTL": false,
        "ajs.datepicker.localisations.month-names.january": "January",
        "ajs.datepicker.localisations.month-names.february": "February",
        "ajs.datepicker.localisations.month-names.march": "March",
        "ajs.datepicker.localisations.month-names.april": "April",
        "ajs.datepicker.localisations.month-names.may": "May",
        "ajs.datepicker.localisations.month-names.june": "June",
        "ajs.datepicker.localisations.month-names.july": "July",
        "ajs.datepicker.localisations.month-names.august": "August",
        "ajs.datepicker.localisations.month-names.september": "September",
        "ajs.datepicker.localisations.month-names.october": "October",
        "ajs.datepicker.localisations.month-names.november": "November",
        "ajs.datepicker.localisations.month-names.december": "December",
        "ajs.datepicker.localisations.show-month-after-year": false,
        "ajs.datepicker.localisations.year-suffix": null
    };
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/i18n.js
(typeof window === "undefined" ? $parcel$global : window).__fa714f1b12d7502957e4e0b6196321bf = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _format = __d31562b45156ec0db003c1af006240d5;
    var _format2 = _interopRequireDefault(_format);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _aui = __7200bf779bc91779c4bd25c87402f30d;
    var _aui2 = _interopRequireDefault(_aui);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Returns the value defined in AJS.I18n.keys for the given key. If AJS.I18n.keys does not exist, or if the given key does not exist,
   * the key is returned - this could occur in plugin mode if the I18n transform is not performed;
   * or in flatpack mode if the i18n JS file is not loaded.
   */ var i18n = {
        keys: _aui2.default,
        getText: function getText(key) {
            var params = Array.prototype.slice.call(arguments, 1);
            if (Object.prototype.hasOwnProperty.call(this.keys, key)) return _format2.default.apply(null, [
                this.keys[key]
            ].concat(params));
            return key;
        }
    };
    (0, _globalize2.default)("I18n", i18n);
    exports.default = i18n;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/skatejs/lib/constants.js
(typeof window === "undefined" ? $parcel$global : window).__09f2943f386e1cc7dddbb02a7eabebab = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__09f2943f386e1cc7dddbb02a7eabebab");
    define.amd = true;
    (function(factory) {
        if (typeof define === "function" && define.amd) define([
            "exports"
        ], factory);
        else if (typeof exports !== "undefined") factory(exports);
    })(function(exports) {
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        var ATTR_IGNORE = "data-skate-ignore";
        exports.ATTR_IGNORE = ATTR_IGNORE;
        var TYPE_ATTRIBUTE = "a";
        exports.TYPE_ATTRIBUTE = TYPE_ATTRIBUTE;
        var TYPE_CLASSNAME = "c";
        exports.TYPE_CLASSNAME = TYPE_CLASSNAME;
        var TYPE_ELEMENT = "t";
        exports.TYPE_ELEMENT = TYPE_ELEMENT;
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/skatejs/lib/version.js
(typeof window === "undefined" ? $parcel$global : window).__3ac87b9829a39b9fd554c8a7b3022630 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__3ac87b9829a39b9fd554c8a7b3022630");
    define.amd = true;
    (function(factory) {
        if (typeof define === "function" && define.amd) define([
            "exports",
            "module"
        ], factory);
        else if (typeof exports !== "undefined" && typeof module !== "undefined") factory(exports, module);
    })(function(exports, module) {
        module.exports = "0.13.17";
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/skatejs/lib/globals.js
(typeof window === "undefined" ? $parcel$global : window).__c6912c7a4bb2bfb86ffa5bd4c0e41172 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports,
        "./version": __3ac87b9829a39b9fd554c8a7b3022630,
        "./version": __3ac87b9829a39b9fd554c8a7b3022630
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__c6912c7a4bb2bfb86ffa5bd4c0e41172");
    define.amd = true;
    (function(factory) {
        if (typeof define === "function" && define.amd) define([
            "exports",
            "module",
            "./version"
        ], factory);
        else if (typeof exports !== "undefined" && typeof module !== "undefined") factory(exports, module, __3ac87b9829a39b9fd554c8a7b3022630);
    })(function(exports, module, _version) {
        var _interopRequire = function(obj) {
            return obj && obj.__esModule ? obj["default"] : obj;
        };
        var version = _interopRequire(_version);
        var VERSION = "__skate_" + version.replace(/[^\w]/g, "_");
        if (!window[VERSION]) window[VERSION] = {
            observer: undefined,
            registry: {}
        };
        module.exports = window[VERSION];
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/skatejs/lib/data.js
(typeof window === "undefined" ? $parcel$global : window).__dfc7d702d382be77c2900d1d6eb85c20 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__dfc7d702d382be77c2900d1d6eb85c20");
    define.amd = true;
    (function(factory) {
        if (typeof define === "function" && define.amd) define([
            "exports",
            "module"
        ], factory);
        else if (typeof exports !== "undefined" && typeof module !== "undefined") factory(exports, module);
    })(function(exports, module) {
        module.exports = function(element) {
            var namespace = arguments[1] === undefined ? "" : arguments[1];
            var data1 = element.__SKATE_DATA || (element.__SKATE_DATA = {});
            return namespace && (data1[namespace] || (data1[namespace] = {})) || data1;
        };
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/skatejs/lib/mutation-observer.js
(typeof window === "undefined" ? $parcel$global : window).__bdae44341fc76c6906a95201c725f098 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__bdae44341fc76c6906a95201c725f098");
    define.amd = true;
    (function(factory) {
        if (typeof define === "function" && define.amd) define([
            "exports"
        ], factory);
        else if (typeof exports !== "undefined") factory(exports);
    })(function(exports) {
        (function(self) {
            // Atlassian: added IIFE
            /**
       * @license
       * Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
       */ // @version 0.7.15
            if (typeof WeakMap === "undefined") (function() {
                var defineProperty = Object.defineProperty;
                var counter = Date.now() % 1000000000;
                var WeakMap1 = function WeakMap1() {
                    this.name = "__st" + (Math.random() * 1000000000 >>> 0) + (counter++ + "__");
                };
                WeakMap1.prototype = {
                    set: function set(key, value1) {
                        var entry = key[this.name];
                        if (entry && entry[0] === key) entry[1] = value1;
                        else defineProperty(key, this.name, {
                            value: [
                                key,
                                value1
                            ],
                            writable: true
                        });
                        return this;
                    },
                    get: function get(key) {
                        var entry;
                        return (entry = key[this.name]) && entry[0] === key ? entry[1] : undefined;
                    },
                    "delete": function _delete(key) {
                        var entry = key[this.name];
                        if (!entry || entry[0] !== key) return false;
                        entry[0] = entry[1] = undefined;
                        return true;
                    },
                    has: function has(key) {
                        var entry = key[this.name];
                        if (!entry) return false;
                        return entry[0] === key;
                    }
                };
                window.WeakMap = WeakMap1;
            })();
            (function(global1) {
                if (global1.JsMutationObserver) return;
                var registrationsTable = new WeakMap();
                var setImmediate;
                if (/Trident|Edge/.test(navigator.userAgent)) setImmediate = setTimeout;
                else if (window.setImmediate) setImmediate = window.setImmediate;
                else {
                    var setImmediateQueue = [];
                    var sentinel = String(Math.random());
                    window.addEventListener("message", function(e) {
                        if (e.data === sentinel) {
                            var queue = setImmediateQueue;
                            setImmediateQueue = [];
                            queue.forEach(function(func) {
                                func();
                            });
                        }
                    });
                    setImmediate = function(func) {
                        setImmediateQueue.push(func);
                        window.postMessage(sentinel, "*");
                    };
                }
                var isScheduled = false;
                var scheduledObservers = [];
                function scheduleCallback(observer) {
                    scheduledObservers.push(observer);
                    if (!isScheduled) {
                        isScheduled = true;
                        setImmediate(dispatchCallbacks);
                    }
                }
                function wrapIfNeeded(node) {
                    return window.ShadowDOMPolyfill && window.ShadowDOMPolyfill.wrapIfNeeded(node) || node;
                }
                function dispatchCallbacks() {
                    isScheduled = false;
                    var observers = scheduledObservers;
                    scheduledObservers = [];
                    observers.sort(function(o1, o2) {
                        return o1.uid_ - o2.uid_;
                    });
                    var anyNonEmpty = false;
                    observers.forEach(function(observer) {
                        var queue = observer.takeRecords();
                        removeTransientObserversFor(observer);
                        if (queue.length) {
                            observer.callback_(queue, observer);
                            anyNonEmpty = true;
                        }
                    });
                    if (anyNonEmpty) dispatchCallbacks();
                }
                function removeTransientObserversFor(observer) {
                    observer.nodes_.forEach(function(node) {
                        var registrations = registrationsTable.get(node);
                        if (!registrations) return;
                        registrations.forEach(function(registration) {
                            if (registration.observer === observer) registration.removeTransientObservers();
                        });
                    });
                }
                function forEachAncestorAndObserverEnqueueRecord(target, callback) {
                    for(var node = target; node; node = node.parentNode){
                        var registrations = registrationsTable.get(node);
                        if (registrations) for(var j = 0; j < registrations.length; j++){
                            var registration = registrations[j];
                            var options = registration.options;
                            if (node !== target && !options.subtree) continue;
                            var record = callback(options);
                            if (record) registration.enqueue(record);
                        }
                    }
                }
                var uidCounter = 0;
                function JsMutationObserver(callback) {
                    this.callback_ = callback;
                    this.nodes_ = [];
                    this.records_ = [];
                    this.uid_ = ++uidCounter;
                }
                JsMutationObserver.prototype = {
                    observe: function observe(target, options) {
                        target = wrapIfNeeded(target);
                        if (!options.childList && !options.attributes && !options.characterData || options.attributeOldValue && !options.attributes || options.attributeFilter && options.attributeFilter.length && !options.attributes || options.characterDataOldValue && !options.characterData) throw new SyntaxError();
                        var registrations = registrationsTable.get(target);
                        if (!registrations) registrationsTable.set(target, registrations = []);
                        var registration;
                        for(var i = 0; i < registrations.length; i++)if (registrations[i].observer === this) {
                            registration = registrations[i];
                            registration.removeListeners();
                            registration.options = options;
                            break;
                        }
                        if (!registration) {
                            registration = new Registration(this, target, options);
                            registrations.push(registration);
                            this.nodes_.push(target);
                        }
                        registration.addListeners();
                    },
                    disconnect: function disconnect() {
                        this.nodes_.forEach(function(node) {
                            var registrations = registrationsTable.get(node);
                            for(var i = 0; i < registrations.length; i++){
                                var registration = registrations[i];
                                if (registration.observer === this) {
                                    registration.removeListeners();
                                    registrations.splice(i, 1);
                                    break;
                                }
                            }
                        }, this);
                        this.records_ = [];
                    },
                    takeRecords: function takeRecords() {
                        var copyOfRecords = this.records_;
                        this.records_ = [];
                        return copyOfRecords;
                    }
                };
                function MutationRecord(type, target) {
                    this.type = type;
                    this.target = target;
                    this.addedNodes = [];
                    this.removedNodes = [];
                    this.previousSibling = null;
                    this.nextSibling = null;
                    this.attributeName = null;
                    this.attributeNamespace = null;
                    this.oldValue = null;
                }
                function copyMutationRecord(original) {
                    var record = new MutationRecord(original.type, original.target);
                    record.addedNodes = original.addedNodes.slice();
                    record.removedNodes = original.removedNodes.slice();
                    record.previousSibling = original.previousSibling;
                    record.nextSibling = original.nextSibling;
                    record.attributeName = original.attributeName;
                    record.attributeNamespace = original.attributeNamespace;
                    record.oldValue = original.oldValue;
                    return record;
                }
                var currentRecord, recordWithOldValue;
                function getRecord(type, target) {
                    return currentRecord = new MutationRecord(type, target);
                }
                function getRecordWithOldValue(oldValue) {
                    if (recordWithOldValue) return recordWithOldValue;
                    recordWithOldValue = copyMutationRecord(currentRecord);
                    recordWithOldValue.oldValue = oldValue;
                    return recordWithOldValue;
                }
                function clearRecords() {
                    currentRecord = recordWithOldValue = undefined;
                }
                function recordRepresentsCurrentMutation(record) {
                    return record === recordWithOldValue || record === currentRecord;
                }
                function selectRecord(lastRecord, newRecord) {
                    if (lastRecord === newRecord) return lastRecord;
                    if (recordWithOldValue && recordRepresentsCurrentMutation(lastRecord)) return recordWithOldValue;
                    return null;
                }
                function Registration(observer, target, options) {
                    this.observer = observer;
                    this.target = target;
                    this.options = options;
                    this.transientObservedNodes = [];
                }
                Registration.prototype = {
                    enqueue: function enqueue(record) {
                        var records = this.observer.records_;
                        var length = records.length;
                        if (records.length > 0) {
                            var lastRecord = records[length - 1];
                            var recordToReplaceLast = selectRecord(lastRecord, record);
                            if (recordToReplaceLast) {
                                records[length - 1] = recordToReplaceLast;
                                return;
                            }
                        } else scheduleCallback(this.observer);
                        records[length] = record;
                    },
                    addListeners: function addListeners() {
                        this.addListeners_(this.target);
                    },
                    addListeners_: function addListeners_(node) {
                        var options = this.options;
                        if (options.attributes) node.addEventListener("DOMAttrModified", this, true);
                        if (options.characterData) node.addEventListener("DOMCharacterDataModified", this, true);
                        if (options.childList) node.addEventListener("DOMNodeInserted", this, true);
                        if (options.childList || options.subtree) node.addEventListener("DOMNodeRemoved", this, true);
                    },
                    removeListeners: function removeListeners() {
                        this.removeListeners_(this.target);
                    },
                    removeListeners_: function removeListeners_(node) {
                        var options = this.options;
                        if (options.attributes) node.removeEventListener("DOMAttrModified", this, true);
                        if (options.characterData) node.removeEventListener("DOMCharacterDataModified", this, true);
                        if (options.childList) node.removeEventListener("DOMNodeInserted", this, true);
                        if (options.childList || options.subtree) node.removeEventListener("DOMNodeRemoved", this, true);
                    },
                    addTransientObserver: function addTransientObserver(node) {
                        if (node === this.target) return;
                        this.addListeners_(node);
                        this.transientObservedNodes.push(node);
                        var registrations = registrationsTable.get(node);
                        if (!registrations) registrationsTable.set(node, registrations = []);
                        registrations.push(this);
                    },
                    removeTransientObservers: function removeTransientObservers() {
                        var transientObservedNodes = this.transientObservedNodes;
                        this.transientObservedNodes = [];
                        transientObservedNodes.forEach(function(node) {
                            this.removeListeners_(node);
                            var registrations = registrationsTable.get(node);
                            for(var i = 0; i < registrations.length; i++)if (registrations[i] === this) {
                                registrations.splice(i, 1);
                                break;
                            }
                        }, this);
                    },
                    handleEvent: function handleEvent(e) {
                        e.stopImmediatePropagation();
                        switch(e.type){
                            case "DOMAttrModified":
                                var name = e.attrName;
                                var namespace = e.relatedNode.namespaceURI;
                                var target = e.target;
                                var record = new getRecord("attributes", target);
                                record.attributeName = name;
                                record.attributeNamespace = namespace;
                                var oldValue = e.attrChange === MutationEvent.ADDITION ? null : e.prevValue;
                                forEachAncestorAndObserverEnqueueRecord(target, function(options) {
                                    if (!options.attributes) return;
                                    if (options.attributeFilter && options.attributeFilter.length && options.attributeFilter.indexOf(name) === -1 && options.attributeFilter.indexOf(namespace) === -1) return;
                                    if (options.attributeOldValue) return getRecordWithOldValue(oldValue);
                                    return record;
                                });
                                break;
                            case "DOMCharacterDataModified":
                                var target = e.target;
                                var record = getRecord("characterData", target);
                                var oldValue = e.prevValue;
                                forEachAncestorAndObserverEnqueueRecord(target, function(options) {
                                    if (!options.characterData) return;
                                    if (options.characterDataOldValue) return getRecordWithOldValue(oldValue);
                                    return record;
                                });
                                break;
                            case "DOMNodeRemoved":
                                this.addTransientObserver(e.target);
                            case "DOMNodeInserted":
                                var changedNode = e.target;
                                var addedNodes, removedNodes;
                                if (e.type === "DOMNodeInserted") {
                                    addedNodes = [
                                        changedNode
                                    ];
                                    removedNodes = [];
                                } else {
                                    addedNodes = [];
                                    removedNodes = [
                                        changedNode
                                    ];
                                }
                                var previousSibling = changedNode.previousSibling;
                                var nextSibling = changedNode.nextSibling;
                                var record = getRecord("childList", e.target.parentNode);
                                record.addedNodes = addedNodes;
                                record.removedNodes = removedNodes;
                                record.previousSibling = previousSibling;
                                record.nextSibling = nextSibling;
                                forEachAncestorAndObserverEnqueueRecord(e.relatedNode, function(options) {
                                    if (!options.childList) return;
                                    return record;
                                });
                        }
                        clearRecords();
                    }
                };
                global1.JsMutationObserver = JsMutationObserver;
                if (!global1.MutationObserver) {
                    global1.MutationObserver = JsMutationObserver;
                    JsMutationObserver._isPolyfilled = true;
                }
            })(self);
        })(window); // Atlassian: added IIFE
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/skatejs/lib/utils.js
(typeof window === "undefined" ? $parcel$global : window).__39d3c59358ccb9df9e8b99850c06d47d = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports,
        "./constants": __09f2943f386e1cc7dddbb02a7eabebab,
        "./constants": __09f2943f386e1cc7dddbb02a7eabebab
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__39d3c59358ccb9df9e8b99850c06d47d");
    define.amd = true;
    (function(factory) {
        if (typeof define === "function" && define.amd) define([
            "exports",
            "./constants"
        ], factory);
        else if (typeof exports !== "undefined") factory(exports, __09f2943f386e1cc7dddbb02a7eabebab);
    })(function(exports, _constants) {
        /**
     * Checks {}.hasOwnProperty in a safe way.
     *
     * @param {Object} obj The object the property is on.
     * @param {String} key The object key to check.
     *
     * @returns {Boolean}
     */ exports.hasOwn = hasOwn;
        /**
     * Camel-cases the specified string.
     *
     * @param {String} str The string to camel-case.
     *
     * @returns {String}
     */ exports.camelCase = camelCase;
        /**
     * Returns whether or not the source element contains the target element.
     * This is for browsers that don't support Element.prototype.contains on an
     * HTMLUnknownElement.
     *
     * @param {HTMLElement} source The source element.
     * @param {HTMLElement} target The target element.
     *
     * @returns {Boolean}
     */ exports.elementContains = elementContains;
        /**
     * Returns a function that will prevent more than one call in a single clock
     * tick.
     *
     * @param {Function} fn The function to call.
     *
     * @returns {Function}
     */ exports.debounce = debounce;
        /**
     * Returns whether or not the specified element has been selectively ignored.
     *
     * @param {Element} element The element to check and traverse up from.
     *
     * @returns {Boolean}
     */ exports.getClosestIgnoredElement = getClosestIgnoredElement;
        /**
     * Merges the second argument into the first.
     *
     * @param {Object} child The object to merge into.
     * @param {Object} parent The object to merge from.
     * @param {Boolean} overwrite Whether or not to overwrite properties on the child.
     *
     * @returns {Object} Returns the child object.
     */ exports.inherit = inherit;
        /**
     * Traverses an object checking hasOwnProperty.
     *
     * @param {Object} obj The object to traverse.
     * @param {Function} fn The function to call for each item in the object.
     *
     * @returns {undefined}
     */ exports.objEach = objEach;
        exports.supportsNativeCustomElements = supportsNativeCustomElements;
        exports.isValidNativeCustomElementName = isValidNativeCustomElementName;
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        var ATTR_IGNORE = _constants.ATTR_IGNORE;
        var elementPrototype = window.HTMLElement.prototype;
        exports.elementPrototype = elementPrototype;
        var elementPrototypeContains = elementPrototype.contains;
        function hasOwn(obj, key) {
            return Object.prototype.hasOwnProperty.call(obj, key);
        }
        function camelCase(str) {
            return str.split(/-/g).map(function(str, index) {
                return index === 0 ? str : str[0].toUpperCase() + str.substring(1);
            }).join("");
        }
        function elementContains(source, target) {
            // The document element does not have the contains method in IE.
            if (source === document && !source.contains) return document.head.contains(target) || document.body.contains(target);
            return source.contains ? source.contains(target) : elementPrototypeContains.call(source, target);
        }
        function debounce(fn) {
            var called = false;
            return function() {
                if (!called) {
                    called = true;
                    setTimeout(function() {
                        called = false;
                        fn();
                    }, 1);
                }
            };
        }
        function getClosestIgnoredElement(element) {
            var parent = element;
            // e.g. document doesn't have a function hasAttribute; no need to go further up
            while(parent instanceof Element){
                if (parent.hasAttribute(ATTR_IGNORE)) return parent;
                parent = parent.parentNode;
            }
        }
        function inherit(child, parent, overwrite) {
            var names = Object.getOwnPropertyNames(parent);
            var namesLen = names.length;
            for(var a = 0; a < namesLen; a++){
                var name = names[a];
                if (overwrite || child[name] === undefined) {
                    var desc = Object.getOwnPropertyDescriptor(parent, name);
                    var shouldDefineProps = desc.get || desc.set || !desc.writable || !desc.enumerable || !desc.configurable;
                    if (shouldDefineProps) Object.defineProperty(child, name, desc);
                    else child[name] = parent[name];
                }
            }
            return child;
        }
        function objEach(obj, fn) {
            for(var a in obj)if (hasOwn(obj, a)) fn(obj[a], a);
        }
        function supportsNativeCustomElements() {
            return typeof document.registerElement === "function";
        }
        function isValidNativeCustomElementName(name) {
            return name.indexOf("-") > 0;
        }
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/skatejs/lib/registry.js
(typeof window === "undefined" ? $parcel$global : window).__0ef805164bf5bb28e2bf07e2a899a384 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports,
        "./constants": __09f2943f386e1cc7dddbb02a7eabebab,
        "./globals": __c6912c7a4bb2bfb86ffa5bd4c0e41172,
        "./utils": __39d3c59358ccb9df9e8b99850c06d47d,
        "./constants": __09f2943f386e1cc7dddbb02a7eabebab,
        "./globals": __c6912c7a4bb2bfb86ffa5bd4c0e41172,
        "./utils": __39d3c59358ccb9df9e8b99850c06d47d
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__0ef805164bf5bb28e2bf07e2a899a384");
    define.amd = true;
    (function(factory) {
        if (typeof define === "function" && define.amd) define([
            "exports",
            "module",
            "./constants",
            "./globals",
            "./utils"
        ], factory);
        else if (typeof exports !== "undefined" && typeof module !== "undefined") factory(exports, module, __09f2943f386e1cc7dddbb02a7eabebab, __c6912c7a4bb2bfb86ffa5bd4c0e41172, __39d3c59358ccb9df9e8b99850c06d47d);
    })(function(exports, module, _constants, _globals, _utils) {
        var _interopRequire = function(obj) {
            return obj && obj.__esModule ? obj["default"] : obj;
        };
        var TYPE_ATTRIBUTE = _constants.TYPE_ATTRIBUTE;
        var TYPE_CLASSNAME = _constants.TYPE_CLASSNAME;
        var TYPE_ELEMENT = _constants.TYPE_ELEMENT;
        var globals = _interopRequire(_globals);
        var hasOwn = _utils.hasOwn;
        var isValidNativeCustomElementName = _utils.isValidNativeCustomElementName;
        var supportsNativeCustomElements = _utils.supportsNativeCustomElements;
        /**
     * Returns the class list for the specified element.
     *
     * @param {Element} element The element to get the class list for.
     *
     * @returns {ClassList | Array}
     */ function getClassList(element) {
            var classList = element.classList;
            if (classList) return classList;
            var attrs = element.attributes;
            return attrs["class"] && attrs["class"].nodeValue.split(/\s+/) || [];
        }
        module.exports = {
            clear: function clear() {
                globals.registry = {};
                return this;
            },
            get: function get(id) {
                return hasOwn(globals.registry, id) && globals.registry[id];
            },
            getForElement: function getForElement(element) {
                var attrs = element.attributes;
                var attrsLen = attrs.length;
                var definitions = [];
                var isAttr = attrs.is;
                var isAttrValue = isAttr && (isAttr.value || isAttr.nodeValue);
                // Using localName as fallback for edge cases when processing <object> tag that is used
                // as inteface to NPAPI plugin.
                var tag = (element.tagName || element.localName).toLowerCase();
                var isAttrOrTag = isAttrValue || tag;
                var definition;
                var tagToExtend;
                if (this.isType(isAttrOrTag, TYPE_ELEMENT)) {
                    definition = globals.registry[isAttrOrTag];
                    tagToExtend = definition["extends"];
                    if (isAttrValue) {
                        if (tag === tagToExtend) definitions.push(definition);
                    } else if (!tagToExtend) definitions.push(definition);
                }
                for(var a = 0; a < attrsLen; a++){
                    var attr = attrs[a].nodeName;
                    if (this.isType(attr, TYPE_ATTRIBUTE)) {
                        definition = globals.registry[attr];
                        tagToExtend = definition["extends"];
                        if (!tagToExtend || tag === tagToExtend) definitions.push(definition);
                    }
                }
                var classList = getClassList(element);
                var classListLen = classList.length;
                for(var b = 0; b < classListLen; b++){
                    var className = classList[b];
                    if (this.isType(className, TYPE_CLASSNAME)) {
                        definition = globals.registry[className];
                        tagToExtend = definition["extends"];
                        if (!tagToExtend || tag === tagToExtend) definitions.push(definition);
                    }
                }
                return definitions;
            },
            isType: function isType(id, type) {
                var def = this.get(id);
                return def && def.type === type;
            },
            isNativeCustomElement: function isNativeCustomElement(id) {
                return supportsNativeCustomElements() && this.isType(id, TYPE_ELEMENT) && isValidNativeCustomElementName(id);
            },
            set: function set(id, definition) {
                if (hasOwn(globals.registry, id)) throw new Error('A component definition of type "' + definition.type + '" with the ID of "' + id + '" already exists.');
                globals.registry[id] = definition;
                return this;
            }
        };
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/skatejs/lib/lifecycle.js
(typeof window === "undefined" ? $parcel$global : window).__5a40ff4a2ef12ed8650068b3e3fb0b80 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports,
        "./constants": __09f2943f386e1cc7dddbb02a7eabebab,
        "./data": __dfc7d702d382be77c2900d1d6eb85c20,
        "./mutation-observer": __bdae44341fc76c6906a95201c725f098,
        "./registry": __0ef805164bf5bb28e2bf07e2a899a384,
        "./utils": __39d3c59358ccb9df9e8b99850c06d47d,
        "./constants": __09f2943f386e1cc7dddbb02a7eabebab,
        "./data": __dfc7d702d382be77c2900d1d6eb85c20,
        "./mutation-observer": __bdae44341fc76c6906a95201c725f098,
        "./registry": __0ef805164bf5bb28e2bf07e2a899a384,
        "./utils": __39d3c59358ccb9df9e8b99850c06d47d
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__5a40ff4a2ef12ed8650068b3e3fb0b80");
    define.amd = true;
    (function(factory) {
        if (typeof define === "function" && define.amd) define([
            "exports",
            "./constants",
            "./data",
            "./mutation-observer",
            "./registry",
            "./utils"
        ], factory);
        else if (typeof exports !== "undefined") factory(exports, __09f2943f386e1cc7dddbb02a7eabebab, __dfc7d702d382be77c2900d1d6eb85c20, __bdae44341fc76c6906a95201c725f098, __0ef805164bf5bb28e2bf07e2a899a384, __39d3c59358ccb9df9e8b99850c06d47d);
    })(function(exports, _constants, _data, _mutationObserver, _registry, _utils) {
        var _interopRequire = function(obj) {
            return obj && obj.__esModule ? obj["default"] : obj;
        };
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        var ATTR_IGNORE = _constants.ATTR_IGNORE;
        var data1 = _interopRequire(_data);
        var registry = _interopRequire(_registry);
        var camelCase = _utils.camelCase;
        var elementContains = _utils.elementContains;
        var hasOwn = _utils.hasOwn;
        var inherit = _utils.inherit;
        var objEach = _utils.objEach;
        var Node1 = window.Node;
        //jshint ignore:line
        var elProto = window.HTMLElement.prototype;
        var nativeMatchesSelector = elProto.matches || elProto.msMatchesSelector || elProto.webkitMatchesSelector || elProto.mozMatchesSelector || elProto.oMatchesSelector;
        // Only IE9 has this msMatchesSelector bug, but best to detect it.
        var hasNativeMatchesSelectorDetattachedBug = !nativeMatchesSelector.call(document.createElement("div"), "div");
        var matchesSelector = function matchesSelector(element, selector) {
            if (hasNativeMatchesSelectorDetattachedBug) {
                var clone = element.cloneNode();
                document.createElement("div").appendChild(clone);
                return nativeMatchesSelector.call(clone, selector);
            }
            return nativeMatchesSelector.call(element, selector);
        };
        // Edge has a bug where oldValue is sent as null instead of the true oldValue
        // when an element attribute is removed. Bug raised at
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7711883/
        var needsAttributeOldValueCaching = /Edge/.test(navigator.userAgent);
        /**
     * Parses an event definition and returns information about it.
     *
     * @param {String} e The event to parse.
     *
     * @returns {Object]}
     */ function parseEvent(e) {
            var parts = e.split(" ");
            return {
                name: parts.shift(),
                delegate: parts.join(" ")
            };
        }
        /**
     * Sets the defined attributes to their default values, if specified.
     *
     * @param {Element} target The web component element.
     * @param {Object} component The web component definition.
     *
     * @returns {undefined}
     */ function initAttributes(target, component) {
            var componentAttributes = component.attributes;
            if (typeof componentAttributes !== "object") return;
            for(var attribute in componentAttributes)if (hasOwn(componentAttributes, attribute) && hasOwn(componentAttributes[attribute], "value") && !target.hasAttribute(attribute)) {
                var value1 = componentAttributes[attribute].value;
                value1 = typeof value1 === "function" ? value1(target) : value1;
                target.setAttribute(attribute, value1);
            }
        }
        /**
     * Defines a property that proxies the specified attribute.
     *
     * @param {Element} target The web component element.
     * @param {String} attribute The attribute name to proxy.
     *
     * @returns {undefined}
     */ function defineAttributeProperty(target, attribute, property) {
            Object.defineProperty(target, property, {
                get: function get() {
                    return this.getAttribute(attribute);
                },
                set: function set(value1) {
                    if (value1 === undefined) this.removeAttribute(attribute);
                    else this.setAttribute(attribute, value1);
                }
            });
        }
        /**
     * Adds links from attributes to properties.
     *
     * @param {Element} target The web component element.
     * @param {Object} component The web component definition.
     *
     * @returns {undefined}
     */ function addAttributeToPropertyLinks(target, component) {
            var componentAttributes = component.attributes;
            if (typeof componentAttributes !== "object") return;
            for(var attribute in componentAttributes){
                var property = camelCase(attribute);
                if (hasOwn(componentAttributes, attribute) && !hasOwn(target, property)) defineAttributeProperty(target, attribute, property);
            }
        }
        function triggerAttributeChanged(target, component, mutationData) {
            var callback;
            var type;
            var name = mutationData.name;
            var newValue = mutationData.newValue;
            var cachedAttributeOldValues;
            if (needsAttributeOldValueCaching) cachedAttributeOldValues = data1(target, "cachedAttributeOldValues");
            // Read the old attribute value from cache if needed, otherwise use native oldValue
            var oldValue = needsAttributeOldValueCaching && hasOwn(cachedAttributeOldValues, name) ? cachedAttributeOldValues[name] : mutationData.oldValue;
            var newValueIsString = typeof newValue === "string";
            var oldValueIsString = typeof oldValue === "string";
            var attrs = component.attributes;
            var specific = attrs && attrs[name];
            if (!oldValueIsString && newValueIsString) type = "created";
            else if (oldValueIsString && newValueIsString) type = "updated";
            else if (oldValueIsString && !newValueIsString) type = "removed";
            if (needsAttributeOldValueCaching) {
                if (type === "removed") delete cachedAttributeOldValues[name];
                else cachedAttributeOldValues[name] = newValue;
            }
            if (specific && typeof specific[type] === "function") callback = specific[type];
            else if (specific && typeof specific.fallback === "function") callback = specific.fallback;
            else if (typeof specific === "function") callback = specific;
            else if (typeof attrs === "function") callback = attrs;
            // Ensure values are null if undefined.
            newValue = newValue === undefined ? null : newValue;
            oldValue = oldValue === undefined ? null : oldValue;
            // There may still not be a callback.
            if (callback) callback(target, {
                type: type,
                name: name,
                newValue: newValue,
                oldValue: oldValue
            });
        }
        function triggerAttributesCreated(target, component) {
            var a;
            var attrs = target.attributes;
            var attrsCopy = [];
            var attrsLen = attrs.length;
            for(a = 0; a < attrsLen; a++)attrsCopy.push(attrs[a]);
            // In default web components, attribute changes aren't triggered for
            // attributes that already exist on an element when it is bound. This sucks
            // when you want to reuse and separate code for attributes away from your
            // lifecycle callbacks. Skate will initialise each attribute by calling the
            // created callback for the attributes that already exist on the element.
            for(a = 0; a < attrsLen; a++){
                var attr = attrsCopy[a];
                triggerAttributeChanged(target, component, {
                    name: attr.nodeName,
                    newValue: attr.value || attr.nodeValue
                });
            }
        }
        function addAttributeListeners(target, component) {
            var attrs = target.attributes;
            if (!component.attributes || registry.isNativeCustomElement(component.id)) return;
            var observer = new window.MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    var name = mutation.attributeName;
                    var attr = attrs[name];
                    triggerAttributeChanged(target, component, {
                        name: name,
                        newValue: attr && (attr.value || attr.nodeValue),
                        oldValue: mutation.oldValue
                    });
                });
            });
            observer.observe(target, {
                attributes: true,
                attributeOldValue: true
            });
        }
        /**
     * Binds event listeners for the specified event handlers.
     *
     * @param {Element} target The component element.
     * @param {Object} component The component data.
     *
     * @returns {undefined}
     */ function addEventListeners(target, component) {
            if (typeof component.events !== "object") return;
            function makeHandler(handler, delegate) {
                return function(e) {
                    // If we're not delegating, trigger directly on the component element.
                    if (!delegate) return handler(target, e, target);
                    // If we're delegating, but the target doesn't match, then we've have
                    // to go up the tree until we find a matching ancestor or stop at the
                    // component element, or document. If a matching ancestor is found, the
                    // handler is triggered on it.
                    var current = e.target;
                    while(current && current !== document && current !== target.parentNode){
                        if (matchesSelector(current, delegate)) return handler(target, e, current);
                        current = current.parentNode;
                    }
                };
            }
            objEach(component.events, function(handler, name) {
                var evt = parseEvent(name);
                var useCapture = !!evt.delegate && (evt.name === "blur" || evt.name === "focus");
                target.addEventListener(evt.name, makeHandler(handler, evt.delegate), useCapture);
            });
        }
        /**
     * Triggers the created lifecycle callback.
     *
     * @param {Element} target The component element.
     * @param {Object} component The component data.
     *
     * @returns {undefined}
     */ function triggerCreated(target, component) {
            var targetData = data1(target, component.id);
            if (targetData.created) return;
            targetData.created = true;
            // TODO: This doesn't need to happen if using native.
            inherit(target, component.prototype, true);
            // We use the unresolved / resolved attributes to flag whether or not the
            // element has been templated or not.
            if (component.template && !target.hasAttribute(component.resolvedAttribute)) component.template(target);
            target.removeAttribute(component.unresolvedAttribute);
            target.setAttribute(component.resolvedAttribute, "");
            addEventListeners(target, component);
            addAttributeListeners(target, component);
            addAttributeToPropertyLinks(target, component);
            initAttributes(target, component);
            triggerAttributesCreated(target, component);
            if (component.created) component.created(target);
        }
        /**
     * Triggers the attached lifecycle callback.
     *
     * @param {Element} target The component element.
     * @param {Object} component The component data.
     *
     * @returns {undefined}
     */ function triggerAttached(target, component) {
            var targetData = data1(target, component.id);
            if (targetData.attached) return;
            if (!elementContains(document, target)) return;
            targetData.attached = true;
            if (component.attached) component.attached(target);
            targetData.detached = false;
        }
        /**
     * Triggers the detached lifecycle callback.
     *
     * @param {Element} target The component element.
     * @param {Object} component The component data.
     *
     * @returns {undefined}
     */ function triggerDetached(target, component) {
            var targetData = data1(target, component.id);
            if (targetData.detached) return;
            targetData.detached = true;
            if (component.detached) component.detached(target);
            targetData.attached = false;
        }
        /**
     * Triggers the entire element lifecycle if it's not being ignored.
     *
     * @param {Element} target The component element.
     * @param {Object} component The component data.
     *
     * @returns {undefined}
     */ function triggerLifecycle(target, component) {
            triggerCreated(target, component);
            triggerAttached(target, component);
        }
        /**
     * Initialises a set of elements.
     *
     * @param {DOMNodeList | Array} elements A traversable set of elements.
     *
     * @returns {undefined}
     */ function initElements(elements) {
            // [CATION] Don't cache elements length! Components initialization could append nodes
            // as siblings (see label's element behaviour for example) and this could lead to problems with
            // components placed at the end of processing childNodes because they will change they index
            // position and get out of cached value range.
            for(var a = 0; a < elements.length; a++){
                var element = elements[a];
                if (element.nodeType !== Node1.ELEMENT_NODE || element.attributes[ATTR_IGNORE]) continue;
                var currentNodeDefinitions = registry.getForElement(element);
                var currentNodeDefinitionsLength = currentNodeDefinitions.length;
                for(var b = 0; b < currentNodeDefinitionsLength; b++)triggerLifecycle(element, currentNodeDefinitions[b]);
                // When <object> tag is used to expose NPAPI api to js may have different behaviour then other
                // tags. One of those differences is that it's childNodes can be undefined.
                var elementChildNodes = element.childNodes || [];
                var elementChildNodesLen = elementChildNodes.length;
                if (elementChildNodesLen) initElements(elementChildNodes);
            }
        }
        /**
     * Triggers the remove lifecycle callback on all of the elements.
     *
     * @param {DOMNodeList} elements The elements to trigger the remove lifecycle
     * callback on.
     *
     * @returns {undefined}
     */ function removeElements(elements) {
            // Don't cache `childNodes` length. For more info see description in `initElements` function.
            for(var a = 0; a < elements.length; a++){
                var element = elements[a];
                if (element.nodeType !== Node1.ELEMENT_NODE) continue;
                removeElements(element.childNodes);
                var definitions = registry.getForElement(element);
                var definitionsLen = definitions.length;
                for(var b = 0; b < definitionsLen; b++)triggerDetached(element, definitions[b]);
            }
        }
        exports.initElements = initElements;
        exports.removeElements = removeElements;
        exports.triggerAttached = triggerAttached;
        exports.triggerAttributeChanged = triggerAttributeChanged;
        exports.triggerCreated = triggerCreated;
        exports.triggerDetached = triggerDetached;
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/skatejs/lib/fix-ie-innerhtml.js
(typeof window === "undefined" ? $parcel$global : window).__93406ff333c4a8a9a0d28c5ce7af50ca = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__93406ff333c4a8a9a0d28c5ce7af50ca");
    define.amd = true;
    (function(factory) {
        if (typeof define === "function" && define.amd) define([
            "exports"
        ], factory);
        else if (typeof exports !== "undefined") factory(exports);
    })(function(exports) {
        var isIeUntil10 = /MSIE/.test(navigator.userAgent);
        var isIe11 = /Trident/.test(navigator.userAgent);
        var isIe = isIeUntil10 || isIe11;
        var elementPrototype = window.HTMLElement.prototype;
        // ! This walkTree method differs from the implementation in ../../utils/walk-tree
        // It invokes the callback only for the children, not the passed node and the second parameter to the callback is the parent node
        function walkTree(node, cb) {
            var childNodes = node.childNodes;
            if (!childNodes) return;
            var childNodesLen = childNodes.length;
            for(var a = 0; a < childNodesLen; a++){
                var childNode = childNodes[a];
                cb(childNode, node);
                walkTree(childNode, cb);
            }
        }
        function fixInnerHTML() {
            var originalInnerHTML = Object.getOwnPropertyDescriptor(elementPrototype, "innerHTML");
            var get = function get() {
                return originalInnerHTML.get.call(this);
            };
            get._hasBeenEnhanced = true;
            // This redefines the innerHTML property so that we can ensure that events
            // are properly triggered.
            Object.defineProperty(elementPrototype, "innerHTML", {
                get: get,
                set: function set(html) {
                    walkTree(this, function(node, parentNode) {
                        var mutationEvent = document.createEvent("MutationEvent");
                        mutationEvent.initMutationEvent("DOMNodeRemoved", true, false, parentNode, null, null, null, null);
                        node.dispatchEvent(mutationEvent);
                    });
                    originalInnerHTML.set.call(this, html);
                }
            });
        }
        if (isIe) {
            // IE 9-11
            var propertyDescriptor = Object.getOwnPropertyDescriptor(elementPrototype, "innerHTML");
            var hasBeenEnhanced = !!propertyDescriptor && propertyDescriptor.get._hasBeenEnhanced;
            if (!hasBeenEnhanced) {
                if (isIe11) // IE11's native MutationObserver needs some help as well :()
                window.MutationObserver = window.JsMutationObserver || window.MutationObserver;
                fixInnerHTML();
            }
        }
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/skatejs/lib/document-observer.js
(typeof window === "undefined" ? $parcel$global : window).__b9ad4b6efd6d34325824d4b388267d22 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports,
        "./globals": __c6912c7a4bb2bfb86ffa5bd4c0e41172,
        "./lifecycle": __5a40ff4a2ef12ed8650068b3e3fb0b80,
        "./mutation-observer": __bdae44341fc76c6906a95201c725f098,
        "./fix-ie-innerhtml": __93406ff333c4a8a9a0d28c5ce7af50ca,
        "./utils": __39d3c59358ccb9df9e8b99850c06d47d,
        "./globals": __c6912c7a4bb2bfb86ffa5bd4c0e41172,
        "./lifecycle": __5a40ff4a2ef12ed8650068b3e3fb0b80,
        "./mutation-observer": __bdae44341fc76c6906a95201c725f098,
        "./fix-ie-innerhtml": __93406ff333c4a8a9a0d28c5ce7af50ca,
        "./utils": __39d3c59358ccb9df9e8b99850c06d47d
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__b9ad4b6efd6d34325824d4b388267d22");
    define.amd = true;
    (function(factory) {
        if (typeof define === "function" && define.amd) define([
            "exports",
            "module",
            "./globals",
            "./lifecycle",
            "./mutation-observer",
            "./fix-ie-innerhtml",
            "./utils"
        ], factory);
        else if (typeof exports !== "undefined" && typeof module !== "undefined") factory(exports, module, __c6912c7a4bb2bfb86ffa5bd4c0e41172, __5a40ff4a2ef12ed8650068b3e3fb0b80, __bdae44341fc76c6906a95201c725f098, __93406ff333c4a8a9a0d28c5ce7af50ca, __39d3c59358ccb9df9e8b99850c06d47d);
    })(function(exports, module, _globals, _lifecycle, _mutationObserver, _fixIeInnerhtml, _utils) {
        var _interopRequire = function(obj) {
            return obj && obj.__esModule ? obj["default"] : obj;
        };
        var globals = _interopRequire(_globals);
        var initElements = _lifecycle.initElements;
        var removeElements = _lifecycle.removeElements;
        var getClosestIgnoredElement = _utils.getClosestIgnoredElement;
        /**
     * The document observer handler.
     *
     * @param {Array} mutations The mutations to handle.
     *
     * @returns {undefined}
     */ function documentObserverHandler(mutations) {
            var mutationsLen = mutations.length;
            for(var a = 0; a < mutationsLen; a++){
                var mutation = mutations[a];
                var addedNodes = mutation.addedNodes;
                var removedNodes = mutation.removedNodes;
                // Since siblings are batched together, we check the first node's parent
                // node to see if it is ignored. If it is then we don't process any added
                // nodes. This prevents having to check every node.
                if (addedNodes && addedNodes.length && !getClosestIgnoredElement(addedNodes[0].parentNode)) initElements(addedNodes);
                // We can't check batched nodes here because they won't have a parent node.
                if (removedNodes && removedNodes.length) removeElements(removedNodes);
            }
        }
        /**
     * Creates a new mutation observer for listening to Skate definitions for the
     * document.
     *
     * @param {Element} root The element to observe.
     *
     * @returns {MutationObserver}
     */ function createDocumentObserver() {
            var observer = new window.MutationObserver(documentObserverHandler);
            // Observe after the DOM content has loaded.
            observer.observe(document, {
                childList: true,
                subtree: true
            });
            return observer;
        }
        module.exports = {
            register: function register(fixIe) {
                // IE has issues with reporting removedNodes correctly. See the polyfill for
                // details. If we fix IE, we must also re-define the document observer.
                if (fixIe) this.unregister();
                if (!globals.observer) globals.observer = createDocumentObserver();
                return this;
            },
            unregister: function unregister() {
                if (globals.observer) {
                    globals.observer.disconnect();
                    globals.observer = undefined;
                }
                return this;
            }
        };
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/skatejs/lib/skate.js
(typeof window === "undefined" ? $parcel$global : window).__8548ccf5d6767d1d4e6633309de41309 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports,
        "./constants": __09f2943f386e1cc7dddbb02a7eabebab,
        "./document-observer": __b9ad4b6efd6d34325824d4b388267d22,
        "./lifecycle": __5a40ff4a2ef12ed8650068b3e3fb0b80,
        "./registry": __0ef805164bf5bb28e2bf07e2a899a384,
        "./utils": __39d3c59358ccb9df9e8b99850c06d47d,
        "./version": __3ac87b9829a39b9fd554c8a7b3022630,
        "./constants": __09f2943f386e1cc7dddbb02a7eabebab,
        "./document-observer": __b9ad4b6efd6d34325824d4b388267d22,
        "./lifecycle": __5a40ff4a2ef12ed8650068b3e3fb0b80,
        "./registry": __0ef805164bf5bb28e2bf07e2a899a384,
        "./utils": __39d3c59358ccb9df9e8b99850c06d47d,
        "./version": __3ac87b9829a39b9fd554c8a7b3022630
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__8548ccf5d6767d1d4e6633309de41309");
    define.amd = true;
    (function(factory) {
        if (typeof define === "function" && define.amd) define([
            "exports",
            "module",
            "./constants",
            "./document-observer",
            "./lifecycle",
            "./registry",
            "./utils",
            "./version"
        ], factory);
        else if (typeof exports !== "undefined" && typeof module !== "undefined") factory(exports, module, __09f2943f386e1cc7dddbb02a7eabebab, __b9ad4b6efd6d34325824d4b388267d22, __5a40ff4a2ef12ed8650068b3e3fb0b80, __0ef805164bf5bb28e2bf07e2a899a384, __39d3c59358ccb9df9e8b99850c06d47d, __3ac87b9829a39b9fd554c8a7b3022630);
    })(function(exports, module, _constants, _documentObserver, _lifecycle, _registry, _utils, _version) {
        var _interopRequire = function(obj) {
            return obj && obj.__esModule ? obj["default"] : obj;
        };
        var TYPE_ATTRIBUTE = _constants.TYPE_ATTRIBUTE;
        var TYPE_CLASSNAME = _constants.TYPE_CLASSNAME;
        var TYPE_ELEMENT = _constants.TYPE_ELEMENT;
        var documentObserver = _interopRequire(_documentObserver);
        var triggerCreated = _lifecycle.triggerCreated;
        var triggerAttached = _lifecycle.triggerAttached;
        var triggerDetached = _lifecycle.triggerDetached;
        var triggerAttributeChanged = _lifecycle.triggerAttributeChanged;
        var initElements = _lifecycle.initElements;
        var registry = _interopRequire(_registry);
        var debounce = _utils.debounce;
        var inherit = _utils.inherit;
        var version = _interopRequire(_version);
        var HTMLElement = window.HTMLElement; //jshint ignore:line
        // IE <= 10 can fire "interactive" too early (#243).
        var isOldIE = !!document.attachEvent; // attachEvent was removed in IE11.
        function isReady() {
            if (isOldIE) return document.readyState === "complete";
            else return document.readyState === "interactive" || document.readyState === "complete";
        }
        /**
     * Initialises all valid elements in the document. Ensures that it does not
     * happen more than once in the same execution, and that it happens after the DOM is ready.
     *
     * @returns {undefined}
     */ var initDocument = debounce(function() {
            var initialiseSkateElementsOnDomLoad = function initialiseSkateElementsOnDomLoad() {
                initElements(document.documentElement.childNodes);
            };
            if (isReady()) initialiseSkateElementsOnDomLoad();
            else if (isOldIE) window.addEventListener("load", initialiseSkateElementsOnDomLoad);
            else document.addEventListener("DOMContentLoaded", initialiseSkateElementsOnDomLoad);
        });
        /**
     * Creates a constructor for the specified definition.
     *
     * @param {Object} definition The definition information to use for generating the constructor.
     *
     * @returns {Function} The element constructor.
     */ function makeElementConstructor(definition) {
            function CustomElement() {
                var element;
                var tagToExtend = definition["extends"];
                var definitionId = definition.id;
                if (tagToExtend) {
                    element = document.createElement(tagToExtend);
                    element.setAttribute("is", definitionId);
                } else element = document.createElement(definitionId);
                // Ensure the definition prototype is up to date with the element's
                // prototype. This ensures that overwriting the element prototype still
                // works.
                definition.prototype = CustomElement.prototype;
                // If they use the constructor we don't have to wait until it's attached.
                triggerCreated(element, definition);
                return element;
            }
            // This allows modifications to the element prototype propagate to the
            // definition prototype.
            CustomElement.prototype = definition.prototype;
            return CustomElement;
        }
        // Public API
        // ----------
        /**
     * Creates a listener for the specified definition.
     *
     * @param {String} id The ID of the definition.
     * @param {Object | Function} definition The definition definition.
     *
     * @returns {Function} Constructor that returns a custom element.
     */ function skate(id, definition) {
            // Just in case the definition is shared, we duplicate it so that internal
            // modifications to the original aren't shared.
            definition = inherit({}, definition);
            definition = inherit(definition, skate.defaults);
            definition.id = id;
            registry.set(id, definition);
            if (registry.isNativeCustomElement(id)) {
                var elementPrototype = definition["extends"] ? document.createElement(definition["extends"]).constructor.prototype : HTMLElement.prototype;
                if (!elementPrototype.isPrototypeOf(definition.prototype)) definition.prototype = inherit(Object.create(elementPrototype), definition.prototype, true);
                var options = {
                    prototype: inherit(definition.prototype, {
                        createdCallback: function createdCallback() {
                            triggerCreated(this, definition);
                        },
                        attachedCallback: function attachedCallback() {
                            triggerAttached(this, definition);
                        },
                        detachedCallback: function detachedCallback() {
                            triggerDetached(this, definition);
                        },
                        attributeChangedCallback: function attributeChangedCallback(name, oldValue, newValue) {
                            triggerAttributeChanged(this, definition, {
                                name: name,
                                oldValue: oldValue,
                                newValue: newValue
                            });
                        }
                    })
                };
                if (definition["extends"]) options["extends"] = definition["extends"];
                return document.registerElement(id, options);
            }
            initDocument();
            documentObserver.register(!!definition.detached);
            if (registry.isType(id, TYPE_ELEMENT)) return makeElementConstructor(definition);
        }
        /**
     * Synchronously initialises the specified element or elements and descendants.
     *
     * @param {Mixed} nodes The node, or nodes to initialise. Can be anything:
     *                      jQuery, DOMNodeList, DOMNode, selector etc.
     *
     * @returns {skate}
     */ skate.init = function(nodes) {
            var nodesToUse = nodes;
            if (!nodes) return nodes;
            if (typeof nodes === "string") nodesToUse = nodes = document.querySelectorAll(nodes);
            else if (nodes instanceof HTMLElement) nodesToUse = [
                nodes
            ];
            initElements(nodesToUse);
            return nodes;
        };
        // Restriction type constants.
        skate.type = {
            ATTRIBUTE: TYPE_ATTRIBUTE,
            CLASSNAME: TYPE_CLASSNAME,
            ELEMENT: TYPE_ELEMENT
        };
        // Makes checking the version easy when debugging.
        skate.version = version;
        /**
     * The default options for a definition.
     *
     * @var {Object}
     */ skate.defaults = {
            // Attribute lifecycle callback or callbacks.
            attributes: undefined,
            // The events to manage the binding and unbinding of during the definition's
            // lifecycle.
            events: undefined,
            // Restricts a particular definition to binding explicitly to an element with
            // a tag name that matches the specified value.
            "extends": undefined,
            // The ID of the definition. This is automatically set in the `skate()`
            // function.
            id: "",
            // Properties and methods to add to each element.
            prototype: {},
            // The attribute name to add after calling the created() callback.
            resolvedAttribute: "resolved",
            // The template to replace the content of the element with.
            template: undefined,
            // The type of bindings to allow.
            type: TYPE_ELEMENT,
            // The attribute name to remove after calling the created() callback.
            unresolvedAttribute: "unresolved"
        };
        // Exporting
        // ---------
        var previousSkate = window.skate;
        skate.noConflict = function() {
            window.skate = previousSkate;
            return skate;
        };
        // Global
        window.skate = skate;
        // ES6
        module.exports = skate;
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/skate.js
(typeof window === "undefined" ? $parcel$global : window).__0ac9a2c09f995a9c0a478af8742f59b7 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _skatejs = __8548ccf5d6767d1d4e6633309de41309;
    var _skatejs2 = _interopRequireDefault(_skatejs);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var auiSkate = _skatejs2.default.noConflict();
    exports.default = auiSkate;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/animation.js
(typeof window === "undefined" ? $parcel$global : window).__6debdf74a4da8ac8391a98223e1bae21 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    /**
   * Force a re-compute of the style of an element.
   *
   * This is useful for CSS transitions and animations that need computed style changes to occur.
   * CSS transitions will fire when the computed value of the property they are transitioning changes.
   * This may not occur if the style changes get batched into one style change event by the browser.
   * We can force the browser to recognise the two different computed values by calling this function when we want it
   * to recompute the styles.
   *
   * For example, consider a transition on the opacity property.
   *
   * With recomputeStyle:
   * $parent.append($el); //opacity=0
   * recomputeStyle($el);
   * $el.addClass('visible'); //opacity=1
   * //Browser calculates value of opacity=0, and then transitions it to opacity=1
   *
   * Without recomputeStyle:
   * $parent.append($el); //opacity=0
   * $el.addClass('visible'); //opacity=1
   * //Browser calculates value of opacity=1 but no transition
   *
   * @param el The DOM or jQuery element for which style should be recomputed
   */ Object.defineProperty(exports, "__esModule", {
        value: true
    });
    function recomputeStyle(el) {
        el = el.jquery ? el[0] : el;
        window.getComputedStyle(el, null).getPropertyValue("left");
    }
    exports.recomputeStyle = recomputeStyle;
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/escape-html.js
(typeof window === "undefined" ? $parcel$global : window).__48697fd7ae587e40e44fef53ab10460c = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function escapeHtml(str) {
        return str.replace(/[&"'<>`]/g, function(str) {
            var special = {
                "<": "&lt;",
                ">": "&gt;",
                "&": "&amp;",
                "'": "&#39;",
                "`": "&#96;"
            };
            if (typeof special[str] === "string") return special[str];
            return "&quot;";
        });
    }
    (0, _globalize2.default)("escapeHtml", escapeHtml);
    exports.default = escapeHtml;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/template.js
(typeof window === "undefined" ? $parcel$global : window).__43d4585c6a21591b4ceac1b326c09405 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _escapeHtml = __48697fd7ae587e40e44fef53ab10460c;
    var _escapeHtml2 = _interopRequireDefault(_escapeHtml);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Creates an object with methods for template support.
   *
   * See <a href="http://confluence.atlassian.com/display/AUI/AJS.template">CAC Documentation</a>.
   *
   * @constructor
   * @class template
   * @namespace AJS
   */ var template = function($) {
        var tokenRegex = /\{([^\}]+)\}/g; // matches "{xxxxx}"
        var objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g; // matches ".xxxxx" or "["xxxxx"]" to run over object properties
        // internal function
        // parses "{xxxxx}" and returns actual value from the given object that matches the expression
        var replacer = function replacer(all, key, obj, isHTML) {
            var res = obj;
            key.replace(objNotationRegex, function(all, name, quote, quotedName, isFunc) {
                name = name || quotedName;
                if (res) {
                    if (name + ":html" in res) {
                        res = res[name + ":html"];
                        isHTML = true;
                    } else if (name in res) res = res[name];
                    if (isFunc && typeof res === "function") res = res();
                }
            });
            // if not found restore original value
            if (res == null || res === obj) res = all;
            res = String(res);
            if (!isHTML) res = T.escape(res);
            return res;
        };
        /**
       * Replaces tokens in the template with corresponding values without HTML escaping
       * @method fillHtml
       * @param obj {Object} to populate the template with
       * @return {Object} the template object
       */ var fillHtml = function fillHtml(obj) {
            this.template = this.template.replace(tokenRegex, function(all, key) {
                return replacer(all, key, obj, true);
            });
            return this;
        };
        /**
       * Replaces tokens in the template with corresponding values with HTML escaping
       * @method fill
       * @param obj {Object} to populate the template with
       * @return {Object} the template object
       */ var fill = function fill(obj) {
            this.template = this.template.replace(tokenRegex, function(all, key) {
                return replacer(all, key, obj);
            });
            return this;
        };
        /**
       * Returns the current templated string.
       * @method toString
       * @return {String} the current template
       */ var toString = function toString() {
            return this.template;
        };
        // internal function
        var T = function T(s) {
            function res() {
                return res.template;
            }
            /**
           * The current templated string
           * @property template
           */ res.template = String(s);
            res.toString = res.valueOf = toString;
            res.fill = fill;
            res.fillHtml = fillHtml;
            return res;
        };
        var cache = {};
        var count = [];
        var findScripts = function findScripts(title) {
            return $("script").filter(function() {
                return this.getAttribute("title") === title;
            });
        };
        // returns template taken form the script tag with given title. Type agnostic, but better put type="text/x-template"
        T.load = function(title) {
            title = String(title);
            if (!cache.hasOwnProperty(title)) {
                if (count.length >= 1e3) delete cache[count.shift()]; // enforce maximum cache size
                count.push(title);
                cache[title] = findScripts(title)[0].text;
            }
            return this(cache[title]);
        };
        // escape HTML dangerous characters
        T.escape = _escapeHtml2.default;
        return T;
    }(_jquery2.default);
    (0, _globalize2.default)("template", template);
    exports.default = template;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js-vendor/underscorejs/underscore.js
(typeof window === "undefined" ? $parcel$global : window).__81a34191ad3e61fcf21096871eebec4b = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__81a34191ad3e61fcf21096871eebec4b");
    define.amd = true;
    //     Underscore.js 1.5.2
    //     http://underscorejs.org
    //     (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    //     Underscore may be freely distributed under the MIT license.
    (function() {
        // Baseline setup
        // --------------
        // Establish the root object, `window` in the browser, or `exports` on the server.
        var root = this;
        // Save the previous value of the `_` variable.
        var previousUnderscore = root._;
        // Establish the object that gets returned to break out of a loop iteration.
        var breaker = {};
        // Save bytes in the minified (but not gzipped) version:
        var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
        // Create quick reference variables for speed access to core prototypes.
        var push = ArrayProto.push, slice = ArrayProto.slice, concat = ArrayProto.concat, toString = ObjProto.toString, hasOwnProperty = ObjProto.hasOwnProperty;
        // All **ECMAScript 5** native function implementations that we hope to use
        // are declared here.
        var nativeForEach = ArrayProto.forEach, nativeMap = ArrayProto.map, nativeReduce = ArrayProto.reduce, nativeReduceRight = ArrayProto.reduceRight, nativeFilter = ArrayProto.filter, nativeEvery = ArrayProto.every, nativeSome = ArrayProto.some, nativeIndexOf = ArrayProto.indexOf, nativeLastIndexOf = ArrayProto.lastIndexOf, nativeIsArray = Array.isArray, nativeKeys = Object.keys, nativeBind = FuncProto.bind;
        // Create a safe reference to the Underscore object for use below.
        var _ = function(obj) {
            if (obj instanceof _) return obj;
            if (!(this instanceof _)) return new _(obj);
            this._wrapped = obj;
        };
        // Export the Underscore object for **Node.js**, with
        // backwards-compatibility for the old `require()` API. If we're in
        // the browser, add `_` as a global object via a string identifier,
        // for Closure Compiler "advanced" mode.
        if (typeof exports !== "undefined") {
            if (typeof module !== "undefined" && module.exports) exports = module.exports = _;
            exports._ = _;
        } else root._ = _;
        // Current version.
        _.VERSION = "1.5.2";
        // Collection Functions
        // --------------------
        // The cornerstone, an `each` implementation, aka `forEach`.
        // Handles objects with the built-in `forEach`, arrays, and raw objects.
        // Delegates to **ECMAScript 5**'s native `forEach` if available.
        var each = _.each = _.forEach = function(obj, iterator, context) {
            if (obj == null) return;
            if (nativeForEach && obj.forEach === nativeForEach) obj.forEach(iterator, context);
            else if (obj.length === +obj.length) for(var i = 0, length = obj.length; i < length; i++){
                if (iterator.call(context, obj[i], i, obj) === breaker) return;
            }
            else {
                var keys = _.keys(obj);
                for(var i = 0, length = keys.length; i < length; i++){
                    if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker) return;
                }
            }
        };
        // Return the results of applying the iterator to each element.
        // Delegates to **ECMAScript 5**'s native `map` if available.
        _.map = _.collect = function(obj, iterator, context) {
            var results = [];
            if (obj == null) return results;
            if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
            each(obj, function(value1, index, list) {
                results.push(iterator.call(context, value1, index, list));
            });
            return results;
        };
        var reduceError = "Reduce of empty array with no initial value";
        // **Reduce** builds up a single result from a list of values, aka `inject`,
        // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
        _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {
            var initial = arguments.length > 2;
            if (obj == null) obj = [];
            if (nativeReduce && obj.reduce === nativeReduce) {
                if (context) iterator = _.bind(iterator, context);
                return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
            }
            each(obj, function(value1, index, list) {
                if (!initial) {
                    memo = value1;
                    initial = true;
                } else memo = iterator.call(context, memo, value1, index, list);
            });
            if (!initial) throw new TypeError(reduceError);
            return memo;
        };
        // The right-associative version of reduce, also known as `foldr`.
        // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
        _.reduceRight = _.foldr = function(obj, iterator, memo, context) {
            var initial = arguments.length > 2;
            if (obj == null) obj = [];
            if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
                if (context) iterator = _.bind(iterator, context);
                return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
            }
            var length = obj.length;
            if (length !== +length) {
                var keys = _.keys(obj);
                length = keys.length;
            }
            each(obj, function(value1, index, list) {
                index = keys ? keys[--length] : --length;
                if (!initial) {
                    memo = obj[index];
                    initial = true;
                } else memo = iterator.call(context, memo, obj[index], index, list);
            });
            if (!initial) throw new TypeError(reduceError);
            return memo;
        };
        // Return the first value which passes a truth test. Aliased as `detect`.
        _.find = _.detect = function(obj, iterator, context) {
            var result;
            any(obj, function(value1, index, list) {
                if (iterator.call(context, value1, index, list)) {
                    result = value1;
                    return true;
                }
            });
            return result;
        };
        // Return all the elements that pass a truth test.
        // Delegates to **ECMAScript 5**'s native `filter` if available.
        // Aliased as `select`.
        _.filter = _.select = function(obj, iterator, context) {
            var results = [];
            if (obj == null) return results;
            if (nativeFilter && obj.filter === nativeFilter) return obj.filter(iterator, context);
            each(obj, function(value1, index, list) {
                if (iterator.call(context, value1, index, list)) results.push(value1);
            });
            return results;
        };
        // Return all the elements for which a truth test fails.
        _.reject = function(obj, iterator, context) {
            return _.filter(obj, function(value1, index, list) {
                return !iterator.call(context, value1, index, list);
            }, context);
        };
        // Determine whether all of the elements match a truth test.
        // Delegates to **ECMAScript 5**'s native `every` if available.
        // Aliased as `all`.
        _.every = _.all = function(obj, iterator, context) {
            iterator || (iterator = _.identity);
            var result = true;
            if (obj == null) return result;
            if (nativeEvery && obj.every === nativeEvery) return obj.every(iterator, context);
            each(obj, function(value1, index, list) {
                if (!(result = result && iterator.call(context, value1, index, list))) return breaker;
            });
            return !!result;
        };
        // Determine if at least one element in the object matches a truth test.
        // Delegates to **ECMAScript 5**'s native `some` if available.
        // Aliased as `any`.
        var any = _.some = _.any = function(obj, iterator, context) {
            iterator || (iterator = _.identity);
            var result = false;
            if (obj == null) return result;
            if (nativeSome && obj.some === nativeSome) return obj.some(iterator, context);
            each(obj, function(value1, index, list) {
                if (result || (result = iterator.call(context, value1, index, list))) return breaker;
            });
            return !!result;
        };
        // Determine if the array or object contains a given value (using `===`).
        // Aliased as `include`.
        _.contains = _.include = function(obj, target) {
            if (obj == null) return false;
            if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
            return any(obj, function(value1) {
                return value1 === target;
            });
        };
        // Invoke a method (with arguments) on every item in a collection.
        _.invoke = function(obj, method) {
            var args = slice.call(arguments, 2);
            var isFunc = _.isFunction(method);
            return _.map(obj, function(value1) {
                return (isFunc ? method : value1[method]).apply(value1, args);
            });
        };
        // Convenience version of a common use case of `map`: fetching a property.
        _.pluck = function(obj, key) {
            return _.map(obj, function(value1) {
                return value1[key];
            });
        };
        // Convenience version of a common use case of `filter`: selecting only objects
        // containing specific `key:value` pairs.
        _.where = function(obj, attrs, first) {
            if (_.isEmpty(attrs)) return first ? void 0 : [];
            return _[first ? "find" : "filter"](obj, function(value1) {
                for(var key in attrs){
                    if (attrs[key] !== value1[key]) return false;
                }
                return true;
            });
        };
        // Convenience version of a common use case of `find`: getting the first object
        // containing specific `key:value` pairs.
        _.findWhere = function(obj, attrs) {
            return _.where(obj, attrs, true);
        };
        // Return the maximum element or (element-based computation).
        // Can't optimize arrays of integers longer than 65,535 elements.
        // See [WebKit Bug 80797](https://bugs.webkit.org/show_bug.cgi?id=80797)
        _.max = function(obj, iterator, context) {
            if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) return Math.max.apply(Math, obj);
            if (!iterator && _.isEmpty(obj)) return -Infinity;
            var result = {
                computed: -Infinity,
                value: -Infinity
            };
            each(obj, function(value1, index, list) {
                var computed = iterator ? iterator.call(context, value1, index, list) : value1;
                computed > result.computed && (result = {
                    value: value1,
                    computed: computed
                });
            });
            return result.value;
        };
        // Return the minimum element (or element-based computation).
        _.min = function(obj, iterator, context) {
            if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) return Math.min.apply(Math, obj);
            if (!iterator && _.isEmpty(obj)) return Infinity;
            var result = {
                computed: Infinity,
                value: Infinity
            };
            each(obj, function(value1, index, list) {
                var computed = iterator ? iterator.call(context, value1, index, list) : value1;
                computed < result.computed && (result = {
                    value: value1,
                    computed: computed
                });
            });
            return result.value;
        };
        // Shuffle an array, using the modern version of the
        // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisherâ€“Yates_shuffle).
        _.shuffle = function(obj) {
            var rand;
            var index = 0;
            var shuffled = [];
            each(obj, function(value1) {
                rand = _.random(index++);
                shuffled[index - 1] = shuffled[rand];
                shuffled[rand] = value1;
            });
            return shuffled;
        };
        // Sample **n** random values from an array.
        // If **n** is not specified, returns a single random element from the array.
        // The internal `guard` argument allows it to work with `map`.
        _.sample = function(obj, n, guard) {
            if (arguments.length < 2 || guard) return obj[_.random(obj.length - 1)];
            return _.shuffle(obj).slice(0, Math.max(0, n));
        };
        // An internal function to generate lookup iterators.
        var lookupIterator = function(value1) {
            return _.isFunction(value1) ? value1 : function(obj) {
                return obj[value1];
            };
        };
        // Sort the object's values by a criterion produced by an iterator.
        _.sortBy = function(obj, value1, context) {
            var iterator = lookupIterator(value1);
            return _.pluck(_.map(obj, function(value1, index, list) {
                return {
                    value: value1,
                    index: index,
                    criteria: iterator.call(context, value1, index, list)
                };
            }).sort(function(left, right) {
                var a = left.criteria;
                var b = right.criteria;
                if (a !== b) {
                    if (a > b || a === void 0) return 1;
                    if (a < b || b === void 0) return -1;
                }
                return left.index - right.index;
            }), "value");
        };
        // An internal function used for aggregate "group by" operations.
        var group = function(behavior) {
            return function(obj, value1, context) {
                var result = {};
                var iterator = value1 == null ? _.identity : lookupIterator(value1);
                each(obj, function(value1, index) {
                    var key = iterator.call(context, value1, index, obj);
                    behavior(result, key, value1);
                });
                return result;
            };
        };
        // Groups the object's values by a criterion. Pass either a string attribute
        // to group by, or a function that returns the criterion.
        _.groupBy = group(function(result, key, value1) {
            (_.has(result, key) ? result[key] : result[key] = []).push(value1);
        });
        // Indexes the object's values by a criterion, similar to `groupBy`, but for
        // when you know that your index values will be unique.
        _.indexBy = group(function(result, key, value1) {
            result[key] = value1;
        });
        // Counts instances of an object that group by a certain criterion. Pass
        // either a string attribute to count by, or a function that returns the
        // criterion.
        _.countBy = group(function(result, key) {
            _.has(result, key) ? result[key]++ : result[key] = 1;
        });
        // Use a comparator function to figure out the smallest index at which
        // an object should be inserted so as to maintain order. Uses binary search.
        _.sortedIndex = function(array, obj, iterator, context) {
            iterator = iterator == null ? _.identity : lookupIterator(iterator);
            var value1 = iterator.call(context, obj);
            var low = 0, high = array.length;
            while(low < high){
                var mid = low + high >>> 1;
                iterator.call(context, array[mid]) < value1 ? low = mid + 1 : high = mid;
            }
            return low;
        };
        // Safely create a real, live array from anything iterable.
        _.toArray = function(obj) {
            if (!obj) return [];
            if (_.isArray(obj)) return slice.call(obj);
            if (obj.length === +obj.length) return _.map(obj, _.identity);
            return _.values(obj);
        };
        // Return the number of elements in an object.
        _.size = function(obj) {
            if (obj == null) return 0;
            return obj.length === +obj.length ? obj.length : _.keys(obj).length;
        };
        // Array Functions
        // ---------------
        // Get the first element of an array. Passing **n** will return the first N
        // values in the array. Aliased as `head` and `take`. The **guard** check
        // allows it to work with `_.map`.
        _.first = _.head = _.take = function(array, n, guard) {
            if (array == null) return void 0;
            return n == null || guard ? array[0] : slice.call(array, 0, n);
        };
        // Returns everything but the last entry of the array. Especially useful on
        // the arguments object. Passing **n** will return all the values in
        // the array, excluding the last N. The **guard** check allows it to work with
        // `_.map`.
        _.initial = function(array, n, guard) {
            return slice.call(array, 0, array.length - (n == null || guard ? 1 : n));
        };
        // Get the last element of an array. Passing **n** will return the last N
        // values in the array. The **guard** check allows it to work with `_.map`.
        _.last = function(array, n, guard) {
            if (array == null) return void 0;
            if (n == null || guard) return array[array.length - 1];
            else return slice.call(array, Math.max(array.length - n, 0));
        };
        // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
        // Especially useful on the arguments object. Passing an **n** will return
        // the rest N values in the array. The **guard**
        // check allows it to work with `_.map`.
        _.rest = _.tail = _.drop = function(array, n, guard) {
            return slice.call(array, n == null || guard ? 1 : n);
        };
        // Trim out all falsy values from an array.
        _.compact = function(array) {
            return _.filter(array, _.identity);
        };
        // Internal implementation of a recursive `flatten` function.
        var flatten = function(input, shallow, output) {
            if (shallow && _.every(input, _.isArray)) return concat.apply(output, input);
            each(input, function(value1) {
                if (_.isArray(value1) || _.isArguments(value1)) shallow ? push.apply(output, value1) : flatten(value1, shallow, output);
                else output.push(value1);
            });
            return output;
        };
        // Flatten out an array, either recursively (by default), or just one level.
        _.flatten = function(array, shallow) {
            return flatten(array, shallow, []);
        };
        // Return a version of the array that does not contain the specified value(s).
        _.without = function(array) {
            return _.difference(array, slice.call(arguments, 1));
        };
        // Produce a duplicate-free version of the array. If the array has already
        // been sorted, you have the option of using a faster algorithm.
        // Aliased as `unique`.
        _.uniq = _.unique = function(array, isSorted, iterator, context) {
            if (_.isFunction(isSorted)) {
                context = iterator;
                iterator = isSorted;
                isSorted = false;
            }
            var initial = iterator ? _.map(array, iterator, context) : array;
            var results = [];
            var seen = [];
            each(initial, function(value1, index) {
                if (isSorted ? !index || seen[seen.length - 1] !== value1 : !_.contains(seen, value1)) {
                    seen.push(value1);
                    results.push(array[index]);
                }
            });
            return results;
        };
        // Produce an array that contains the union: each distinct element from all of
        // the passed-in arrays.
        _.union = function() {
            return _.uniq(_.flatten(arguments, true));
        };
        // Produce an array that contains every item shared between all the
        // passed-in arrays.
        _.intersection = function(array) {
            var rest = slice.call(arguments, 1);
            return _.filter(_.uniq(array), function(item) {
                return _.every(rest, function(other) {
                    return _.indexOf(other, item) >= 0;
                });
            });
        };
        // Take the difference between one array and a number of other arrays.
        // Only the elements present in just the first array will remain.
        _.difference = function(array) {
            var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
            return _.filter(array, function(value1) {
                return !_.contains(rest, value1);
            });
        };
        // Zip together multiple lists into a single array -- elements that share
        // an index go together.
        _.zip = function() {
            var length = _.max(_.pluck(arguments, "length").concat(0));
            var results = new Array(length);
            for(var i = 0; i < length; i++)results[i] = _.pluck(arguments, "" + i);
            return results;
        };
        // Converts lists into objects. Pass either a single array of `[key, value]`
        // pairs, or two parallel arrays of the same length -- one of keys, and one of
        // the corresponding values.
        _.object = function(list, values) {
            if (list == null) return {};
            var result = {};
            for(var i = 0, length = list.length; i < length; i++)if (values) result[list[i]] = values[i];
            else result[list[i][0]] = list[i][1];
            return result;
        };
        // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
        // we need this function. Return the position of the first occurrence of an
        // item in an array, or -1 if the item is not included in the array.
        // Delegates to **ECMAScript 5**'s native `indexOf` if available.
        // If the array is large and already in sort order, pass `true`
        // for **isSorted** to use binary search.
        _.indexOf = function(array, item, isSorted) {
            if (array == null) return -1;
            var i = 0, length = array.length;
            if (isSorted) {
                if (typeof isSorted == "number") i = isSorted < 0 ? Math.max(0, length + isSorted) : isSorted;
                else {
                    i = _.sortedIndex(array, item);
                    return array[i] === item ? i : -1;
                }
            }
            if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
            for(; i < length; i++)if (array[i] === item) return i;
            return -1;
        };
        // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
        _.lastIndexOf = function(array, item, from) {
            if (array == null) return -1;
            var hasIndex = from != null;
            if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
            var i = hasIndex ? from : array.length;
            while(i--)if (array[i] === item) return i;
            return -1;
        };
        // Generate an integer Array containing an arithmetic progression. A port of
        // the native Python `range()` function. See
        // [the Python documentation](http://docs.python.org/library/functions.html#range).
        _.range = function(start, stop, step) {
            if (arguments.length <= 1) {
                stop = start || 0;
                start = 0;
            }
            step = arguments[2] || 1;
            var length = Math.max(Math.ceil((stop - start) / step), 0);
            var idx = 0;
            var range = new Array(length);
            while(idx < length){
                range[idx++] = start;
                start += step;
            }
            return range;
        };
        // Function (ahem) Functions
        // ------------------
        // Reusable constructor function for prototype setting.
        var ctor = function() {};
        // Create a function bound to a given object (assigning `this`, and arguments,
        // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
        // available.
        _.bind = function(func, context) {
            var args, bound;
            if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
            if (!_.isFunction(func)) throw new TypeError;
            args = slice.call(arguments, 2);
            return bound = function() {
                if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
                ctor.prototype = func.prototype;
                var self = new ctor;
                ctor.prototype = null;
                var result = func.apply(self, args.concat(slice.call(arguments)));
                if (Object(result) === result) return result;
                return self;
            };
        };
        // Partially apply a function by creating a version that has had some of its
        // arguments pre-filled, without changing its dynamic `this` context.
        _.partial = function(func) {
            var args = slice.call(arguments, 1);
            return function() {
                return func.apply(this, args.concat(slice.call(arguments)));
            };
        };
        // Bind all of an object's methods to that object. Useful for ensuring that
        // all callbacks defined on an object belong to it.
        _.bindAll = function(obj) {
            var funcs = slice.call(arguments, 1);
            if (funcs.length === 0) throw new Error("bindAll must be passed function names");
            each(funcs, function(f) {
                obj[f] = _.bind(obj[f], obj);
            });
            return obj;
        };
        // Memoize an expensive function by storing its results.
        _.memoize = function(func, hasher) {
            var memo = {};
            hasher || (hasher = _.identity);
            return function() {
                var key = hasher.apply(this, arguments);
                return _.has(memo, key) ? memo[key] : memo[key] = func.apply(this, arguments);
            };
        };
        // Delays a function for the given number of milliseconds, and then calls
        // it with the arguments supplied.
        _.delay = function(func, wait) {
            var args = slice.call(arguments, 2);
            return setTimeout(function() {
                return func.apply(null, args);
            }, wait);
        };
        // Defers a function, scheduling it to run after the current call stack has
        // cleared.
        _.defer = function(func) {
            return _.delay.apply(_, [
                func,
                1
            ].concat(slice.call(arguments, 1)));
        };
        // Returns a function, that, when invoked, will only be triggered at most once
        // during a given window of time. Normally, the throttled function will run
        // as much as it can, without ever going more than once per `wait` duration;
        // but if you'd like to disable the execution on the leading edge, pass
        // `{leading: false}`. To disable execution on the trailing edge, ditto.
        _.throttle = function(func, wait, options) {
            var context, args, result;
            var timeout = null;
            var previous = 0;
            options || (options = {});
            var later = function() {
                previous = options.leading === false ? 0 : new Date;
                timeout = null;
                result = func.apply(context, args);
            };
            return function() {
                var now = new Date;
                if (!previous && options.leading === false) previous = now;
                var remaining = wait - (now - previous);
                context = this;
                args = arguments;
                if (remaining <= 0) {
                    clearTimeout(timeout);
                    timeout = null;
                    previous = now;
                    result = func.apply(context, args);
                } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
                return result;
            };
        };
        // Returns a function, that, as long as it continues to be invoked, will not
        // be triggered. The function will be called after it stops being called for
        // N milliseconds. If `immediate` is passed, trigger the function on the
        // leading edge, instead of the trailing.
        _.debounce = function(func, wait, immediate) {
            var timeout, args, context, timestamp, result;
            return function() {
                context = this;
                args = arguments;
                timestamp = new Date();
                var later = function() {
                    var last = new Date() - timestamp;
                    if (last < wait) timeout = setTimeout(later, wait - last);
                    else {
                        timeout = null;
                        if (!immediate) result = func.apply(context, args);
                    }
                };
                var callNow = immediate && !timeout;
                if (!timeout) timeout = setTimeout(later, wait);
                if (callNow) result = func.apply(context, args);
                return result;
            };
        };
        // Returns a function that will be executed at most one time, no matter how
        // often you call it. Useful for lazy initialization.
        _.once = function(func) {
            var ran = false, memo;
            return function() {
                if (ran) return memo;
                ran = true;
                memo = func.apply(this, arguments);
                func = null;
                return memo;
            };
        };
        // Returns the first function passed as an argument to the second,
        // allowing you to adjust arguments, run code before and after, and
        // conditionally execute the original function.
        _.wrap = function(func, wrapper) {
            return function() {
                var args = [
                    func
                ];
                push.apply(args, arguments);
                return wrapper.apply(this, args);
            };
        };
        // Returns a function that is the composition of a list of functions, each
        // consuming the return value of the function that follows.
        _.compose = function() {
            var funcs = arguments;
            return function() {
                var args = arguments;
                for(var i = funcs.length - 1; i >= 0; i--)args = [
                    funcs[i].apply(this, args)
                ];
                return args[0];
            };
        };
        // Returns a function that will only be executed after being called N times.
        _.after = function(times, func) {
            return function() {
                if (--times < 1) return func.apply(this, arguments);
            };
        };
        // Object Functions
        // ----------------
        // Retrieve the names of an object's properties.
        // Delegates to **ECMAScript 5**'s native `Object.keys`
        _.keys = nativeKeys || function(obj) {
            if (obj !== Object(obj)) throw new TypeError("Invalid object");
            var keys = [];
            for(var key in obj)if (_.has(obj, key)) keys.push(key);
            return keys;
        };
        // Retrieve the values of an object's properties.
        _.values = function(obj) {
            var keys = _.keys(obj);
            var length = keys.length;
            var values = new Array(length);
            for(var i = 0; i < length; i++)values[i] = obj[keys[i]];
            return values;
        };
        // Convert an object into a list of `[key, value]` pairs.
        _.pairs = function(obj) {
            var keys = _.keys(obj);
            var length = keys.length;
            var pairs = new Array(length);
            for(var i = 0; i < length; i++)pairs[i] = [
                keys[i],
                obj[keys[i]]
            ];
            return pairs;
        };
        // Invert the keys and values of an object. The values must be serializable.
        _.invert = function(obj) {
            var result = {};
            var keys = _.keys(obj);
            for(var i = 0, length = keys.length; i < length; i++)result[obj[keys[i]]] = keys[i];
            return result;
        };
        // Return a sorted list of the function names available on the object.
        // Aliased as `methods`
        _.functions = _.methods = function(obj) {
            var names = [];
            for(var key in obj)if (_.isFunction(obj[key])) names.push(key);
            return names.sort();
        };
        // Extend a given object with all the properties in passed-in object(s).
        _.extend = function(obj) {
            each(slice.call(arguments, 1), function(source) {
                if (source) for(var prop in source)obj[prop] = source[prop];
            });
            return obj;
        };
        // Return a copy of the object only containing the whitelisted properties.
        _.pick = function(obj) {
            var copy = {};
            var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
            each(keys, function(key) {
                if (key in obj) copy[key] = obj[key];
            });
            return copy;
        };
        // Return a copy of the object without the blacklisted properties.
        _.omit = function(obj) {
            var copy = {};
            var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
            for(var key in obj)if (!_.contains(keys, key)) copy[key] = obj[key];
            return copy;
        };
        // Fill in a given object with default properties.
        _.defaults = function(obj) {
            each(slice.call(arguments, 1), function(source) {
                if (source) {
                    for(var prop in source)if (obj[prop] === void 0) obj[prop] = source[prop];
                }
            });
            return obj;
        };
        // Create a (shallow-cloned) duplicate of an object.
        _.clone = function(obj) {
            if (!_.isObject(obj)) return obj;
            return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
        };
        // Invokes interceptor with the obj, and then returns obj.
        // The primary purpose of this method is to "tap into" a method chain, in
        // order to perform operations on intermediate results within the chain.
        _.tap = function(obj, interceptor) {
            interceptor(obj);
            return obj;
        };
        // Internal recursive comparison function for `isEqual`.
        var eq = function(a, b, aStack, bStack) {
            // Identical objects are equal. `0 === -0`, but they aren't identical.
            // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
            if (a === b) return a !== 0 || 1 / a == 1 / b;
            // A strict comparison is necessary because `null == undefined`.
            if (a == null || b == null) return a === b;
            // Unwrap any wrapped objects.
            if (a instanceof _) a = a._wrapped;
            if (b instanceof _) b = b._wrapped;
            // Compare `[[Class]]` names.
            var className = toString.call(a);
            if (className != toString.call(b)) return false;
            switch(className){
                // Strings, numbers, dates, and booleans are compared by value.
                case "[object String]":
                    // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                    // equivalent to `new String("5")`.
                    return a == String(b);
                case "[object Number]":
                    // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
                    // other numeric values.
                    return a != +a ? b != +b : a == 0 ? 1 / a == 1 / b : a == +b;
                case "[object Date]":
                case "[object Boolean]":
                    // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                    // millisecond representations. Note that invalid dates with millisecond representations
                    // of `NaN` are not equivalent.
                    return +a == +b;
                // RegExps are compared by their source patterns and flags.
                case "[object RegExp]":
                    return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
            }
            if (typeof a != "object" || typeof b != "object") return false;
            // Assume equality for cyclic structures. The algorithm for detecting cyclic
            // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
            var length = aStack.length;
            while(length--){
                // Linear search. Performance is inversely proportional to the number of
                // unique nested structures.
                if (aStack[length] == a) return bStack[length] == b;
            }
            // Objects with different constructors are not equivalent, but `Object`s
            // from different frames are.
            var aCtor = a.constructor, bCtor = b.constructor;
            if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor)) return false;
            // Add the first object to the stack of traversed objects.
            aStack.push(a);
            bStack.push(b);
            var size = 0, result = true;
            // Recursively compare objects and arrays.
            if (className == "[object Array]") {
                // Compare array lengths to determine if a deep comparison is necessary.
                size = a.length;
                result = size == b.length;
                if (result) // Deep compare the contents, ignoring non-numeric properties.
                while(size--){
                    if (!(result = eq(a[size], b[size], aStack, bStack))) break;
                }
            } else {
                // Deep compare objects.
                for(var key in a)if (_.has(a, key)) {
                    // Count the expected number of properties.
                    size++;
                    // Deep compare each member.
                    if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
                }
                // Ensure that both objects contain the same number of properties.
                if (result) {
                    for(key in b){
                        if (_.has(b, key) && !size--) break;
                    }
                    result = !size;
                }
            }
            // Remove the first object from the stack of traversed objects.
            aStack.pop();
            bStack.pop();
            return result;
        };
        // Perform a deep comparison to check if two objects are equal.
        _.isEqual = function(a, b) {
            return eq(a, b, [], []);
        };
        // Is a given array, string, or object empty?
        // An "empty" object has no enumerable own-properties.
        _.isEmpty = function(obj) {
            if (obj == null) return true;
            if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
            for(var key in obj)if (_.has(obj, key)) return false;
            return true;
        };
        // Is a given value a DOM element?
        _.isElement = function(obj) {
            return !!(obj && obj.nodeType === 1);
        };
        // Is a given value an array?
        // Delegates to ECMA5's native Array.isArray
        _.isArray = nativeIsArray || function(obj) {
            return toString.call(obj) == "[object Array]";
        };
        // Is a given variable an object?
        _.isObject = function(obj) {
            return obj === Object(obj);
        };
        // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
        each([
            "Arguments",
            "Function",
            "String",
            "Number",
            "Date",
            "RegExp"
        ], function(name) {
            _["is" + name] = function(obj) {
                return toString.call(obj) == "[object " + name + "]";
            };
        });
        // Define a fallback version of the method in browsers (ahem, IE), where
        // there isn't any inspectable "Arguments" type.
        if (!_.isArguments(arguments)) _.isArguments = function(obj) {
            return !!(obj && _.has(obj, "callee"));
        };
        // Optimize `isFunction` if appropriate.
        if (typeof /./ !== "function") _.isFunction = function(obj) {
            return typeof obj === "function";
        };
        // Is a given object a finite number?
        _.isFinite = function(obj) {
            return isFinite(obj) && !isNaN(parseFloat(obj));
        };
        // Is the given value `NaN`? (NaN is the only number which does not equal itself).
        _.isNaN = function(obj) {
            return _.isNumber(obj) && obj != +obj;
        };
        // Is a given value a boolean?
        _.isBoolean = function(obj) {
            return obj === true || obj === false || toString.call(obj) == "[object Boolean]";
        };
        // Is a given value equal to null?
        _.isNull = function(obj) {
            return obj === null;
        };
        // Is a given variable undefined?
        _.isUndefined = function(obj) {
            return obj === void 0;
        };
        // Shortcut function for checking if an object has a given property directly
        // on itself (in other words, not on a prototype).
        _.has = function(obj, key) {
            return hasOwnProperty.call(obj, key);
        };
        // Utility Functions
        // -----------------
        // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
        // previous owner. Returns a reference to the Underscore object.
        _.noConflict = function() {
            root._ = previousUnderscore;
            return this;
        };
        // Keep the identity function around for default iterators.
        _.identity = function(value1) {
            return value1;
        };
        // Run a function **n** times.
        _.times = function(n, iterator, context) {
            var accum = Array(Math.max(0, n));
            for(var i = 0; i < n; i++)accum[i] = iterator.call(context, i);
            return accum;
        };
        // Return a random integer between min and max (inclusive).
        _.random = function(min, max) {
            if (max == null) {
                max = min;
                min = 0;
            }
            return min + Math.floor(Math.random() * (max - min + 1));
        };
        // List of HTML entities for escaping.
        var entityMap = {
            escape: {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#x27;"
            }
        };
        entityMap.unescape = _.invert(entityMap.escape);
        // Regexes containing the keys and values listed immediately above.
        var entityRegexes = {
            escape: new RegExp("[" + _.keys(entityMap.escape).join("") + "]", "g"),
            unescape: new RegExp("(" + _.keys(entityMap.unescape).join("|") + ")", "g")
        };
        // Functions for escaping and unescaping strings to/from HTML interpolation.
        _.each([
            "escape",
            "unescape"
        ], function(method) {
            _[method] = function(string) {
                if (string == null) return "";
                return ("" + string).replace(entityRegexes[method], function(match) {
                    return entityMap[method][match];
                });
            };
        });
        // If the value of the named `property` is a function then invoke it with the
        // `object` as context; otherwise, return it.
        _.result = function(object, property) {
            if (object == null) return void 0;
            var value1 = object[property];
            return _.isFunction(value1) ? value1.call(object) : value1;
        };
        // Add your own custom functions to the Underscore object.
        _.mixin = function(obj) {
            each(_.functions(obj), function(name) {
                var func = _[name] = obj[name];
                _.prototype[name] = function() {
                    var args = [
                        this._wrapped
                    ];
                    push.apply(args, arguments);
                    return result.call(this, func.apply(_, args));
                };
            });
        };
        // Generate a unique integer id (unique within the entire client session).
        // Useful for temporary DOM ids.
        var idCounter = 0;
        _.uniqueId = function(prefix) {
            var id = ++idCounter + "";
            return prefix ? prefix + id : id;
        };
        // By default, Underscore uses ERB-style template delimiters, change the
        // following template settings to use alternative delimiters.
        _.templateSettings = {
            evaluate: /<%([\s\S]+?)%>/g,
            interpolate: /<%=([\s\S]+?)%>/g,
            escape: /<%-([\s\S]+?)%>/g
        };
        // When customizing `templateSettings`, if you don't want to define an
        // interpolation, evaluation or escaping regex, we need one that is
        // guaranteed not to match.
        var noMatch = /(.)^/;
        // Certain characters need to be escaped so that they can be put into a
        // string literal.
        var escapes = {
            "'": "'",
            "\\": "\\",
            "\r": "r",
            "\n": "n",
            "	": "t",
            "\u2028": "u2028",
            "\u2029": "u2029"
        };
        var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;
        // JavaScript micro-templating, similar to John Resig's implementation.
        // Underscore templating handles arbitrary delimiters, preserves whitespace,
        // and correctly escapes quotes within interpolated code.
        _.template = function(text, data1, settings) {
            var render;
            settings = _.defaults({}, settings, _.templateSettings);
            // Combine delimiters into one regular expression via alternation.
            var matcher = new RegExp([
                (settings.escape || noMatch).source,
                (settings.interpolate || noMatch).source,
                (settings.evaluate || noMatch).source
            ].join("|") + "|$", "g");
            // Compile the template source, escaping string literals appropriately.
            var index = 0;
            var source = "__p+='";
            text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
                source += text.slice(index, offset).replace(escaper, function(match) {
                    return "\\" + escapes[match];
                });
                if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
                if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
                if (evaluate) source += "';\n" + evaluate + "\n__p+='";
                index = offset + match.length;
                return match;
            });
            source += "';\n";
            // If a variable is not specified, place data values in local scope.
            if (!settings.variable) source = "with(obj||{}){\n" + source + "}\n";
            source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + "return __p;\n";
            try {
                render = new Function(settings.variable || "obj", "_", source);
            } catch (e) {
                e.source = source;
                throw e;
            }
            if (data1) return render(data1, _);
            var template = function(data1) {
                return render.call(this, data1, _);
            };
            // Provide the compiled function source as a convenience for precompilation.
            template.source = "function(" + (settings.variable || "obj") + "){\n" + source + "}";
            return template;
        };
        // Add a "chain" function, which will delegate to the wrapper.
        _.chain = function(obj) {
            return _(obj).chain();
        };
        // OOP
        // ---------------
        // If Underscore is called as a function, it returns a wrapped object that
        // can be used OO-style. This wrapper holds altered versions of all the
        // underscore functions. Wrapped objects may be chained.
        // Helper function to continue chaining intermediate results.
        var result = function(obj) {
            return this._chain ? _(obj).chain() : obj;
        };
        // Add all of the Underscore functions to the wrapper object.
        _.mixin(_);
        // Add all mutator Array functions to the wrapper.
        each([
            "pop",
            "push",
            "reverse",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(name) {
            var method = ArrayProto[name];
            _.prototype[name] = function() {
                var obj = this._wrapped;
                method.apply(obj, arguments);
                if ((name == "shift" || name == "splice") && obj.length === 0) delete obj[0];
                return result.call(this, obj);
            };
        });
        // Add all accessor Array functions to the wrapper.
        each([
            "concat",
            "join",
            "slice"
        ], function(name) {
            var method = ArrayProto[name];
            _.prototype[name] = function() {
                return result.call(this, method.apply(this._wrapped, arguments));
            };
        });
        _.extend(_.prototype, {
            // Start chaining a wrapped Underscore object.
            chain: function() {
                this._chain = true;
                return this;
            },
            // Extracts the result from a wrapped and chained object.
            value: function() {
                return this._wrapped;
            }
        });
    }).call(this);
    /**
  * FOLLOWING LINES MODIFIED BY ATLASSIAN
  * @see https://ecosystem.atlassian.net/browse/AUI-2989
  */ if (typeof window.define === "function") define("underscore", [], function() {
        return window._;
    });
    /** END ATLASSIAN */ return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/underscore.js
(typeof window === "undefined" ? $parcel$global : window).__59c1c30030f41c99b6757d449d9a3a7b = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _underscore = __81a34191ad3e61fcf21096871eebec4b;
    var _underscore2 = _interopRequireDefault(_underscore);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    if (!window._) window._ = _underscore2.default;
    exports.default = window._;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/spinner.js
(typeof window === "undefined" ? $parcel$global : window).__6c1bd26c14066cf537a86a0966c2d4fc = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.SIZE = undefined;
    var _skatejs = __8548ccf5d6767d1d4e6633309de41309;
    var _skatejs2 = _interopRequireDefault(_skatejs);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var _underscore = __59c1c30030f41c99b6757d449d9a3a7b;
    var _underscore2 = _interopRequireDefault(_underscore);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * @typedef {"small"|"medium"|"large"} SpinnerSize
   */ /**
   * @typedef {Object} SpinnerSizeConfig
   * @param {SpinnerSize} name
   * @param {number} px
   * @param {number} radius
   */ /**
   * @enum {SpinnerSizeConfig}
   * @readonly
   */ var SIZE = {
        SMALL: {
            name: "small",
            px: 20,
            radius: 9
        },
        MEDIUM: {
            name: "medium",
            px: 30,
            radius: 13.5
        },
        LARGE: {
            name: "large",
            px: 50,
            radius: 22.5
        }
    };
    var DEFAULTS = {
        filled: false,
        size: SIZE.MEDIUM.name
    };
    var filledAttributeReplacementText = "Add CSS to the parent element of the <aui-spinner>.\nUse CSS flexbox or grid to vertically align it.\nSee https://css-tricks.com/centering-css-complete-guide/ for techniques.";
    var filledAttributeDeprecatedLogger = (0, _deprecation.getMessageLogger)("<aui-spinner> filled attribute", {
        sinceVersion: "7.9.4",
        removeInVersion: "9",
        extraInfo: filledAttributeReplacementText
    });
    var filledPropDeprecatedLogger = (0, _deprecation.getMessageLogger)("<aui-spinner> filled property", {
        sinceVersion: "7.9.4",
        removeInVersion: "9",
        extraInfo: filledAttributeReplacementText
    });
    /** @deprecated */ function setMiddleTop(element, height) {
        var parent = element.parentNode;
        // only operate on elements, not documentFragment or comment nodes, etc.
        if (parent && parent.nodeType === 1) {
            var selfDomRect = element.getBoundingClientRect();
            var parentDomRect = parent.getBoundingClientRect();
            var parentMiddleTop = parentDomRect.top + parentDomRect.height / 2;
            var spinnerMiddleTop = selfDomRect.top + height / 2;
            element.querySelector("svg").style.top = parentMiddleTop - spinnerMiddleTop + "px";
        }
    }
    /** @deprecated */ function removeMiddleTop(element) {
        delete element.querySelector("svg").style.top;
    }
    function validateSize(size) {
        var result = SIZE.MEDIUM.name;
        if (typeof size === "string") {
            size = size.toLowerCase();
            var possibleSizes = Object.keys(SIZE).map(function(key) {
                return key.toLowerCase();
            });
            if (possibleSizes.indexOf(size) > -1) result = size;
        }
        return result;
    }
    function setSize(element, size, radius) {
        var svg = element.querySelector("svg");
        var circle = element.querySelector("circle");
        svg.setAttribute("size", size);
        svg.setAttribute("height", size);
        svg.setAttribute("width", size);
        svg.setAttribute("viewBox", "0 0 " + size + " " + size);
        var circleSize = size / 2;
        circle.setAttribute("cx", circleSize);
        circle.setAttribute("cy", circleSize);
        circle.setAttribute("r", radius);
    }
    function refresh(element) {
        var _ref = _underscore2.default.find(SIZE, function(s) {
            return s.name === element._data.size;
        }) || SIZE.MEDIUM, px = _ref.px, radius = _ref.radius;
        setSize(element, px, radius);
        if (element._data.filled) setMiddleTop(element, px);
        else removeMiddleTop(element);
    }
    var SpinnerEl = (0, _skatejs2.default)("aui-spinner", {
        template: function template(element) {
            element.innerHTML = '<div class="aui-spinner spinner"><svg focusable="false"><circle></circle></svg></div>';
            refresh(element);
        },
        attached: function attached(element) {
            refresh(element);
        },
        attributes: {
            filled: {
                /** @deprecated */ created: function created(element) {
                    filledAttributeDeprecatedLogger();
                    element._data.filled = true;
                    refresh(element);
                },
                /** @deprecated */ removed: function removed(element) {
                    element._data.filled = false;
                    refresh(element);
                }
            },
            size: function size(element, data1) {
                element._data.size = validateSize(data1.newValue);
                refresh(element);
            }
        },
        prototype: {
            get _data () {
                return this.__data || (this._data = _underscore2.default.defaults({}, DEFAULTS));
            },
            set _data (data){
                return this.__data = data;
            },
            /** @deprecated */ set filled (isFilled){
                filledPropDeprecatedLogger();
                !!isFilled ? this.setAttribute("filled", "") : this.removeAttribute("filled");
            },
            set size (newSize){
                var size = validateSize(newSize);
                this.setAttribute("size", size);
            }
        }
    });
    exports.default = SpinnerEl;
    exports.SIZE = SIZE;
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/skatejs-template-html/dist/template-html.js
(typeof window === "undefined" ? $parcel$global : window).__c6b5725916d210b9653318d2ea2472cb = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__c6b5725916d210b9653318d2ea2472cb");
    define.amd = true;
    (function() {
        var DocumentFragment = window.DocumentFragment;
        var elProto = window.HTMLElement.prototype;
        var matchesSelector = elProto.matches || elProto.msMatchesSelector || elProto.webkitMatchesSelector || elProto.mozMatchesSelector || elProto.oMatchesSelector;
        function getData(element, name) {
            if (element.__SKATE_TEMPLATE_HTML_DATA) return element.__SKATE_TEMPLATE_HTML_DATA[name];
        }
        function setData(element, name, value1) {
            if (!element.__SKATE_TEMPLATE_HTML_DATA) element.__SKATE_TEMPLATE_HTML_DATA = {};
            element.__SKATE_TEMPLATE_HTML_DATA[name] = value1;
            return element;
        }
        function createFragmentFromString(domString) {
            var specialMap = {
                caption: "table",
                dd: "dl",
                dt: "dl",
                li: "ul",
                tbody: "table",
                td: "tr",
                thead: "table",
                tr: "tbody"
            };
            var tag = domString.match(/\s*<([^\s>]+)/);
            var div = document.createElement(tag && specialMap[tag[1]] || "div");
            div.innerHTML = domString;
            return createFragmentFromNodeList(div.childNodes);
        }
        function createFragmentFromNodeList(nodeList) {
            var frag = document.createDocumentFragment();
            while(nodeList && nodeList.length)frag.appendChild(nodeList[0]);
            return frag;
        }
        function getNodesBetween(startNode, endNode) {
            var nodes = [];
            var nextNode = startNode.nextSibling;
            while(nextNode !== endNode){
                nodes.push(nextNode);
                nextNode = nextNode.nextSibling;
            }
            return nodes;
        }
        function findChildrenMatchingSelector(sourceNode, selector) {
            if (selector) {
                var found = sourceNode.querySelectorAll(selector);
                var foundLength = found.length;
                var filtered = [];
                for(var a = 0; a < foundLength; a++){
                    var node = found[a];
                    if (node.parentNode === sourceNode) filtered.push(node);
                }
                return filtered;
            }
            return [].slice.call(sourceNode.childNodes) || [];
        }
        function htmlTemplateParentWrapper(element) {
            var contentNodes = getData(element, "content");
            var contentNodesLen = contentNodes.length;
            return {
                childNodes: {
                    get: function() {
                        var nodes = [];
                        for(var a = 0; a < contentNodesLen; a++){
                            var contentNode = contentNodes[a];
                            if (contentNode.isDefault) continue;
                            nodes = nodes.concat(getNodesBetween(contentNode.startNode, contentNode.endNode));
                        }
                        return nodes;
                    }
                },
                firstChild: {
                    get: function() {
                        var childNodes = this.childNodes;
                        return childNodes.length && childNodes[0] || null;
                    }
                },
                innerHTML: {
                    get: function() {
                        var html = "";
                        var childNodes = this.childNodes;
                        var childNodesLen = childNodes.length;
                        for(var a = 0; a < childNodesLen; a++){
                            var childNode = childNodes[a];
                            html += childNode.outerHTML || childNode.textContent;
                        }
                        return html;
                    },
                    set: function(html) {
                        var targetFragment = createFragmentFromString(html);
                        for(var a = 0; a < contentNodesLen; a++){
                            var contentNode = contentNodes[a];
                            var childNodes = getNodesBetween(contentNode.startNode, contentNode.endNode);
                            // Remove all nodes (including default content).
                            for(var b = 0; b < childNodes.length; b++){
                                var childNode = childNodes[b];
                                childNode.parentNode.removeChild(childNode);
                            }
                            var foundNodes = findChildrenMatchingSelector(targetFragment, contentNode.selector);
                            // Add any matched nodes from the given HTML.
                            for(var c = 0; c < foundNodes.length; c++)contentNode.container.insertBefore(foundNodes[c], contentNode.endNode);
                            // If no nodes were found, set the default content.
                            if (foundNodes.length) removeDefaultContent(contentNode);
                            else addDefaultContent(contentNode);
                        }
                    }
                },
                lastChild: {
                    get: function() {
                        for(var a = contentNodesLen - 1; a > -1; a--){
                            var contentNode = contentNodes[a];
                            if (contentNode.isDefault) continue;
                            var childNodes = this.childNodes;
                            var childNodesLen = childNodes.length;
                            return childNodes[childNodesLen - 1];
                        }
                        return null;
                    }
                },
                outerHTML: {
                    get: function() {
                        var name = this.tagName.toLowerCase();
                        var html = "<" + name;
                        var attrs = this.attributes;
                        if (attrs) {
                            var attrsLength = attrs.length;
                            for(var a = 0; a < attrsLength; a++){
                                var attr = attrs[a];
                                html += " " + attr.nodeName + '="' + attr.nodeValue + '"';
                            }
                        }
                        html += ">";
                        html += this.innerHTML;
                        html += "</" + name + ">";
                        return html;
                    }
                },
                textContent: {
                    get: function() {
                        var textContent = "";
                        var childNodes = this.childNodes;
                        var childNodesLength = this.childNodes.length;
                        for(var a = 0; a < childNodesLength; a++)textContent += childNodes[a].textContent;
                        return textContent;
                    },
                    set: function(textContent) {
                        var acceptsTextContent;
                        // Removes all nodes (including default content).
                        this.innerHTML = "";
                        // Find the first content node without a selector.
                        for(var a = 0; a < contentNodesLen; a++){
                            var contentNode = contentNodes[a];
                            if (!contentNode.selector) {
                                acceptsTextContent = contentNode;
                                break;
                            }
                        }
                        // There may be no content nodes that accept text content.
                        if (acceptsTextContent) {
                            if (textContent) {
                                removeDefaultContent(acceptsTextContent);
                                acceptsTextContent.container.insertBefore(document.createTextNode(textContent), acceptsTextContent.endNode);
                            } else addDefaultContent(acceptsTextContent);
                        }
                    }
                },
                appendChild: {
                    value: function(node) {
                        if (node instanceof DocumentFragment) {
                            var fragChildNodes = node.childNodes;
                            [].slice.call(fragChildNodes).forEach((function(node) {
                                this.appendChild(node);
                            }).bind(this));
                            return this;
                        }
                        for(var b = 0; b < contentNodesLen; b++){
                            var contentNode = contentNodes[b];
                            var contentSelector = contentNode.selector;
                            if (!contentSelector || node instanceof window.HTMLElement && matchesSelector.call(node, contentSelector)) {
                                removeDefaultContent(contentNode);
                                contentNode.endNode.parentNode.insertBefore(node, contentNode.endNode);
                                break;
                            }
                        }
                        return this;
                    }
                },
                insertAdjacentHTML: {
                    value: function(where, html) {
                        if (where === "afterbegin") this.insertBefore(createFragmentFromString(html), this.childNodes[0]);
                        else if (where === "beforeend") this.appendChild(createFragmentFromString(html));
                        else element.insertAdjacentHTML(where, html);
                        return this;
                    }
                },
                insertBefore: {
                    value: function(node, referenceNode) {
                        // If no reference node is supplied, we append. This also means that we
                        // don't need to add / remove any default content because either there
                        // aren't any nodes or appendChild will handle it.
                        if (!referenceNode) return this.appendChild(node);
                        // Handle document fragments.
                        if (node instanceof DocumentFragment) {
                            var fragChildNodes = node.childNodes;
                            if (fragChildNodes) {
                                var fragChildNodesLength = fragChildNodes.length;
                                for(var a = 0; a < fragChildNodesLength; a++)this.insertBefore(fragChildNodes[a], referenceNode);
                            }
                            return this;
                        }
                        var hasFoundReferenceNode = false;
                        // There's no reason to handle default content add / remove because:
                        // 1. If no reference node is supplied, appendChild handles it.
                        // 2. If a reference node is supplied, there already is content.
                        // 3. If a reference node is invalid, an exception is thrown, but also
                        //    it's state would not change even if it wasn't.
                        mainLoop: for(var b = 0; b < contentNodesLen; b++){
                            var contentNode = contentNodes[b];
                            var betweenNodes = getNodesBetween(contentNode.startNode, contentNode.endNode);
                            var betweenNodesLen = betweenNodes.length;
                            for(var c = 0; c < betweenNodesLen; c++){
                                var betweenNode = betweenNodes[c];
                                if (betweenNode === referenceNode) hasFoundReferenceNode = true;
                                if (hasFoundReferenceNode) {
                                    var selector = contentNode.selector;
                                    if (!selector || matchesSelector.call(node, selector)) {
                                        betweenNode.parentNode.insertBefore(node, betweenNode);
                                        break mainLoop;
                                    }
                                }
                            }
                        }
                        // If no reference node was found as a child node of the element we must
                        // throw an error. This works for both no child nodes, or if the
                        // reference wasn't found to be a child node.
                        if (!hasFoundReferenceNode) throw new Error("DOMException 8: The node before which the new node is to be inserted is not a child of this node.");
                        return node;
                    }
                },
                removeChild: {
                    value: function(childNode) {
                        var removed = false;
                        for(var a = 0; a < contentNodesLen; a++){
                            var contentNode = contentNodes[a];
                            if (contentNode.container === childNode.parentNode) {
                                contentNode.container.removeChild(childNode);
                                removed = true;
                                break;
                            }
                            if (contentNode.startNode.nextSibling === contentNode.endNode) addDefaultContent(contentNode);
                        }
                        if (!removed) throw new Error("DOMException 8: The node in which you are trying to remove is not a child of this node.");
                        return childNode;
                    }
                },
                replaceChild: {
                    value: function(newChild, oldChild) {
                        for(var a = 0; a < contentNodesLen; a++){
                            var contentNode = contentNodes[a];
                            if (contentNode.container === oldChild.parentNode) {
                                contentNode.container.replaceChild(newChild, oldChild);
                                break;
                            }
                        }
                        return this;
                    }
                }
            };
        }
        function addDefaultContent(content) {
            var nodes = content.defaultNodes;
            var nodesLen = nodes.length;
            for(var a = 0; a < nodesLen; a++)content.container.insertBefore(nodes[a], content.endNode);
            content.isDefault = true;
        }
        function removeDefaultContent(content) {
            var nodes = content.defaultNodes;
            var nodesLen = nodes.length;
            for(var a = 0; a < nodesLen; a++){
                var node = nodes[a];
                node.parentNode.removeChild(node);
            }
            content.isDefault = false;
        }
        function createProxyProperty(node, name) {
            return {
                get: function() {
                    var value1 = node[name];
                    if (typeof value1 === "function") return value1.bind(node);
                    return value1;
                },
                set: function(value1) {
                    node[name] = value1;
                }
            };
        }
        function wrapNodeWith(node, wrapper) {
            var wrapped = {};
            for(var name in node){
                var inWrapper = name in wrapper;
                if (inWrapper) Object.defineProperty(wrapped, name, wrapper[name]);
                else Object.defineProperty(wrapped, name, createProxyProperty(node, name));
            }
            return wrapped;
        }
        function cacheContentData(node) {
            var contentNodes = node.getElementsByTagName("content");
            var contentNodesLen = contentNodes && contentNodes.length;
            if (contentNodesLen) {
                var contentData = [];
                while(contentNodes.length){
                    var contentNode = contentNodes[0];
                    var parentNode = contentNode.parentNode;
                    var selector = contentNode.getAttribute("select");
                    var startNode = document.createComment(" content ");
                    var endNode = document.createComment(" /content ");
                    contentData.push({
                        container: parentNode,
                        contentNode: contentNode,
                        defaultNodes: [].slice.call(contentNode.childNodes),
                        endNode: endNode,
                        isDefault: true,
                        selector: selector,
                        startNode: startNode
                    });
                    parentNode.replaceChild(endNode, contentNode);
                    parentNode.insertBefore(startNode, endNode);
                    // Cache data in the comment that can be read if no content information
                    // is cached. This allows seamless server-side rendering.
                    startNode.textContent += JSON.stringify({
                        defaultContent: contentNode.innerHTML,
                        selector: selector
                    }) + " ";
                }
                setData(node, "content", contentData);
            }
        }
        // Content Parser
        // --------------
        function parseCommentNode(node) {
            var data1;
            var matches = node.textContent.match(/^ (\/?)content (.*)/i);
            if (matches) {
                if (matches[2]) try {
                    data1 = JSON.parse(matches[2]);
                } catch (e) {
                    throw new Error('Unable to parse content comment data: "' + e + '" in "<!--' + node.textContent + '-->".');
                }
                return {
                    data: data1 || {
                        defaultContent: undefined,
                        isDefault: undefined,
                        selector: undefined
                    },
                    type: matches[1] ? "close" : "open"
                };
            }
        }
        function parseNodeForContent(node) {
            var a;
            var childNodes = node.childNodes;
            var childNodesLen = childNodes.length;
            var contentDatas = [];
            var lastContentNode;
            for(a = 0; a < childNodesLen; a++){
                var childNode = childNodes[a];
                if (childNode.nodeType === 8) {
                    var contentInfo = parseCommentNode(childNode);
                    if (contentInfo) {
                        if (contentInfo.type === "open") {
                            if (lastContentNode) throw new Error('Cannot have an opening content placeholder after another content placeholder at the same level in the DOM tree: "' + childNode.textContent + '" in "' + childNode.parentNode.innerHTML + '".');
                            lastContentNode = {
                                container: childNode.parentNode,
                                contentNode: childNode,
                                defaultNodes: contentInfo.data.defaultContent && createFragmentFromString(contentInfo.data.defaultContent).childNodes || [],
                                isDefault: contentInfo.data.isDefault,
                                selector: contentInfo.data.selector,
                                startNode: childNode
                            };
                        } else if (contentInfo.type === "close") {
                            if (!lastContentNode) throw new Error('Unmatched closing content placeholder: "' + childNode.textContent + '" in "' + childNode.parentNode.innerHTML + '".');
                            lastContentNode.endNode = childNode;
                            contentDatas.push(lastContentNode);
                            lastContentNode = undefined;
                        }
                    }
                } else contentDatas = contentDatas.concat(parseNodeForContent(childNode));
            }
            return contentDatas;
        }
        // Public API
        // ----------
        function skateTemplateHtml() {
            var template = [].slice.call(arguments).join("");
            return function(target) {
                var frag = createFragmentFromNodeList(target.childNodes);
                target.innerHTML = template;
                cacheContentData(target);
                if (frag.childNodes.length) skateTemplateHtml.wrap(target).appendChild(frag);
            };
        }
        skateTemplateHtml.wrap = function(node) {
            if (!getData(node, "content")) setData(node, "content", parseNodeForContent(node));
            return wrapNodeWith(node, htmlTemplateParentWrapper(node));
        };
        // Exporting
        // ---------
        // Global.
        window.skateTemplateHtml = skateTemplateHtml;
        // AMD.
        if (typeof define === "function") define(function() {
            return skateTemplateHtml;
        });
        // CommonJS.
        if (typeof module === "object") module.exports = skateTemplateHtml;
    })();
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/debounce.js
(typeof window === "undefined" ? $parcel$global : window).__ee62e24d4acb40214d4f9e21b1a58bfc = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = debounce;
    exports.debounceImmediate = debounceImmediate;
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function debounce(func, wait) {
        var timeout;
        var result;
        return function() {
            var args = arguments;
            var context = this;
            var later = function later() {
                result = func.apply(context, args);
                context = args = null;
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            return result;
        };
    }
    (0, _globalize2.default)("debounce", debounce);
    function debounceImmediate(func, wait) {
        var timeout = null;
        var result;
        return function() {
            var context = this;
            var args = arguments;
            var later = function later() {
                timeout = context = args = null;
            };
            if (timeout === null) result = func.apply(context, args);
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            return result;
        };
    }
    (0, _globalize2.default)("debounceImmediate", debounceImmediate);
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/tether/tether.js
(typeof window === "undefined" ? $parcel$global : window).__fa684b4d01a07bdbba6bdddc34918300 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__fa684b4d01a07bdbba6bdddc34918300");
    define.amd = true;
    /*! tether 0.6.5 */ (function(root) {
        (function() {
            var Evented, addClass, defer, deferred, extend, flush, getBounds, getOffsetParent, getOrigin, getScrollBarSize, getScrollParent, hasClass, node, removeClass, uniqueId, updateClasses, zeroPosCache, __hasProp = {}.hasOwnProperty, __indexOf = [].indexOf || function(item) {
                for(var i = 0, l = this.length; i < l; i++){
                    if (i in this && this[i] === item) return i;
                }
                return -1;
            }, __slice = [].slice;
            if (this.Tether == null) this.Tether = {
                modules: []
            };
            getScrollParent = function(el) {
                var parent, position, scrollParent, style, _ref;
                position = getComputedStyle(el).position;
                if (position === "fixed") return el;
                scrollParent = void 0;
                parent = el;
                while(parent = parent.parentNode){
                    try {
                        style = getComputedStyle(parent);
                    } catch (_error) {}
                    if (style == null) return parent;
                    if (/(auto|scroll)/.test(style["overflow"] + style["overflow-y"] + style["overflow-x"])) {
                        if (position !== "absolute" || (_ref = style["position"]) === "relative" || _ref === "absolute" || _ref === "fixed") return parent;
                    }
                }
                return document.body;
            };
            uniqueId = function() {
                var id;
                id = 0;
                return function() {
                    return id++;
                };
            }();
            zeroPosCache = {};
            getOrigin = function(doc) {
                var id, k, node, v, _ref;
                node = doc._tetherZeroElement;
                if (node == null) {
                    node = doc.createElement("div");
                    node.setAttribute("data-tether-id", uniqueId());
                    extend(node.style, {
                        top: 0,
                        left: 0,
                        position: "absolute"
                    });
                    doc.body.appendChild(node);
                    doc._tetherZeroElement = node;
                }
                id = node.getAttribute("data-tether-id");
                if (zeroPosCache[id] == null) {
                    zeroPosCache[id] = {};
                    _ref = node.getBoundingClientRect();
                    for(k in _ref){
                        v = _ref[k];
                        zeroPosCache[id][k] = v;
                    }
                    defer(function() {
                        return zeroPosCache[id] = void 0;
                    });
                }
                return zeroPosCache[id];
            };
            node = null;
            getBounds = function(el) {
                var box, doc, docEl, k, origin, v, _ref;
                if (el === document) {
                    doc = document;
                    el = document.documentElement;
                } else doc = el.ownerDocument;
                docEl = doc.documentElement;
                box = {};
                _ref = el.getBoundingClientRect();
                for(k in _ref){
                    v = _ref[k];
                    box[k] = v;
                }
                origin = getOrigin(doc);
                box.top -= origin.top;
                box.left -= origin.left;
                if (box.width == null) box.width = document.body.scrollWidth - box.left - box.right;
                if (box.height == null) box.height = document.body.scrollHeight - box.top - box.bottom;
                box.top = box.top - docEl.clientTop;
                box.left = box.left - docEl.clientLeft;
                box.right = doc.body.clientWidth - box.width - box.left;
                box.bottom = doc.body.clientHeight - box.height - box.top;
                return box;
            };
            getOffsetParent = function(el) {
                return el.offsetParent || document.documentElement;
            };
            getScrollBarSize = function() {
                var inner, outer, width, widthContained, widthScroll;
                inner = document.createElement("div");
                inner.style.width = "100%";
                inner.style.height = "200px";
                outer = document.createElement("div");
                extend(outer.style, {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    pointerEvents: "none",
                    visibility: "hidden",
                    width: "200px",
                    height: "150px",
                    overflow: "hidden"
                });
                outer.appendChild(inner);
                document.body.appendChild(outer);
                widthContained = inner.offsetWidth;
                outer.style.overflow = "scroll";
                widthScroll = inner.offsetWidth;
                if (widthContained === widthScroll) widthScroll = outer.clientWidth;
                document.body.removeChild(outer);
                width = widthContained - widthScroll;
                return {
                    width: width,
                    height: width
                };
            };
            extend = function(out) {
                var args, key, obj, val, _i, _len, _ref;
                if (out == null) out = {};
                args = [];
                Array.prototype.push.apply(args, arguments);
                _ref = args.slice(1);
                for(_i = 0, _len = _ref.length; _i < _len; _i++){
                    obj = _ref[_i];
                    if (obj) for(key in obj){
                        if (!__hasProp.call(obj, key)) continue;
                        val = obj[key];
                        out[key] = val;
                    }
                }
                return out;
            };
            removeClass = function(el, name) {
                var cls, _i, _len, _ref, _results;
                if (el.classList != null) {
                    _ref = name.split(" ");
                    _results = [];
                    for(_i = 0, _len = _ref.length; _i < _len; _i++){
                        cls = _ref[_i];
                        if (cls.trim()) _results.push(el.classList.remove(cls));
                    }
                    return _results;
                } else return el.className = el.className.replace(new RegExp("(^| )" + name.split(" ").join("|") + "( |$)", "gi"), " ");
            };
            addClass = function(el, name) {
                var cls, _i, _len, _ref, _results;
                if (el.classList != null) {
                    _ref = name.split(" ");
                    _results = [];
                    for(_i = 0, _len = _ref.length; _i < _len; _i++){
                        cls = _ref[_i];
                        if (cls.trim()) _results.push(el.classList.add(cls));
                    }
                    return _results;
                } else {
                    removeClass(el, name);
                    return el.className += " " + name;
                }
            };
            hasClass = function(el, name) {
                if (el.classList != null) return el.classList.contains(name);
                else return new RegExp("(^| )" + name + "( |$)", "gi").test(el.className);
            };
            updateClasses = function(el, add, all) {
                var cls, _i, _j, _len, _len1, _results;
                for(_i = 0, _len = all.length; _i < _len; _i++){
                    cls = all[_i];
                    if (__indexOf.call(add, cls) < 0) {
                        if (hasClass(el, cls)) removeClass(el, cls);
                    }
                }
                _results = [];
                for(_j = 0, _len1 = add.length; _j < _len1; _j++){
                    cls = add[_j];
                    if (!hasClass(el, cls)) _results.push(addClass(el, cls));
                    else _results.push(void 0);
                }
                return _results;
            };
            deferred = [];
            defer = function(fn) {
                return deferred.push(fn);
            };
            flush = function() {
                var fn, _results;
                _results = [];
                while(fn = deferred.pop())_results.push(fn());
                return _results;
            };
            Evented = function() {
                function Evented() {}
                Evented.prototype.on = function(event, handler, ctx, once) {
                    var _base;
                    if (once == null) once = false;
                    if (this.bindings == null) this.bindings = {};
                    if ((_base = this.bindings)[event] == null) _base[event] = [];
                    return this.bindings[event].push({
                        handler: handler,
                        ctx: ctx,
                        once: once
                    });
                };
                Evented.prototype.once = function(event, handler, ctx) {
                    return this.on(event, handler, ctx, true);
                };
                Evented.prototype.off = function(event, handler) {
                    var i, _ref, _results;
                    if (((_ref = this.bindings) != null ? _ref[event] : void 0) == null) return;
                    if (handler == null) return delete this.bindings[event];
                    else {
                        i = 0;
                        _results = [];
                        while(i < this.bindings[event].length)if (this.bindings[event][i].handler === handler) _results.push(this.bindings[event].splice(i, 1));
                        else _results.push(i++);
                        return _results;
                    }
                };
                Evented.prototype.trigger = function() {
                    var args, ctx, event, handler, i, once, _ref, _ref1, _results;
                    event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
                    if ((_ref = this.bindings) != null ? _ref[event] : void 0) {
                        i = 0;
                        _results = [];
                        while(i < this.bindings[event].length){
                            _ref1 = this.bindings[event][i], handler = _ref1.handler, ctx = _ref1.ctx, once = _ref1.once;
                            handler.apply(ctx != null ? ctx : this, args);
                            if (once) _results.push(this.bindings[event].splice(i, 1));
                            else _results.push(i++);
                        }
                        return _results;
                    }
                };
                return Evented;
            }();
            this.Tether.Utils = {
                getScrollParent: getScrollParent,
                getBounds: getBounds,
                getOffsetParent: getOffsetParent,
                extend: extend,
                addClass: addClass,
                removeClass: removeClass,
                hasClass: hasClass,
                updateClasses: updateClasses,
                defer: defer,
                flush: flush,
                uniqueId: uniqueId,
                Evented: Evented,
                getScrollBarSize: getScrollBarSize
            };
        }).call(this);
        (function() {
            var MIRROR_LR, MIRROR_TB, OFFSET_MAP, Tether, addClass, addOffset, attachmentToOffset, autoToFixedAttachment, defer, extend, flush, getBounds, getOffsetParent, getOuterSize, getScrollBarSize, getScrollParent, getSize, now, offsetToPx, parseAttachment, parseOffset, position, removeClass, tethers, transformKey, updateClasses, within, _Tether, _ref, __slice = [].slice, __bind = function(fn, me) {
                return function() {
                    return fn.apply(me, arguments);
                };
            };
            if (this.Tether == null) throw new Error("You must include the utils.js file before tether.js");
            Tether = this.Tether;
            _ref = Tether.Utils, getScrollParent = _ref.getScrollParent, getSize = _ref.getSize, getOuterSize = _ref.getOuterSize, getBounds = _ref.getBounds, getOffsetParent = _ref.getOffsetParent, extend = _ref.extend, addClass = _ref.addClass, removeClass = _ref.removeClass, updateClasses = _ref.updateClasses, defer = _ref.defer, flush = _ref.flush, getScrollBarSize = _ref.getScrollBarSize;
            within = function(a, b, diff) {
                if (diff == null) diff = 1;
                return a + diff >= b && b >= a - diff;
            };
            transformKey = function() {
                var el, key, _i, _len, _ref1;
                el = document.createElement("div");
                _ref1 = [
                    "transform",
                    "webkitTransform",
                    "OTransform",
                    "MozTransform",
                    "msTransform"
                ];
                for(_i = 0, _len = _ref1.length; _i < _len; _i++){
                    key = _ref1[_i];
                    if (el.style[key] !== void 0) return key;
                }
            }();
            tethers = [];
            position = function() {
                var tether, _i, _len;
                for(_i = 0, _len = tethers.length; _i < _len; _i++){
                    tether = tethers[_i];
                    tether.position(false);
                }
                return flush();
            };
            now = function() {
                var _ref1;
                return (_ref1 = typeof performance !== "undefined" && performance !== null ? typeof performance.now === "function" ? performance.now() : void 0 : void 0) != null ? _ref1 : +new Date;
            };
            (function() {
                var event, lastCall, lastDuration, pendingTimeout, tick, _i, _len, _ref1, _results;
                lastCall = null;
                lastDuration = null;
                pendingTimeout = null;
                tick = function() {
                    if (lastDuration != null && lastDuration > 16) {
                        lastDuration = Math.min(lastDuration - 16, 250);
                        pendingTimeout = setTimeout(tick, 250);
                        return;
                    }
                    if (lastCall != null && now() - lastCall < 10) return;
                    if (pendingTimeout != null) {
                        clearTimeout(pendingTimeout);
                        pendingTimeout = null;
                    }
                    lastCall = now();
                    position();
                    return lastDuration = now() - lastCall;
                };
                _ref1 = [
                    "resize",
                    "scroll",
                    "touchmove"
                ];
                _results = [];
                for(_i = 0, _len = _ref1.length; _i < _len; _i++){
                    event = _ref1[_i];
                    _results.push(window.addEventListener(event, tick));
                }
                return _results;
            })();
            MIRROR_LR = {
                center: "center",
                left: "right",
                right: "left"
            };
            MIRROR_TB = {
                middle: "middle",
                top: "bottom",
                bottom: "top"
            };
            OFFSET_MAP = {
                top: 0,
                left: 0,
                middle: "50%",
                center: "50%",
                bottom: "100%",
                right: "100%"
            };
            autoToFixedAttachment = function(attachment, relativeToAttachment) {
                var left, top;
                left = attachment.left, top = attachment.top;
                if (left === "auto") left = MIRROR_LR[relativeToAttachment.left];
                if (top === "auto") top = MIRROR_TB[relativeToAttachment.top];
                return {
                    left: left,
                    top: top
                };
            };
            attachmentToOffset = function(attachment) {
                var _ref1, _ref2;
                return {
                    left: (_ref1 = OFFSET_MAP[attachment.left]) != null ? _ref1 : attachment.left,
                    top: (_ref2 = OFFSET_MAP[attachment.top]) != null ? _ref2 : attachment.top
                };
            };
            addOffset = function() {
                var left, offsets, out, top, _i, _len, _ref1;
                offsets = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
                out = {
                    top: 0,
                    left: 0
                };
                for(_i = 0, _len = offsets.length; _i < _len; _i++){
                    _ref1 = offsets[_i], top = _ref1.top, left = _ref1.left;
                    if (typeof top === "string") top = parseFloat(top, 10);
                    if (typeof left === "string") left = parseFloat(left, 10);
                    out.top += top;
                    out.left += left;
                }
                return out;
            };
            offsetToPx = function(offset, size) {
                if (typeof offset.left === "string" && offset.left.indexOf("%") !== -1) offset.left = parseFloat(offset.left, 10) / 100 * size.width;
                if (typeof offset.top === "string" && offset.top.indexOf("%") !== -1) offset.top = parseFloat(offset.top, 10) / 100 * size.height;
                return offset;
            };
            parseAttachment = parseOffset = function(value1) {
                var left, top, _ref1;
                _ref1 = value1.split(" "), top = _ref1[0], left = _ref1[1];
                return {
                    top: top,
                    left: left
                };
            };
            _Tether = function() {
                _Tether.modules = [];
                function _Tether(options) {
                    this.position = __bind(this.position, this);
                    var module, _i, _len, _ref1, _ref2;
                    tethers.push(this);
                    this.history = [];
                    this.setOptions(options, false);
                    _ref1 = Tether.modules;
                    for(_i = 0, _len = _ref1.length; _i < _len; _i++){
                        module = _ref1[_i];
                        if ((_ref2 = module.initialize) != null) _ref2.call(this);
                    }
                    this.position();
                }
                _Tether.prototype.getClass = function(key) {
                    var _ref1, _ref2;
                    if ((_ref1 = this.options.classes) != null ? _ref1[key] : void 0) return this.options.classes[key];
                    else if (((_ref2 = this.options.classes) != null ? _ref2[key] : void 0) !== false) {
                        if (this.options.classPrefix) return "" + this.options.classPrefix + "-" + key;
                        else return key;
                    } else return "";
                };
                _Tether.prototype.setOptions = function(options, position) {
                    var defaults, key, _i, _len, _ref1, _ref2;
                    this.options = options;
                    if (position == null) position = true;
                    defaults = {
                        offset: "0 0",
                        targetOffset: "0 0",
                        targetAttachment: "auto auto",
                        classPrefix: "tether"
                    };
                    this.options = extend(defaults, this.options);
                    _ref1 = this.options, this.element = _ref1.element, this.target = _ref1.target, this.targetModifier = _ref1.targetModifier;
                    if (this.target === "viewport") {
                        this.target = document.body;
                        this.targetModifier = "visible";
                    } else if (this.target === "scroll-handle") {
                        this.target = document.body;
                        this.targetModifier = "scroll-handle";
                    }
                    _ref2 = [
                        "element",
                        "target"
                    ];
                    for(_i = 0, _len = _ref2.length; _i < _len; _i++){
                        key = _ref2[_i];
                        if (this[key] == null) throw new Error("Tether Error: Both element and target must be defined");
                        if (this[key].jquery != null) this[key] = this[key][0];
                        else if (typeof this[key] === "string") this[key] = document.querySelector(this[key]);
                    }
                    addClass(this.element, this.getClass("element"));
                    addClass(this.target, this.getClass("target"));
                    if (!this.options.attachment) throw new Error("Tether Error: You must provide an attachment");
                    this.targetAttachment = parseAttachment(this.options.targetAttachment);
                    this.attachment = parseAttachment(this.options.attachment);
                    this.offset = parseOffset(this.options.offset);
                    this.targetOffset = parseOffset(this.options.targetOffset);
                    if (this.scrollParent != null) this.disable();
                    if (this.targetModifier === "scroll-handle") this.scrollParent = this.target;
                    else this.scrollParent = getScrollParent(this.target);
                    if (this.options.enabled !== false) return this.enable(position);
                };
                _Tether.prototype.getTargetBounds = function() {
                    var bounds, fitAdj, hasBottomScroll, height, out, scrollBottom, scrollPercentage, style, target;
                    if (this.targetModifier != null) switch(this.targetModifier){
                        case "visible":
                            if (this.target === document.body) return {
                                top: pageYOffset,
                                left: pageXOffset,
                                height: innerHeight,
                                width: innerWidth
                            };
                            else {
                                bounds = getBounds(this.target);
                                out = {
                                    height: bounds.height,
                                    width: bounds.width,
                                    top: bounds.top,
                                    left: bounds.left
                                };
                                out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
                                out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
                                out.height = Math.min(innerHeight, out.height);
                                out.height -= 2;
                                out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
                                out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
                                out.width = Math.min(innerWidth, out.width);
                                out.width -= 2;
                                if (out.top < pageYOffset) out.top = pageYOffset;
                                if (out.left < pageXOffset) out.left = pageXOffset;
                                return out;
                            }
                            break;
                        case "scroll-handle":
                            target = this.target;
                            if (target === document.body) {
                                target = document.documentElement;
                                bounds = {
                                    left: pageXOffset,
                                    top: pageYOffset,
                                    height: innerHeight,
                                    width: innerWidth
                                };
                            } else bounds = getBounds(target);
                            style = getComputedStyle(target);
                            hasBottomScroll = target.scrollWidth > target.clientWidth || (style.overflow, style.overflowX, false) || this.target !== document.body;
                            scrollBottom = 0;
                            if (hasBottomScroll) scrollBottom = 15;
                            height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;
                            out = {
                                width: 15,
                                height: height * 0.975 * (height / target.scrollHeight),
                                left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
                            };
                            fitAdj = 0;
                            if (height < 408 && this.target === document.body) fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
                            if (this.target !== document.body) out.height = Math.max(out.height, 24);
                            scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
                            out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);
                            if (this.target === document.body) out.height = Math.max(out.height, 24);
                            return out;
                    }
                    else return getBounds(this.target);
                };
                _Tether.prototype.clearCache = function() {
                    return this._cache = {};
                };
                _Tether.prototype.cache = function(k, getter) {
                    if (this._cache == null) this._cache = {};
                    if (this._cache[k] == null) this._cache[k] = getter.call(this);
                    return this._cache[k];
                };
                _Tether.prototype.enable = function(position) {
                    if (position == null) position = true;
                    addClass(this.target, this.getClass("enabled"));
                    addClass(this.element, this.getClass("enabled"));
                    this.enabled = true;
                    if (this.scrollParent !== document) this.scrollParent.addEventListener("scroll", this.position);
                    if (position) return this.position();
                };
                _Tether.prototype.disable = function() {
                    removeClass(this.target, this.getClass("enabled"));
                    removeClass(this.element, this.getClass("enabled"));
                    this.enabled = false;
                    if (this.scrollParent != null) return this.scrollParent.removeEventListener("scroll", this.position);
                };
                _Tether.prototype.destroy = function() {
                    var i, tether, _i, _len, _results;
                    this.disable();
                    _results = [];
                    for(i = _i = 0, _len = tethers.length; _i < _len; i = ++_i){
                        tether = tethers[i];
                        if (tether === this) {
                            tethers.splice(i, 1);
                            break;
                        } else _results.push(void 0);
                    }
                    return _results;
                };
                _Tether.prototype.updateAttachClasses = function(elementAttach, targetAttach) {
                    var add, all, side, sides, _i, _j, _len, _len1, _ref1, _this = this;
                    if (elementAttach == null) elementAttach = this.attachment;
                    if (targetAttach == null) targetAttach = this.targetAttachment;
                    sides = [
                        "left",
                        "top",
                        "bottom",
                        "right",
                        "middle",
                        "center"
                    ];
                    if ((_ref1 = this._addAttachClasses) != null ? _ref1.length : void 0) this._addAttachClasses.splice(0, this._addAttachClasses.length);
                    add = this._addAttachClasses != null ? this._addAttachClasses : this._addAttachClasses = [];
                    if (elementAttach.top) add.push("" + this.getClass("element-attached") + "-" + elementAttach.top);
                    if (elementAttach.left) add.push("" + this.getClass("element-attached") + "-" + elementAttach.left);
                    if (targetAttach.top) add.push("" + this.getClass("target-attached") + "-" + targetAttach.top);
                    if (targetAttach.left) add.push("" + this.getClass("target-attached") + "-" + targetAttach.left);
                    all = [];
                    for(_i = 0, _len = sides.length; _i < _len; _i++){
                        side = sides[_i];
                        all.push("" + this.getClass("element-attached") + "-" + side);
                    }
                    for(_j = 0, _len1 = sides.length; _j < _len1; _j++){
                        side = sides[_j];
                        all.push("" + this.getClass("target-attached") + "-" + side);
                    }
                    return defer(function() {
                        if (_this._addAttachClasses == null) return;
                        updateClasses(_this.element, _this._addAttachClasses, all);
                        updateClasses(_this.target, _this._addAttachClasses, all);
                        return _this._addAttachClasses = void 0;
                    });
                };
                _Tether.prototype.position = function(flushChanges) {
                    var elementPos, elementStyle, height, left, manualOffset, manualTargetOffset, module, next, offset, offsetBorder, offsetParent, offsetParentSize, offsetParentStyle, offsetPosition, ret, scrollLeft, scrollTop, scrollbarSize, side, targetAttachment, targetOffset, targetPos, targetSize, top, width, _i, _j, _len, _len1, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _this = this;
                    if (flushChanges == null) flushChanges = true;
                    if (!this.enabled) return;
                    this.clearCache();
                    targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);
                    this.updateAttachClasses(this.attachment, targetAttachment);
                    elementPos = this.cache("element-bounds", function() {
                        return getBounds(_this.element);
                    });
                    width = elementPos.width, height = elementPos.height;
                    if (width === 0 && height === 0 && this.lastSize != null) _ref1 = this.lastSize, width = _ref1.width, height = _ref1.height;
                    else this.lastSize = {
                        width: width,
                        height: height
                    };
                    targetSize = targetPos = this.cache("target-bounds", function() {
                        return _this.getTargetBounds();
                    });
                    offset = offsetToPx(attachmentToOffset(this.attachment), {
                        width: width,
                        height: height
                    });
                    targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);
                    manualOffset = offsetToPx(this.offset, {
                        width: width,
                        height: height
                    });
                    manualTargetOffset = offsetToPx(this.targetOffset, targetSize);
                    offset = addOffset(offset, manualOffset);
                    targetOffset = addOffset(targetOffset, manualTargetOffset);
                    left = targetPos.left + targetOffset.left - offset.left;
                    top = targetPos.top + targetOffset.top - offset.top;
                    _ref2 = Tether.modules;
                    for(_i = 0, _len = _ref2.length; _i < _len; _i++){
                        module = _ref2[_i];
                        ret = module.position.call(this, {
                            left: left,
                            top: top,
                            targetAttachment: targetAttachment,
                            targetPos: targetPos,
                            attachment: this.attachment,
                            elementPos: elementPos,
                            offset: offset,
                            targetOffset: targetOffset,
                            manualOffset: manualOffset,
                            manualTargetOffset: manualTargetOffset,
                            scrollbarSize: scrollbarSize
                        });
                        if (ret == null || typeof ret !== "object") continue;
                        else if (ret === false) return false;
                        else top = ret.top, left = ret.left;
                    }
                    next = {
                        page: {
                            top: top,
                            left: left
                        },
                        viewport: {
                            top: top - pageYOffset,
                            bottom: pageYOffset - top - height + innerHeight,
                            left: left - pageXOffset,
                            right: pageXOffset - left - width + innerWidth
                        }
                    };
                    if (document.body.scrollWidth > window.innerWidth) {
                        scrollbarSize = this.cache("scrollbar-size", getScrollBarSize);
                        next.viewport.bottom -= scrollbarSize.height;
                    }
                    if (document.body.scrollHeight > window.innerHeight) {
                        scrollbarSize = this.cache("scrollbar-size", getScrollBarSize);
                        next.viewport.right -= scrollbarSize.width;
                    }
                    if ((_ref3 = document.body.style.position) !== "" && _ref3 !== "static" || (_ref4 = document.body.parentElement.style.position) !== "" && _ref4 !== "static") {
                        next.page.bottom = document.body.scrollHeight - top - height;
                        next.page.right = document.body.scrollWidth - left - width;
                    }
                    if (((_ref5 = this.options.optimizations) != null ? _ref5.moveElement : void 0) !== false && this.targetModifier == null) {
                        offsetParent = this.cache("target-offsetparent", function() {
                            return getOffsetParent(_this.target);
                        });
                        offsetPosition = this.cache("target-offsetparent-bounds", function() {
                            return getBounds(offsetParent);
                        });
                        offsetParentStyle = getComputedStyle(offsetParent);
                        elementStyle = getComputedStyle(this.element);
                        offsetParentSize = offsetPosition;
                        offsetBorder = {};
                        _ref6 = [
                            "Top",
                            "Left",
                            "Bottom",
                            "Right"
                        ];
                        for(_j = 0, _len1 = _ref6.length; _j < _len1; _j++){
                            side = _ref6[_j];
                            offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle["border" + side + "Width"]);
                        }
                        offsetPosition.right = document.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
                        offsetPosition.bottom = document.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;
                        if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
                            if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
                                scrollTop = offsetParent.scrollTop;
                                scrollLeft = offsetParent.scrollLeft;
                                next.offset = {
                                    top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
                                    left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
                                };
                            }
                        }
                    }
                    this.move(next);
                    this.history.unshift(next);
                    if (this.history.length > 3) this.history.pop();
                    if (flushChanges) flush();
                    return true;
                };
                _Tether.prototype.move = function(position) {
                    var css, elVal, found, key, moved, offsetParent, point, same, transcribe, type, val, write, writeCSS, _i, _len, _ref1, _ref2, _this = this;
                    if (this.element.parentNode == null) return;
                    same = {};
                    for(type in position){
                        same[type] = {};
                        for(key in position[type]){
                            found = false;
                            _ref1 = this.history;
                            for(_i = 0, _len = _ref1.length; _i < _len; _i++){
                                point = _ref1[_i];
                                if (!within((_ref2 = point[type]) != null ? _ref2[key] : void 0, position[type][key])) {
                                    found = true;
                                    break;
                                }
                            }
                            if (!found) same[type][key] = true;
                        }
                    }
                    css = {
                        top: "",
                        left: "",
                        right: "",
                        bottom: ""
                    };
                    transcribe = function(same, pos) {
                        var xPos, yPos, _ref3;
                        if (((_ref3 = _this.options.optimizations) != null ? _ref3.gpu : void 0) !== false) {
                            if (same.top) {
                                css.top = 0;
                                yPos = pos.top;
                            } else {
                                css.bottom = 0;
                                yPos = -pos.bottom;
                            }
                            if (same.left) {
                                css.left = 0;
                                xPos = pos.left;
                            } else {
                                css.right = 0;
                                xPos = -pos.right;
                            }
                            css[transformKey] = "translateX(" + Math.round(xPos) + "px) translateY(" + Math.round(yPos) + "px)";
                            if (transformKey !== "msTransform") return css[transformKey] += " translateZ(0)";
                        } else {
                            if (same.top) css.top = "" + pos.top + "px";
                            else css.bottom = "" + pos.bottom + "px";
                            if (same.left) return css.left = "" + pos.left + "px";
                            else return css.right = "" + pos.right + "px";
                        }
                    };
                    moved = false;
                    if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
                        css.position = "absolute";
                        transcribe(same.page, position.page);
                    } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
                        css.position = "fixed";
                        transcribe(same.viewport, position.viewport);
                    } else if (same.offset != null && same.offset.top && same.offset.left) {
                        css.position = "absolute";
                        offsetParent = this.cache("target-offsetparent", function() {
                            return getOffsetParent(_this.target);
                        });
                        if (getOffsetParent(this.element) !== offsetParent) defer(function() {
                            _this.element.parentNode.removeChild(_this.element);
                            return offsetParent.appendChild(_this.element);
                        });
                        transcribe(same.offset, position.offset);
                        moved = true;
                    } else {
                        css.position = "absolute";
                        transcribe({
                            top: true,
                            left: true
                        }, position.page);
                    }
                    if (!moved && this.element.parentNode.tagName !== "BODY") {
                        this.element.parentNode.removeChild(this.element);
                        document.body.appendChild(this.element);
                    }
                    writeCSS = {};
                    write = false;
                    for(key in css){
                        val = css[key];
                        elVal = this.element.style[key];
                        if (elVal !== "" && val !== "" && (key === "top" || key === "left" || key === "bottom" || key === "right")) {
                            elVal = parseFloat(elVal);
                            val = parseFloat(val);
                        }
                        if (elVal !== val) {
                            write = true;
                            writeCSS[key] = css[key];
                        }
                    }
                    if (write) return defer(function() {
                        return extend(_this.element.style, writeCSS);
                    });
                };
                return _Tether;
            }();
            Tether.position = position;
            this.Tether = extend(_Tether, Tether);
        }).call(this);
        (function() {
            var BOUNDS_FORMAT, MIRROR_ATTACH, defer, extend, getBoundingRect, getBounds, getOuterSize, getSize, updateClasses, _ref, __indexOf = [].indexOf || function(item) {
                for(var i = 0, l = this.length; i < l; i++){
                    if (i in this && this[i] === item) return i;
                }
                return -1;
            };
            _ref = this.Tether.Utils, getOuterSize = _ref.getOuterSize, getBounds = _ref.getBounds, getSize = _ref.getSize, extend = _ref.extend, updateClasses = _ref.updateClasses, defer = _ref.defer;
            MIRROR_ATTACH = {
                left: "right",
                right: "left",
                top: "bottom",
                bottom: "top",
                middle: "middle"
            };
            BOUNDS_FORMAT = [
                "left",
                "top",
                "right",
                "bottom"
            ];
            getBoundingRect = function(tether, to) {
                var i, pos, side, size, style, _i, _len;
                if (to === "scrollParent") to = tether.scrollParent;
                else if (to === "window") to = [
                    pageXOffset,
                    pageYOffset,
                    innerWidth + pageXOffset,
                    innerHeight + pageYOffset
                ];
                if (to === document) to = to.documentElement;
                if (to.nodeType != null) {
                    pos = size = getBounds(to);
                    style = getComputedStyle(to);
                    to = [
                        pos.left,
                        pos.top,
                        size.width + pos.left,
                        size.height + pos.top
                    ];
                    for(i = _i = 0, _len = BOUNDS_FORMAT.length; _i < _len; i = ++_i){
                        side = BOUNDS_FORMAT[i];
                        side = side[0].toUpperCase() + side.substr(1);
                        if (side === "Top" || side === "Left") to[i] += parseFloat(style["border" + side + "Width"]);
                        else to[i] -= parseFloat(style["border" + side + "Width"]);
                    }
                }
                return to;
            };
            this.Tether.modules.push({
                position: function(_arg) {
                    var addClasses, allClasses, attachment, bounds, changeAttachX, changeAttachY, cls, constraint, eAttachment, height, left, oob, oobClass, p, pin, pinned, pinnedClass, removeClass, side, tAttachment, targetAttachment, targetHeight, targetSize, targetWidth, to, top, width, _i, _j, _k, _l, _len, _len1, _len2, _len3, _len4, _len5, _m, _n, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _this = this;
                    top = _arg.top, left = _arg.left, targetAttachment = _arg.targetAttachment;
                    if (!this.options.constraints) return true;
                    removeClass = function(prefix) {
                        var side, _i, _len, _results;
                        _this.removeClass(prefix);
                        _results = [];
                        for(_i = 0, _len = BOUNDS_FORMAT.length; _i < _len; _i++){
                            side = BOUNDS_FORMAT[_i];
                            _results.push(_this.removeClass("" + prefix + "-" + side));
                        }
                        return _results;
                    };
                    _ref1 = this.cache("element-bounds", function() {
                        return getBounds(_this.element);
                    }), height = _ref1.height, width = _ref1.width;
                    if (width === 0 && height === 0 && this.lastSize != null) _ref2 = this.lastSize, width = _ref2.width, height = _ref2.height;
                    targetSize = this.cache("target-bounds", function() {
                        return _this.getTargetBounds();
                    });
                    targetHeight = targetSize.height;
                    targetWidth = targetSize.width;
                    tAttachment = {};
                    eAttachment = {};
                    allClasses = [
                        this.getClass("pinned"),
                        this.getClass("out-of-bounds")
                    ];
                    _ref3 = this.options.constraints;
                    for(_i = 0, _len = _ref3.length; _i < _len; _i++){
                        constraint = _ref3[_i];
                        if (constraint.outOfBoundsClass) allClasses.push(constraint.outOfBoundsClass);
                        if (constraint.pinnedClass) allClasses.push(constraint.pinnedClass);
                    }
                    for(_j = 0, _len1 = allClasses.length; _j < _len1; _j++){
                        cls = allClasses[_j];
                        _ref4 = [
                            "left",
                            "top",
                            "right",
                            "bottom"
                        ];
                        for(_k = 0, _len2 = _ref4.length; _k < _len2; _k++){
                            side = _ref4[_k];
                            allClasses.push("" + cls + "-" + side);
                        }
                    }
                    addClasses = [];
                    tAttachment = extend({}, targetAttachment);
                    eAttachment = extend({}, this.attachment);
                    _ref5 = this.options.constraints;
                    for(_l = 0, _len3 = _ref5.length; _l < _len3; _l++){
                        constraint = _ref5[_l];
                        to = constraint.to, attachment = constraint.attachment, pin = constraint.pin;
                        if (attachment == null) attachment = "";
                        if (__indexOf.call(attachment, " ") >= 0) _ref6 = attachment.split(" "), changeAttachY = _ref6[0], changeAttachX = _ref6[1];
                        else changeAttachX = changeAttachY = attachment;
                        bounds = getBoundingRect(this, to);
                        if (changeAttachY === "target" || changeAttachY === "both") {
                            if (top < bounds[1] && tAttachment.top === "top") {
                                top += targetHeight;
                                tAttachment.top = "bottom";
                            }
                            if (top + height > bounds[3] && tAttachment.top === "bottom") {
                                top -= targetHeight;
                                tAttachment.top = "top";
                            }
                        }
                        if (changeAttachY === "together") {
                            if (top < bounds[1] && tAttachment.top === "top") {
                                if (eAttachment.top === "bottom") {
                                    top += targetHeight;
                                    tAttachment.top = "bottom";
                                    top += height;
                                    eAttachment.top = "top";
                                } else if (eAttachment.top === "top") {
                                    top += targetHeight;
                                    tAttachment.top = "bottom";
                                    top -= height;
                                    eAttachment.top = "bottom";
                                }
                            }
                            if (top + height > bounds[3] && tAttachment.top === "bottom") {
                                if (eAttachment.top === "top") {
                                    top -= targetHeight;
                                    tAttachment.top = "top";
                                    top -= height;
                                    eAttachment.top = "bottom";
                                } else if (eAttachment.top === "bottom") {
                                    top -= targetHeight;
                                    tAttachment.top = "top";
                                    top += height;
                                    eAttachment.top = "top";
                                }
                            }
                            if (tAttachment.top === "middle") {
                                if (top + height > bounds[3] && eAttachment.top === "top") {
                                    top -= height;
                                    eAttachment.top = "bottom";
                                } else if (top < bounds[1] && eAttachment.top === "bottom") {
                                    top += height;
                                    eAttachment.top = "top";
                                }
                            }
                        }
                        if (changeAttachX === "target" || changeAttachX === "both") {
                            if (left < bounds[0] && tAttachment.left === "left") {
                                left += targetWidth;
                                tAttachment.left = "right";
                            }
                            if (left + width > bounds[2] && tAttachment.left === "right") {
                                left -= targetWidth;
                                tAttachment.left = "left";
                            }
                        }
                        if (changeAttachX === "together") {
                            if (left < bounds[0] && tAttachment.left === "left") {
                                if (eAttachment.left === "right") {
                                    left += targetWidth;
                                    tAttachment.left = "right";
                                    left += width;
                                    eAttachment.left = "left";
                                } else if (eAttachment.left === "left") {
                                    left += targetWidth;
                                    tAttachment.left = "right";
                                    left -= width;
                                    eAttachment.left = "right";
                                }
                            } else if (left + width > bounds[2] && tAttachment.left === "right") {
                                if (eAttachment.left === "left") {
                                    left -= targetWidth;
                                    tAttachment.left = "left";
                                    left -= width;
                                    eAttachment.left = "right";
                                } else if (eAttachment.left === "right") {
                                    left -= targetWidth;
                                    tAttachment.left = "left";
                                    left += width;
                                    eAttachment.left = "left";
                                }
                            } else if (tAttachment.left === "center") {
                                if (left + width > bounds[2] && eAttachment.left === "left") {
                                    left -= width;
                                    eAttachment.left = "right";
                                } else if (left < bounds[0] && eAttachment.left === "right") {
                                    left += width;
                                    eAttachment.left = "left";
                                }
                            }
                        }
                        if (changeAttachY === "element" || changeAttachY === "both") {
                            if (top < bounds[1] && eAttachment.top === "bottom") {
                                top += height;
                                eAttachment.top = "top";
                            }
                            if (top + height > bounds[3] && eAttachment.top === "top") {
                                top -= height;
                                eAttachment.top = "bottom";
                            }
                        }
                        if (changeAttachX === "element" || changeAttachX === "both") {
                            if (left < bounds[0] && eAttachment.left === "right") {
                                left += width;
                                eAttachment.left = "left";
                            }
                            if (left + width > bounds[2] && eAttachment.left === "left") {
                                left -= width;
                                eAttachment.left = "right";
                            }
                        }
                        if (typeof pin === "string") pin = function() {
                            var _len4, _m, _ref7, _results;
                            _ref7 = pin.split(",");
                            _results = [];
                            for(_m = 0, _len4 = _ref7.length; _m < _len4; _m++){
                                p = _ref7[_m];
                                _results.push(p.trim());
                            }
                            return _results;
                        }();
                        else if (pin === true) pin = [
                            "top",
                            "left",
                            "right",
                            "bottom"
                        ];
                        pin || (pin = []);
                        pinned = [];
                        oob = [];
                        if (top < bounds[1]) {
                            if (__indexOf.call(pin, "top") >= 0) {
                                top = bounds[1];
                                pinned.push("top");
                            } else oob.push("top");
                        }
                        if (top + height > bounds[3]) {
                            if (__indexOf.call(pin, "bottom") >= 0) {
                                top = bounds[3] - height;
                                pinned.push("bottom");
                            } else oob.push("bottom");
                        }
                        if (left < bounds[0]) {
                            if (__indexOf.call(pin, "left") >= 0) {
                                left = bounds[0];
                                pinned.push("left");
                            } else oob.push("left");
                        }
                        if (left + width > bounds[2]) {
                            if (__indexOf.call(pin, "right") >= 0) {
                                left = bounds[2] - width;
                                pinned.push("right");
                            } else oob.push("right");
                        }
                        if (pinned.length) {
                            pinnedClass = (_ref7 = this.options.pinnedClass) != null ? _ref7 : this.getClass("pinned");
                            addClasses.push(pinnedClass);
                            for(_m = 0, _len4 = pinned.length; _m < _len4; _m++){
                                side = pinned[_m];
                                addClasses.push("" + pinnedClass + "-" + side);
                            }
                        }
                        if (oob.length) {
                            oobClass = (_ref8 = this.options.outOfBoundsClass) != null ? _ref8 : this.getClass("out-of-bounds");
                            addClasses.push(oobClass);
                            for(_n = 0, _len5 = oob.length; _n < _len5; _n++){
                                side = oob[_n];
                                addClasses.push("" + oobClass + "-" + side);
                            }
                        }
                        if (__indexOf.call(pinned, "left") >= 0 || __indexOf.call(pinned, "right") >= 0) eAttachment.left = tAttachment.left = false;
                        if (__indexOf.call(pinned, "top") >= 0 || __indexOf.call(pinned, "bottom") >= 0) eAttachment.top = tAttachment.top = false;
                        if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== this.attachment.top || eAttachment.left !== this.attachment.left) this.updateAttachClasses(eAttachment, tAttachment);
                    }
                    defer(function() {
                        updateClasses(_this.target, addClasses, allClasses);
                        return updateClasses(_this.element, addClasses, allClasses);
                    });
                    return {
                        top: top,
                        left: left
                    };
                }
            });
        }).call(this);
        (function() {
            var defer, getBounds, updateClasses, _ref;
            _ref = this.Tether.Utils, getBounds = _ref.getBounds, updateClasses = _ref.updateClasses, defer = _ref.defer;
            this.Tether.modules.push({
                position: function(_arg) {
                    var abutted, addClasses, allClasses, bottom, height, left, right, side, sides, targetPos, top, width, _i, _j, _k, _l, _len, _len1, _len2, _len3, _ref1, _ref2, _ref3, _ref4, _ref5, _this = this;
                    top = _arg.top, left = _arg.left;
                    _ref1 = this.cache("element-bounds", function() {
                        return getBounds(_this.element);
                    }), height = _ref1.height, width = _ref1.width;
                    targetPos = this.getTargetBounds();
                    bottom = top + height;
                    right = left + width;
                    abutted = [];
                    if (top <= targetPos.bottom && bottom >= targetPos.top) {
                        _ref2 = [
                            "left",
                            "right"
                        ];
                        for(_i = 0, _len = _ref2.length; _i < _len; _i++){
                            side = _ref2[_i];
                            if ((_ref3 = targetPos[side]) === left || _ref3 === right) abutted.push(side);
                        }
                    }
                    if (left <= targetPos.right && right >= targetPos.left) {
                        _ref4 = [
                            "top",
                            "bottom"
                        ];
                        for(_j = 0, _len1 = _ref4.length; _j < _len1; _j++){
                            side = _ref4[_j];
                            if ((_ref5 = targetPos[side]) === top || _ref5 === bottom) abutted.push(side);
                        }
                    }
                    allClasses = [];
                    addClasses = [];
                    sides = [
                        "left",
                        "top",
                        "right",
                        "bottom"
                    ];
                    allClasses.push(this.getClass("abutted"));
                    for(_k = 0, _len2 = sides.length; _k < _len2; _k++){
                        side = sides[_k];
                        allClasses.push("" + this.getClass("abutted") + "-" + side);
                    }
                    if (abutted.length) addClasses.push(this.getClass("abutted"));
                    for(_l = 0, _len3 = abutted.length; _l < _len3; _l++){
                        side = abutted[_l];
                        addClasses.push("" + this.getClass("abutted") + "-" + side);
                    }
                    defer(function() {
                        updateClasses(_this.target, addClasses, allClasses);
                        return updateClasses(_this.element, addClasses, allClasses);
                    });
                    return true;
                }
            });
        }).call(this);
        (function() {
            this.Tether.modules.push({
                position: function(_arg) {
                    var left, result, shift, shiftLeft, shiftTop, top, _ref;
                    top = _arg.top, left = _arg.left;
                    if (!this.options.shift) return;
                    result = function(val) {
                        if (typeof val === "function") return val.call(this, {
                            top: top,
                            left: left
                        });
                        else return val;
                    };
                    shift = result(this.options.shift);
                    if (typeof shift === "string") {
                        shift = shift.split(" ");
                        shift[1] || (shift[1] = shift[0]);
                        shiftTop = shift[0], shiftLeft = shift[1];
                        shiftTop = parseFloat(shiftTop, 10);
                        shiftLeft = parseFloat(shiftLeft, 10);
                    } else _ref = [
                        shift.top,
                        shift.left
                    ], shiftTop = _ref[0], shiftLeft = _ref[1];
                    top += shiftTop;
                    left += shiftLeft;
                    return {
                        top: top,
                        left: left
                    };
                }
            });
        }).call(this);
        root.Tether = this.Tether;
        if (typeof define === "function") define([], function() {
            return root.Tether;
        });
        else if (typeof exports === "object") module.exports = root.Tether;
    })(this);
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/alignment.js
(typeof window === "undefined" ? $parcel$global : window).__81deba69899d0f1851f2c511b87bbbae = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var _tether = __fa684b4d01a07bdbba6bdddc34918300;
    var _tether2 = _interopRequireDefault(_tether);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var ATTR_ALIGNMENT = "alignment";
    var ATTR_ALIGNMENT_STATIC = "alignment-static";
    var ATTR_CONTAINER = "alignment-container";
    var CLASS_PREFIX_ALIGNMENT = "aui-alignment";
    var CLASS_PREFIX_SIDE = "aui-alignment-side-";
    var CLASS_PREFIX_SNAP = "aui-alignment-snap-";
    var DEFAULT_ATTACHMENT = "right middle";
    var attachmentMap = {
        "top left": {
            el: "bottom left",
            target: "top left"
        },
        "top center": {
            el: "bottom center",
            target: "top center"
        },
        "top right": {
            el: "bottom right",
            target: "top right"
        },
        "right top": {
            el: "top left",
            target: "top right"
        },
        "right middle": {
            el: "middle left",
            target: "middle right"
        },
        "right bottom": {
            el: "bottom left",
            target: "bottom right"
        },
        "bottom left": {
            el: "top left",
            target: "bottom left"
        },
        "bottom center": {
            el: "top center",
            target: "bottom center"
        },
        "bottom right": {
            el: "top right",
            target: "bottom right"
        },
        "left top": {
            el: "top right",
            target: "top left"
        },
        "left middle": {
            el: "middle right",
            target: "middle left"
        },
        "left bottom": {
            el: "bottom right",
            target: "bottom left"
        },
        "submenu left": {
            el: "top left",
            target: "top right"
        },
        "submenu right": {
            el: "top right",
            target: "top left"
        }
    };
    function hasClass(element, className) {
        return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
    }
    function addAlignmentClasses(element, side, snap) {
        var sideClass = CLASS_PREFIX_SIDE + side;
        var snapClass = CLASS_PREFIX_SNAP + snap;
        if (!hasClass(element, sideClass)) element.className += " " + sideClass;
        if (!hasClass(element, snapClass)) element.className += " " + snapClass;
    }
    function getAttribute(element, name) {
        return element.getAttribute(name) || element.getAttribute("data-aui-" + name);
    }
    function hasAttribute(element, name) {
        return element.hasAttribute(name) || element.hasAttribute("data-aui-" + name);
    }
    function getAlignment(element) {
        var _split = (getAttribute(element, ATTR_ALIGNMENT) || DEFAULT_ATTACHMENT).split(" "), _split2 = _slicedToArray(_split, 2), side = _split2[0], snap = _split2[1];
        return {
            side: side,
            snap: snap
        };
    }
    function getContainer(element) {
        var container = getAttribute(element, ATTR_CONTAINER) || window;
        if (typeof container === "string") container = document.querySelector(container);
        return container;
    }
    function calculateBestAlignmentSnap(target, container) {
        var snap = "left";
        if (!container || container === window || container === document) container = document.documentElement;
        if (container && container.nodeType && container.nodeType === Node.ELEMENT_NODE) {
            var containerBounds = container.getBoundingClientRect();
            var targetBounds = target.getBoundingClientRect();
            if (targetBounds.left > containerBounds.right / 2) snap = "right";
        }
        return snap;
    }
    function getAttachment(side, snap) {
        return attachmentMap[side + " " + snap] || attachmentMap[DEFAULT_ATTACHMENT];
    }
    function Alignment(element, target) {
        var container = getContainer(element);
        var alignment = getAlignment(element);
        if (!alignment.snap || alignment.snap === "auto") alignment.snap = calculateBestAlignmentSnap(target, container);
        var attachment = getAttachment(alignment.side, alignment.snap);
        var isStaticallyAligned = hasAttribute(element, ATTR_ALIGNMENT_STATIC);
        var tether = new _tether2.default({
            enabled: false,
            element: element,
            target: target,
            attachment: attachment.el,
            targetAttachment: attachment.target,
            classPrefix: CLASS_PREFIX_ALIGNMENT,
            constraints: [
                {
                    // Try and keep the element on page
                    to: container === window ? "window" : container,
                    attachment: isStaticallyAligned === true ? "none" : "together"
                }
            ]
        });
        addAlignmentClasses(element, alignment.side, alignment.snap);
        this._auiTether = tether;
    }
    Alignment.prototype = {
        /**
       * Stops aligning and cleans up.
       *
       * @returns {Alignment}
       */ destroy: function destroy() {
            this._auiTether.destroy();
            return this;
        },
        /**
       * Disables alignment.
       *
       * @returns {Alignment}
       */ disable: function disable() {
            this._auiTether.disable();
            return this;
        },
        /**
       * Enables alignment.
       *
       * @returns {Alignment}
       */ enable: function enable() {
            this._auiTether.enable();
            return this;
        }
    };
    exports.default = Alignment;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/polyfills/custom-event.js
(typeof window === "undefined" ? $parcel$global : window).__f7a5e0d2ea8865b104efc9b94861591e = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var CustomEvent = void 0;
    (function() {
        if (window.CustomEvent) // Some browsers don't support constructable custom events yet.
        try {
            var ce = new window.CustomEvent("name", {
                bubbles: false,
                cancelable: true,
                detail: {
                    x: "y"
                }
            });
            ce.preventDefault();
            if (ce.defaultPrevented !== true) throw new Error("Could not prevent default");
            if (ce.type !== "name") throw new Error("Could not set custom name");
            if (ce.detail.x !== "y") throw new Error("Could not set detail");
            CustomEvent = window.CustomEvent;
            return;
        } catch (e) {
        // polyfill it
        }
        /**
       * @type CustomEvent
       * @param {String} event - the name of the event.
       * @param {Object} [params] - optional configuration of the custom event.
       * @param {Boolean} [params.cancelable=false] - A boolean indicating whether the event is cancelable (i.e., can call preventDefault and set the defaultPrevented property).
       * @param {Boolean} [params.bubbles=false] - A boolean indicating whether the event bubbles up through the DOM or not.
       * @param {Boolean} [params.detail] - The data passed when initializing the event.
       * @extends Event
       * @returns {Event}
       * @constructor
       */ CustomEvent = function CustomEvent(event, params) {
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined
            };
            var evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(event, !!params.bubbles, !!params.cancelable, params.detail);
            var origPrevent = evt.preventDefault;
            evt.preventDefault = function() {
                origPrevent.call(this);
                try {
                    Object.defineProperty(this, "defaultPrevented", {
                        get: function get() {
                            return true;
                        }
                    });
                } catch (e) {
                    this.defaultPrevented = true;
                }
            };
            return evt;
        };
        CustomEvent.prototype = window.Event.prototype;
    })();
    exports.default = CustomEvent;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/blanket.js
(typeof window === "undefined" ? $parcel$global : window).__4c4f13d92d5dcb8f12059ce701946463 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.undim = exports.dim = undefined;
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var _animation = __6debdf74a4da8ac8391a98223e1bae21;
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var overflowEl;
    var _hiddenByAui = [];
    /**
   * Dims the screen using a blanket div
   * @param useShim deprecated, it is calculated by dim() now
   */ function dim(useShim, zIndex) {
        //if we're blanketing the page it means we want to hide the whatever is under the blanket from the screen readers as well
        function hasAriaHidden(element) {
            return element.hasAttribute("aria-hidden");
        }
        function isAuiLayer(element) {
            return element.classList.contains("aui-layer");
        }
        Array.prototype.forEach.call(document.body.children, function(element) {
            if (!hasAriaHidden(element) && !isAuiLayer(element)) {
                element.setAttribute("aria-hidden", "true");
                _hiddenByAui.push(element);
            }
        });
        if (!overflowEl) overflowEl = document.body;
        if (useShim === true) useShimDeprecationLogger();
        var isBlanketShowing = !!dim.$dim && dim.$dim.attr("aria-hidden") === "false";
        if (!!dim.$dim) {
            dim.$dim.remove();
            dim.$dim = null;
        }
        dim.$dim = (0, _jquery2.default)("<div></div>").addClass("aui-blanket");
        dim.$dim.attr("tabindex", "0"); //required, or the last element's focusout event will go to the browser
        dim.$dim.appendTo(document.body);
        if (!isBlanketShowing) {
            //recompute after insertion and before setting aria-hidden=false to ensure we calculate a difference in
            //computed styles
            (0, _animation.recomputeStyle)(dim.$dim);
            dim.cachedOverflow = {
                overflow: overflowEl.style.overflow,
                overflowX: overflowEl.style.overflowX,
                overflowY: overflowEl.style.overflowY
            };
            overflowEl.style.overflowX = "hidden";
            overflowEl.style.overflowY = "hidden";
            overflowEl.style.overflow = "hidden";
        }
        dim.$dim.attr("aria-hidden", "false");
        if (zIndex) dim.$dim.css({
            zIndex: zIndex
        });
        return dim.$dim;
    }
    /**
   * Removes semitransparent DIV
   * @see dim
   */ function undim() {
        _hiddenByAui.forEach(function(element) {
            element.removeAttribute("aria-hidden");
        });
        _hiddenByAui = [];
        if (dim.$dim) {
            dim.$dim.attr("aria-hidden", "true");
            if (overflowEl) {
                overflowEl.style.overflow = dim.cachedOverflow.overflow;
                overflowEl.style.overflowX = dim.cachedOverflow.overflowX;
                overflowEl.style.overflowY = dim.cachedOverflow.overflowY;
            }
        }
    }
    var useShimDeprecationLogger = (0, _deprecation.getMessageLogger)("useShim", {
        extraInfo: "useShim has no alternative as it is now calculated by dim()."
    });
    (0, _globalize2.default)("dim", dim);
    (0, _globalize2.default)("undim", undim);
    exports.dim = dim;
    exports.undim = undim;
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/focus-manager.js
(typeof window === "undefined" ? $parcel$global : window).__f65d8c24422fc9cfa97e7b7162425c04 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    (function initSelectors() {
        /*
      :tabbable and :focusable functions from jQuery UI v 1.10.4
      renamed to :aui-tabbable and :aui-focusable to not clash with jquery-ui if it's included.
      Code modified slightly to be compatible with jQuery < 1.8
      .addBack() replaced with .andSelf()
      $.curCSS() replaced with $.css()
       */ function visible(element) {
            return _jquery2.default.css(element, "visibility") === "visible";
        }
        function focusable(element, isTabIndexNotNaN) {
            var nodeName = element.nodeName.toLowerCase();
            if (nodeName === "aui-select") return true;
            if (nodeName === "area") {
                var map = element.parentNode;
                var mapName = map.name;
                var imageMap = (0, _jquery2.default)("img[usemap=#" + mapName + "]").get();
                if (!element.href || !mapName || map.nodeName.toLowerCase() !== "map") return false;
                return imageMap && visible(imageMap);
            }
            var isFormElement = /input|select|textarea|button|object/.test(nodeName);
            var isAnchor = nodeName === "a";
            var isAnchorTabbable = element.href || isTabIndexNotNaN;
            return (isFormElement ? !element.disabled : isAnchor ? isAnchorTabbable : isTabIndexNotNaN) && visible(element);
        }
        function tabbable(element) {
            var tabIndex = _jquery2.default.attr(element, "tabindex");
            var isTabIndexNaN = isNaN(tabIndex);
            var hasTabIndex = isTabIndexNaN || tabIndex >= 0;
            return hasTabIndex && focusable(element, !isTabIndexNaN);
        }
        _jquery2.default.extend(_jquery2.default.expr[":"], {
            "aui-focusable": function auiFocusable(element) {
                return focusable(element, !isNaN(_jquery2.default.attr(element, "tabindex")));
            },
            "aui-tabbable": tabbable
        });
    })();
    var RESTORE_FOCUS_DATA_KEY = "_aui-focus-restore";
    function FocusManager() {
        this._focusTrapStack = [];
        (0, _jquery2.default)(document).on("focusout", {
            focusTrapStack: this._focusTrapStack
        }, focusTrapHandler);
    }
    FocusManager.defaultFocusSelector = ":aui-tabbable";
    FocusManager.prototype.enter = function($el) {
        // remember focus on old element
        $el.data(RESTORE_FOCUS_DATA_KEY, (0, _jquery2.default)(document.activeElement));
        // focus on new selector
        if ($el.attr("data-aui-focus") !== "false") {
            var focusSelector = $el.attr("data-aui-focus-selector") || FocusManager.defaultFocusSelector;
            var $focusEl = $el.is(focusSelector) ? $el : $el.find(focusSelector);
            $focusEl.first().focus();
        }
        if (elementTrapsFocus($el)) trapFocus($el, this._focusTrapStack);
    };
    function trapFocus($el, focusTrapStack) {
        focusTrapStack.push($el);
    }
    function untrapFocus(focusTrapStack) {
        focusTrapStack.pop();
    }
    function elementTrapsFocus($el) {
        return $el.is(".aui-dialog2");
    }
    FocusManager.prototype.exit = function($el) {
        if (elementTrapsFocus($el)) untrapFocus(this._focusTrapStack);
        // AUI-1059: remove focus from the active element when dialog is hidden
        var activeElement = document.activeElement;
        if ($el[0] === activeElement || $el.has(activeElement).length) (0, _jquery2.default)(activeElement).blur();
        var $restoreFocus = $el.data(RESTORE_FOCUS_DATA_KEY);
        if ($restoreFocus && $restoreFocus.length) {
            $el.removeData(RESTORE_FOCUS_DATA_KEY);
            $restoreFocus.focus();
        }
    };
    function focusTrapHandler(event) {
        var focusTrapStack = event.data.focusTrapStack;
        if (!event.relatedTarget) //Does not work in firefox, see https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        return;
        if (focusTrapStack.length === 0) return;
        var $focusTrapElement = focusTrapStack[focusTrapStack.length - 1];
        var focusOrigin = event.target;
        var focusTo = event.relatedTarget;
        var $tabbableElements = $focusTrapElement.find(":aui-tabbable");
        var $firstTabbableElement = (0, _jquery2.default)($tabbableElements.first());
        var $lastTabbableElement = (0, _jquery2.default)($tabbableElements.last());
        var elementContainsOrigin = $focusTrapElement.has(focusTo).length === 0;
        var focusLeavingElement = elementContainsOrigin && focusTo;
        if (focusLeavingElement) {
            if ($firstTabbableElement.is(focusOrigin)) $lastTabbableElement.focus();
            else if ($lastTabbableElement.is(focusOrigin)) $firstTabbableElement.focus();
        }
    }
    FocusManager.global = new FocusManager();
    (0, _globalize2.default)("FocusManager", FocusManager);
    exports.default = FocusManager;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/widget.js
(typeof window === "undefined" ? $parcel$global : window).__d2e8fc66dac2ecebdc205fcab991f687 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = function(name, Ctor) {
        var dataAttr = "_aui-widget-" + name;
        return function(selectorOrOptions, maybeOptions) {
            var selector;
            var options;
            if (_jquery2.default.isPlainObject(selectorOrOptions)) options = selectorOrOptions;
            else {
                selector = selectorOrOptions;
                options = maybeOptions;
            }
            var $el = selector && (0, _jquery2.default)(selector);
            var widget;
            if (!$el || !$el.data(dataAttr)) {
                widget = new Ctor($el, options || {});
                $el = widget.$el;
                $el.data(dataAttr, widget);
            } else widget = $el.data(dataAttr);
            return widget;
        };
    };
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    module.exports = exports["default"];
    /**
   * @param {string} name The name of the widget to use in any messaging.
   * @param {function(new:{ $el: jQuery }, ?jQuery, ?Object)} Ctor
   *     A constructor which will only ever be called with "new". It must take a JQuery object as the first
   *     parameter, or generate one if not provided. The second parameter will be a configuration object.
   *     The returned object must have an $el property and a setOptions function.
   * @constructor
   */ return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/layer.js
(typeof window === "undefined" ? $parcel$global : window).__3ada4a8272640e5242be87f12c7e0fdf = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _blanket = __4c4f13d92d5dcb8f12059ce701946463;
    var _focusManager = __f65d8c24422fc9cfa97e7b7162425c04;
    var _focusManager2 = _interopRequireDefault(_focusManager);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _keyCode = __e246bf93af36eb4453f35afeb1c302d9;
    var _keyCode2 = _interopRequireDefault(_keyCode);
    var _widget = __d2e8fc66dac2ecebdc205fcab991f687;
    var _widget2 = _interopRequireDefault(_widget);
    var _customEvent = __f7a5e0d2ea8865b104efc9b94861591e;
    var _customEvent2 = _interopRequireDefault(_customEvent);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var EVENT_PREFIX = "_aui-internal-layer-";
    var GLOBAL_EVENT_PREFIX = "_aui-internal-layer-global-";
    var LAYER_EVENT_PREFIX = "aui-layer-";
    var AUI_EVENT_PREFIX = "aui-";
    var $doc = (0, _jquery2.default)(document);
    // AUI-3708 - Abstracted to reflect code implemented upstream.
    function isTransitioning(el, prop) {
        var transition = window.getComputedStyle(el).transitionProperty;
        return transition ? transition.indexOf(prop) > -1 : false;
    }
    function onTransitionEnd(el, prop, func, once) {
        function handler(e) {
            if (prop !== e.propertyName) return;
            func.call(el);
            if (once) el.removeEventListener("transitionend", handler);
        }
        if (isTransitioning(el, prop)) el.addEventListener("transitionend", handler);
        else func.call(el);
    }
    function oneTransitionEnd(el, prop, func) {
        onTransitionEnd(el, prop, func, true);
    }
    // end AUI-3708
    function ariaHide($el) {
        $el.attr("aria-hidden", "true");
    }
    function ariaShow($el) {
        $el.attr("aria-hidden", "false");
    }
    /**
  * @return {bool} Returns false if at least one of the event handlers called .preventDefault(). Returns true otherwise.
  */ function triggerEvent($el, deprecatedName, newNativeName) {
        var e1 = _jquery2.default.Event(EVENT_PREFIX + deprecatedName);
        var e2 = _jquery2.default.Event(GLOBAL_EVENT_PREFIX + deprecatedName);
        // TODO: Remove this 'aui-layer-' prefixed event once it is no longer used by inline dialog and dialog2.
        var nativeEvent = new _customEvent2.default(LAYER_EVENT_PREFIX + newNativeName, {
            bubbles: true,
            cancelable: true
        });
        var nativeEvent2 = new _customEvent2.default(AUI_EVENT_PREFIX + newNativeName, {
            bubbles: true,
            cancelable: true
        });
        $el.trigger(e1);
        $el.trigger(e2, [
            $el
        ]);
        $el[0].dispatchEvent(nativeEvent);
        $el[0].dispatchEvent(nativeEvent2);
        return !e1.isDefaultPrevented() && !e2.isDefaultPrevented() && !nativeEvent.defaultPrevented && !nativeEvent2.defaultPrevented;
    }
    function Layer(selector) {
        this.$el = (0, _jquery2.default)(selector || '<div class="aui-layer" aria-hidden="true"></div>');
        this.$el.addClass("aui-layer");
    }
    Layer.prototype = {
        /**
       * Returns the layer below the current layer if it exists.
       *
       * @returns {jQuery | undefined}
       */ below: function below() {
            return LayerManager.global.item(LayerManager.global.indexOf(this.$el) - 1);
        },
        /**
       * Returns the layer above the current layer if it exists.
       *
       * @returns {jQuery | undefined}
       */ above: function above() {
            return LayerManager.global.item(LayerManager.global.indexOf(this.$el) + 1);
        },
        /**
       * Sets the width and height of the layer.
       *
       * @param {Integer} width The width to set.
       * @param {Integer} height The height to set.
       *
       * @returns {Layer}
       */ changeSize: function changeSize(width, height) {
            this.$el.css("width", width);
            this.$el.css("height", height === "content" ? "" : height);
            return this;
        },
        /**
       * Binds a layer event.
       *
       * @param {String} event The event name to listen to.
       * @param {Function} fn The event handler.
       *
       * @returns {Layer}
       */ on: function on(event, fn) {
            this.$el.on(EVENT_PREFIX + event, fn);
            return this;
        },
        /**
       * Unbinds a layer event.
       *
       * @param {String} event The event name to unbind=.
       * @param {Function} fn Optional. The event handler.
       *
       * @returns {Layer}
       */ off: function off(event, fn) {
            this.$el.off(EVENT_PREFIX + event, fn);
            return this;
        },
        /**
       * Shows the layer.
       *
       * @returns {Layer}
       */ show: function show() {
            if (this.isVisible()) {
                ariaShow(this.$el);
                return this;
            }
            if (!triggerEvent(this.$el, "beforeShow", "show")) return this;
            // AUI-3708
            // Ensures that the display property is removed if it's been added
            // during hiding.
            if (this.$el.css("display") === "none") this.$el.css("display", "");
            LayerManager.global.push(this.$el);
            return this;
        },
        /**
       * Hides the layer.
       *
       * @returns {Layer}
       */ hide: function hide() {
            if (!this.isVisible()) {
                ariaHide(this.$el);
                return this;
            }
            if (!triggerEvent(this.$el, "beforeHide", "hide")) return this;
            // AUI-3708
            var thisLayer = this;
            oneTransitionEnd(this.$el.get(0), "opacity", function() {
                if (!thisLayer.isVisible()) this.style.display = "none";
            });
            LayerManager.global.popUntil(this.$el);
            return this;
        },
        /**
       * Checks to see if the layer is visible.
       *
       * @returns {Boolean}
       */ isVisible: function isVisible() {
            return this.$el.attr("aria-hidden") === "false";
        },
        /**
       * Removes the layer and cleans up internal state.
       *
       * @returns {undefined}
       */ remove: function remove() {
            this.hide();
            this.$el.remove();
            this.$el = null;
        },
        /**
       * Returns whether or not the layer is blanketed.
       *
       * @returns {Boolean}
       */ isBlanketed: function isBlanketed() {
            return this.$el.attr("data-aui-blanketed") === "true";
        },
        /**
       * Returns whether or not the layer is persistent.
       *
       * @returns {Boolean}
       */ isPersistent: function isPersistent() {
            var modal = this.$el.attr("modal") || this.$el.attr("data-aui-modal");
            var isPersistent = this.$el[0].hasAttribute("persistent");
            return modal === "true" || isPersistent;
        },
        _hideLayer: function _hideLayer(triggerBeforeEvents) {
            if (this.isPersistent() || this.isBlanketed()) _focusManager2.default.global.exit(this.$el);
            if (triggerBeforeEvents) triggerEvent(this.$el, "beforeHide", "hide");
            this.$el.attr("aria-hidden", "true");
            this.$el.css("z-index", this.$el.data("_aui-layer-cached-z-index") || "");
            this.$el.data("_aui-layer-cached-z-index", "");
            this.$el.trigger(EVENT_PREFIX + "hide");
            this.$el.trigger(GLOBAL_EVENT_PREFIX + "hide", [
                this.$el
            ]);
        },
        _showLayer: function _showLayer(zIndex) {
            if (!this.$el.parent().is("body")) this.$el.appendTo(document.body);
            this.$el.data("_aui-layer-cached-z-index", this.$el.css("z-index"));
            this.$el.css("z-index", zIndex);
            this.$el.attr("aria-hidden", "false");
            if (this.isPersistent() || this.isBlanketed()) _focusManager2.default.global.enter(this.$el);
            this.$el.trigger(EVENT_PREFIX + "show");
            this.$el.trigger(GLOBAL_EVENT_PREFIX + "show", [
                this.$el
            ]);
        }
    };
    var createLayer = (0, _widget2.default)("layer", Layer);
    createLayer.on = function(eventName, selector, fn) {
        $doc.on(GLOBAL_EVENT_PREFIX + eventName, selector, fn);
        return this;
    };
    createLayer.off = function(eventName, selector, fn) {
        $doc.off(GLOBAL_EVENT_PREFIX + eventName, selector, fn);
        return this;
    };
    // Layer Manager
    // -------------
    /**
   * Manages layers.
   *
   * There is a single global layer manager.
   * Additional instances can be created however this should generally only be used in tests.
   *
   * Layers are added by the push($el) method. Layers are removed by the
   * popUntil($el) method.
   *
   * popUntil's contract is that it pops all layers above & including the given
   * layer. This is used to support popping multiple layers.
   * Say we were showing a dropdown inside an inline dialog inside a dialog - we
   * have a stack of dialog layer, inline dialog layer, then dropdown layer. Calling
   * popUntil(dialog.$el) would hide all layers above & including the dialog.
   */ function getTrigger($layer) {
        return (0, _jquery2.default)('[aria-controls="' + $layer.attr("id") + '"]');
    }
    function hasTrigger($layer) {
        return getTrigger($layer).length > 0;
    }
    function topIndexWhere(layerArr, fn) {
        var i = layerArr.length;
        while(i--){
            if (fn(layerArr[i])) return i;
        }
        return -1;
    }
    function layerIndex(layerArr, $el) {
        return topIndexWhere(layerArr, function($layer) {
            return $layer[0] === $el[0];
        });
    }
    function topBlanketedIndex(layerArr) {
        return topIndexWhere(layerArr, function($layer) {
            return createLayer($layer).isBlanketed();
        });
    }
    function nextZIndex(layerArr) {
        var _nextZIndex;
        if (layerArr.length) {
            var $topEl = layerArr[layerArr.length - 1];
            var zIndex = parseInt($topEl.css("z-index"), 10);
            _nextZIndex = (isNaN(zIndex) ? 0 : zIndex) + 100;
        } else _nextZIndex = 0;
        return Math.max(3000, _nextZIndex);
    }
    function updateBlanket(stack, oldBlanketIndex) {
        var newTopBlanketedIndex = topBlanketedIndex(stack);
        if (oldBlanketIndex !== newTopBlanketedIndex) {
            if (newTopBlanketedIndex > -1) (0, _blanket.dim)(false, stack[newTopBlanketedIndex].css("z-index") - 20);
            else (0, _blanket.undim)();
        }
    }
    function popLayers(stack, stopIndex, forceClosePersistent) {
        if (stopIndex < 0) return;
        for(var a = stack.length - 1; a >= stopIndex; a--){
            var $layer = stack[a];
            var layer = createLayer($layer);
            if (forceClosePersistent || !layer.isPersistent()) {
                layer._hideLayer(true);
                stack.splice(a, 1);
            }
        }
    }
    function getParentLayer($childLayer) {
        var $layerTrigger = getTrigger($childLayer);
        if ($layerTrigger.length > 0) return $layerTrigger.closest(".aui-layer");
    }
    function LayerManager() {
        this._stack = [];
    }
    LayerManager.prototype = {
        /**
      * Pushes a layer onto the stack. The same element cannot be opened as a layer multiple times - if the given
      * element is already an open layer, this method throws an exception.
      *
      * @param {HTMLElement | String | jQuery} element  The element to push onto the stack.
      *
      * @returns {LayerManager}
      */ push: function push(element) {
            var $el = element instanceof _jquery2.default ? element : (0, _jquery2.default)(element);
            if (layerIndex(this._stack, $el) >= 0) throw new Error("The given element is already an active layer.");
            this.popLayersBeside($el);
            var layer = createLayer($el);
            var zIndex = nextZIndex(this._stack);
            layer._showLayer(zIndex);
            if (layer.isBlanketed()) (0, _blanket.dim)(false, zIndex - 20);
            this._stack.push($el);
            return this;
        },
        popLayersBeside: function popLayersBeside(element) {
            var $layer = element instanceof _jquery2.default ? element : (0, _jquery2.default)(element);
            if (!hasTrigger($layer)) {
                // We can't find this layer's trigger, we will pop all non-persistent until a blanket or the document
                var blanketedIndex = topBlanketedIndex(this._stack);
                popLayers(this._stack, ++blanketedIndex, false);
                return;
            }
            var $parentLayer = getParentLayer($layer);
            if ($parentLayer) {
                var parentIndex = this.indexOf($parentLayer);
                popLayers(this._stack, ++parentIndex, false);
            } else popLayers(this._stack, 0, false);
        },
        /**
      * Returns the index of the specified layer in the layer stack.
      *
      * @param {HTMLElement | String | jQuery} element  The element to find in the stack.
      *
      * @returns {Number} the (zero-based) index of the element, or -1 if not in the stack.
      */ indexOf: function indexOf(element) {
            return layerIndex(this._stack, (0, _jquery2.default)(element));
        },
        /**
      * Returns the item at the particular index or false.
      *
      * @param {Number} index The index of the element to get.
      *
      * @returns {jQuery | Boolean}
      */ item: function item(index) {
            return this._stack[index];
        },
        /**
      * Hides all layers in the stack.
      *
      * @returns {LayerManager}
      */ hideAll: function hideAll() {
            this._stack.reverse().forEach(function(element) {
                var layer = createLayer(element);
                if (layer.isBlanketed() || layer.isPersistent()) return;
                layer.hide();
            });
            return this;
        },
        /**
      * Gets the previous layer below the given layer, which is non modal and non persistent. If it finds a blanketed layer on the way
      * it returns it regardless if it is modal or not
      *
      * @param {HTMLElement | String | jQuery} element layer to start the search from.
      *
      * @returns {jQuery | null} the next matching layer or null if none found.
      */ getNextLowerNonPersistentOrBlanketedLayer: function getNextLowerNonPersistentOrBlanketedLayer(element) {
            var $el = element instanceof _jquery2.default ? element : (0, _jquery2.default)(element);
            var index = layerIndex(this._stack, $el);
            if (index < 0) return null;
            var $nextEl;
            index--;
            while(index >= 0){
                $nextEl = this._stack[index];
                var layer = createLayer($nextEl);
                if (!layer.isPersistent() || layer.isBlanketed()) return $nextEl;
                index--;
            }
            return null;
        },
        /**
      * Gets the next layer which is neither modal or blanketed, from the given layer.
      *
      * @param {HTMLElement | String | jQuery} element layer to start the search from.
      *
      * @returns {jQuery | null} the next non modal non blanketed layer or null if none found.
      */ getNextHigherNonPeristentAndNonBlanketedLayer: function getNextHigherNonPeristentAndNonBlanketedLayer(element) {
            var $el = element instanceof _jquery2.default ? element : (0, _jquery2.default)(element);
            var index = layerIndex(this._stack, $el);
            if (index < 0) return null;
            var $nextEl;
            index++;
            while(index < this._stack.length){
                $nextEl = this._stack[index];
                var layer = createLayer($nextEl);
                if (!(layer.isPersistent() || layer.isBlanketed())) return $nextEl;
                index++;
            }
            return null;
        },
        /**
      * Removes all non-modal layers above & including the given element. If the given element is not an active layer, this method
      * is a no-op. The given element will be removed regardless of whether or not it is modal.
      *
      * @param {HTMLElement | String | jQuery} element layer to pop.
      *
      * @returns {jQuery} The last layer that was popped, or null if no layer matching the given $el was found.
      */ popUntil: function popUntil(element) {
            var $el = element instanceof _jquery2.default ? element : (0, _jquery2.default)(element);
            var index = layerIndex(this._stack, $el);
            if (index === -1) return null;
            var oldTopBlanketedIndex = topBlanketedIndex(this._stack);
            // Removes all layers above the current one.
            popLayers(this._stack, index + 1, createLayer($el).isBlanketed());
            // Removes the current layer.
            createLayer($el)._hideLayer();
            this._stack.splice(index, 1);
            updateBlanket(this._stack, oldTopBlanketedIndex);
            return $el;
        },
        /**
      * Gets the top layer, if it exists.
      *
      * @returns The layer on top of the stack, if it exists, otherwise null.
      */ getTopLayer: function getTopLayer() {
            if (!this._stack.length) return null;
            var $topLayer = this._stack[this._stack.length - 1];
            return $topLayer;
        },
        /**
      * Pops the top layer, if it exists and it is non modal and non persistent.
      *
      * @returns The layer that was popped, if it was popped.
      */ popTopIfNonPersistent: function popTopIfNonPersistent() {
            var $topLayer = this.getTopLayer();
            var layer = createLayer($topLayer);
            if (!$topLayer || layer.isPersistent()) return null;
            return this.popUntil($topLayer);
        },
        /**
      * Pops all layers above and including the top blanketed layer. If layers exist but none are blanketed, this method
      * does nothing.
      *
      * @returns The blanketed layer that was popped, if it exists, otherwise null.
      */ popUntilTopBlanketed: function popUntilTopBlanketed() {
            var i = topBlanketedIndex(this._stack);
            if (i < 0) return null;
            var $topBlanketedLayer = this._stack[i];
            var layer = createLayer($topBlanketedLayer);
            if (layer.isPersistent()) {
                // We can't pop the blanketed layer, only the things ontop
                var $next = this.getNextHigherNonPeristentAndNonBlanketedLayer($topBlanketedLayer);
                if ($next) {
                    var stopIndex = layerIndex(this._stack, $next);
                    popLayers(this._stack, stopIndex, true);
                    return $next;
                }
                return null;
            }
            popLayers(this._stack, i, true);
            updateBlanket(this._stack, i);
            return $topBlanketedLayer;
        },
        /**
      * Pops all layers above and including the top persistent layer. If layers exist but none are persistent, this method
      * does nothing.
      */ popUntilTopPersistent: function popUntilTopPersistent() {
            var $toPop = LayerManager.global.getTopLayer();
            if (!$toPop) return;
            var stopIndex;
            var oldTopBlanketedIndex = topBlanketedIndex(this._stack);
            var toPop = createLayer($toPop);
            if (toPop.isPersistent()) {
                if (toPop.isBlanketed()) return;
                else {
                    // Get the closest non modal layer below, stop at the first blanketed layer though, we don't want to pop below that
                    $toPop = LayerManager.global.getNextLowerNonPersistentOrBlanketedLayer($toPop);
                    toPop = createLayer($toPop);
                    if ($toPop && !toPop.isPersistent()) {
                        stopIndex = layerIndex(this._stack, $toPop);
                        popLayers(this._stack, stopIndex, true);
                        updateBlanket(this._stack, oldTopBlanketedIndex);
                    } else // Here we have a blanketed persistent layer
                    return;
                }
            } else {
                stopIndex = layerIndex(this._stack, $toPop);
                popLayers(this._stack, stopIndex, true);
                updateBlanket(this._stack, oldTopBlanketedIndex);
            }
        }
    };
    // LayerManager.global
    // -------------------
    function initCloseLayerOnEscPress() {
        $doc.on("keydown", function(e) {
            if (e.keyCode === _keyCode2.default.ESCAPE) {
                LayerManager.global.popUntilTopPersistent();
                e.preventDefault();
            }
        });
    }
    function initCloseLayerOnBlanketClick() {
        $doc.on("click", ".aui-blanket", function(e) {
            if (LayerManager.global.popUntilTopBlanketed()) e.preventDefault();
        });
    }
    function hasLayer($trigger) {
        if (!$trigger.length) return false;
        var layer = document.getElementById($trigger.attr("aria-controls"));
        return LayerManager.global.indexOf(layer) > -1;
    }
    // If it's a click on a trigger, do nothing.
    // If it's a click on a layer, close all layers above.
    // Otherwise, close all layers.
    function initCloseLayerOnOuterClick() {
        $doc.on("click", function(e) {
            var $target = (0, _jquery2.default)(e.target);
            if ($target.closest(".aui-blanket").length) return;
            var $trigger = $target.closest("[aria-controls]");
            var $layer = $target.closest(".aui-layer");
            if (!$layer.length && !hasLayer($trigger)) {
                LayerManager.global.hideAll();
                return;
            }
            // Triggers take precedence over layers
            if (hasLayer($trigger)) return;
            if ($layer.length) {
                // We dont want to explicitly call close on a modal dialog if it happens to be next.
                // All blanketed layers should be below us, as otherwise the blanket should have caught the click.
                // We make sure we dont close a blanketed one explicitly as a hack, this is to fix the problem arising
                // from dialog2 triggers inside dialog2's having no aria controls, where the dialog2 that was just
                // opened would be closed instantly
                var $next = LayerManager.global.getNextHigherNonPeristentAndNonBlanketedLayer($layer);
                if ($next) createLayer($next).hide();
            }
        });
    }
    initCloseLayerOnEscPress();
    initCloseLayerOnBlanketClick();
    initCloseLayerOnOuterClick();
    LayerManager.global = new LayerManager();
    createLayer.Manager = LayerManager;
    (0, _globalize2.default)("layer", createLayer);
    exports.default = createLayer;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/state.js
(typeof window === "undefined" ? $parcel$global : window).__3f2c7809aecfe899611b77461a9218ac = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    function state(element) {
        return {
            /**
           * sets an internal state on a component element
           * @param element the element to which the state will be added
           * @param stateName the name of the state
           * @param stateValue the value that the state will be changed to
           */ set: function set(stateName, stateValue) {
                if (element._state === undefined) element._state = {};
                element._state[stateName] = stateValue;
            },
            /**
           * gets an internal state on a component element
           * @param element the element to which the state will be added
           * @param stateName the name of the state
           */ get: function get(stateName) {
                if (element._state) return element._state[stateName];
            }
        };
    }
    exports.default = state;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/dropdown2.js
(typeof window === "undefined" ? $parcel$global : window).__63997c0b88d4f299b5d69bd1c1668c63 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    __fa714f1b12d7502957e4e0b6196321bf;
    __6c1bd26c14066cf537a86a0966c2d4fc;
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _skatejsTemplateHtml = __c6b5725916d210b9653318d2ea2472cb;
    var _skatejsTemplateHtml2 = _interopRequireDefault(_skatejsTemplateHtml);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var deprecate = _interopRequireWildcard(_deprecation);
    var _log = __c1e961001275c079e48525ad3a48c8c2;
    var logger = _interopRequireWildcard(_log);
    var _debounce = __ee62e24d4acb40214d4f9e21b1a58bfc;
    var _browser = __7a2976c482edfafd9b5879a49ffe0535;
    var _alignment = __81deba69899d0f1851f2c511b87bbbae;
    var _alignment2 = _interopRequireDefault(_alignment);
    var _customEvent = __f7a5e0d2ea8865b104efc9b94861591e;
    var _customEvent2 = _interopRequireDefault(_customEvent);
    var _keyCode = __e246bf93af36eb4453f35afeb1c302d9;
    var _keyCode2 = _interopRequireDefault(_keyCode);
    var _layer = __3ada4a8272640e5242be87f12c7e0fdf;
    var _layer2 = _interopRequireDefault(_layer);
    var _state = __3f2c7809aecfe899611b77461a9218ac;
    var _state2 = _interopRequireDefault(_state);
    var _skate = __0ac9a2c09f995a9c0a478af8742f59b7;
    var _skate2 = _interopRequireDefault(_skate);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function isChecked(el) {
        return (0, _jquery2.default)(el).is('.checked, .aui-dropdown2-checked, [aria-checked="true"]');
    }
    function getTrigger(control) {
        return control._triggeringElement || document.querySelector('[aria-controls="' + control.id + '"]');
    }
    function doIfTrigger(triggerable, callback) {
        var trigger = getTrigger(triggerable);
        if (trigger) callback(trigger);
    }
    function setDropdownTriggerActiveState(trigger, isActive) {
        var $trigger = (0, _jquery2.default)(trigger);
        if (isActive) {
            $trigger.attr("aria-expanded", "true");
            $trigger.addClass("active aui-dropdown2-active");
        } else {
            $trigger.attr("aria-expanded", "false");
            $trigger.removeClass("active aui-dropdown2-active");
        }
    }
    // LOADING STATES
    var UNLOADED = "unloaded";
    var LOADING = "loading";
    var ERROR = "error";
    var SUCCESS = "success";
    // ASYNC DROPDOWN FUNCTIONS
    function makeAsyncDropdownContents(json) {
        var dropdownContents = json.map(function makeSection(sectionData) {
            var sectionItemsHtml = sectionData.items.map(function makeSectionItem(itemData) {
                function makeBooleanAttribute(attr) {
                    return itemData[attr] ? attr + ' ="true"' : "";
                }
                function makeAttribute(attr) {
                    return itemData[attr] ? attr + '="' + itemData[attr] + '"' : "";
                }
                var tagName = "aui-item-" + itemData.type;
                var itemHtml = "\n                <" + tagName + " " + makeAttribute("for") + " " + makeAttribute("href") + " " + makeBooleanAttribute("interactive") + "\n                    " + makeBooleanAttribute("checked") + " " + makeBooleanAttribute("disabled") + " " + makeBooleanAttribute("hidden") + ">\n                    " + itemData.content + "\n                </" + tagName + ">";
                return itemHtml;
            }).join("");
            var sectionAttributes = sectionData.label ? 'label="' + sectionData.label + '"' : "";
            var sectionHtml = "\n            <aui-section " + sectionAttributes + ">\n                " + sectionItemsHtml + "\n            </aui-section>";
            return sectionHtml;
        }).join("\n");
        return dropdownContents;
    }
    function setDropdownContents(dropdown, json) {
        (0, _state2.default)(dropdown).set("loading-state", SUCCESS);
        _skatejsTemplateHtml2.default.wrap(dropdown).innerHTML = makeAsyncDropdownContents(json);
        _skate2.default.init(dropdown);
    }
    function setDropdownErrorState(dropdown) {
        (0, _state2.default)(dropdown).set("loading-state", ERROR);
        (0, _state2.default)(dropdown).set("hasErrorBeenShown", dropdown.isVisible());
        _skatejsTemplateHtml2.default.wrap(dropdown).innerHTML = '\n        <div class="aui-message aui-message-error aui-dropdown-error">\n            <p>' + AJS.I18n.getText("aui.dropdown.async.error") + "</p>\n        </div>\n    ";
    }
    function setDropdownLoadingState(dropdown) {
        (0, _state2.default)(dropdown).set("loading-state", LOADING);
        (0, _state2.default)(dropdown).set("hasErrorBeenShown", false);
        doIfTrigger(dropdown, function(trigger) {
            trigger.setAttribute("aria-busy", "true");
        });
        _skatejsTemplateHtml2.default.wrap(dropdown).innerHTML = '\n        <div class="aui-dropdown-loading">\n            <aui-spinner size="small"></aui-spinner> ' + AJS.I18n.getText("aui.dropdown.async.loading") + "\n        </div>\n    ";
    }
    function setDropdownLoaded(dropdown) {
        doIfTrigger(dropdown, function(trigger) {
            trigger.setAttribute("aria-busy", "false");
        });
    }
    function loadContentsIfAsync(dropdown) {
        if (!dropdown.src || (0, _state2.default)(dropdown).get("loading-state") === LOADING) return;
        setDropdownLoadingState(dropdown);
        _jquery2.default.ajax(dropdown.src).done(function(json, status, xhr) {
            var isValidStatus = xhr.status === 200;
            if (isValidStatus) setDropdownContents(dropdown, json);
            else setDropdownErrorState(dropdown);
        }).fail(function() {
            setDropdownErrorState(dropdown);
        }).always(function() {
            setDropdownLoaded(dropdown);
        });
    }
    function loadContentWhenMouseEnterTrigger(dropdown) {
        var isDropdownUnloaded = (0, _state2.default)(dropdown).get("loading-state") === UNLOADED;
        var hasCurrentErrorBeenShown = (0, _state2.default)(dropdown).get("hasErrorBeenShown");
        if (isDropdownUnloaded || hasCurrentErrorBeenShown && !dropdown.isVisible()) loadContentsIfAsync(dropdown);
    }
    function loadContentWhenMenuShown(dropdown) {
        var isDropdownUnloaded = (0, _state2.default)(dropdown).get("loading-state") === UNLOADED;
        var hasCurrentErrorBeenShown = (0, _state2.default)(dropdown).get("hasErrorBeenShown");
        if (isDropdownUnloaded || hasCurrentErrorBeenShown) loadContentsIfAsync(dropdown);
        if ((0, _state2.default)(dropdown).get("loading-state") === ERROR) (0, _state2.default)(dropdown).set("hasErrorBeenShown", true);
    }
    // The dropdown's trigger
    // ----------------------
    function triggerCreated(trigger) {
        var dropdownID = trigger.getAttribute("aria-controls");
        if (!dropdownID) {
            dropdownID = trigger.getAttribute("aria-owns");
            if (!dropdownID) logger.error('Dropdown triggers need either a "aria-owns" or "aria-controls" attribute');
            else {
                trigger.removeAttribute("aria-owns");
                trigger.setAttribute("aria-controls", dropdownID);
            }
        }
        trigger.setAttribute("aria-haspopup", true);
        trigger.setAttribute("aria-expanded", false);
        var shouldSetHref = trigger.nodeName === "A" && !trigger.href;
        if (shouldSetHref) trigger.setAttribute("href", "#" + dropdownID);
        function handleIt(e) {
            e.preventDefault();
            if (!trigger.isEnabled()) return;
            var dropdown = document.getElementById(dropdownID);
            // AUI-4271 - Maintains legacy integration with parent elements.
            var $trigger = (0, _jquery2.default)(trigger);
            if ($trigger.parent().hasClass("aui-buttons")) dropdown.classList.add("aui-dropdown2-in-buttons");
            if ($trigger.parents().hasClass("aui-header")) dropdown.classList.add("aui-dropdown2-in-header");
            dropdown.toggle(e);
            dropdown.isSubmenu = trigger.hasSubmenu();
            return dropdown;
        }
        function handleMouseEnter(e) {
            e.preventDefault();
            if (!trigger.isEnabled()) return;
            var dropdown = document.getElementById(dropdownID);
            loadContentWhenMouseEnterTrigger(dropdown);
            if (trigger.hasSubmenu()) {
                dropdown.show(e);
                dropdown.isSubmenu = trigger.hasSubmenu();
            }
            return dropdown;
        }
        function handleKeydown(e) {
            var normalInvoke = e.keyCode === _keyCode2.default.ENTER || e.keyCode === _keyCode2.default.SPACE;
            var submenuInvoke = e.keyCode === _keyCode2.default.RIGHT && trigger.hasSubmenu();
            var rootMenuInvoke = (e.keyCode === _keyCode2.default.UP || e.keyCode === _keyCode2.default.DOWN) && !trigger.hasSubmenu();
            if (normalInvoke || submenuInvoke || rootMenuInvoke) {
                var dropdown = handleIt(e);
                if (dropdown) dropdown.focusItem(0);
            }
        }
        (0, _jquery2.default)(trigger).on("aui-button-invoke", handleIt).on("click", handleIt).on("keydown", handleKeydown).on("mouseenter", handleMouseEnter);
    }
    var triggerPrototype = {
        disable: function disable() {
            this.setAttribute("aria-disabled", "true");
        },
        enable: function enable() {
            this.setAttribute("aria-disabled", "false");
        },
        isEnabled: function isEnabled() {
            return this.getAttribute("aria-disabled") !== "true";
        },
        hasSubmenu: function hasSubmenu() {
            var triggerClasses = (this.className || "").split(/\s+/);
            return triggerClasses.indexOf("aui-dropdown2-sub-trigger") !== -1;
        }
    };
    (0, _skate2.default)("aui-dropdown2-trigger", {
        type: _skate2.default.type.CLASSNAME,
        created: triggerCreated,
        prototype: triggerPrototype
    });
    //To remove at a later date. Some dropdown triggers initialise lazily, so we need to listen for mousedown
    //and synchronously init before the click event is fired.
    //TODO: delete in AUI 8.0.0, see AUI-2868
    function bindLazyTriggerInitialisation() {
        (0, _jquery2.default)(document).on("mousedown", ".aui-dropdown2-trigger", function() {
            var isElementSkated = this.hasAttribute("resolved");
            if (!isElementSkated) {
                _skate2.default.init(this);
                var lazyDeprecate = deprecate.getMessageLogger("Dropdown2 lazy initialisation", {
                    removeInVersion: "8.0.0",
                    alternativeName: "initialisation on DOM insertion",
                    sinceVersion: "5.8.0",
                    extraInfo: "Dropdown2 triggers should have all necessary attributes on DOM insertion",
                    deprecationType: "JS"
                });
                lazyDeprecate();
            }
        });
    }
    bindLazyTriggerInitialisation();
    (0, _skate2.default)("aui-dropdown2-sub-trigger", {
        type: _skate2.default.type.CLASSNAME,
        created: function created(trigger) {
            trigger.className += " aui-dropdown2-trigger";
            _skate2.default.init(trigger);
        }
    });
    // Dropdown trigger groups
    // -----------------------
    (0, _jquery2.default)(document).on("mouseenter", ".aui-dropdown2-trigger-group a, .aui-dropdown2-trigger-group button", function(e) {
        var $item = (0, _jquery2.default)(e.currentTarget);
        if ($item.is(".aui-dropdown2-active")) return; // No point doing anything if we're hovering over the already-active item trigger.
        if ($item.closest(".aui-dropdown2").length) return; // We don't want to deal with dropdown items, just the potential triggers in the group.
        var $triggerGroup = $item.closest(".aui-dropdown2-trigger-group");
        var $groupActiveTrigger = $triggerGroup.find(".aui-dropdown2-active");
        if ($groupActiveTrigger.length && $item.is(".aui-dropdown2-trigger")) {
            $groupActiveTrigger.blur(); // Remove focus from the previously opened menu.
            $item.trigger("aui-button-invoke"); // Open this trigger's menu.
            e.preventDefault();
        }
        var $groupFocusedTrigger = $triggerGroup.find(":focus");
        if ($groupFocusedTrigger.length && $item.is(".aui-dropdown2-trigger")) $groupFocusedTrigger.blur();
    });
    // Dropdown items
    // --------------
    function getDropdownItems(dropdown, filter) {
        return (0, _jquery2.default)(dropdown).find([
            // Legacy markup.
            "> ul > li",
            "> .aui-dropdown2-section > ul > li",
            // Accessible markup.
            '> div[role] > .aui-dropdown2-section > div[role="group"] > ul[role] > li[role]',
            // Web component.
            "aui-item-link",
            "aui-item-checkbox",
            "aui-item-radio"
        ].join(", ")).filter(filter).children('a, button, [role="checkbox"], [role="menuitemcheckbox"], [role="radio"], [role="menuitemradio"]');
    }
    function getAllDropdownItems(dropdown) {
        return getDropdownItems(dropdown, function() {
            return true;
        });
    }
    function getVisibleDropdownItems(dropdown) {
        return getDropdownItems(dropdown, function() {
            return this.className.indexOf("hidden") === -1 && !this.hasAttribute("hidden");
        });
    }
    function amendDropdownItem(item) {
        var $item = (0, _jquery2.default)(item);
        $item.attr("tabindex", "-1");
        /**
       * Honouring the documentation.
       * @link https://docs.atlassian.com/aui/latest/docs/dropdown2.html
       */ if ($item.hasClass("aui-dropdown2-disabled") || $item.parent().hasClass("aui-dropdown2-hidden")) $item.attr("aria-disabled", true);
    }
    function amendDropdownContent(dropdown) {
        // Add assistive semantics to each dropdown item
        getAllDropdownItems(dropdown).each(function() {
            amendDropdownItem(this);
        });
    }
    /**
   * Honours behaviour for code written using only the legacy class names.
   * To maintain old behaviour (i.e., remove the 'hidden' class and the item will become un-hidden)
   * whilst allowing our code to only depend on the new classes, we need to
   * keep the state of the DOM in sync with legacy classes.
   *
   * Calling this function will add the new namespaced classes to elements with legacy names.
   * @returns {Function} a function to remove the new namespaced classes, only from the elements they were added to.
   */ function migrateAndSyncLegacyClassNames(dropdown) {
        var $dropdown = (0, _jquery2.default)(dropdown);
        // Migrate away from legacy class names
        var $hiddens = $dropdown.find(".hidden").addClass("aui-dropdown2-hidden");
        var $disableds = $dropdown.find(".disabled").addClass("aui-dropdown2-disabled");
        var $interactives = $dropdown.find(".interactive").addClass("aui-dropdown2-interactive");
        return function revertToOriginalMarkup() {
            $hiddens.removeClass("aui-dropdown2-hidden");
            $disableds.removeClass("aui-dropdown2-disabled");
            $interactives.removeClass("aui-dropdown2-interactive");
        };
    }
    // The Dropdown itself
    // -------------------
    function setLayerAlignment(dropdown, trigger) {
        var hasSubmenu = trigger && trigger.hasSubmenu && trigger.hasSubmenu();
        var hasSubmenuAlignment = dropdown.getAttribute("data-aui-alignment") === "submenu auto";
        if (!hasSubmenu && hasSubmenuAlignment) restorePreviousAlignment(dropdown);
        var hasAnyAlignment = dropdown.hasAttribute("data-aui-alignment");
        if (hasSubmenu && !hasSubmenuAlignment) {
            saveCurrentAlignment(dropdown);
            dropdown.setAttribute("data-aui-alignment", "submenu auto");
            dropdown.setAttribute("data-aui-alignment-static", true);
        } else if (!hasAnyAlignment) {
            dropdown.setAttribute("data-aui-alignment", "bottom auto");
            dropdown.setAttribute("data-aui-alignment-static", true);
        }
        if (dropdown._auiAlignment) dropdown._auiAlignment.destroy();
        dropdown._auiAlignment = new _alignment2.default(dropdown, trigger);
        dropdown._auiAlignment.enable();
    }
    function saveCurrentAlignment(dropdown) {
        var $dropdown = (0, _jquery2.default)(dropdown);
        if (dropdown.hasAttribute("data-aui-alignment")) $dropdown.data("previous-data-aui-alignment", dropdown.getAttribute("data-aui-alignment"));
        $dropdown.data("had-data-aui-alignment-static", dropdown.hasAttribute("data-aui-alignment-static"));
    }
    function restorePreviousAlignment(dropdown) {
        var $dropdown = (0, _jquery2.default)(dropdown);
        var previousAlignment = $dropdown.data("previous-data-aui-alignment");
        if (previousAlignment) dropdown.setAttribute("data-aui-alignment", previousAlignment);
        else dropdown.removeAttribute("data-aui-alignment");
        $dropdown.removeData("previous-data-aui-alignment");
        if (!$dropdown.data("had-data-aui-alignment-static")) dropdown.removeAttribute("data-aui-alignment-static");
        $dropdown.removeData("had-data-aui-alignment-static");
    }
    function getDropdownHideLocation(dropdown, trigger) {
        var possibleHome = trigger.getAttribute("data-dropdown2-hide-location");
        return document.getElementById(possibleHome) || dropdown.parentNode;
    }
    var keyboardClose = false;
    function keyboardCloseDetected() {
        keyboardClose = true;
    }
    function wasProbablyClosedViaKeyboard() {
        var result = keyboardClose === true;
        keyboardClose = false;
        return result;
    }
    function bindDropdownBehaviourToLayer(dropdown) {
        (0, _layer2.default)(dropdown);
        dropdown.addEventListener("aui-layer-show", function() {
            (0, _jquery2.default)(dropdown).trigger("aui-dropdown2-show");
            dropdown._syncClasses = migrateAndSyncLegacyClassNames(dropdown);
            amendDropdownContent(this);
            doIfTrigger(dropdown, function(trigger) {
                setDropdownTriggerActiveState(trigger, true);
                dropdown._returnTo = getDropdownHideLocation(dropdown, trigger);
            });
        });
        dropdown.addEventListener("aui-layer-hide", function() {
            (0, _jquery2.default)(dropdown).trigger("aui-dropdown2-hide");
            if (dropdown._syncClasses) {
                dropdown._syncClasses();
                delete dropdown._syncClasses;
            }
            if (dropdown._auiAlignment) {
                dropdown._auiAlignment.disable();
                dropdown._auiAlignment.destroy();
            }
            if (dropdown._returnTo) {
                if (dropdown.parentNode && dropdown.parentNode !== dropdown._returnTo) dropdown._returnTo.appendChild(dropdown);
            }
            (0, _jquery2.default)(dropdown).removeClass("aui-dropdown2-in-buttons");
            getVisibleDropdownItems(dropdown).removeClass("active aui-dropdown2-active");
            doIfTrigger(dropdown, function(trigger) {
                if (wasProbablyClosedViaKeyboard()) {
                    trigger.focus();
                    setDropdownTriggerActiveState(trigger, trigger.hasSubmenu && trigger.hasSubmenu());
                } else setDropdownTriggerActiveState(trigger, false);
            });
            // Gets set by submenu trigger invocation. Bad coupling point?
            delete dropdown.isSubmenu;
            dropdown._triggeringElement = null;
        });
    }
    function bindItemInteractionBehaviourToDropdown(dropdown) {
        var $dropdown = (0, _jquery2.default)(dropdown);
        $dropdown.on("keydown", function(e) {
            if (e.keyCode === _keyCode2.default.DOWN) {
                dropdown.focusNext();
                e.preventDefault();
            } else if (e.keyCode === _keyCode2.default.UP) {
                dropdown.focusPrevious();
                e.preventDefault();
            } else if (e.keyCode === _keyCode2.default.LEFT) {
                if (dropdown.isSubmenu) {
                    keyboardCloseDetected();
                    dropdown.hide(e);
                    e.preventDefault();
                }
            } else if (e.keyCode === _keyCode2.default.ESCAPE) // The closing will be handled by the LayerManager!
            keyboardCloseDetected();
            else if (e.keyCode === _keyCode2.default.TAB) {
                keyboardCloseDetected();
                dropdown.hide(e);
            }
        });
        var hideIfNotSubmenuAndNotInteractive = function hideIfNotSubmenuAndNotInteractive(e) {
            var $item = (0, _jquery2.default)(e.currentTarget);
            if ($item.attr("aria-disabled") === "true") {
                e.preventDefault();
                return;
            }
            var isSubmenuTrigger = e.currentTarget.hasSubmenu && e.currentTarget.hasSubmenu();
            if (!isSubmenuTrigger && !$item.is(".aui-dropdown2-interactive")) {
                var theMenu = dropdown;
                do {
                    var dd = (0, _layer2.default)(theMenu);
                    theMenu = (0, _layer2.default)(theMenu).below();
                    if (dd.$el.is(".aui-dropdown2")) dd.hide(e);
                }while (theMenu);
            }
        };
        $dropdown.on("click keydown", 'a, button, [role="menuitem"], [role="menuitemcheckbox"], [role="checkbox"], [role="menuitemradio"], [role="radio"]', function(e) {
            var item = e.currentTarget;
            var $item = (0, _jquery2.default)(item);
            var eventKeyCode = e.keyCode;
            var isEnter = eventKeyCode === _keyCode2.default.ENTER;
            var isSpace = eventKeyCode === _keyCode2.default.SPACE;
            // AUI-4283: Accessibility - need to ignore enter on links/buttons so
            // that the dropdown remains visible to allow the click event to eventually fire.
            var itemIgnoresEnter = isEnter && $item.is("a[href], button");
            if (!itemIgnoresEnter && (e.type === "click" || isEnter || isSpace)) hideIfNotSubmenuAndNotInteractive(e);
        });
        // close a submenus when the mouse moves over items other than its trigger
        $dropdown.on("mouseenter", 'a, button, [role="menuitem"], [role="menuitemcheckbox"], [role="checkbox"], [role="menuitemradio"], [role="radio"]', function(e) {
            var item = e.currentTarget;
            var hasSubmenu = item.hasSubmenu && item.hasSubmenu();
            if (!e.isDefaultPrevented() && !hasSubmenu) {
                var maybeALayer = (0, _layer2.default)(dropdown).above();
                if (maybeALayer) (0, _layer2.default)(maybeALayer).hide();
            }
        });
    }
    (0, _jquery2.default)(window).on("resize", (0, _debounce.debounceImmediate)(function() {
        (0, _jquery2.default)(".aui-dropdown2").each(function(index, dropdown) {
            _skate2.default.init(dropdown);
            if (dropdown.isVisible()) dropdown.hide();
        });
    }, 1000));
    // Dropdowns
    // ---------
    function dropdownCreated(dropdown) {
        var $dropdown = (0, _jquery2.default)(dropdown);
        $dropdown.addClass("aui-dropdown2");
        // swap the inner div to presentation as application is only needed for Windows
        if ((0, _browser.supportsVoiceOver)()) $dropdown.find('> div[role="application"]').attr("role", "presentation");
        if (dropdown.hasAttribute("data-container")) {
            $dropdown.attr("data-aui-alignment-container", $dropdown.attr("data-container"));
            $dropdown.removeAttr("data-container");
        }
        bindDropdownBehaviourToLayer(dropdown);
        bindItemInteractionBehaviourToDropdown(dropdown);
        dropdown.hide();
        (0, _jquery2.default)(dropdown).delegate(".aui-dropdown2-checkbox:not(.disabled):not(.aui-dropdown2-disabled)", "click keydown", function(e) {
            if (e.type === "click" || e.keyCode === _keyCode2.default.ENTER || e.keyCode === _keyCode2.default.SPACE) {
                var checkbox = this;
                if (e.isDefaultPrevented()) return;
                if (checkbox.isInteractive()) e.preventDefault();
                if (checkbox.isEnabled()) {
                    // toggle the checked state
                    if (checkbox.isChecked()) checkbox.uncheck();
                    else checkbox.check();
                }
            }
        });
        (0, _jquery2.default)(dropdown).delegate(".aui-dropdown2-radio:not(.checked):not(.aui-dropdown2-checked):not(.disabled):not(.aui-dropdown2-disabled)", "click keydown", function(e) {
            if (e.type === "click" || e.keyCode === _keyCode2.default.ENTER || e.keyCode === _keyCode2.default.SPACE) {
                var radio = this;
                if (e.isDefaultPrevented()) return;
                if (radio.isInteractive()) e.preventDefault();
                var $radio = (0, _jquery2.default)(this);
                if (this.isEnabled() && this.isChecked() === false) {
                    // toggle the checked state
                    $radio.closest("ul,[role=group]").find(".aui-dropdown2-checked").not(this).each(function() {
                        this.uncheck();
                    });
                    radio.check();
                }
            }
        });
    }
    var dropdownPrototype = {
        /**
       * Toggles the visibility of the dropdown menu
       */ toggle: function toggle(e) {
            if (this.isVisible()) this.hide(e);
            else this.show(e);
        },
        /**
       * Explicitly shows the menu
       *
       * @returns {HTMLElement}
       */ show: function show(e) {
            if (e && e.currentTarget && e.currentTarget.classList.contains("aui-dropdown2-trigger")) this._triggeringElement = e.currentTarget;
            (0, _layer2.default)(this).show();
            var dropdown = this;
            doIfTrigger(dropdown, function(trigger) {
                setLayerAlignment(dropdown, trigger);
            });
            return this;
        },
        /**
       * Explicitly hides the menu
       *
       * @returns {HTMLElement}
       */ hide: function hide() {
            (0, _layer2.default)(this).hide();
            return this;
        },
        /**
       * Shifts explicit focus to the next available item in the menu
       *
       * @returns {undefined}
       */ focusNext: function focusNext() {
            var $items = getVisibleDropdownItems(this);
            var selected = document.activeElement;
            var idx;
            if ($items.last()[0] !== selected) {
                idx = $items.toArray().indexOf(selected);
                this.focusItem($items.get(idx + 1));
            }
        },
        /**
       * Shifts explicit focus to the previous available item in the menu
       *
       * @returns {undefined}
       */ focusPrevious: function focusPrevious() {
            var $items = getVisibleDropdownItems(this);
            var selected = document.activeElement;
            var idx;
            if ($items.first()[0] !== selected) {
                idx = $items.toArray().indexOf(selected);
                this.focusItem($items.get(idx - 1));
            }
        },
        /**
       * Shifts explicit focus to the menu item matching the index param
       */ focusItem: function focusItem(item) {
            var $items = getVisibleDropdownItems(this);
            var $item;
            if (typeof item === "number") item = $items.get(item);
            $item = (0, _jquery2.default)(item);
            $item.focus();
            $items.removeClass("active aui-dropdown2-active");
            $item.addClass("active aui-dropdown2-active");
        },
        /**
       * Checks whether or not the menu is currently displayed
       *
       * @returns {Boolean}
       */ isVisible: function isVisible() {
            return (0, _layer2.default)(this).isVisible();
        }
    };
    // Web component API for dropdowns
    // -------------------------------
    var disabledAttributeHandler = {
        created: function created(element) {
            var a = element.children[0];
            a.setAttribute("aria-disabled", "true");
            a.className += " aui-dropdown2-disabled";
        },
        removed: function removed(element) {
            var a = element.children[0];
            a.setAttribute("aria-disabled", "false");
            (0, _jquery2.default)(a).removeClass("aui-dropdown2-disabled");
        }
    };
    var interactiveAttributeHandler = {
        created: function created(element) {
            var a = element.children[0];
            a.className += " aui-dropdown2-interactive";
        },
        removed: function removed(element) {
            var a = element.children[0];
            (0, _jquery2.default)(a).removeClass("aui-dropdown2-interactive");
        }
    };
    var checkedAttributeHandler = {
        created: function created(element) {
            var a = element.children[0];
            (0, _jquery2.default)(a).addClass("checked aui-dropdown2-checked");
            a.setAttribute("aria-checked", true);
            element.dispatchEvent(new _customEvent2.default("change", {
                bubbles: true
            }));
        },
        removed: function removed(element) {
            var a = element.children[0];
            (0, _jquery2.default)(a).removeClass("checked aui-dropdown2-checked");
            a.setAttribute("aria-checked", false);
            element.dispatchEvent(new _customEvent2.default("change", {
                bubbles: true
            }));
        }
    };
    var hiddenAttributeHandler = {
        created: function created(element) {
            disabledAttributeHandler.created(element);
        },
        removed: function removed(element) {
            disabledAttributeHandler.removed(element);
        }
    };
    var stringAttributeHandlerGenerator = function stringAttributeHandlerGenerator(attrName) {
        return {
            fallback: function fallback(element, change) {
                var a = element.children[0];
                a.setAttribute(attrName, change.newValue);
            },
            removed: function removed(element) {
                var a = element.children[0];
                a.removeAttribute(attrName);
            }
        };
    };
    (0, _skate2.default)("aui-item-link", {
        template: (0, _skatejsTemplateHtml2.default)('<a role="menuitem" tabindex="-1"><content></content></a>'),
        attributes: {
            disabled: disabledAttributeHandler,
            interactive: interactiveAttributeHandler,
            hidden: hiddenAttributeHandler,
            href: stringAttributeHandlerGenerator("href"),
            "item-id": stringAttributeHandlerGenerator("id"),
            for: {
                created: function created(element) {
                    var anchor = element.children[0];
                    anchor.setAttribute("aria-controls", element.getAttribute("for"));
                    (0, _jquery2.default)(anchor).addClass("aui-dropdown2-sub-trigger");
                },
                updated: function updated(element) {
                    var anchor = element.children[0];
                    anchor.setAttribute("aria-controls", element.getAttribute("for"));
                },
                removed: function removed(element) {
                    var anchor = element.children[0];
                    anchor.removeAttribute("aria-controls");
                    (0, _jquery2.default)(anchor).removeClass("aui-dropdown2-sub-trigger");
                }
            }
        }
    });
    (0, _skate2.default)("aui-item-checkbox", {
        template: (0, _skatejsTemplateHtml2.default)('<span role="checkbox" class="aui-dropdown2-checkbox" tabindex="-1"><content></content></span>'),
        attributes: {
            "item-id": stringAttributeHandlerGenerator("id"),
            disabled: disabledAttributeHandler,
            interactive: interactiveAttributeHandler,
            checked: checkedAttributeHandler,
            hidden: hiddenAttributeHandler
        }
    });
    (0, _skate2.default)("aui-item-radio", {
        template: (0, _skatejsTemplateHtml2.default)('<span role="radio" class="aui-dropdown2-radio" tabindex="-1"><content></content></span>'),
        attributes: {
            "item-id": stringAttributeHandlerGenerator("id"),
            disabled: disabledAttributeHandler,
            interactive: interactiveAttributeHandler,
            checked: checkedAttributeHandler,
            hidden: hiddenAttributeHandler
        }
    });
    (0, _skate2.default)("aui-section", {
        template: (0, _skatejsTemplateHtml2.default)('\n        <strong aria-role="presentation" class="aui-dropdown2-heading"></strong>\n        <div role="group">\n            <content></content>\n        </div>\n    '),
        attributes: {
            label: function label(element, data1) {
                var headingElement = element.children[0];
                var groupElement = element.children[1];
                headingElement.textContent = data1.newValue;
                groupElement.setAttribute("aria-label", data1.newValue);
            }
        },
        created: function created(element) {
            element.className += " aui-dropdown2-section";
            element.setAttribute("role", "presentation");
        }
    });
    (0, _skate2.default)("aui-dropdown-menu", {
        template: (0, _skatejsTemplateHtml2.default)('\n        <div role="application">\n            <content></content>\n        </div>\n    '),
        created: function created(dropdown) {
            dropdown.setAttribute("role", "menu");
            dropdown.className = "aui-dropdown2 aui-style-default aui-layer";
            (0, _state2.default)(dropdown).set("loading-state", UNLOADED);
            // Now skate the .aui-dropdown2 behaviour.
            _skate2.default.init(dropdown);
        },
        attributes: {
            src: {}
        },
        prototype: dropdownPrototype,
        events: {
            "aui-layer-show": loadContentWhenMenuShown
        }
    });
    // Legacy dropdown inits
    // ---------------------
    (0, _skate2.default)("aui-dropdown2", {
        type: _skate2.default.type.CLASSNAME,
        created: dropdownCreated,
        prototype: dropdownPrototype
    });
    (0, _skate2.default)("data-aui-dropdown2", {
        type: _skate2.default.type.ATTRIBUTE,
        created: dropdownCreated,
        prototype: dropdownPrototype
    });
    // Checkboxes and radios
    // ---------------------
    (0, _skate2.default)("aui-dropdown2-checkbox", {
        type: _skate2.default.type.CLASSNAME,
        created: function created(checkbox) {
            var checked = isChecked(checkbox);
            if (checked) (0, _jquery2.default)(checkbox).addClass("checked aui-dropdown2-checked");
            checkbox.setAttribute("aria-checked", checked);
            checkbox.setAttribute("tabindex", "0");
            // swap from menuitemcheckbox to just plain checkbox for VoiceOver
            if ((0, _browser.supportsVoiceOver)()) checkbox.setAttribute("role", "checkbox");
        },
        prototype: {
            isEnabled: function isEnabled() {
                return !(this.getAttribute("aria-disabled") !== null && this.getAttribute("aria-disabled") === "true");
            },
            isChecked: function isChecked() {
                return this.getAttribute("aria-checked") !== null && this.getAttribute("aria-checked") === "true";
            },
            isInteractive: function isInteractive() {
                return (0, _jquery2.default)(this).hasClass("aui-dropdown2-interactive");
            },
            uncheck: function uncheck() {
                if (this.parentNode.tagName.toLowerCase() === "aui-item-checkbox") this.parentNode.removeAttribute("checked");
                this.setAttribute("aria-checked", "false");
                (0, _jquery2.default)(this).removeClass("checked aui-dropdown2-checked");
                (0, _jquery2.default)(this).trigger("aui-dropdown2-item-uncheck");
            },
            check: function check() {
                if (this.parentNode.tagName.toLowerCase() === "aui-item-checkbox") this.parentNode.setAttribute("checked", "");
                this.setAttribute("aria-checked", "true");
                (0, _jquery2.default)(this).addClass("checked aui-dropdown2-checked");
                (0, _jquery2.default)(this).trigger("aui-dropdown2-item-check");
            }
        }
    });
    (0, _skate2.default)("aui-dropdown2-radio", {
        type: _skate2.default.type.CLASSNAME,
        created: function created(radio) {
            // add a dash of ARIA
            var checked = isChecked(radio);
            if (checked) (0, _jquery2.default)(radio).addClass("checked aui-dropdown2-checked");
            radio.setAttribute("aria-checked", checked);
            radio.setAttribute("tabindex", "0");
            // swap from menuitemradio to just plain radio for VoiceOver
            if ((0, _browser.supportsVoiceOver)()) radio.setAttribute("role", "radio");
        },
        prototype: {
            isEnabled: function isEnabled() {
                return !(this.getAttribute("aria-disabled") !== null && this.getAttribute("aria-disabled") === "true");
            },
            isChecked: function isChecked() {
                return this.getAttribute("aria-checked") !== null && this.getAttribute("aria-checked") === "true";
            },
            isInteractive: function isInteractive() {
                return (0, _jquery2.default)(this).hasClass("aui-dropdown2-interactive");
            },
            uncheck: function uncheck() {
                if (this.parentNode.tagName.toLowerCase() === "aui-item-radio") this.parentNode.removeAttribute("checked");
                this.setAttribute("aria-checked", "false");
                (0, _jquery2.default)(this).removeClass("checked aui-dropdown2-checked");
                (0, _jquery2.default)(this).trigger("aui-dropdown2-item-uncheck");
            },
            check: function check() {
                if (this.parentNode.tagName.toLowerCase() === "aui-item-radio") this.parentNode.setAttribute("checked", "");
                this.setAttribute("aria-checked", "true");
                (0, _jquery2.default)(this).addClass("checked aui-dropdown2-checked");
                (0, _jquery2.default)(this).trigger("aui-dropdown2-item-check");
            }
        }
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/unique-id.js
(typeof window === "undefined" ? $parcel$global : window).__a0ab588de7b0759818853425dc8ad2f2 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var uniqueID;
    var uniqueIDstring;
    var uniqueIDcounter = 0;
    /**
   * Generate a unique ID string, checking the ID is not present in the DOM before
   * returning. Note uniqueID, uniqueIDstring, uniqueIDcounter = 0; set at top of
   * file.
   *
   * @param {String} prefix String to prepend to ID instead of default AUI prefix.
   *
   * @returns {String}
   */ function generateUniqueId(prefix) {
        uniqueID = uniqueIDcounter++ + "";
        uniqueIDstring = prefix ? prefix + uniqueID : "aui-uid-" + uniqueID;
        if (!document.getElementById(uniqueIDstring)) return uniqueIDstring;
        else {
            uniqueIDstring = uniqueIDstring + "-" + new Date().getTime();
            if (!document.getElementById(uniqueIDstring)) return uniqueIDstring;
            else throw new Error('Timestamped fallback ID "' + uniqueIDstring + '" exists.');
        }
    }
    (0, _globalize2.default)("id", generateUniqueId);
    exports.default = generateUniqueId;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/enforcer.js
(typeof window === "undefined" ? $parcel$global : window).__2512e2cfb8f46670d5cb777690a28c72 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _log = __c1e961001275c079e48525ad3a48c8c2;
    var logger = _interopRequireWildcard(_log);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function enforcer(element) {
        function attributeExists(attributeName) {
            var errorMessage = attributeName + " wasn't defined";
            return satisfiesRules(function() {
                return element.hasAttribute(attributeName);
            }, errorMessage);
        }
        function refersTo(attributeName) {
            if (!attributeExists(attributeName, element)) return false;
            var desiredId = element.getAttribute(attributeName);
            var errorMessage = 'an element with id set to "' + desiredId + '" was not found';
            return satisfiesRules(function() {
                return document.getElementById(desiredId);
            }, errorMessage);
        }
        function ariaControls() {
            return refersTo("aria-controls");
        }
        function ariaOwns() {
            return refersTo("aria-owns");
        }
        function satisfiesRules(predicate, message) {
            if (!predicate()) {
                if (element) logger.error(message, element);
                else logger.error(message);
                return false;
            }
            return true;
        }
        return {
            attributeExists: attributeExists,
            refersTo: refersTo,
            satisfiesRules: satisfiesRules,
            ariaControls: ariaControls,
            ariaOwns: ariaOwns
        };
    }
    exports.default = enforcer;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/events.js
(typeof window === "undefined" ? $parcel$global : window).__f3ccb1e110c37fc6c95e5fa43d2c3f4f = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.triggerEvtForInst = exports.triggerEvt = exports.bindEvt = undefined;
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var deprecate = _interopRequireWildcard(_deprecation);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var eventRoot = document || {};
    var $eventTarget = (0, _jquery2.default)(eventRoot);
    /**
   * Triggers a custom event on the AJS object
   *
   * @param {String} name - name of event
   * @param {Array} args - args for event handler
   */ function triggerEvt(name, args) {
        $eventTarget.trigger(name, args);
    }
    /**
   * Binds handler to the AJS object
   *
   * @param {String} name
   * @param {Function} func
   */ function bindEvt(name, func) {
        $eventTarget.bind(name, func);
    }
    /**
   * Some generic error handling that fires event in multiple contexts
   * - on AJS object
   * - on Instance
   * - on AJS object with prefixed id.
   *
   * @param evt
   * @param inst
   * @param args
   */ function triggerEvtForInst(evt, inst, args) {
        (0, _jquery2.default)(inst).trigger(evt, args);
        triggerEvt(evt, args);
        if (inst.id) triggerEvt(inst.id + "-" + evt, args);
    }
    exports.bindEvt = bindEvt = deprecate.fn(bindEvt, "bindEvt", {
        sinceVersion: "5.8.0"
    });
    exports.triggerEvt = triggerEvt = deprecate.fn(triggerEvt, "triggerEvt", {
        sinceVersion: "5.8.0"
    });
    exports.triggerEvtForInst = triggerEvtForInst = deprecate.fn(triggerEvtForInst, "triggerEvtForInst", {
        sinceVersion: "5.8.0"
    });
    (0, _globalize2.default)("bindEvt", bindEvt);
    (0, _globalize2.default)("triggerEvt", triggerEvt);
    (0, _globalize2.default)("triggerEvtForInst", triggerEvtForInst);
    exports.bindEvt = bindEvt;
    exports.triggerEvt = triggerEvt;
    exports.triggerEvtForInst = triggerEvtForInst;
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/event.js
(typeof window === "undefined" ? $parcel$global : window).__51139989be9b25b15c1774d709ce985b = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.trigger = exports.unbind = exports.bind = undefined;
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _log = __c1e961001275c079e48525ad3a48c8c2;
    var logger = _interopRequireWildcard(_log);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Binds events to the window object. See jQuery bind documentation for more
   * details. Exceptions are caught and logged.
   */ function bind(eventType, eventData, handler) {
        try {
            if (typeof handler === "function") return (0, _jquery2.default)(window).bind(eventType, eventData, handler);
            else return (0, _jquery2.default)(window).bind(eventType, eventData);
        } catch (e) {
            logger.log("error while binding: " + e.message);
        }
    }
    /**
   * Unbinds event handlers from the window object. See jQuery unbind
   * documentation for more details. Exceptions are caught and logged.
   */ function unbind(eventType, handler) {
        try {
            return (0, _jquery2.default)(window).unbind(eventType, handler);
        } catch (e) {
            logger.log("error while unbinding: " + e.message);
        }
    }
    /**
   * Triggers events on the window object. See jQuery trigger documentation for
   * more details. Exceptions are caught and logged.
   */ function trigger(eventType, extraParameters) {
        try {
            return (0, _jquery2.default)(window).trigger(eventType, extraParameters);
        } catch (e) {
            logger.log("error while triggering: " + e.message);
        }
    }
    (0, _globalize2.default)("bind", bind);
    (0, _globalize2.default)("trigger", trigger);
    (0, _globalize2.default)("unbind", unbind);
    exports.bind = bind;
    exports.unbind = unbind;
    exports.trigger = trigger;
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/forms.js
(typeof window === "undefined" ? $parcel$global : window).__8741535334cf9725b62821139abd6dba = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.inlineHelp = exports.enable = undefined;
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Enables the specified form element.
   *
   * @param {Element} el The element to enable.
   * @param {Boolean} b The flag setting enabled / disabled.
   *
   * @returns {jQuery}
   */ function enable(el, b) {
        var $el = (0, _jquery2.default)(el);
        if (typeof b === "undefined") b = true;
        return $el.each(function() {
            this.disabled = !b;
        });
    }
    /**
   * Forms: Inline Help - toggles visibility of inline help content.
   *
   * @method inlineHelp
   * @namespace AJS
   * @for AJS
   */ function inlineHelp() {
        (0, _jquery2.default)(".icon-inline-help").click(function() {
            var $t = (0, _jquery2.default)(this).siblings(".field-help");
            if ($t.hasClass("hidden")) $t.removeClass("hidden");
            else $t.addClass("hidden");
        });
    }
    (0, _globalize2.default)("enable", enable);
    (0, _globalize2.default)("inlineHelp", inlineHelp);
    exports.enable = enable;
    exports.inlineHelp = inlineHelp;
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/dialog.js
(typeof window === "undefined" ? $parcel$global : window).__bc50e12d2af94e34822ae0035ae0e67f = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.popup = exports.Dialog = undefined;
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }; // can't "use strict"
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _keyCode = __e246bf93af36eb4453f35afeb1c302d9;
    var _keyCode2 = _interopRequireDefault(_keyCode);
    var _log = __c1e961001275c079e48525ad3a48c8c2;
    var logger = _interopRequireWildcard(_log);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var deprecate = _interopRequireWildcard(_deprecation);
    var _event = __51139989be9b25b15c1774d709ce985b;
    var _blanket = __4c4f13d92d5dcb8f12059ce701946463;
    var _forms = __8741535334cf9725b62821139abd6dba;
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Creates a generic popup that will be displayed in the center of the screen with a
   * grey blanket in the background.
   * Usage:
   * <pre>
   * createPopup({
   *     width: 800,
   *     height: 400,
   *     id: "my-dialog"
   * });
   * </pre>
   * @param options {object} [optional] Permitted options and defaults are as follows:
   * width (800), height (600), keypressListener (closes dialog on ESC).
  */ function createPopup(options) {
        var defaults = {
            width: 800,
            height: 600,
            closeOnOutsideClick: false,
            keypressListener: function keypressListener(e) {
                if (e.keyCode === _keyCode2.default.ESCAPE && popup.is(":visible")) res.hide();
            }
        };
        // for backwards-compatibility
        if ((typeof options === "undefined" ? "undefined" : _typeof(options)) !== "object") {
            options = {
                width: arguments[0],
                height: arguments[1],
                id: arguments[2]
            };
            options = _jquery2.default.extend({}, options, arguments[3]);
        }
        options = _jquery2.default.extend({}, defaults, options);
        var popup = (0, _jquery2.default)("<div></div>").addClass("aui-popup");
        if (options.id) popup.attr("id", options.id);
        //find the highest z-index on the page to ensure any new popup that is shown is shown on top
        var highestZIndex = 3000;
        (0, _jquery2.default)(".aui-dialog").each(function() {
            var currentPopup = (0, _jquery2.default)(this);
            highestZIndex = currentPopup.css("z-index") > highestZIndex ? currentPopup.css("z-index") : highestZIndex;
        });
        var applySize = function _applySize(width, height) {
            options.width = width = width || options.width;
            options.height = height = height || options.height;
            popup.css({
                marginTop: -Math.round(height / 2) + "px",
                marginLeft: -Math.round(width / 2) + "px",
                width: width,
                height: height,
                "z-index": parseInt(highestZIndex, 10) + 2 //+ 2 so that the shadow can be shown on +1 (underneath the popup but above everything else)
            });
            return _applySize;
        }(options.width, options.height);
        (0, _jquery2.default)("body").append(popup);
        popup.hide();
        (0, _forms.enable)(popup);
        /**
       * Popup object
       * @class Popup
       * @static
      */ //blanket for reference further down
        var blanket = (0, _jquery2.default)(".aui-blanket");
        var focusItem = function focusItem(selector, element) {
            var item = (0, _jquery2.default)(selector, element);
            if (item.length) {
                item.focus();
                return true;
            }
            return false;
        };
        // we try and place focus, in the configured element or by looking for the first input
        // in page body, then button panel and finally page menu.
        var focusDialog = function focusDialog(element) {
            if ((0, _jquery2.default)(".dialog-page-body", element).find(":focus").length !== 0) return;
            if (options.focusSelector) return focusItem(options.focusSelector, element);
            var defaultFocusSelector = ":input:visible:enabled:first";
            if (focusItem(defaultFocusSelector, (0, _jquery2.default)(".dialog-page-body", element))) return;
            if (focusItem(defaultFocusSelector, (0, _jquery2.default)(".dialog-button-panel", element))) return;
            focusItem(defaultFocusSelector, (0, _jquery2.default)(".dialog-page-menu", element));
        };
        var res = {
            changeSize: function changeSize(w, h) {
                if (w && w != options.width || h && h != options.height) applySize(w, h);
                this.show();
            },
            /**
           * Shows the popup
           * @method show
          */ show: function show() {
                var show = function show() {
                    (0, _jquery2.default)(document).off("keydown", options.keypressListener).on("keydown", options.keypressListener);
                    (0, _blanket.dim)();
                    blanket = (0, _jquery2.default)(".aui-blanket");
                    if (blanket.length !== 0 && options.closeOnOutsideClick) blanket.click(function() {
                        if (popup.is(":visible")) res.hide();
                    });
                    popup.show();
                    createPopup.current = this;
                    focusDialog(popup);
                    (0, _jquery2.default)(document).trigger("showLayer", [
                        "popup",
                        this
                    ]);
                };
                show.call(this);
                this.show = show;
            },
            /**
           * Hides the popup.
           * @method hide
          */ hide: function hide() {
                (0, _jquery2.default)(document).unbind("keydown", options.keypressListener);
                blanket.unbind();
                this.element.hide();
                //only undim if no other dialogs are visible
                if ((0, _jquery2.default)(".aui-dialog:visible").length === 0) (0, _blanket.undim)();
                // AUI-1059: remove focus from the active element when dialog is hidden
                var activeElement = document.activeElement;
                if (this.element.has(activeElement).length) activeElement.blur();
                (0, _jquery2.default)(document).trigger("hideLayer", [
                    "popup",
                    this
                ]);
                createPopup.current = null;
                this.enable();
            },
            /**
           * jQuery object, representing popup DOM element
           * @property element
          */ element: popup,
            /**
           * Removes popup elements from the DOM
           * @method remove
          */ remove: function remove() {
                popup.remove();
                this.element = null;
            },
            /**
           * disables the popup
           * @method disable
          */ disable: function disable() {
                if (!this.disabled) {
                    this.popupBlanket = (0, _jquery2.default)("<div class='dialog-blanket'> </div>").css({
                        height: popup.height(),
                        width: popup.width()
                    });
                    popup.append(this.popupBlanket);
                    this.disabled = true;
                }
            },
            /**
           * enables the popup if it is disabled
           * @method enable
          */ enable: function enable() {
                if (this.disabled) {
                    this.disabled = false;
                    this.popupBlanket.remove();
                    this.popupBlanket = null;
                }
            }
        };
        return res;
    }
    // Scoping function
    var Dialog = function() {
        /**
       * @class Button
       * @constructor Button
       * @param page {number} page id
       * @param label {string} button label
       * @param onclick {function} [optional] click event handler
       * @param className {string} [optional] class name
       * @private
      */ function Button(page, label, onclick, className) {
            if (!page.buttonpanel) page.addButtonPanel();
            this.page = page;
            this.onclick = onclick;
            this._onclick = function(e) {
                return onclick.call(this, page.dialog, page, e) === true;
            };
            this.item = (0, _jquery2.default)("<button></button>").html(label).addClass("button-panel-button");
            if (className) this.item.addClass(className);
            if (typeof onclick === "function") this.item.click(this._onclick);
            page.buttonpanel.append(this.item);
            this.id = page.button.length;
            page.button[this.id] = this;
        }
        /**
       * @class Link
       * @constructor Link
       * @param page {number} page id
       * @param label {string} button label
       * @param onclick {function} [optional] click event handler
       * @param className {string} [optional] class name
       * @private
      */ function Link(page, label, onclick, className, url) {
            if (!page.buttonpanel) page.addButtonPanel();
            //if no url is given use # as default
            if (!url) url = "#";
            this.page = page;
            this.onclick = onclick;
            this._onclick = function(e) {
                return onclick.call(this, page.dialog, page, e) === true;
            };
            this.item = (0, _jquery2.default)("<a></a>").html(label).attr("href", url).addClass("button-panel-link");
            if (className) this.item.addClass(className);
            if (typeof onclick === "function") this.item.click(this._onclick);
            page.buttonpanel.append(this.item);
            this.id = page.button.length;
            page.button[this.id] = this;
        }
        function itemMove(leftOrRight, target) {
            var dir = leftOrRight == "left" ? -1 : 1;
            return function(step) {
                var dtarget = this.page[target];
                if (this.id != (dir == 1 ? dtarget.length - 1 : 0)) {
                    dir *= step || 1;
                    dtarget[this.id + dir].item[dir < 0 ? "before" : "after"](this.item);
                    dtarget.splice(this.id, 1);
                    dtarget.splice(this.id + dir, 0, this);
                    for(var i = 0, ii = dtarget.length; i < ii; i++){
                        if (target == "panel" && this.page.curtab == dtarget[i].id) this.page.curtab = i;
                        dtarget[i].id = i;
                    }
                }
                return this;
            };
        }
        function itemRemove(target) {
            return function() {
                this.page[target].splice(this.id, 1);
                for(var i = 0, ii = this.page[target].length; i < ii; i++)this.page[target][i].id = i;
                this.item.remove();
            };
        }
        /**
       * Moves item left in the hierarchy
       * @method moveUp
       * @method moveLeft
       * @param step {number} how many items to move, default is 1
       * @return {object} button
      */ Button.prototype.moveUp = Button.prototype.moveLeft = itemMove("left", "button");
        /**
       * Moves item right in the hierarchy
       * @method moveDown
       * @method moveRight
       * @param step {number} how many items to move, default is 1
       * @return {object} button
      */ Button.prototype.moveDown = Button.prototype.moveRight = itemMove("right", "button");
        /**
       * Removes item
       * @method remove
      */ Button.prototype.remove = itemRemove("button");
        /**
       * Getter and setter for label
       * @method label
       * @param label {string} [optional] label of the button
       * @return {string} label, if nothing is passed in
       * @return {object} jQuery button object, if label is passed in
      */ Button.prototype.html = function(label) {
            return this.item.html(label);
        };
        /**
       * Getter and setter of onclick event handler
       * @method onclick
       * @param onclick {function} [optional] new event handler, that is going to replace the old one
       * @return {function} existing event handler if new one is undefined
      */ Button.prototype.onclick = function(onclick) {
            var self = this;
            if (typeof onclick === "undefined") return this.onclick;
            else {
                this.item.unbind("click", this._onclick);
                this._onclick = function(e) {
                    return onclick.call(this, self.page.dialog, self.page, e) === true;
                };
                if (typeof onclick === "function") this.item.click(this._onclick);
            }
        };
        var DEFAULT_PADDING = 20;
        /**
       * Class for panels
       * @class Panel
       * @constructor
       * @param page {number} page id
       * @param title {string} panel title
       * @param reference {string} or {object} jQuery object or selector for the contents of the Panel
       * @param className {string} [optional] HTML class name
       * @param panelButtonId {string} the unique id that will be put on the button element for this panel.
       * @private
      */ var Panel = function Panel(page, title, reference, className, panelButtonId) {
            if (!(reference instanceof _jquery2.default)) reference = (0, _jquery2.default)(reference);
            this.dialog = page.dialog;
            this.page = page;
            this.id = page.panel.length;
            this.button = (0, _jquery2.default)("<button></button>").html(title).addClass("item-button");
            if (panelButtonId) this.button[0].id = panelButtonId;
            this.item = (0, _jquery2.default)("<li></li>").append(this.button).addClass("page-menu-item");
            this.body = (0, _jquery2.default)("<div></div>").append(reference).addClass("dialog-panel-body").css("height", page.dialog.height + "px");
            this.padding = DEFAULT_PADDING;
            if (className) this.body.addClass(className);
            var i = page.panel.length;
            var tab = this;
            page.menu.append(this.item);
            page.body.append(this.body);
            page.panel[i] = this;
            var onclick = function onclick() {
                var cur;
                if (page.curtab + 1) {
                    cur = page.panel[page.curtab];
                    cur.body.hide();
                    cur.item.removeClass("selected");
                    typeof cur.onblur === "function" && cur.onblur();
                }
                page.curtab = tab.id;
                tab.body.show();
                tab.item.addClass("selected");
                typeof tab.onselect === "function" && tab.onselect();
                typeof page.ontabchange === "function" && page.ontabchange(tab, cur);
            };
            if (!this.button.click) {
                logger.log("atlassian-dialog:Panel:constructor - this.button.click false");
                this.button.onclick = onclick;
            } else this.button.click(onclick);
            onclick();
            if (i == 0) page.menu.css("display", "none"); // don't use jQuery hide()
            else page.menu.show();
        };
        /**
       * Selects current panel
       * @method select
      */ Panel.prototype.select = function() {
            this.button.click();
        };
        /**
       * Moves item left in the hierarchy
       * @method moveUp
       * @method moveLeft
       * @param step {number} how many items to move, default is 1
       * @return {object} panel
      */ Panel.prototype.moveUp = Panel.prototype.moveLeft = itemMove("left", "panel");
        /**
       * Moves item right in the hierarchy
       * @method moveDown
       * @method moveRight
       * @param step {number} how many items to move, default is 1
       * @return {object} panel
      */ Panel.prototype.moveDown = Panel.prototype.moveRight = itemMove("right", "panel");
        /**
       * Removes item
       * @method remove
      */ Panel.prototype.remove = itemRemove("panel");
        /**
       * Getter and setter of inner HTML of the panel
       * @method html
       * @param html {string} HTML source to set up
       * @return {object} panel
       * @return {string} current HTML source
      */ Panel.prototype.html = function(html) {
            if (html) {
                this.body.html(html);
                return this;
            } else return this.body.html();
        };
        /**
       * This method gives you ability to overwrite default padding value. Use it with caution.
       * @method setPadding
       * @param padding {number} padding in pixels
       * @return {object} panel
       * @see DEFAULT_PADDING
      */ Panel.prototype.setPadding = function(padding) {
            if (!isNaN(+padding)) {
                this.body.css("padding", +padding);
                this.padding = +padding;
                this.page.recalcSize();
            }
            return this;
        };
        var HEADER_HEIGHT = 62;
        var BUTTONS_HEIGHT = 52;
        var MIN_DIALOG_VERTICAL_BUFFER = 50;
        /**
       * Class for pages
       * @class Page
       * @constructor
       * @param dialog {object} dialog object
       * @param className {string} [optional] HTML class name
       * @private
      */ var Page = function Page(dialog, className) {
            this.dialog = dialog;
            this.id = dialog.page.length;
            this.element = (0, _jquery2.default)("<div></div>").addClass("dialog-components");
            this.body = (0, _jquery2.default)("<div></div>").addClass("dialog-page-body");
            this.menu = (0, _jquery2.default)("<ul></ul>").addClass("dialog-page-menu").css("height", dialog.height + "px");
            this.body.append(this.menu);
            this.curtab;
            this.panel = [];
            this.button = [];
            if (className) this.body.addClass(className);
            dialog.popup.element.append(this.element.append(this.menu).append(this.body));
            dialog.page[dialog.page.length] = this;
        };
        /**
       * Size updater for contents of the page. For internal use
       * @method recalcSize
      */ Page.prototype.recalcSize = function() {
            var headerHeight = this.header ? HEADER_HEIGHT : 0;
            var buttonHeight = this.buttonpanel ? BUTTONS_HEIGHT : 0;
            for(var i = this.panel.length; i--;){
                var dialogComponentsHeight = this.dialog.height - headerHeight - buttonHeight;
                this.panel[i].body.css("height", dialogComponentsHeight);
                this.menu.css("height", dialogComponentsHeight);
            }
        };
        /**
       * Adds a button panel to the bottom of dialog
       * @method addButtonPanel
       */ Page.prototype.addButtonPanel = function() {
            this.buttonpanel = (0, _jquery2.default)("<div></div>").addClass("dialog-button-panel");
            this.element.append(this.buttonpanel);
        };
        /**
       * Method for adding new panel to the page
       * @method addPanel
       * @param title {string} panel title
       * @param reference {string} or {object} jQuery object or selector for the contents of the Panel
       * @param className {string} [optional] HTML class name
       * @param panelButtonId {string} [optional] The unique id for the panel's button.
       * @return {object} the page
      */ Page.prototype.addPanel = function(title, reference, className, panelButtonId) {
            new Panel(this, title, reference, className, panelButtonId);
            this.recalcSize();
            return this;
        };
        /**
       * Method for adding header to the page
       * @method addHeader
       * @param title {string} panel title
       * @param className {string} [optional] CSS class name
       * @return {object} the page
      */ Page.prototype.addHeader = function(title, className) {
            if (this.header) this.header.remove();
            this.header = (0, _jquery2.default)("<h2></h2>").text(title || "").addClass("dialog-title");
            className && this.header.addClass(className);
            this.element.prepend(this.header);
            this.recalcSize();
            return this;
        };
        /**
       * Method for adding new button to the page
       * @method addButton
       * @param label {string} button label
       * @param onclick {function} [optional] click event handler
       * @param className {string} [optional] class name
       * @return {object} the page
      */ Page.prototype.addButton = function(label, onclick, className) {
            new Button(this, label, onclick, className);
            this.recalcSize();
            return this;
        };
        /**
       * Method for adding new link to the page
       * @method addLink
       * @param label {string} button label
       * @param onclick {function} [optional] click event handler
       * @param className {string} [optional] class name
       * @return {object} the page
      */ Page.prototype.addLink = function(label, onclick, className, url) {
            new Link(this, label, onclick, className, url);
            this.recalcSize();
            return this;
        };
        /**
       * Selects corresponding panel
       * @method gotoPanel
       * @param panel {object} panel object
       * @param panel {number} id of the panel
      */ Page.prototype.gotoPanel = function(panel) {
            this.panel[panel.id || panel].select();
        };
        /**
       * Returns current panel on the page
       * @method getCurrentPanel
       * @return panel {object} the panel
      */ Page.prototype.getCurrentPanel = function() {
            return this.panel[this.curtab];
        };
        /**
       * Hides the page
       * @method hide
      */ Page.prototype.hide = function() {
            this.element.hide();
        };
        /**
       * Shows the page, if it was hidden
       * @method show
      */ Page.prototype.show = function() {
            this.element.show();
        };
        /**
       * Removes the page
       * @method remove
      */ Page.prototype.remove = function() {
            this.element.remove();
        };
        /**
       * Constructor for a Dialog. A Dialog is a popup which consists of Pages, where each Page can consist of Panels,
       * Buttons and a Header. The dialog must be constructed in page order as it has a current page state. For example,
       * calling addButton() will add a button to the 'current' page.
       * <p>
       * By default, a new Dialog will have one page. If there are multiple Panels on a Page, a
       * menu is displayed on the left side of the dialog.
       * </p>
       * Usage:
       * <pre>
       * var dialog = new Dialog(860, 530);
       * dialog.addHeader("Insert Macro")
       * .addPanel("All", "&lt;p&gt;&lt;/p&gt;")
       * .addPanel("Some", "&lt;p&gt;&lt;/p&gt;")
       * .addButton("Next", function (dialog) {dialog.nextPage();})
       * .addButton("Cancel", function (dialog) {dialog.hide();});
       *
       * dialog.addPage()
       * .addButton("Cancel", function (dialog) {dialog.hide();});
       *
       * somebutton.click(function () {dialog.show();});
       * </pre>
       * @class Dialog
       * @constructor
       * @param width {number} dialog width in pixels, or an object containing the Dialog parameters
       * @param height {number} dialog height in pixels
       * @param id {number} [optional] dialog id
      */ function Dialog(width, height, id) {
            var options = {};
            if (!+width) {
                options = Object(width);
                width = options.width;
                height = options.height;
                id = options.id;
            }
            this.height = height || 480;
            this.width = width || 640;
            this.id = id;
            options = _jquery2.default.extend({}, options, {
                width: this.width,
                height: this.height,
                id: this.id
            });
            this.popup = createPopup(options);
            this.popup.element.addClass("aui-dialog");
            this.page = [];
            this.curpage = 0;
            new Page(this);
        }
        /**
       * Method for adding header to the current page
       * @method addHeader
       * @param title {string} panel title
       * @param className {string} [optional] HTML class name
       * @return {object} the dialog
      */ Dialog.prototype.addHeader = function(title, className) {
            this.page[this.curpage].addHeader(title, className);
            return this;
        };
        /**
       * Method for adding new button to the current page
       * @method addButton
       * @param label {string} button label
       * @param onclick {function} [optional] click event handler
       * @param className {string} [optional] class name
       * @return {object} the dialog
      */ Dialog.prototype.addButton = function(label, onclick, className) {
            this.page[this.curpage].addButton(label, onclick, className);
            return this;
        };
        /**
       * Method for adding new link to the current page
       * @method addButton
       * @param label {string} link label
       * @param onclick {function} [optional] click event handler
       * @param className {string} [optional] class name
       * @return {object} the dialog
      */ Dialog.prototype.addLink = function(label, onclick, className, url) {
            this.page[this.curpage].addLink(label, onclick, className, url);
            return this;
        };
        /**
      * Method for adding a submit button to the current page
      * @method addSubmit
      * @param label {string} link label
      * @param onclick {function} [optional] click event handler
      * @return {object} the dialog
      */ Dialog.prototype.addSubmit = function(label, onclick) {
            this.page[this.curpage].addButton(label, onclick, "button-panel-submit-button");
            return this;
        };
        /**
      * Method for adding a cancel link to the current page
      * @method addCancel
      * @param label {string} link label
      * @param onclick {function} [optional] click event handler
      * @return {object} the dialog
      */ Dialog.prototype.addCancel = function(label, onclick) {
            this.page[this.curpage].addLink(label, onclick, "button-panel-cancel-link");
            return this;
        };
        /**
       * Method for adding new button panel to the current page
       * @return {object} the dialog
      */ Dialog.prototype.addButtonPanel = function() {
            this.page[this.curpage].addButtonPanel();
            return this;
        };
        /**
       * Method for adding new panel to the current page.
       * @method addPanel
       * @param title {string} panel title
       * @param reference {string} or {object} jQuery object or selector for the contents of the Panel
       * @param className {string} [optional] HTML class name
       * @param panelButtonId {String} [optional] The unique id for the panel's button.
       * @return {object} the dialog
      */ Dialog.prototype.addPanel = function(title, reference, className, panelButtonId) {
            this.page[this.curpage].addPanel(title, reference, className, panelButtonId);
            return this;
        };
        /**
       * Adds a new page to the dialog and sets the new page as the current page
       * @method addPage
       * @param className {string} [optional] HTML class name
       * @return {object} the dialog
      */ Dialog.prototype.addPage = function(className) {
            new Page(this, className);
            this.page[this.curpage].hide();
            this.curpage = this.page.length - 1;
            return this;
        };
        /**
       * Making next page in hierarchy visible and active
       * @method nextPage
       * @return {object} the dialog
      */ Dialog.prototype.nextPage = function() {
            this.page[this.curpage++].hide();
            if (this.curpage >= this.page.length) this.curpage = 0;
            this.page[this.curpage].show();
            return this;
        };
        /**
       * Making previous page in hierarchy visible and active
       * @method prevPage
       * @return {object} the dialog
      */ Dialog.prototype.prevPage = function() {
            this.page[this.curpage--].hide();
            if (this.curpage < 0) this.curpage = this.page.length - 1;
            this.page[this.curpage].show();
            return this;
        };
        /**
       * Making specified page visible and active
       * @method gotoPage
       * @param num {number} page id
       * @return {object} the dialog
      */ Dialog.prototype.gotoPage = function(num) {
            this.page[this.curpage].hide();
            this.curpage = num;
            if (this.curpage < 0) this.curpage = this.page.length - 1;
            else if (this.curpage >= this.page.length) this.curpage = 0;
            this.page[this.curpage].show();
            return this;
        };
        /**
       * Returns specified panel at the current page
       * @method getPanel
       * @param pageorpanelId {number} page id or panel id
       * @param panelId {number} panel id
       * @return {object} the internal Panel object
      */ Dialog.prototype.getPanel = function(pageorpanelId, panelId) {
            var pageid = panelId == null ? this.curpage : pageorpanelId;
            if (panelId == null) panelId = pageorpanelId;
            return this.page[pageid].panel[panelId];
        };
        /**
       * Returns specified page
       * @method getPage
       * @param pageid {number} page id
       * @return {object} the internal Page Object
      */ Dialog.prototype.getPage = function(pageid) {
            return this.page[pageid];
        };
        /**
       * Returns current panel at the current page
       * @method getCurrentPanel
       * @return {object} the internal Panel object
      */ Dialog.prototype.getCurrentPanel = function() {
            return this.page[this.curpage].getCurrentPanel();
        };
        /**
       * Selects corresponding panel
       * @method gotoPanel
       * @param pageorpanel {object} panel object or page object
       * @param panel {object} panel object
       * @param panel {number} id of the panel
      */ Dialog.prototype.gotoPanel = function(pageorpanel, panel) {
            if (panel != null) {
                var pageid = pageorpanel.id || pageorpanel;
                this.gotoPage(pageid);
            }
            this.page[this.curpage].gotoPanel(typeof panel === "undefined" ? pageorpanel : panel);
        };
        /**
       * Shows the dialog, if it is not visible
       * @method show
       * @return {object} the dialog
      */ Dialog.prototype.show = function() {
            this.popup.show();
            (0, _event.trigger)("show.dialog", {
                dialog: this
            });
            return this;
        };
        /**
       * Hides the dialog, if it was visible
       * @method hide
       * @return {object} the dialog
      */ Dialog.prototype.hide = function() {
            this.popup.hide();
            (0, _event.trigger)("hide.dialog", {
                dialog: this
            });
            return this;
        };
        /**
       * Removes the dialog elements from the DOM
       * @method remove
      */ Dialog.prototype.remove = function() {
            this.popup.hide();
            this.popup.remove();
            (0, _event.trigger)("remove.dialog", {
                dialog: this
            });
        };
        /**
       * Disables the dialog if enabled
       * @method disable
      */ Dialog.prototype.disable = function() {
            this.popup.disable();
            return this;
        };
        /**
       * Enables the dialog if disabled
       * @method disable
      */ Dialog.prototype.enable = function() {
            this.popup.enable();
            return this;
        };
        /**
       * Gets set of items depending on query
       * @method get
       * @param query {string} query to search for panels, pages, headers or buttons
       * e.g.
       *      '#Name' will find all dialog components with the given name such as panels and buttons, etc
       *      'panel#Name' will find only panels with the given name
       *      'panel#"Foo bar"' will find only panels with given name
       *      'panel:3' will find the third panel
       */ Dialog.prototype.get = function(query) {
            var coll = [];
            var dialog = this;
            var nameExp = '#([^"][^ ]*|"[^"]*")'; // a name is a hash followed by either a bare word or quoted string
            var indexExp = ":(\\d+)"; // an index is a colon followed by some digits
            var typeExp = "page|panel|button|header"; // one of the allowed types
            var selectorExp = "(?:(" + typeExp + ")(?:" + nameExp + "|" + indexExp + ")?" + // a type optionally followed by either #name or :index
            "|" + nameExp + // or just a #name
            ")";
            var queryRE = new RegExp("(?:^|,)\\s*" + selectorExp + // optional space and a selector
            "(?:\\s+" + selectorExp + ")?" + // optionally, followed by some space and a second selector
            "\\s*(?=,|$)", "ig"); // followed by, but not including, a comma or the end of the string
            (query + "").replace(queryRE, function(all, name, title, id, justtitle, name2, title2, id2, justtitle2) {
                name = name && name.toLowerCase();
                var pages = [];
                if (name == "page" && dialog.page[id]) {
                    pages.push(dialog.page[id]);
                    name = name2;
                    name = name && name.toLowerCase();
                    title = title2;
                    id = id2;
                    justtitle = justtitle2;
                } else pages = dialog.page;
                title = title && (title + "").replace(/"/g, "");
                title2 = title2 && (title2 + "").replace(/"/g, "");
                justtitle = justtitle && (justtitle + "").replace(/"/g, "");
                justtitle2 = justtitle2 && (justtitle2 + "").replace(/"/g, "");
                if (name || justtitle) for(var i = pages.length; i--;){
                    if (justtitle || name == "panel" && (title || !title && id == null)) {
                        for(var j = pages[i].panel.length; j--;)if (pages[i].panel[j].button.html() == justtitle || pages[i].panel[j].button.html() == title || name == "panel" && !title && id == null) coll.push(pages[i].panel[j]);
                    }
                    if (justtitle || name == "button" && (title || !title && id == null)) {
                        for(var j = pages[i].button.length; j--;)if (pages[i].button[j].item.html() == justtitle || pages[i].button[j].item.html() == title || name == "button" && !title && id == null) coll.push(pages[i].button[j]);
                    }
                    if (pages[i][name] && pages[i][name][id]) coll.push(pages[i][name][id]);
                    if (name == "header" && pages[i].header) coll.push(pages[i].header);
                }
                else coll = coll.concat(pages);
            });
            var res = {
                length: coll.length
            };
            for(var i = coll.length; i--;){
                res[i] = coll[i];
                for(var method in coll[i])if (!(method in res)) (function(m) {
                    res[m] = function() {
                        for(var j = this.length; j--;)if (typeof this[j][m] === "function") this[j][m].apply(this[j], arguments);
                    };
                })(method);
            }
            return res;
        };
        /**
       * Updates height of panels, to contain content without the need for scroll bars.
       *
       * @method updateHeight
       */ Dialog.prototype.updateHeight = function() {
            var height = 0;
            var maxDialogHeight = (0, _jquery2.default)(window).height() - HEADER_HEIGHT - BUTTONS_HEIGHT - MIN_DIALOG_VERTICAL_BUFFER * 2;
            for(var i = 0; this.getPanel(i); i++){
                if (this.getPanel(i).body.css({
                    height: "auto",
                    display: "block"
                }).outerHeight() > height) height = Math.min(maxDialogHeight, this.getPanel(i).body.outerHeight());
                if (i !== this.page[this.curpage].curtab) this.getPanel(i).body.css({
                    display: "none"
                });
            }
            for(i = 0; this.getPanel(i); i++)this.getPanel(i).body.css({
                height: height || this.height
            });
            this.page[0].menu.height(height);
            this.height = height + HEADER_HEIGHT + BUTTONS_HEIGHT + 1;
            this.popup.changeSize(undefined, this.height);
        };
        /**
       * Returns whether the dialog has been resized to it's maximum height (has been capped by the viewport height and vertical buffer).
       *
       * @method isMaximised
       */ Dialog.prototype.isMaximised = function() {
            return this.popup.element.outerHeight() >= (0, _jquery2.default)(window).height() - MIN_DIALOG_VERTICAL_BUFFER * 2;
        };
        /**
       * Returns the current panel.
       * @deprecated Since 3.0.1 Use getCurrentPanel() instead.
       */ Dialog.prototype.getCurPanel = function() {
            return this.getPanel(this.page[this.curpage].curtab);
        };
        /**
       * Returns the current button panel.
       * @deprecated Since 3.0.1 Use get() instead.
       */ Dialog.prototype.getCurPanelButton = function() {
            return this.getCurPanel().button;
        };
        return Dialog;
    }();
    exports.Dialog = Dialog = deprecate.construct(Dialog, "Dialog constructor", {
        alternativeName: "Dialog2"
    });
    exports.popup = createPopup = deprecate.construct(createPopup, "Dialog popup constructor", {
        alternatveName: "Dialog2"
    });
    (0, _globalize2.default)("Dialog", Dialog);
    (0, _globalize2.default)("popup", createPopup);
    exports.Dialog = Dialog;
    exports.popup = createPopup;
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/clone.js
(typeof window === "undefined" ? $parcel$global : window).__e7d0e8462b4386c30e9bcd3ad0a49ad3 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Clones the element specified by the selector and removes the id attribute.
   *
   * @param {String} selector A jQuery selector
   */ function clone(selector) {
        return (0, _jquery2.default)(selector).clone().removeAttr("id");
    }
    (0, _globalize2.default)("clone", clone);
    exports.default = clone;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/attributes.js
(typeof window === "undefined" ? $parcel$global : window).__ab489eda548cad099ce93b60faa6a3d5 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.computeBooleanValue = computeBooleanValue;
    exports.setBooleanAttribute = setBooleanAttribute;
    exports.computeEnumValue = computeEnumValue;
    exports.setEnumAttribute = setEnumAttribute;
    /**
   * Like el.hasAttribute(attr) but designed for use within a skate attribute
   * change handler where you only have access to change.oldValue.
   */ function computeBooleanValue(attrValue) {
        return attrValue !== null;
    }
    function setBooleanAttribute(el, attr, newValue) {
        if (newValue) el.setAttribute(attr, "");
        else el.removeAttribute(attr);
    }
    function computeEnumValue(enumOptions, value1) {
        var matchesEnumValue = function matchesEnumValue(enumValue) {
            return enumValue.toLowerCase() === value1.toLowerCase();
        };
        var isMissing = value1 === null;
        var isInvalid = !isMissing && !enumOptions.values.filter(matchesEnumValue).length;
        if (isMissing) {
            if (enumOptions.hasOwnProperty("missingDefault")) return enumOptions.missingDefault;
            return null;
        }
        if (isInvalid) {
            if (enumOptions.hasOwnProperty("invalidDefault")) return enumOptions.invalidDefault;
            else if (enumOptions.hasOwnProperty("missingDefault")) return enumOptions.missingDefault;
            return null;
        }
        return enumOptions.values.length ? enumOptions.values.filter(matchesEnumValue)[0] : null;
    }
    function setEnumAttribute(el, enumOptions, newValue) {
        el.setAttribute(enumOptions.attribute, newValue);
    }
    /**
   * Helper functions useful for implementing reflected boolean and enumerated
   * attributes and properties.
   *
   * @see https://html.spec.whatwg.org/multipage/infrastructure.html#reflecting-content-attributes-in-idl-attributes
   * @see https://html.spec.whatwg.org/multipage/infrastructure.html#boolean-attribute
   * @see https://html.spec.whatwg.org/multipage/infrastructure.html#enumerated-attribute
   */ exports.default = {
        computeBooleanValue: computeBooleanValue,
        setBooleanAttribute: setBooleanAttribute,
        computeEnumValue: computeEnumValue,
        setEnumAttribute: setEnumAttribute
    };
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/header/create-header.js
(typeof window === "undefined" ? $parcel$global : window).__455206c30630fecc55c648cca374a3ea = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _customEvent = __f7a5e0d2ea8865b104efc9b94861591e;
    var _customEvent2 = _interopRequireDefault(_customEvent);
    var _debounce = __ee62e24d4acb40214d4f9e21b1a58bfc;
    var _debounce2 = _interopRequireDefault(_debounce);
    var _i18n = __fa714f1b12d7502957e4e0b6196321bf;
    var _i18n2 = _interopRequireDefault(_i18n);
    var _skate = __0ac9a2c09f995a9c0a478af8742f59b7;
    var _skate2 = _interopRequireDefault(_skate);
    var _skatejsTemplateHtml = __c6b5725916d210b9653318d2ea2472cb;
    var _skatejsTemplateHtml2 = _interopRequireDefault(_skatejsTemplateHtml);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $window = (0, _jquery2.default)(window);
    function Header(element) {
        var that = this;
        this.element = element;
        this.$element = (0, _jquery2.default)(element);
        this.index = (0, _jquery2.default)("aui-header, .aui-header").index(element);
        this.$secondaryNav = this.$element.find(".aui-header-secondary .aui-nav").first();
        this.menuItems = [];
        this.totalWidth = 0;
        this.$moreMenu = undefined;
        this.rightMostNavItemIndex = undefined;
        this.$applicationLogo = this.$element.find("#logo");
        this.moreMenuWidth = 0;
        this.primaryButtonsWidth = 0;
        // to cache the selector and give .find convenience
        this.$headerFind = function() {
            var $header = (0, _jquery2.default)(that.$element[0].querySelector(".aui-header-primary"));
            return function(selector) {
                return $header.find(selector);
            };
        }();
    }
    Header.prototype = {
        init: function init() {
            var that = this;
            this.element.setAttribute("data-aui-responsive", "true");
            this.$headerFind(".aui-button").parent().each(function() {
                that.primaryButtonsWidth += (0, _jquery2.default)(this).outerWidth(true);
            });
            // remember the widths of all the menu items
            this.$headerFind(".aui-nav > li > a:not(.aui-button)").each(function() {
                var $this = (0, _jquery2.default)(this).parent();
                var outerWidth = $this.outerWidth(true);
                that.totalWidth += outerWidth;
                that.menuItems.push({
                    $element: $this,
                    outerWidth: outerWidth
                });
            });
            /** The zero based index of the right-most visible nav menu item. */ this.rightMostNavItemIndex = this.menuItems.length - 1;
            $window.on("resize", this._resizeHandler = (0, _debounce2.default)(function() {
                that.constructResponsiveDropdown();
            }, 100));
            // So that the header logo doesn't mess things up. (size is unknown before the image loads)
            var $logoImg = this.$applicationLogo.find("img");
            if ($logoImg.length !== 0) {
                $logoImg.attr("data-aui-responsive-header-index", this.index);
                $logoImg.on("load", function() {
                    that.constructResponsiveDropdown();
                });
            }
            this.constructResponsiveDropdown();
            // show the aui nav (hidden via css on load)
            this.$headerFind(".aui-nav").css("width", "auto");
        },
        destroy: function destroy() {
            $window.off("resize", this._resizeHandler);
        },
        // calculate widths based on the current state of the page
        calculateAvailableWidth: function calculateAvailableWidth() {
            // if there is no secondary nav, use the right of the screen as the boundary instead
            var rightMostBoundary = this.$secondaryNav.is(":visible") ? this.$secondaryNav.offset().left : this.$element.outerWidth();
            // the right most side of the primary nav, this is assumed to exists if this code is running
            var primaryNavRight = this.$applicationLogo.offset().left + this.$applicationLogo.outerWidth(true) + this.primaryButtonsWidth;
            return rightMostBoundary - primaryNavRight;
        },
        showResponsiveDropdown: function showResponsiveDropdown() {
            if (this.$moreMenu === undefined) this.$moreMenu = this.createResponsiveDropdownTrigger();
            this.$moreMenu.css("display", "");
        },
        hideResponsiveDropdown: function hideResponsiveDropdown() {
            if (this.$moreMenu !== undefined) this.$moreMenu.css("display", "none");
        },
        constructResponsiveDropdown: function constructResponsiveDropdown() {
            if (!this.menuItems.length) return;
            var remainingWidth;
            var availableWidth = this.calculateAvailableWidth(this.$element, this.primaryButtonsWidth);
            if (availableWidth > this.totalWidth) this.showAll();
            else {
                this.showResponsiveDropdown();
                remainingWidth = availableWidth - this.moreMenuWidth;
                // Figure out how many nav menu items fit into the available space.
                var newRightMostNavItemIndex = -1;
                while(remainingWidth - this.menuItems[newRightMostNavItemIndex + 1].outerWidth >= 0){
                    remainingWidth -= this.menuItems[newRightMostNavItemIndex + 1].outerWidth;
                    newRightMostNavItemIndex++;
                }
                if (newRightMostNavItemIndex < this.rightMostNavItemIndex) this.moveToResponsiveDropdown(this.rightMostNavItemIndex - newRightMostNavItemIndex);
                else if (this.rightMostNavItemIndex < newRightMostNavItemIndex) this.moveOutOfResponsiveDropdown(newRightMostNavItemIndex - this.rightMostNavItemIndex);
            }
        },
        // creates the trigger and content elements for the show more dropdown
        createResponsiveDropdownTrigger: function createResponsiveDropdownTrigger() {
            var moreNavItemEl = document.createElement("li");
            var dropdownEl = document.createElement("aui-dropdown-menu");
            dropdownEl.id = "aui-responsive-header-dropdown-" + this.index;
            _skate2.default.init(dropdownEl);
            var dropdownSectionEl = document.createElement("aui-section");
            dropdownSectionEl.id = "aui-responsive-header-dropdown-list-" + this.index;
            _skate2.default.init(dropdownSectionEl);
            _skatejsTemplateHtml2.default.wrap(dropdownEl).appendChild(dropdownSectionEl);
            var triggerEl = createTriggerAndAssociate(dropdownEl);
            moreNavItemEl.appendChild(triggerEl);
            moreNavItemEl.appendChild(dropdownEl);
            // Append the More menu before any primary buttons.
            if (this.primaryButtonsWidth === 0) this.$headerFind(".aui-nav").append(moreNavItemEl);
            else this.$headerFind(".aui-nav > li > .aui-button:first").parent().before(moreNavItemEl);
            this.moreMenuWidth = (0, _jquery2.default)(moreNavItemEl).outerWidth(true);
            return (0, _jquery2.default)(moreNavItemEl);
        },
        // function that handles moving items out of the show more menu into the app header
        moveOutOfResponsiveDropdown: function moveOutOfResponsiveDropdown(numItems) {
            if (numItems <= 0) return;
            var $moreDropdown = (0, _jquery2.default)("#aui-responsive-header-dropdown-" + this.index);
            // Move items (working top-to-bottom) from the more menu into the nav bar.
            var leftMostIndexToMove = this.rightMostNavItemIndex + 1;
            var rightMostIndexToMove = this.rightMostNavItemIndex + numItems;
            for(var i = leftMostIndexToMove; i <= rightMostIndexToMove; i++){
                var $navItem = this.menuItems[i].$element;
                var $navItemTrigger = $navItem.children("a");
                if ($navItemTrigger.attr("aria-controls")) {
                    var $navItemDropdown = (0, _jquery2.default)(document.getElementById($navItemTrigger.attr("aria-controls")));
                    $navItemDropdown.removeClass("aui-dropdown2-sub-menu");
                    $navItem.append($navItemDropdown);
                }
                $moreDropdown.find("aui-item-link:first").remove();
                $navItem.insertBefore(this.$moreMenu);
            }
            this.rightMostNavItemIndex += numItems;
        },
        // function that handles moving items into the show more menu
        moveToResponsiveDropdown: function moveToResponsiveDropdown(numItems) {
            if (numItems <= 0) return;
            var moreDropdownSectionEl = _skatejsTemplateHtml2.default.wrap(this.$moreMenu[0].querySelector("aui-section"));
            // Move items (working right-to-left) from the nav bar to the more menu.
            var rightMostIndexToMove = this.rightMostNavItemIndex;
            var leftMostIndexToMove = this.rightMostNavItemIndex - numItems + 1;
            for(var i = rightMostIndexToMove; i >= leftMostIndexToMove; i--){
                var $navItem = this.menuItems[i].$element;
                var $navItemTrigger = $navItem.children("a");
                _skate2.default.init($navItemTrigger); // ensure all triggers have gone through their lifecycle before we check for submenus
                var moreDropdownItemEl = document.createElement("aui-item-link");
                moreDropdownItemEl.setAttribute("href", $navItemTrigger.attr("href"));
                if ($navItemTrigger.attr("aria-controls")) {
                    var $navItemDropdown = (0, _jquery2.default)(document.getElementById($navItemTrigger.attr("aria-controls")));
                    moreDropdownItemEl.setAttribute("for", $navItemTrigger.attr("aria-controls"));
                    $navItemDropdown.addClass("aui-dropdown2-sub-menu");
                    $navItemDropdown.appendTo("body");
                }
                _skate2.default.init(moreDropdownItemEl);
                _skatejsTemplateHtml2.default.wrap(moreDropdownItemEl).textContent = $navItemTrigger.text();
                $navItem.detach();
                moreDropdownSectionEl.insertBefore(moreDropdownItemEl, moreDropdownSectionEl.firstChild);
                this.element.dispatchEvent(new _customEvent2.default("aui-responsive-menu-item-created", {
                    bubbles: true,
                    detail: {
                        originalItem: $navItem[0],
                        newItem: moreDropdownItemEl
                    }
                }));
            }
            this.rightMostNavItemIndex -= numItems;
        },
        // function that handles show everything
        showAll: function showAll() {
            this.moveOutOfResponsiveDropdown(this.menuItems.length - 1 - this.rightMostNavItemIndex);
            this.hideResponsiveDropdown();
        }
    };
    function createTriggerAndAssociate(dropdown) {
        var trigger = document.createElement("a");
        trigger.setAttribute("class", "aui-dropdown2-trigger");
        trigger.setAttribute("href", "#");
        trigger.id = dropdown.id + "-trigger";
        trigger.setAttribute("aria-controls", dropdown.id);
        trigger.innerHTML = _i18n2.default.getText("aui.words.more");
        return trigger;
    }
    /**
   * Initialise a Header, or return an existing Header for an element.
   */ function createHeader(element) {
        var header = element._header;
        if (!(header instanceof Header)) {
            header = new Header(element);
            header.init();
            element._header = header;
        }
        return header;
    }
    exports.default = createHeader;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/polyfills/console.js
(typeof window === "undefined" ? $parcel$global : window).__b95257c5ba3aaa36d3a5493aa734a2d7 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    /**
   * AUI-2773
   *
   * The following shim for console is deprecated and to be removed in AUI 6.
   * We shouldn't be creating console.log if it doesn't exist; instead, we should avoid using it directly.
   * @start deprecated
   */ if (typeof window.console === "undefined") window.console = {
        messages: [],
        log: function log(text) {
            this.messages.push(text);
        },
        show: function show() {
            alert(this.messages.join("\n"));
            this.messages = [];
        }
    };
    else // Firebug console - show not required to do anything.
    window.console.show = function() {};
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/binder.js
(typeof window === "undefined" ? $parcel$global : window).__0bbb661b86f4b304c81cc691259d70c9 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var deprecate = _interopRequireWildcard(_deprecation);
    var _log = __c1e961001275c079e48525ad3a48c8c2;
    var logger = _interopRequireWildcard(_log);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Support for markup based binder components. Binder components must be objects with the following "interface":
   *
   * <pre>
   * {
   *   selector: "input.foo",
   *   run: function(element) {
   *      //do stuff on given element
   *   }
   * }
   * </pre>
   */ var Binder = function() {
        var binders = {};
        return {
            /**
           * Runs all the binder components for the given scope, or the document body if none specified.
           *
           * @method runBinders
           * @param scope {Element} element scope to run the binders in
           */ runBinders: function runBinders(scope) {
                if (_jquery2.default.isEmptyObject(binders)) {
                    logger.log("No binders to run");
                    return;
                }
                scope = scope || document.body;
                (0, _jquery2.default)("*:not(link, script)", scope).each(function(i, element) {
                    var $element = (0, _jquery2.default)(element);
                    _jquery2.default.each(binders, function(id, binder) {
                        if (!$element.data(id) && $element.is(binder.selector)) {
                            logger.log("Running binder component: " + id + " on element " + element);
                            $element.data(id, true); // so we don't bind to the same element again later
                            binder.run(element);
                        }
                    });
                });
            },
            /**
           * Register a binder component with the given id.
           * @method register
           */ register: function register(id, binder) {
                binders[id] = binder;
            },
            /**
           * Unregister a binder component for the given id.
           * @method unregister
           */ unregister: function unregister(id) {
                binders[id] = null;
            }
        };
    }();
    Binder = deprecate.construct(Binder, "Binder", {
        sinceVersion: "5.8.0"
    });
    (0, _globalize2.default)("Binder", Binder);
    exports.default = Binder;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/binders/placeholder.js
(typeof window === "undefined" ? $parcel$global : window).__4aa3faf3e1a039ca7e641017624fd4d6 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _binder = __0bbb661b86f4b304c81cc691259d70c9;
    var _binder2 = _interopRequireDefault(_binder);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    (function() {
        // browser supports placeholder, no need to do anything
        var temp = document.createElement("input");
        if ("placeholder" in temp) return;
        /**
       * Displays default text in the input field when its value is empty.
       * If the browser supports placeholder input attributes (HTML5), then
       * we skip this component.
       *
       * Usage:
       * <pre>
       * &lt;input placeholder='Some default text'&gt;
       * </pre>
       *
       * Events thrown: reset.placeholder
       */ _binder2.default.register("placeholder", {
            selector: "input[placeholder]",
            run: function run(element) {
                var $this = (0, _jquery2.default)(element);
                var applyDefaultText = function applyDefaultText() {
                    if (!_jquery2.default.trim($this.val()).length) $this.val($this.attr("placeholder")).addClass("placeholder-shown").trigger("reset.placeholder");
                };
                applyDefaultText();
                $this.blur(applyDefaultText).focus(function() {
                    if ($this.hasClass("placeholder-shown")) $this.val("").removeClass("placeholder-shown");
                });
            }
        });
    })();
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/jquery/jquery.os.js
(typeof window === "undefined" ? $parcel$global : window).__be0f3ffb01e9197c7ddcba01a61a66ce = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    jQuery.os = {};
    (function() {
        var platform = navigator.platform.toLowerCase();
        jQuery.os.windows = platform.indexOf("win") != -1;
        jQuery.os.mac = platform.indexOf("mac") != -1;
        jQuery.os.linux = platform.indexOf("linux") != -1;
    })();
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/jquery/jquery.moveto.js
(typeof window === "undefined" ? $parcel$global : window).__25e29eb27170014b389726db2d540673 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    /**
   *
   * @module Controls
   * @requires AJS, jQuery
   */ /**
   * If not visible, moves the scroll position of the screen to the element
   *
   * <pre>
   * <strong>Usage:</strong>
   * jQuery("li.item").moveTo();
   * </pre>
   *
   * This plugin also supports options as an argument.  The options
   * that can be defined are:
   * <ul>
   * <li>transition - if set to true will cause a smooth scrolling transition (false by default)</li>
   * <li>scrollOffset - defines an offset to scroll past the element to view in pixels such that
   * all of it can be viewed (35 pixels by default)</li>
   * </ul>
   *
   * @class moveTo
   * @constuctor moveTo
   * @namespace jQuery.fn
   * @param {Object} options
   */ jQuery.fn.moveTo = function(options) {
        var defaults = {
            transition: false,
            scrollOffset: 35
        };
        var opts = jQuery.extend(defaults, options);
        var instance = this;
        var topOffset = instance.offset().top;
        var scrollTarget;
        if ((jQuery(window).scrollTop() + jQuery(window).height() - this.outerHeight() < topOffset || jQuery(window).scrollTop() + opts.scrollOffset > topOffset) && jQuery(window).height() > opts.scrollOffset) {
            if (jQuery(window).scrollTop() + opts.scrollOffset > topOffset) //move up
            scrollTarget = topOffset - (jQuery(window).height() - this.outerHeight()) + opts.scrollOffset;
            else //move down
            scrollTarget = topOffset - opts.scrollOffset;
            if (!jQuery.fn.moveTo.animating && opts.transition) {
                jQuery(document).trigger("moveToStarted", this);
                jQuery.fn.moveTo.animating = true;
                jQuery("html,body").animate({
                    scrollTop: scrollTarget
                }, 1000, function() {
                    jQuery(document).trigger("moveToFinished", instance);
                    delete jQuery.fn.moveTo.animating;
                });
                return this;
            } else {
                var jQueryCache = jQuery("html, body");
                if (jQueryCache.is(":animated")) {
                    jQueryCache.stop();
                    delete jQuery.fn.moveTo.animating;
                }
                jQuery(document).trigger("moveToStarted");
                jQuery(window).scrollTop(scrollTarget);
                //need to put a slight timeout for the moveToFinished event such that recipients of this event
                //have time to act on it.
                setTimeout(function() {
                    jQuery(document).trigger("moveToFinished", instance);
                }, 100);
                return this;
            }
        }
        jQuery(document).trigger("moveToFinished", this);
        return this;
    };
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/cookie.js
(typeof window === "undefined" ? $parcel$global : window).__333ca678b27b3f668a8ab6b3ea8ee781 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.save = exports.read = exports.erase = undefined;
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var deprecate = _interopRequireWildcard(_deprecation);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    var COOKIE_NAME = "AJS.conglomerate.cookie";
    var UNESCAPE_COOKIE_REGEX = /(\\|^"|"$)/g;
    var CONSECUTIVE_PIPE_CHARS_REGEX = /\|\|+/g;
    var ANY_QUOTE_REGEX = /"/g;
    var REGEX_SPECIAL_CHARS = /[.*+?|^$()[\]{\\]/g;
    function regexEscape(str) {
        return str.replace(REGEX_SPECIAL_CHARS, "\\$&");
    }
    function getValueFromConglomerate(name, cookieValue) {
        // A null cookieValue is just the first time through so create it.
        cookieValue = cookieValue || "";
        var reg = new RegExp(regexEscape(name) + "=([^|]+)");
        var res = cookieValue.match(reg);
        return res && res[1];
    }
    // Either append or replace the value in the cookie string/
    function addOrAppendToValue(name, value1, cookieValue) {
        // A cookie name follows after any amount of white space mixed with any amount of '|' characters.
        // A cookie value is preceded by '=', then anything except for '|'.
        var reg = new RegExp("(\\s|\\|)*\\b" + regexEscape(name) + "=[^|]*[|]*");
        cookieValue = cookieValue || "";
        cookieValue = cookieValue.replace(reg, "|");
        if (value1 !== "") {
            var pair = name + "=" + value1;
            if (cookieValue.length + pair.length < 4020) cookieValue += "|" + pair;
        }
        return cookieValue.replace(CONSECUTIVE_PIPE_CHARS_REGEX, "|");
    }
    function unescapeCookieValue(name) {
        return name.replace(UNESCAPE_COOKIE_REGEX, "");
    }
    function getCookieValue(name) {
        var reg = new RegExp("\\b" + regexEscape(name) + "=((?:[^\\\\;]+|\\\\.)*)(?:;|$)");
        var res = document.cookie.match(reg);
        return res && unescapeCookieValue(res[1]);
    }
    function saveCookie(name, value1, days) {
        var ex = "";
        var d;
        var quotedValue = '"' + value1.replace(ANY_QUOTE_REGEX, '\\"') + '"';
        if (days) {
            d = new Date();
            d.setTime(+d + days * 86400000);
            ex = "; expires=" + d.toGMTString();
        }
        document.cookie = name + "=" + quotedValue + ex + ";path=/";
    }
    /**
   * Save a cookie.
   * @param name {String} name of cookie
   * @param value {String} value of cookie
   * @param expires {Number} number of days before cookie expires
   */ function save(name, value1, expires) {
        var cookieValue = getCookieValue(COOKIE_NAME);
        cookieValue = addOrAppendToValue(name, value1, cookieValue);
        saveCookie(COOKIE_NAME, cookieValue, expires || 365);
    }
    /**
   * Get the value of a cookie.
   * @param name {String} name of cookie to read
   * @param defaultValue {String} the default value of the cookie to return if not found
   */ function read(name, defaultValue) {
        var cookieValue = getCookieValue(COOKIE_NAME);
        var value1 = getValueFromConglomerate(name, cookieValue);
        if (value1 != null) return value1;
        return defaultValue;
    }
    /**
   * Remove the given cookie.
   * @param name {String} the name of the cookie to remove
   */ function erase(name) {
        save(name, "");
    }
    var cookie = {
        erase: erase,
        read: read,
        save: save
    };
    (0, _globalize2.default)("cookie", cookie);
    (0, _globalize2.default)("Cookie", cookie);
    deprecate.prop(AJS, "Cookie", {
        alternativeName: "cookie",
        sinceVersion: "5.8.0"
    });
    exports.erase = erase;
    exports.read = read;
    exports.save = save;
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/firebug.js
(typeof window === "undefined" ? $parcel$global : window).__d985b91328862a9b5001134fdbcdc855 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.warnAboutFirebug = exports.firebug = undefined;
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var deprecate = _interopRequireWildcard(_deprecation);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Does nothing because legacy code.
   *
   * @returns {undefined}
   */ function warnAboutFirebug() {}
    /**
   * Includes firebug lite for debugging in IE. Especially in IE.
   *
   * @returns {undefined}
   */ function firebug() {
        var script = (0, _jquery2.default)(document.createElement("script"));
        script.attr("src", "https://getfirebug.com/releases/lite/1.2/firebug-lite-compressed.js");
        (0, _jquery2.default)("head").append(script);
        (function() {
            if (window.firebug) firebug.init();
            else setTimeout(firebug, 0);
        })();
    }
    exports.firebug = firebug = deprecate.fn(firebug, "firebug", {
        sinceVersion: "5.1.0"
    });
    exports.warnAboutFirebug = warnAboutFirebug = deprecate.fn(warnAboutFirebug, "warnAboutFirebug", {
        sinceVersion: "5.8.0"
    });
    (0, _globalize2.default)("firebug", firebug);
    (0, _globalize2.default)("warnAboutFirebug", warnAboutFirebug);
    exports.firebug = firebug;
    exports.warnAboutFirebug = warnAboutFirebug;
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/internal/add-id.js
(typeof window === "undefined" ? $parcel$global : window).__3b7b37131a17b9c12e44694d7b12c1e2 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _uniqueId = __a0ab588de7b0759818853425dc8ad2f2;
    var _uniqueId2 = _interopRequireDefault(_uniqueId);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Apply a unique ID to the element. Preserves ID if the element already has one.
   *
   * @param {Element} el Selector to find target element.
   * @param {string} prefix Optional. String to prepend to ID instead of default AUI prefix.
   *
   * @returns {undefined}
   */ function addId(el, prefix) {
        var element = (0, _jquery2.default)(el);
        var addprefix = prefix || false;
        element.each(function() {
            var $el = (0, _jquery2.default)(this);
            if (!$el.attr("id")) $el.attr("id", (0, _uniqueId2.default)(addprefix));
        });
    }
    (0, _globalize2.default)("_addID", addId);
    exports.default = addId;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/alphanum.js
(typeof window === "undefined" ? $parcel$global : window).__40ab0ec9dde6fa5e8252e2a0ff1128be = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Compare two strings in alphanumeric way
   * @method alphanum
   * @param {String} a first string to compare
   * @param {String} b second string to compare
   * @return {Number(-1|0|1)} -1 if a < b, 0 if a = b, 1 if a > b
   */ function alphanum(a, b) {
        a = (a + "").toLowerCase();
        b = (b + "").toLowerCase();
        var chunks = /(\d+|\D+)/g;
        var am = a.match(chunks);
        var bm = b.match(chunks);
        var len = Math.max(am.length, bm.length);
        for(var i = 0; i < len; i++){
            if (i === am.length) return -1;
            if (i === bm.length) return 1;
            var ad = parseInt(am[i], 10) + "";
            var bd = parseInt(bm[i], 10) + "";
            if (ad === am[i] && bd === bm[i] && ad !== bd) return (ad - bd) / Math.abs(ad - bd);
            if ((ad !== am[i] || bd !== bm[i]) && am[i] !== bm[i]) return am[i] < bm[i] ? -1 : 1;
        }
        return 0;
    }
    (0, _globalize2.default)("alphanum", alphanum);
    exports.default = alphanum;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/contain-dropdown.js
(typeof window === "undefined" ? $parcel$global : window).__52a74afd29a9ba78099fd55036d7da10 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function containDropdown(dropdown, containerSelector, dynamic) {
        function getDropdownOffset() {
            return dropdown.$.offset().top - (0, _jquery2.default)(containerSelector).offset().top;
        }
        var container;
        var ddOffset;
        var availableArea;
        var shadowOffset = 25;
        if (dropdown.$.parents(containerSelector).length !== -1) {
            container = (0, _jquery2.default)(containerSelector);
            ddOffset = getDropdownOffset();
            shadowOffset = 30;
            availableArea = container.outerHeight() - ddOffset - shadowOffset;
            if (availableArea <= parseInt(dropdown.$.attr("scrollHeight"), 10)) containDropdown.containHeight(dropdown, availableArea);
            else if (dynamic) containDropdown.releaseContainment(dropdown);
            dropdown.reset();
        }
    }
    containDropdown.containHeight = function(dropdown, availableArea) {
        dropdown.$.css({
            height: availableArea
        });
        if (dropdown.$.css("overflowY") !== "scroll") dropdown.$.css({
            width: 15 + dropdown.$.attr("scrollWidth"),
            overflowY: "scroll",
            overflowX: "hidden"
        });
    };
    containDropdown.releaseContainment = function(dropdown) {
        dropdown.$.css({
            height: "",
            width: "",
            overflowY: "",
            overflowX: ""
        });
    };
    (0, _globalize2.default)("containDropdown", containDropdown);
    exports.default = containDropdown;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/index-of.js
(typeof window === "undefined" ? $parcel$global : window).__3e63601581c20cf62a12c1c11776baa0 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Finds the index of an element in the array.
   *
   * @param {Array} The array being searched.
   * @param {Mixed} item Element which will be searched for.
   * @param {Integer} fromIndex The index from which the item will be searched. Negative values will search from the end of the array.
   *
   * @returns {Integer}
   */ function indexOf(array, item, fromIndex) {
        var length = array.length;
        if (!fromIndex) fromIndex = 0;
        else if (fromIndex < 0) fromIndex = Math.max(0, length + fromIndex);
        for(var i = fromIndex; i < length; i++){
            if (array[i] === item) return i;
        }
        return -1;
    }
    (0, _globalize2.default)("indexOf", indexOf);
    exports.default = indexOf;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/contains.js
(typeof window === "undefined" ? $parcel$global : window).__314cfd19ff44fc21aa5412fc0dd1f9c1 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _indexOf = __3e63601581c20cf62a12c1c11776baa0;
    var _indexOf2 = _interopRequireDefault(_indexOf);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Looks for an element inside the array.
   *
   * @param {Array} array The array being searched.
   * @param {Array} item The current item.
   *
   * @return {Boolean}
   */ function contains(array, item) {
        return (0, _indexOf2.default)(array, item) > -1;
    }
    (0, _globalize2.default)("contains", contains);
    exports.default = contains;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js-vendor/jquery/plugins/jquery.aop.js
(typeof window === "undefined" ? $parcel$global : window).__cfcac90972818498ca2c12686d1dadc4 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    /**
  * jQuery AOP - jQuery plugin to add features of aspect-oriented programming (AOP) to jQuery.
  * http://jquery-aop.googlecode.com/
  *
  * Licensed under the MIT license:
  * http://www.opensource.org/licenses/mit-license.php
  *
  * Version: 1.3
  *
  * Cross-frame type detection based on Daniel Steigerwald's code (http://daniel.steigerwald.cz)
  * http://gist.github.com/204554
  *
  * Modified by Atlassian (workaround for IE6/7 removed)
  */ (function() {
        var _after = 1;
        var _afterThrow = 2;
        var _afterFinally = 3;
        var _before = 4;
        var _around = 5;
        var _intro = 6;
        var _regexEnabled = true;
        var _arguments = "arguments";
        var _undef = "undefined";
        var getType = function() {
            var toString = Object.prototype.toString, toStrings = {}, nodeTypes = {
                1: "element",
                3: "textnode",
                9: "document",
                11: "fragment"
            }, types = "Arguments Array Boolean Date Document Element Error Fragment Function NodeList Null Number Object RegExp String TextNode Undefined Window".split(" ");
            for(var i = types.length; i--;){
                var type = types[i], constructor = window[type];
                if (constructor) try {
                    toStrings[toString.call(new constructor)] = type.toLowerCase();
                } catch (e) {}
            }
            return function(item) {
                return item == null && (item === undefined ? _undef : "null") || item.nodeType && nodeTypes[item.nodeType] || typeof item.length == "number" && (item.callee && _arguments || item.alert && "window" || item.item && "nodelist") || toStrings[toString.call(item)];
            };
        }();
        var isFunc = function(obj) {
            return getType(obj) == "function";
        };
        /**
  	 * Private weaving function.
  	 */ var weaveOne = function(source, method, advice) {
            var old = source[method];
            // IE6/7 behavior on some native method return object instances instead of functions
            // and may cause the issue https://github.com/gonzalocasas/jquery-aop/issues/7.
            // Workaround was removed as it uses eval. See: http://ecosystem.atlassian.net/browse/AUI-4391
            var aspect;
            if (advice.type == _after || advice.type == _afterThrow || advice.type == _afterFinally) aspect = function() {
                var returnValue, exceptionThrown = null;
                try {
                    returnValue = old.apply(this, arguments);
                } catch (e) {
                    exceptionThrown = e;
                }
                if (advice.type == _after) {
                    if (exceptionThrown == null) returnValue = advice.value.apply(this, [
                        returnValue,
                        method
                    ]);
                    else throw exceptionThrown;
                } else if (advice.type == _afterThrow && exceptionThrown != null) returnValue = advice.value.apply(this, [
                    exceptionThrown,
                    method
                ]);
                else if (advice.type == _afterFinally) returnValue = advice.value.apply(this, [
                    returnValue,
                    exceptionThrown,
                    method
                ]);
                return returnValue;
            };
            else if (advice.type == _before) aspect = function() {
                advice.value.apply(this, [
                    arguments,
                    method
                ]);
                return old.apply(this, arguments);
            };
            else if (advice.type == _intro) aspect = function() {
                return advice.value.apply(this, arguments);
            };
            else if (advice.type == _around) aspect = function() {
                var invocation = {
                    object: this,
                    args: Array.prototype.slice.call(arguments)
                };
                return advice.value.apply(invocation.object, [
                    {
                        arguments: invocation.args,
                        method: method,
                        proceed: function() {
                            return old.apply(invocation.object, invocation.args);
                        }
                    }
                ]);
            };
            aspect.unweave = function() {
                source[method] = old;
                pointcut = source = aspect = old = null;
            };
            source[method] = aspect;
            return aspect;
        };
        /**
  	 * Private method search
  	 */ var search = function(source, pointcut1, advice) {
            var methods = [];
            for(var method in source){
                var item = null;
                // Ignore exceptions during method retrival
                try {
                    item = source[method];
                } catch (e) {}
                if (item != null && method.match(pointcut1.method) && isFunc(item)) methods[methods.length] = {
                    source: source,
                    method: method,
                    advice: advice
                };
            }
            return methods;
        };
        /**
  	 * Private weaver and pointcut parser.
  	 */ var weave = function(pointcut1, advice) {
            var source = typeof pointcut1.target.prototype != _undef ? pointcut1.target.prototype : pointcut1.target;
            var advices = [];
            // If it's not an introduction and no method was found, try with regex...
            if (advice.type != _intro && typeof source[pointcut1.method] == _undef) {
                // First try directly on target
                var methods = search(pointcut1.target, pointcut1, advice);
                // No method found, re-try directly on prototype
                if (methods.length == 0) methods = search(source, pointcut1, advice);
                for(var i in methods)advices[advices.length] = weaveOne(methods[i].source, methods[i].method, methods[i].advice);
            } else // Return as an array of one element
            advices[0] = weaveOne(source, pointcut1.method, advice);
            return _regexEnabled ? advices : advices[0];
        };
        jQuery.aop = {
            /**
  		 * Creates an advice after the defined point-cut. The advice will be executed after the point-cut method
  		 * has completed execution successfully, and will receive one parameter with the result of the execution.
  		 * This function returns an array of weaved aspects (Function).
  		 *
  		 * @example jQuery.aop.after( {target: window, method: 'MyGlobalMethod'}, function(result) {
  		 *                alert('Returned: ' + result);
  		 *                return result;
  		 *          } );
  		 * @result Array<Function>
  		 *
  		 * @example jQuery.aop.after( {target: String, method: 'indexOf'}, function(index) {
  		 *                alert('Result found at: ' + index + ' on:' + this);
  		 *                return index;
  		 *          } );
  		 * @result Array<Function>
  		 *
  		 * @name after
  		 * @param Map pointcut Definition of the point-cut to apply the advice. A point-cut is the definition of the object/s and method/s to be weaved.
  		 * @option Object target Target object to be weaved.
  		 * @option String method Name of the function to be weaved. Regex are supported, but not on built-in objects.
  		 * @param Function advice Function containing the code that will get called after the execution of the point-cut. It receives one parameter
  		 *                        with the result of the point-cut's execution. The function can choose to return this same value or a different one.
  		 *
  		 * @type Array<Function>
  		 * @cat Plugins/General
  		 */ after: function(pointcut1, advice) {
                return weave(pointcut1, {
                    type: _after,
                    value: advice
                });
            },
            /**
  		 * Creates an advice after the defined point-cut only for unhandled exceptions. The advice will be executed
  		 * after the point-cut method only if the execution failed and an exception has been thrown. It will receive one
  		 * parameter with the exception thrown by the point-cut method.
  		 * This function returns an array of weaved aspects (Function).
  		 *
  		 * @example jQuery.aop.afterThrow( {target: String, method: 'indexOf'}, function(exception) {
  		 *                alert('Unhandled exception: ' + exception);
  		 *                return -1;
  		 *          } );
  		 * @result Array<Function>
  		 *
  		 * @example jQuery.aop.afterThrow( {target: calculator, method: 'Calculate'}, function(exception) {
  		 *                console.log('Unhandled exception: ' + exception);
  		 *                throw exception;
  		 *          } );
  		 * @result Array<Function>
  		 *
  		 * @name afterThrow
  		 * @param Map pointcut Definition of the point-cut to apply the advice. A point-cut is the definition of the object/s and method/s to be weaved.
  		 * @option Object target Target object to be weaved.
  		 * @option String method Name of the function to be weaved. Regex are supported, but not on built-in objects.
  		 * @param Function advice Function containing the code that will get called after the execution of the point-cut. It receives one parameter
  		 *                        with the exception thrown by the point-cut method.
  		 *
  		 * @type Array<Function>
  		 * @cat Plugins/General
  		 */ afterThrow: function(pointcut1, advice) {
                return weave(pointcut1, {
                    type: _afterThrow,
                    value: advice
                });
            },
            /**
  		 * Creates an advice after the defined point-cut. The advice will be executed after the point-cut method
  		 * regardless of its success or failure, and it will receive two parameters: one with the
  		 * result of a successful execution or null, and another one with the exception thrown or null.
  		 * This function returns an array of weaved aspects (Function).
  		 *
  		 * @example jQuery.aop.afterFinally( {target: window, method: 'MyGlobalMethod'}, function(result, exception) {
  		 *                if (exception == null)
  		 *                    return 'Returned: ' + result;
  		 *                else
  		 *                    return 'Unhandled exception: ' + exception;
  		 *          } );
  		 * @result Array<Function>
  		 *
  		 * @name afterFinally
  		 * @param Map pointcut Definition of the point-cut to apply the advice. A point-cut is the definition of the object/s and method/s to be weaved.
  		 * @option Object target Target object to be weaved.
  		 * @option String method Name of the function to be weaved. Regex are supported, but not on built-in objects.
  		 * @param Function advice Function containing the code that will get called after the execution of the point-cut regardless of its success or failure.
  		 *                        It receives two parameters, the first one with the result of a successful execution or null, and the second one with the
  		 *                        exception or null.
  		 *
  		 * @type Array<Function>
  		 * @cat Plugins/General
  		 */ afterFinally: function(pointcut1, advice) {
                return weave(pointcut1, {
                    type: _afterFinally,
                    value: advice
                });
            },
            /**
  		 * Creates an advice before the defined point-cut. The advice will be executed before the point-cut method
  		 * but cannot modify the behavior of the method, or prevent its execution.
  		 * This function returns an array of weaved aspects (Function).
  		 *
  		 * @example jQuery.aop.before( {target: window, method: 'MyGlobalMethod'}, function() {
  		 *                alert('About to execute MyGlobalMethod');
  		 *          } );
  		 * @result Array<Function>
  		 *
  		 * @example jQuery.aop.before( {target: String, method: 'indexOf'}, function(index) {
  		 *                alert('About to execute String.indexOf on: ' + this);
  		 *          } );
  		 * @result Array<Function>
  		 *
  		 * @name before
  		 * @param Map pointcut Definition of the point-cut to apply the advice. A point-cut is the definition of the object/s and method/s to be weaved.
  		 * @option Object target Target object to be weaved.
  		 * @option String method Name of the function to be weaved. Regex are supported, but not on built-in objects.
  		 * @param Function advice Function containing the code that will get called before the execution of the point-cut.
  		 *
  		 * @type Array<Function>
  		 * @cat Plugins/General
  		 */ before: function(pointcut1, advice) {
                return weave(pointcut1, {
                    type: _before,
                    value: advice
                });
            },
            /**
  		 * Creates an advice 'around' the defined point-cut. This type of advice can control the point-cut method execution by calling
  		 * the functions '.proceed()' on the 'invocation' object, and also, can modify the arguments collection before sending them to the function call.
  		 * This function returns an array of weaved aspects (Function).
  		 *
  		 * @example jQuery.aop.around( {target: window, method: 'MyGlobalMethod'}, function(invocation) {
  		 *                alert('# of Arguments: ' + invocation.arguments.length);
  		 *                return invocation.proceed();
  		 *          } );
  		 * @result Array<Function>
  		 *
  		 * @example jQuery.aop.around( {target: String, method: 'indexOf'}, function(invocation) {
  		 *                alert('Searching: ' + invocation.arguments[0] + ' on: ' + this);
  		 *                return invocation.proceed();
  		 *          } );
  		 * @result Array<Function>
  		 *
  		 * @example jQuery.aop.around( {target: window, method: /Get(\d+)/}, function(invocation) {
  		 *                alert('Executing ' + invocation.method);
  		 *                return invocation.proceed();
  		 *          } );
  		 * @desc Matches all global methods starting with 'Get' and followed by a number.
  		 * @result Array<Function>
  		 *
  		 *
  		 * @name around
  		 * @param Map pointcut Definition of the point-cut to apply the advice. A point-cut is the definition of the object/s and method/s to be weaved.
  		 * @option Object target Target object to be weaved.
  		 * @option String method Name of the function to be weaved. Regex are supported, but not on built-in objects.
  		 * @param Function advice Function containing the code that will get called around the execution of the point-cut. This advice will be called with one
  		 *                        argument containing one function '.proceed()', the collection of arguments '.arguments', and the matched method name '.method'.
  		 *
  		 * @type Array<Function>
  		 * @cat Plugins/General
  		 */ around: function(pointcut1, advice) {
                return weave(pointcut1, {
                    type: _around,
                    value: advice
                });
            },
            /**
  		 * Creates an introduction on the defined point-cut. This type of advice replaces any existing methods with the same
  		 * name. To restore them, just unweave it.
  		 * This function returns an array with only one weaved aspect (Function).
  		 *
  		 * @example jQuery.aop.introduction( {target: window, method: 'MyGlobalMethod'}, function(result) {
  		 *                alert('Returned: ' + result);
  		 *          } );
  		 * @result Array<Function>
  		 *
  		 * @example jQuery.aop.introduction( {target: String, method: 'log'}, function() {
  		 *                alert('Console: ' + this);
  		 *          } );
  		 * @result Array<Function>
  		 *
  		 * @name introduction
  		 * @param Map pointcut Definition of the point-cut to apply the advice. A point-cut is the definition of the object/s and method/s to be weaved.
  		 * @option Object target Target object to be weaved.
  		 * @option String method Name of the function to be weaved.
  		 * @param Function advice Function containing the code that will be executed on the point-cut.
  		 *
  		 * @type Array<Function>
  		 * @cat Plugins/General
  		 */ introduction: function(pointcut1, advice) {
                return weave(pointcut1, {
                    type: _intro,
                    value: advice
                });
            },
            /**
  		 * Configures global options.
  		 *
  		 * @name setup
  		 * @param Map settings Configuration options.
  		 * @option Boolean regexMatch Enables/disables regex matching of method names.
  		 *
  		 * @example jQuery.aop.setup( { regexMatch: false } );
  		 * @desc Disable regex matching.
  		 *
  		 * @type Void
  		 * @cat Plugins/General
  		 */ setup: function(settings) {
                _regexEnabled = settings.regexMatch;
            }
        };
    })();
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/drop-down.js
(typeof window === "undefined" ? $parcel$global : window).__d2e2813117e78f01f4e5be88e6b92a17 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    __cfcac90972818498ca2c12686d1dadc4;
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var deprecate = _interopRequireWildcard(_deprecation);
    var _log = __c1e961001275c079e48525ad3a48c8c2;
    var logger = _interopRequireWildcard(_log);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Displays a drop down, typically used for menus.
   *
   * @param obj {jQuery Object|String|Array} object to populate the drop down from.
   * @param usroptions optional dropdown configuration. Supported properties are:
   * <li>alignment - "left" or "right" alignment of the drop down</li>
   * <li>escapeHandler - function to handle on escape key presses</li>
   * <li>activeClass - class name to be added to drop down items when 'active' ie. hover over</li>
   * <li>selectionHandler - function to handle when drop down items are selected on</li>
   * <li>hideHandler - function to handle when the drop down is hidden</li>
   * When an object of type Array is passed in, you can also configure:
   * <li>isHiddenByDefault - set to true if you would like to hide the drop down on initialisation</li>
   * <li>displayHandler - function to display text in the drop down</li>
   * <li>useDisabled - If set to true, the dropdown will not appear if a class of disabled is added to aui-dd-parent</li>
   *
   * @returns {Array} an array of jQuery objects, referring to the drop down container elements
   */ function dropDown(obj, usroptions) {
        var dd = null;
        var result = [];
        var moving = false;
        var $doc = (0, _jquery2.default)(document);
        var options = {
            item: "li:has(a)",
            activeClass: "active",
            alignment: "right",
            displayHandler: function displayHandler(obj) {
                return obj.name;
            },
            escapeHandler: function escapeHandler() {
                this.hide("escape");
                return false;
            },
            hideHandler: function hideHandler() {},
            moveHandler: function moveHandler() {},
            useDisabled: false
        };
        _jquery2.default.extend(options, usroptions);
        options.alignment = ({
            left: "left",
            right: "right"
        })[options.alignment.toLowerCase()] || "left";
        if (obj && obj.jquery) // if $
        dd = obj;
        else if (typeof obj === "string") // if $ selector
        dd = (0, _jquery2.default)(obj);
        else if (obj && obj.constructor === Array) {
            // if JSON
            dd = (0, _jquery2.default)("<div></div>").addClass("aui-dropdown").toggleClass("hidden", !!options.isHiddenByDefault);
            for(var i = 0, ii = obj.length; i < ii; i++){
                var ol = (0, _jquery2.default)("<ol></ol>");
                for(var j = 0, jj = obj[i].length; j < jj; j++){
                    var li = (0, _jquery2.default)("<li></li>");
                    var properties = obj[i][j];
                    if (properties.href) {
                        li.append((0, _jquery2.default)("<a></a>").html("<span>" + options.displayHandler(properties) + "</span>").attr({
                            href: properties.href
                        }).addClass(properties.className));
                        // deprecated - use the properties on the li, not the span
                        _jquery2.default.data((0, _jquery2.default)("a > span", li)[0], "properties", properties);
                    } else li.html(properties.html).addClass(properties.className);
                    if (properties.icon) li.prepend((0, _jquery2.default)("<img />").attr("src", properties.icon));
                    if (properties.insideSpanIcon) li.children("a").prepend((0, _jquery2.default)("<span></span>").attr("class", "icon"));
                    if (properties.iconFontClass) li.children("a").prepend((0, _jquery2.default)("<span></span>").addClass("aui-icon aui-icon-small aui-iconfont-" + properties.iconFontClass));
                    _jquery2.default.data(li[0], "properties", properties);
                    ol.append(li);
                }
                if (i === ii - 1) ol.addClass("last");
                dd.append(ol);
            }
            (0, _jquery2.default)("body").append(dd);
        } else throw new Error("dropDown function was called with illegal parameter. Should be $ object, $ selector or array.");
        var moveDown = function moveDown() {
            move(1);
        };
        var moveUp = function moveUp() {
            move(-1);
        };
        var move = function move(dir) {
            var trigger = !moving;
            var cdd = dropDown.current.$[0];
            var links = dropDown.current.links;
            var oldFocus = cdd.focused;
            moving = true;
            if (links.length === 0) // Nothing to move focus to. Abort.
            return;
            cdd.focused = typeof oldFocus === "number" ? oldFocus : -1;
            if (!dropDown.current) {
                logger.log("move - not current, aborting");
                return true;
            }
            cdd.focused += dir;
            // Resolve out of bounds values:
            if (cdd.focused < 0) cdd.focused = links.length - 1;
            else if (cdd.focused >= links.length) cdd.focused = 0;
            options.moveHandler((0, _jquery2.default)(links[cdd.focused]), dir < 0 ? "up" : "down");
            if (trigger && links.length) {
                (0, _jquery2.default)(links[cdd.focused]).addClass(options.activeClass);
                moving = false;
            } else if (!links.length) moving = false;
        };
        var moveFocus = function moveFocus(e) {
            if (!dropDown.current) return true;
            var c = e.which;
            var cdd = dropDown.current.$[0];
            var links = dropDown.current.links;
            dropDown.current.cleanActive();
            switch(c){
                case 40:
                    moveDown();
                    break;
                case 38:
                    moveUp();
                    break;
                case 27:
                    return options.escapeHandler.call(dropDown.current, e);
                case 13:
                    if (cdd.focused >= 0) {
                        if (!options.selectionHandler) {
                            if ((0, _jquery2.default)(links[cdd.focused]).attr("nodeName") != "a") return (0, _jquery2.default)("a", links[cdd.focused]).trigger("focus"); //focus on the "a" within the parent item elements
                            else return (0, _jquery2.default)(links[cdd.focused]).trigger("focus"); //focus on the "a"
                        } else return options.selectionHandler.call(dropDown.current, e, (0, _jquery2.default)(links[cdd.focused])); //call the selection handler
                    }
                    return true;
                default:
                    if (links.length) (0, _jquery2.default)(links[cdd.focused]).addClass(options.activeClass);
                    return true;
            }
            e.stopPropagation();
            e.preventDefault();
            return false;
        };
        var hider = function hider(e) {
            if (!(e && e.which && e.which == 3 || e && e.button && e.button == 2 || false)) // right click check
            {
                if (dropDown.current) dropDown.current.hide("click");
            }
        };
        var active = function active(i) {
            return function() {
                if (!dropDown.current) return;
                dropDown.current.cleanFocus();
                this.originalClass = this.className;
                (0, _jquery2.default)(this).addClass(options.activeClass);
                dropDown.current.$[0].focused = i;
            };
        };
        var handleClickSelection = function handleClickSelection(e) {
            if (e.button || e.metaKey || e.ctrlKey || e.shiftKey) return true;
            if (dropDown.current && options.selectionHandler) options.selectionHandler.call(dropDown.current, e, (0, _jquery2.default)(this));
        };
        var isEventsBound = function isEventsBound(el) {
            var bound = false;
            if (el.data("events")) _jquery2.default.each(el.data("events"), function(i, handler) {
                _jquery2.default.each(handler, function(type, handler) {
                    if (handleClickSelection === handler) {
                        bound = true;
                        return false;
                    }
                });
            });
            return bound;
        };
        dd.each(function() {
            var cdd = this;
            var $cdd = (0, _jquery2.default)(this);
            var res = {};
            var methods = {
                reset: function reset() {
                    res = _jquery2.default.extend(res, {
                        $: $cdd,
                        links: (0, _jquery2.default)(options.item || "li:has(a)", cdd),
                        cleanActive: function cleanActive() {
                            if (cdd.focused + 1 && res.links.length) (0, _jquery2.default)(res.links[cdd.focused]).removeClass(options.activeClass);
                        },
                        cleanFocus: function cleanFocus() {
                            res.cleanActive();
                            cdd.focused = -1;
                        },
                        moveDown: moveDown,
                        moveUp: moveUp,
                        moveFocus: moveFocus,
                        getFocusIndex: function getFocusIndex() {
                            return typeof cdd.focused === "number" ? cdd.focused : -1;
                        }
                    });
                    res.links.each(function(i) {
                        var $this = (0, _jquery2.default)(this);
                        if (!isEventsBound($this)) {
                            $this.hover(active(i), res.cleanFocus);
                            $this.click(handleClickSelection);
                        }
                    });
                },
                appear: function appear(dir) {
                    if (dir) {
                        $cdd.removeClass("hidden");
                        //handle left or right alignment
                        $cdd.addClass("aui-dropdown-" + options.alignment);
                    } else $cdd.addClass("hidden");
                },
                fade: function fade(dir) {
                    if (dir) $cdd.fadeIn("fast");
                    else $cdd.fadeOut("fast");
                },
                scroll: function scroll(dir) {
                    if (dir) $cdd.slideDown("fast");
                    else $cdd.slideUp("fast");
                }
            };
            res.reset = methods.reset;
            res.reset();
            /**
           * Uses Aspect Oriented Programming (AOP) to wrap a method around another method
           * Allows control of the execution of the wrapped method.
           * specified method has returned @see $.aop
           * @method addControlProcess
           * @param {String} methodName - Name of a public method
           * @param {Function} callback - Function to be executed
           * @return {Array} weaved aspect
           */ res.addControlProcess = function(method, process) {
                _jquery2.default.aop.around({
                    target: this,
                    method: method
                }, process);
            };
            /**
           * Uses Aspect Oriented Programming (AOP) to insert callback <em>after</em> the
           * specified method has returned @see $.aop
           * @method addCallback
           * @param {String} methodName - Name of a public method
           * @param {Function} callback - Function to be executed
           * @return {Array} weaved aspect
           */ res.addCallback = function(method, callback) {
                return _jquery2.default.aop.after({
                    target: this,
                    method: method
                }, callback);
            };
            res.show = function(method) {
                if (options.useDisabled && this.$.closest(".aui-dd-parent").hasClass("disabled")) return;
                this.alignment = options.alignment;
                hider();
                dropDown.current = this;
                this.method = method || this.method || "appear";
                this.timer = setTimeout(function() {
                    $doc.click(hider);
                }, 0);
                $doc.keydown(moveFocus);
                if (options.firstSelected && this.links[0]) active(0).call(this.links[0]);
                (0, _jquery2.default)(cdd.offsetParent).css({
                    zIndex: 2000
                });
                methods[this.method](true);
                (0, _jquery2.default)(document).trigger("showLayer", [
                    "dropdown",
                    dropDown.current
                ]);
            };
            res.hide = function(causer) {
                this.method = this.method || "appear";
                (0, _jquery2.default)($cdd.get(0).offsetParent).css({
                    zIndex: ""
                });
                this.cleanFocus();
                methods[this.method](false);
                $doc.unbind("click", hider).unbind("keydown", moveFocus);
                (0, _jquery2.default)(document).trigger("hideLayer", [
                    "dropdown",
                    dropDown.current
                ]);
                dropDown.current = null;
                return causer;
            };
            res.addCallback("reset", function() {
                if (options.firstSelected && this.links[0]) active(0).call(this.links[0]);
            });
            if (!dropDown.iframes) dropDown.iframes = [];
            dropDown.createShims = function createShims() {
                (0, _jquery2.default)("iframe").each(function(idx) {
                    var iframe = this;
                    if (!iframe.shim) {
                        iframe.shim = (0, _jquery2.default)("<div />").addClass("shim hidden").appendTo("body");
                        dropDown.iframes.push(iframe);
                    }
                });
                return createShims;
            }();
            res.addCallback("show", function() {
                (0, _jquery2.default)(dropDown.iframes).each(function() {
                    var $this = (0, _jquery2.default)(this);
                    if ($this.is(":visible")) {
                        var offset = $this.offset();
                        offset.height = $this.height();
                        offset.width = $this.width();
                        this.shim.css({
                            left: offset.left + "px",
                            top: offset.top + "px",
                            height: offset.height + "px",
                            width: offset.width + "px"
                        }).removeClass("hidden");
                    }
                });
            });
            res.addCallback("hide", function() {
                (0, _jquery2.default)(dropDown.iframes).each(function() {
                    this.shim.addClass("hidden");
                });
                options.hideHandler();
            });
            result.push(res);
        });
        return result;
    }
    /**
   * For the given item in the drop down get the value of the named additional property. If there is no
   * property with the specified name then null will be returned.
   *
   * @method getAdditionalPropertyValue
   * @namespace dropDown
   * @param item {Object} jQuery Object of the drop down item. An LI element is expected.
   * @param name {String} name of the property to retrieve
   */ dropDown.getAdditionalPropertyValue = function(item, name) {
        var el = item[0];
        if (!el || typeof el.tagName !== "string" || el.tagName.toLowerCase() !== "li") // we are moving the location of the properties and want to deprecate the attachment to the span
        // but are unsure where and how its being called so for now we just log
        logger.log("dropDown.getAdditionalPropertyValue : item passed in should be an LI element wrapped by jQuery");
        var properties = _jquery2.default.data(el, "properties");
        return properties ? properties[name] : null;
    };
    /**
   * Only here for backwards compatibility
   * @method removeAllAdditionalProperties
   * @namespace dropDown
   * @deprecated Since 3.0
   */ dropDown.removeAllAdditionalProperties = function(item) {};
    /**
   * Base dropdown control. Enables you to identify triggers that when clicked, display dropdown.
   *
   * @class Standard
   * @constructor
   * @namespace dropDown
   * @param {Object} usroptions
   * @return {Object
   */ dropDown.Standard = function(usroptions) {
        var res = [];
        var options = {
            selector: ".aui-dd-parent",
            dropDown: ".aui-dropdown",
            trigger: ".aui-dd-trigger"
        };
        var dropdownParents;
        // extend defaults with user options
        _jquery2.default.extend(options, usroptions);
        var hookUpDropDown = function hookUpDropDown($trigger, $parent, $dropdown, ddcontrol) {
            // extend to control to have any additional properties/methods
            _jquery2.default.extend(ddcontrol, {
                trigger: $trigger
            });
            // flag it to prevent additional dd controls being applied
            $parent.addClass("dd-allocated");
            //hide dropdown if not already hidden
            $dropdown.addClass("hidden");
            //show the dropdown if isHiddenByDefault is set to false
            if (options.isHiddenByDefault == false) ddcontrol.show();
            ddcontrol.addCallback("show", function() {
                $parent.addClass("active");
            });
            ddcontrol.addCallback("hide", function() {
                $parent.removeClass("active");
            });
        };
        var handleEvent = function handleEvent(event, $trigger, $dropdown, ddcontrol) {
            if (ddcontrol != dropDown.current) {
                $dropdown.css({
                    top: $trigger.outerHeight()
                });
                ddcontrol.show();
                event.stopImmediatePropagation();
            }
            event.preventDefault();
        };
        if (options.useLiveEvents) {
            // cache arrays so that we don't have to recalculate the dropdowns. Since we can't store objects as keys in a map,
            // we have two arrays: keysCache stores keys of dropdown triggers; valuesCache stores a map of internally used objects
            var keysCache = [];
            var valuesCache = [];
            (0, _jquery2.default)(options.trigger).live("click", function(event) {
                var $trigger = (0, _jquery2.default)(this);
                var $parent;
                var $dropdown;
                var ddcontrol;
                // if we're cached, don't recalculate the dropdown and do all that funny shite.
                var index;
                if ((index = _jquery2.default.inArray(this, keysCache)) >= 0) {
                    var val = valuesCache[index];
                    $parent = val.parent;
                    $dropdown = val.dropdown;
                    ddcontrol = val.ddcontrol;
                } else {
                    $parent = $trigger.closest(options.selector);
                    $dropdown = $parent.find(options.dropDown);
                    // Sanity checking
                    if ($dropdown.length === 0) return;
                    ddcontrol = dropDown($dropdown, options)[0];
                    // Sanity checking
                    if (!ddcontrol) return;
                    // cache
                    keysCache.push(this);
                    val = {
                        parent: $parent,
                        dropdown: $dropdown,
                        ddcontrol: ddcontrol
                    };
                    hookUpDropDown($trigger, $parent, $dropdown, ddcontrol);
                    valuesCache.push(val);
                }
                handleEvent(event, $trigger, $dropdown, ddcontrol);
            });
        } else {
            // handling for jQuery collections
            if (this instanceof _jquery2.default) dropdownParents = this;
            else dropdownParents = (0, _jquery2.default)(options.selector);
            // a series of checks to ensure we are dealing with valid dropdowns
            dropdownParents = dropdownParents.not(".dd-allocated").filter(":has(" + options.dropDown + ")").filter(":has(" + options.trigger + ")");
            dropdownParents.each(function() {
                var $parent = (0, _jquery2.default)(this);
                var $dropdown = (0, _jquery2.default)(options.dropDown, this);
                var $trigger = (0, _jquery2.default)(options.trigger, this);
                var ddcontrol = dropDown($dropdown, options)[0];
                // extend to control to have any additional properties/methods
                _jquery2.default.extend(ddcontrol, {
                    trigger: $trigger
                });
                hookUpDropDown($trigger, $parent, $dropdown, ddcontrol);
                $trigger.click(function(e) {
                    handleEvent(e, $trigger, $dropdown, ddcontrol);
                });
                // add control to the response
                res.push(ddcontrol);
            });
        }
        return res;
    };
    /**
   * A NewStandard dropdown, however, with the ability to populate its content's via ajax.
   *
   * @class Ajax
   * @constructor
   * @namespace dropDown
   * @param {Object} options
   * @return {Object} dropDown instance
   */ dropDown.Ajax = function(usroptions) {
        var dropdowns;
        var options = {
            cache: true
        };
        // extend defaults with user options
        _jquery2.default.extend(options, usroptions || {});
        // we call with "this" in case we are called in the context of a jQuery collection
        dropdowns = dropDown.Standard.call(this, options);
        (0, _jquery2.default)(dropdowns).each(function() {
            var ddcontrol = this;
            _jquery2.default.extend(ddcontrol, {
                getAjaxOptions: function getAjaxOptions(opts) {
                    var success = function success(response) {
                        if (options.formatResults) response = options.formatResults(response);
                        if (options.cache) ddcontrol.cache.set(ddcontrol.getAjaxOptions(), response);
                        ddcontrol.refreshSuccess(response);
                    };
                    if (options.ajaxOptions) {
                        if (_jquery2.default.isFunction(options.ajaxOptions)) return _jquery2.default.extend(options.ajaxOptions.call(ddcontrol), {
                            success: success
                        });
                        else return _jquery2.default.extend(options.ajaxOptions, {
                            success: success
                        });
                    }
                    return _jquery2.default.extend(opts, {
                        success: success
                    });
                },
                refreshSuccess: function refreshSuccess(response) {
                    this.$.html(response);
                },
                cache: function() {
                    var c = {};
                    return {
                        get: function get(ajaxOptions) {
                            var data1 = ajaxOptions.data || "";
                            return c[(ajaxOptions.url + data1).replace(/[\?\&]/gi, "")];
                        },
                        set: function set(ajaxOptions, responseData) {
                            var data1 = ajaxOptions.data || "";
                            c[(ajaxOptions.url + data1).replace(/[\?\&]/gi, "")] = responseData;
                        },
                        reset: function reset() {
                            c = {};
                        }
                    };
                }(),
                show: function(superMethod) {
                    return function() {
                        if (options.cache && !!ddcontrol.cache.get(ddcontrol.getAjaxOptions())) {
                            ddcontrol.refreshSuccess(ddcontrol.cache.get(ddcontrol.getAjaxOptions()));
                            superMethod.call(ddcontrol);
                        } else {
                            (0, _jquery2.default)(_jquery2.default.ajax(ddcontrol.getAjaxOptions())).throbber({
                                target: ddcontrol.$,
                                end: function end() {
                                    ddcontrol.reset();
                                }
                            });
                            superMethod.call(ddcontrol);
                            if (ddcontrol.iframeShim) ddcontrol.iframeShim.hide();
                        }
                    };
                }(ddcontrol.show),
                resetCache: function resetCache() {
                    ddcontrol.cache.reset();
                }
            });
            ddcontrol.addCallback("refreshSuccess", function() {
                ddcontrol.reset();
            });
        });
        return dropdowns;
    };
    // OMG. No. Just no.
    _jquery2.default.fn.dropDown = function(type, options) {
        type = (type || "Standard").replace(/^([a-z])/, function(match) {
            return match.toUpperCase();
        });
        return dropDown[type].call(this, options);
    };
    _jquery2.default.fn.dropDown = deprecate.construct(_jquery2.default.fn.dropDown, "Dropdown constructor", {
        alternativeName: "Dropdown2"
    });
    (0, _globalize2.default)("dropDown", dropDown);
    exports.default = dropDown;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/escape.js
(typeof window === "undefined" ? $parcel$global : window).__358322a372d0f4ddd93ba2e992bb9c50 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Similar to Javascript's in-built escape() function, but where the built-in escape()
   * might encode unicode charaters as %uHHHH, this function will leave them as-is.
   *
   * NOTE: this function does not do html-escaping, see escapeHtml().
   */ var jsEscape = window.escape;
    function escape(string) {
        return jsEscape(string).replace(/%u\w{4}/gi, function(w) {
            return unescape(w);
        });
    }
    (0, _globalize2.default)("escape", escape);
    exports.default = escape;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// node_modules/fancy-file-input/dist/fancy-file-input.js
(typeof window === "undefined" ? $parcel$global : window).__186749e421250c560daa7ea3c89b915e = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    var defineDependencies = {
        "module": module,
        "exports": exports,
        "jquery": __700a145ba3db9966cc95664c892049f8,
        "jquery": __700a145ba3db9966cc95664c892049f8
    };
    var define = function defineReplacementWrapper(generatedModuleName) {
        return function defineReplacement(name, deps, func) {
            var root = typeof window === "undefined" ? $parcel$global : window;
            var defineGlobal = root.define;
            var rval;
            var type;
            func = [
                func,
                deps,
                name
            ].filter(function(cur) {
                return typeof cur === "function";
            })[0];
            deps = [
                deps,
                name,
                []
            ].filter(Array.isArray)[0];
            rval = func.apply(null, deps.map(function(value1) {
                return defineDependencies[value1];
            }));
            type = typeof rval;
            // Support existing AMD libs.
            if (typeof defineGlobal === "function") // Almond always expects a name so resolve one (#29).
            defineGlobal(typeof name === "string" ? name : generatedModuleName, deps, func);
            // Some processors like Babel don't check to make sure that the module value
            // is not a primitive before calling Object.defineProperty() on it. We ensure
            // it is an instance so that it can.
            if (type === "string") rval = String(rval);
            else if (type === "number") rval = Number(rval);
            else if (type === "boolean") rval = Boolean(rval);
            // Reset the exports to the defined module. This is how we convert AMD to
            // CommonJS and ensures both can either co-exist, or be used separately. We
            // only set it if it is not defined because there is no object representation
            // of undefined, thus calling Object.defineProperty() on it would fail.
            if (rval !== undefined) exports = module.exports = rval;
        };
    }("__186749e421250c560daa7ea3c89b915e");
    define.amd = true;
    /*! jQuery Fancy File Input plugin - v2.0.3 - 2017-10-25
  * Copyright (c) 2017 Atlassian Pty Ltd; Licensed Apache-2.0 */ (function(root, factory) {
        if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module unless amdModuleId is set
        define([
            "jquery"
        ], function(a0) {
            return root["FancyFileInput"] = factory(a0);
        });
        else if (typeof module === "object" && module.exports) // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(__700a145ba3db9966cc95664c892049f8);
        else root["FancyFileInput"] = factory(root["jQuery"]);
    })(this, function($) {
        /**
   * --------------------------------------------------------------------
   * jQuery Fancy File Input plugin
   * Author: Atlassian Pty Ltd
   * Copyright © 2012 - 2016 Atlassian Pty Ltd. Licensed under the
   * Apache License, Version 2.0 (the "License"); you may not use this
   * file except in compliance with the License. You may obtain a copy
   * of the License at http://www.apache.org/licenses/LICENSE-2.0.
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
   * implied. See the License for the specific language governing
   * permissions and limitations under the License.
   * --------------------------------------------------------------------
   */ /* jshint -W097 */ var fakePathRegex = /^.*[\\\/]/;
        var multipleFileTextRegex = /\{0\}/gi;
        var ie = function() {
            var v = 3;
            var div = document.createElement("div");
            var all = div.getElementsByTagName("i");
            do div.innerHTML = "<!--[if gt IE " + ++v + "]><i></i><![endif]-->";
            while (all[0]);
            return v > 4 ? v : document.documentMode;
        }();
        function FancyFileInput(el, options) {
            var instance = $(el).data("FancyFileInput");
            if (instance) return instance;
            options = $.extend({}, FancyFileInput.defaults, options);
            this.el = el;
            this.$el = $(el);
            this.$label = this.createLabel(options.buttonText);
            this._addLabelText();
            this.$clearButton = $("<button>", {
                text: this.$label.attr("data-ffi-clearButtonText") || options.clearButtonText,
                "class": "ffi-clear",
                type: "button",
                "tabindex": "-1"
            });
            this.multipleFileTextPattern = this.$label.attr("data-ffi-multipleFileTextPattern") || options.multipleFileTextPattern;
            this._eventNamespace = ".ffi";
            this.CLASSES = {
                disabled: "is-disabled",
                focused: "is-focused",
                active: "is-active",
                valid: "is-valid",
                invalid: "is-invalid"
            };
            this[this.isDisabled() ? "disable" : "enable"]();
            this.isFocused = false;
        }
        FancyFileInput.defaults = {
            buttonText: "Browse\u2026",
            clearButtonText: "Clear",
            multipleFileTextPattern: "{0} files"
        };
        FancyFileInput.prototype._addLabelText = function attLabelText() {
            var $associatedLabel = $('label[for="' + this.el.id + '"]');
            if ($associatedLabel.length) this.$el.attr("aria-label", $associatedLabel.text());
        };
        FancyFileInput.prototype.createLabel = function(buttonText) {
            var $label = this.$el.parent(".ffi[data-ffi-button-text]");
            if (!$label.length) $label = this.$el.wrap($("<label>", {
                "class": "ffi",
                "data-ffi-button-text": buttonText
            })).parent();
            return $label;
        };
        FancyFileInput.prototype.isDisabled = function() {
            return this.$el.is(":disabled");
        };
        FancyFileInput.prototype.formatMultipleFileText = function(numFiles) {
            return this.multipleFileTextPattern.replace(multipleFileTextRegex, numFiles);
        };
        FancyFileInput.prototype.bindEvents = function() {
            this.$el.on("invalid" + this._eventNamespace, $.proxy(this.checkValidity, this)).on("change" + this._eventNamespace, $.proxy(this.change, this)).on("keydown" + this._eventNamespace, $.proxy(this.keydown, this)).on("mousedown" + this._eventNamespace, $.proxy(this.mousedown, this)).on("mouseup" + this._eventNamespace, $.proxy(this.mouseup, this)).on("focus" + this._eventNamespace, $.proxy(this.focus, this)).on("blur" + this._eventNamespace, $.proxy(this.blur, this));
            this.$clearButton.on("click" + this._eventNamespace, $.proxy(this.clear, this));
        };
        FancyFileInput.prototype.unbindEvents = function() {
            this.$el.off(this._eventNamespace);
            this.$clearButton.off(this._eventNamespace);
        };
        FancyFileInput.prototype.fireEvent = function(event) {
            this.$el.trigger(event + this._eventNamespace);
        };
        FancyFileInput.prototype.enable = function() {
            this.bindEvents();
            this.$el.prop("disabled", false);
            this.$label.removeClass(this.CLASSES.disabled);
        };
        FancyFileInput.prototype.disable = function() {
            this.unbindEvents();
            this.$el.prop("disabled", true);
            this.$label.addClass(this.CLASSES.disabled);
        };
        FancyFileInput.prototype.clear = function() {
            this.$el.wrap("<form>").closest("form").get(0).reset();
            this.$el.unwrap();
            this.el.value = "";
            this.change();
            return false;
        };
        FancyFileInput.prototype.focus = function() {
            var instance = this;
            this.$label.addClass(this.CLASSES.focused);
            // toggle focus so that the cursor appears back in the field instead of on the button
            if (ie && !this.isFocused) {
                this.isFocused = true;
                setTimeout(function() {
                    instance.$el.blur();
                    instance.$el.focus();
                }, 0);
            }
        };
        FancyFileInput.prototype.blur = function() {
            if (!ie || !this.isFocused) {
                this.$label.removeClass(this.CLASSES.focused);
                this.isFocused = false;
            }
        };
        FancyFileInput.prototype.mousedown = function() {
            this.$label.addClass(this.CLASSES.active);
        };
        FancyFileInput.prototype.mouseup = function() {
            this.$label.removeClass(this.CLASSES.active);
        };
        FancyFileInput.prototype.keydown = function(e) {
            var keyCode = e.which;
            var BACKSPACE = 8;
            var TAB = 9;
            var DELETE = 46;
            // Add clear behaviour for all browsers
            if (keyCode === BACKSPACE || keyCode === DELETE) {
                this.clear();
                e.preventDefault();
            }
            // This works around the IE double tab-stop - no events or blur/change occur when moving between
            //  the field part of the input and the button part. This is dirty, but it works.
            if (ie && keyCode === TAB) {
                var instance = this;
                this.isFocused = false;
                this.$el.prop("disabled", true);
                setTimeout(function() {
                    instance.$el.prop("disabled", false).blur();
                }, 0);
            }
        };
        FancyFileInput.prototype.checkValidity = function() {
            if (!this.el.required) return;
            var isInvalid = this.$el.is(":invalid");
            this.$label.toggleClass(this.CLASSES.invalid, isInvalid).toggleClass(this.CLASSES.valid, !isInvalid);
        };
        FancyFileInput.prototype.change = function() {
            var files;
            var val = "";
            this.checkValidity();
            // multiple file selection
            if (this.el.multiple && this.el.files.length > 1) files = this.formatMultipleFileText(this.el.files.length); // '5 files'
            else files = this.el.value; // 'README.txt'
            if (files.length) {
                val = files.replace(fakePathRegex, ""); // Strips off the C:\fakepath nonsense
                this.$clearButton.appendTo(this.$label);
            } else this.$clearButton.detach();
            this.$el.focus();
            this.setFieldText(val);
            this.fireEvent("value-changed");
        };
        FancyFileInput.prototype.setFieldText = function(text) {
            var dataAttribute = "data-ffi-value";
            if (text.length) {
                this.$label.attr(dataAttribute, text);
                this.fireEvent("value-added");
            } else {
                this.$label.removeAttr(dataAttribute);
                this.fireEvent("value-cleared");
            }
        };
        $.fn.fancyFileInput = function(options) {
            return this.each(function() {
                var ffi = new FancyFileInput(this, options);
                $(this).data("FancyFileInput", ffi);
            });
        };
        return FancyFileInput;
    });
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/fancy-file-input.js
(typeof window === "undefined" ? $parcel$global : window).__57b6a2051b8779488be56ba67bc3c21c = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    /* AUI-4199: This puts the FFI object on the jQuery global for backwards compatibility. */ Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _fancyFileInput = __186749e421250c560daa7ea3c89b915e;
    var _fancyFileInput2 = _interopRequireDefault(_fancyFileInput);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    exports.default = _fancyFileInput2.default;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/filter-by-search.js
(typeof window === "undefined" ? $parcel$global : window).__0601db35e0320a246a2e95c4a20b98b4 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Filters a list of entries by a passed search term.
   *
   * Options:
   * - `keywordsField` name of entry field containing keywords, default "keywords".
   * - `ignoreForCamelCase` ignore search case for camel case, e.g. CB matches Code Block *and* Code block.
   * - `matchBoundary` match words only at boundary, e.g. link matches "linking" but not "hyperlinks".
   * - `splitRegex` regex to split search words, instead of on whitespace.
   *
   * @param {Array} entries An array of objects with a "keywords" property.
   * @param {String} search One or more words to search on, which may include camel-casing.
   * @param {Object} options Specifiy to override default behaviour.
   *
   * @returns {Array}
   */ function filterBySearch(entries, search, options) {
        // search for nothing, get nothing - up to calling code to handle.
        if (!search) return [];
        var keywordsField = options && options.keywordsField || "keywords";
        var camelCaseFlags = options && options.ignoreForCamelCase ? "i" : "";
        var boundaryFlag = options && options.matchBoundary ? "\\b" : "";
        var splitRegex = options && options.splitRegex || /\s+/;
        // each word in the input is considered a distinct filter that has to match a keyword in the record
        var filterWords = search.split(splitRegex);
        var filters = [];
        filterWords.forEach(function(word) {
            // anchor on word boundaries
            var subfilters = [
                new RegExp(boundaryFlag + word, "i")
            ];
            // split camel-case into separate words
            if (/^([A-Z][a-z]*) {2,}$/.test(this)) {
                var camelRegexStr = this.replace(/([A-Z][a-z]*)/g, "\\b$1[^,]*");
                subfilters.push(new RegExp(camelRegexStr, camelCaseFlags));
            }
            filters.push(subfilters);
        });
        var result = [];
        entries.forEach(function(entry) {
            for(var i = 0; i < filters.length; i++){
                var somethingMatches = false;
                for(var j = 0; j < filters[i].length; j++)if (filters[i][j].test(entry[keywordsField])) {
                    somethingMatches = true;
                    break;
                }
                if (!somethingMatches) return;
            }
            result.push(entry);
        });
        return result;
    }
    var filterBySearch = (0, _deprecation.fn)(filterBySearch, "filterBySearch", {
        sinceVersion: "5.9.0",
        extraInfo: "No alternative will be provided. If products require this function, this should be copied."
    });
    (0, _globalize2.default)("filterBySearch", filterBySearch);
    exports.default = filterBySearch;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/include.js
(typeof window === "undefined" ? $parcel$global : window).__b47fe435d7d231cd9ccf33cd539d9888 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var _contains = __314cfd19ff44fc21aa5412fc0dd1f9c1;
    var _contains2 = _interopRequireDefault(_contains);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var included = [];
    function include(url) {
        if (!(0, _contains2.default)(included, url)) {
            included.push(url);
            var s = document.createElement("script");
            s.src = url;
            (0, _jquery2.default)("body").append(s);
        }
    }
    var include = (0, _deprecation.fn)(include, "include", {
        sinceVersion: "5.9.0",
        extraInfo: "No alternative will be provided. Use a proper module loader instead."
    });
    (0, _globalize2.default)("include", include);
    exports.default = include;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/inline-dialog2.js
(typeof window === "undefined" ? $parcel$global : window).__b4529c3c44b8657454bfd27f30c89b5c = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _alignment = __81deba69899d0f1851f2c511b87bbbae;
    var _alignment2 = _interopRequireDefault(_alignment);
    var _amdify = __65ca28a9d6b0f244027266ff8e6a6d1c;
    var _amdify2 = _interopRequireDefault(_amdify);
    var _attributes = __ab489eda548cad099ce93b60faa6a3d5;
    var _attributes2 = _interopRequireDefault(_attributes);
    var _enforcer = __2512e2cfb8f46670d5cb777690a28c72;
    var _enforcer2 = _interopRequireDefault(_enforcer);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _layer = __3ada4a8272640e5242be87f12c7e0fdf;
    var _layer2 = _interopRequireDefault(_layer);
    var _skate = __0ac9a2c09f995a9c0a478af8742f59b7;
    var _skate2 = _interopRequireDefault(_skate);
    var _state = __3f2c7809aecfe899611b77461a9218ac;
    var _state2 = _interopRequireDefault(_state);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var DEFAULT_HOVEROUT_DELAY = 1000;
    function getTrigger(element) {
        return document.querySelector('[aria-controls="' + element.id + '"]');
    }
    function doIfTrigger(element, callback) {
        var trigger = getTrigger(element);
        if (trigger) callback(trigger);
    }
    function initAlignment(element, trigger) {
        if (!element._auiAlignment) element._auiAlignment = new _alignment2.default(element, trigger);
    }
    function enableAlignment(element, trigger) {
        initAlignment(element, trigger);
        element._auiAlignment.enable();
    }
    function disableAlignment(element, trigger) {
        initAlignment(element, trigger);
        element._auiAlignment.disable();
    }
    function handleMessage(element, message) {
        var messageTypeMap = {
            toggle: [
                "click"
            ],
            hover: [
                "mouseenter",
                "mouseleave",
                "focus",
                "blur"
            ]
        };
        var messageList = messageTypeMap[element.respondsTo];
        if (messageList && messageList.indexOf(message.type) > -1) messageHandler[message.type](element, message);
    }
    var messageHandler = {
        click: function click(element) {
            if (element.open) {
                if (!(0, _layer2.default)(element).isPersistent()) element.open = false;
            } else element.open = true;
        },
        mouseenter: function mouseenter(element) {
            if (!element.open) element.open = true;
            if (element._clearMouseleaveTimeout) element._clearMouseleaveTimeout();
        },
        mouseleave: function mouseleave(element) {
            if ((0, _layer2.default)(element).isPersistent() || !element.open) return;
            if (element._clearMouseleaveTimeout) element._clearMouseleaveTimeout();
            var timeout = setTimeout(function() {
                if (!(0, _state2.default)(element).get("mouse-inside")) element.open = false;
            }, DEFAULT_HOVEROUT_DELAY);
            element._clearMouseleaveTimeout = function() {
                clearTimeout(timeout);
                element._clearMouseleaveTimeout = null;
            };
        },
        focus: function focus(element) {
            if (!element.open) element.open = true;
        },
        blur: function blur(element) {
            if (!(0, _layer2.default)(element).isPersistent() && element.open) element.open = false;
        }
    };
    function onMouseEnter(e) {
        var element = e.target;
        (0, _state2.default)(element).set("mouse-inside", true);
        element.message({
            type: "mouseenter"
        });
    }
    function onMouseLeave(e) {
        var element = e.target;
        (0, _state2.default)(element).set("mouse-inside", false);
        element.message({
            type: "mouseleave"
        });
    }
    function rebindMouseEvents(el) {
        (0, _state2.default)(el).set("mouse-inside", undefined);
        el.removeEventListener("mouseenter", onMouseEnter);
        el.removeEventListener("mouseleave", onMouseLeave);
        if (el.respondsTo === "hover") {
            (0, _state2.default)(el).set("mouse-inside", false);
            el.addEventListener("mouseenter", onMouseEnter);
            el.addEventListener("mouseleave", onMouseLeave);
        }
    }
    function showInlineDialog(el) {
        (0, _layer2.default)(el).show();
        if ((0, _layer2.default)(el).isVisible()) doIfTrigger(el, function(trigger) {
            enableAlignment(el, trigger);
            trigger.setAttribute("aria-expanded", "true");
        });
        else el.open = false;
    }
    function hideInlineDialog(el) {
        (0, _layer2.default)(el).hide();
        if (!(0, _layer2.default)(el).isVisible()) doIfTrigger(el, function(trigger) {
            disableAlignment(el, trigger);
            trigger.setAttribute("aria-expanded", "false");
        });
        else el.open = true;
    }
    function reflectOpenness(el) {
        var isInitalizing = !el.hasAttribute("aria-hidden");
        var shouldBeOpen = el.hasAttribute("open");
        if (isInitalizing || el.open !== shouldBeOpen) {
            if (shouldBeOpen) {
                (0, _state2.default)(el).set("is-processing-show", true);
                showInlineDialog(el);
                (0, _state2.default)(el).set("is-processing-show", false);
            } else hideInlineDialog(el);
        }
    }
    var RESPONDS_TO_ATTRIBUTE_ENUM = {
        attribute: "responds-to",
        values: [
            "toggle",
            "hover"
        ],
        missingDefault: "toggle",
        invalidDefault: "toggle"
    };
    var inlineDialog = (0, _skate2.default)("aui-inline-dialog", {
        prototype: {
            /**
           * Returns whether the inline dialog is open.
           */ get open () {
                return (0, _layer2.default)(this).isVisible();
            },
            /**
           * Opens or closes the inline dialog, returning whether the dialog is
           * open or closed as a result (since event handlers can prevent either
           * action).
           *
           * You should check the value of open after setting this
           * value since the before show/hide events may have prevented it.
           */ set open (value){
                // TODO AUI-3726 Revisit double calls to canceled event handlers.
                // Explicitly calling reflectOpenness(…) in this setter means
                // that in native we'll get two sync calls to reflectOpenness(…)
                // and in polyfill one sync (here) and one async (attr change
                // handler). The latter of the two calls, for both cases, will
                // usually be a noop (except when show/hide events are cancelled).
                _attributes2.default.setBooleanAttribute(this, "open", value);
                reflectOpenness(this);
            },
            get persistent () {
                return this.hasAttribute("persistent");
            },
            set persistent (value){
                _attributes2.default.setBooleanAttribute(this, "persistent", value);
            },
            get respondsTo () {
                var attr = RESPONDS_TO_ATTRIBUTE_ENUM.attribute;
                return _attributes2.default.computeEnumValue(RESPONDS_TO_ATTRIBUTE_ENUM, this.getAttribute(attr));
            },
            set respondsTo (value){
                var oldComputedValue = this.respondsTo;
                _attributes2.default.setEnumAttribute(this, RESPONDS_TO_ATTRIBUTE_ENUM, value);
                if (oldComputedValue !== this.respondsTo) rebindMouseEvents(this);
            },
            /**
           * Handles the receiving of a message from another component.
           *
           * @param {Object} msg The message to act on.
           *
           * @returns {HTMLElement}
           */ message: function message(msg) {
                handleMessage(this, msg);
                return this;
            }
        },
        created: function created(element) {
            (0, _state2.default)(element).set("is-processing-show", false);
            doIfTrigger(element, function(trigger) {
                trigger.setAttribute("aria-expanded", element.open);
                trigger.setAttribute("aria-haspopup", "true");
            });
        },
        attributes: {
            "aria-hidden": function ariaHidden(element, change) {
                if (change.newValue === "true") {
                    var trigger = getTrigger(element);
                    if (trigger) trigger.setAttribute("aria-expanded", "false");
                }
                // Whenever layer manager hides us, we need to sync the open attribute.
                _attributes2.default.setBooleanAttribute(element, "open", change.newValue === "false");
            },
            open: function open(element) {
                // skate runs the created callback for attributes before the
                // element is attached to the DOM, so guard against that.
                if (document.body.contains(element)) reflectOpenness(element);
            },
            "responds-to": function respondsTo(element, change) {
                var oldComputedValue = _attributes2.default.computeEnumValue(RESPONDS_TO_ATTRIBUTE_ENUM, change.oldValue);
                var newComputedValue = _attributes2.default.computeEnumValue(RESPONDS_TO_ATTRIBUTE_ENUM, change.newValue);
                if (oldComputedValue !== newComputedValue) rebindMouseEvents(element);
            }
        },
        attached: function attached(element) {
            (0, _enforcer2.default)(element).attributeExists("id");
            if (element.hasAttribute("open")) // show() can cause the element to be reattached (to the <body>),
            // so guard against a nested show() call that blows up the layer
            // manager (since it sees us pushing the same element twice).
            {
                if (!(0, _state2.default)(element).get("is-processing-show")) reflectOpenness(element);
            } else reflectOpenness(element);
            rebindMouseEvents(element);
        },
        detached: function detached(element) {
            if (element._auiAlignment) element._auiAlignment.destroy();
        },
        template: function template(element) {
            var elem = (0, _jquery2.default)('<div class="aui-inline-dialog-contents"></div>').append(element.childNodes);
            (0, _jquery2.default)(element).addClass("aui-layer").html(elem);
        }
    });
    (0, _amdify2.default)("aui/inline-dialog2", inlineDialog);
    (0, _globalize2.default)("InlineDialog2", inlineDialog);
    exports.default = inlineDialog;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/is-clipped.js
(typeof window === "undefined" ? $parcel$global : window).__9c7e09af5e0b55833c235e1d20ff8617 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Shortcut function to see if passed element is truncated/clipped, eg. with
   * text-overflow: ellipsis.
   *
   * @param {String | Element | jQuery} element The element to check.
   *
   * @returns {Boolean}
   */ function isClipped(el) {
        el = (0, _jquery2.default)(el);
        return el.prop("scrollWidth") > el.prop("clientWidth");
    }
    (0, _globalize2.default)("isClipped", isClipped);
    exports.default = isClipped;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/is-visible.js
(typeof window === "undefined" ? $parcel$global : window).__3dba0a8df57d5c27ea6aae5ec8bcb981 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Shortcut function to see if passed element is currently visible on screen.
   *
   * @param {String | Element} element The HTMLElement or an jQuery selector to check.
   *
   * @returns {Boolean}
   */ function isVisible(element) {
        return !(0, _jquery2.default)(element).hasClass("hidden");
    }
    var isVisible = (0, _deprecation.fn)(isVisible, "isVisible", {
        sinceVersion: "5.9.0",
        extraInfo: "No alternative will be provided. Use jQuery.hasClass() instead."
    });
    (0, _globalize2.default)("isVisible", isVisible);
    exports.default = isVisible;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/layer-manager.js
(typeof window === "undefined" ? $parcel$global : window).__390cf96dd9cd56462d8fa8c8e223fa6a = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _layer = __3ada4a8272640e5242be87f12c7e0fdf;
    var _layer2 = _interopRequireDefault(_layer);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    (0, _globalize2.default)("LayerManager", _layer2.default.Manager);
    exports.default = _layer2.default.Manager;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/messages.js
(typeof window === "undefined" ? $parcel$global : window).__4416794d9d63726eadee43839f3abf71 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var deprecate = _interopRequireWildcard(_deprecation);
    var _log = __c1e961001275c079e48525ad3a48c8c2;
    var logger = _interopRequireWildcard(_log);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _keyCode = __e246bf93af36eb4453f35afeb1c302d9;
    var _keyCode2 = _interopRequireDefault(_keyCode);
    var _skate = __0ac9a2c09f995a9c0a478af8742f59b7;
    var _skate2 = _interopRequireDefault(_skate);
    var _template = __43d4585c6a21591b4ceac1b326c09405;
    var _template2 = _interopRequireDefault(_template);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var DEFAULT_FADEOUT_DURATION = 500;
    var DEFAULT_FADEOUT_DELAY = 5000;
    var FADEOUT_RESTORE_DURATION = 100;
    var MESSAGE_TEMPLATE = '<div class="aui-message aui-message-{type} {closeable} {shadowed} {fadeout}"><p class="title"><strong>{title}</strong></p>{body}<!-- .aui-message --></div>';
    var MESSAGE_WITHOUT_TITLE_TEMPLATE = '<div class="aui-message aui-message-{type} {closeable} {shadowed} {fadeout}">{body}<!-- .aui-message --></div>';
    function createMessageConstructor(type) {
        /**
       *
       * @param context
       * @param {Object} obj - message configuration
       * @param {String} [obj.id] - ID to add to the message.
       * @param {String} [obj.title] - Plain-text title of the message. If provided, will appear above the message body.
       * @param {String} obj.body - Content of the message. Can be HTML content.
       * @param {boolean} [obj.closeable] - If true, the message can be manually closed by the end-user via the UI.
       * @param {boolean} [obj.shadowed]
       * @param {boolean} [obj.fadeout]
       * @param {boolean} [obj.duration]
       * @param {boolean} [obj.delay]
       * @returns {*|HTMLElement}
       */ messages[type] = function(context, obj) {
            if (!obj) {
                obj = context;
                context = "#aui-message-bar";
            }
            // Set up our template options
            obj.closeable = obj.closeable !== null && obj.closeable !== false;
            // shadowed no longer does anything but left in so it doesn't break
            obj.shadowed = obj.shadowed !== null && obj.shadowed !== false;
            var title = (obj.title || "").toString().trim();
            var $message = renderMessageElement(title ? this.template : this.templateAlt, obj, type);
            insertMessageIntoContext($message, obj.insert, context);
            // Attach the optional extra behaviours
            if (obj.closeable) makeCloseable($message);
            if (obj.fadeout) makeFadeout($message, obj.delay, obj.duration);
            return $message;
        };
    }
    function makeCloseable(message) {
        (0, _jquery2.default)(message || "div.aui-message.closeable").each(function() {
            var $this = (0, _jquery2.default)(this);
            var $closeIcons = $this.find(".aui-icon.icon-close");
            var $icon = $closeIcons.length > 0 ? $closeIcons.first() : (0, _jquery2.default)('<span class="aui-icon icon-close" role="button" tabindex="0"></span>');
            $this.addClass("closeable");
            $this.append($icon);
            initCloseMessageBoxOnClickAndKeypress($this);
        });
    }
    function makeFadeout(message, delay, duration) {
        delay = typeof delay !== "undefined" ? delay : DEFAULT_FADEOUT_DELAY;
        duration = typeof duration !== "undefined" ? duration : DEFAULT_FADEOUT_DURATION;
        (0, _jquery2.default)(message || "div.aui-message.fadeout").each(function() {
            var $this = (0, _jquery2.default)(this);
            //Store the component state to avoid collisions between animations
            var hasFocus = false;
            var isHover = false;
            //Small functions to keep the code easier to read and avoid code duplication
            function fadeOut() {
                //Algorithm:
                //1. Stop all running animations (first arg), including any fade animation and delay
                //   Do not jump to the end of the animation (second arg). This prevents the message to abruptly
                //   jump to opacity:0 or opacity:1
                //2. Wait <delay> ms before starting the fadeout
                //3. Start the fadeout with a duration of <duration> ms
                //4. Close the message at the end of the animation
                $this.stop(true, false).delay(delay).fadeOut(duration, function() {
                    $this.closeMessage();
                });
            }
            function resetFadeOut() {
                //Algorithm:
                //1. Stop all running animations (first arg), including any fade animation and delay
                //   Do not jump to the end of the animation (second arg). This prevents the message to abruptly
                //   jump to opacity:0 or opacity:1
                //2. Fast animation to opacity:1
                $this.stop(true, false).fadeTo(FADEOUT_RESTORE_DURATION, 1);
            }
            function shouldStartFadeOut() {
                return !hasFocus && !isHover;
            }
            //Attach handlers for user interactions (focus and hover)
            $this.focusin(function() {
                hasFocus = true;
                resetFadeOut();
            }).focusout(function() {
                hasFocus = false;
                if (shouldStartFadeOut()) fadeOut();
            }).hover(function() {
                //should be called .hoverin(), but jQuery does not implement that method
                isHover = true;
                resetFadeOut();
            }, function() {
                //should be called .hoverout(), but jQuery does not implement that method
                isHover = false;
                if (shouldStartFadeOut()) fadeOut();
            });
            //Initial animation
            fadeOut();
        });
    }
    /**
   * Utility methods to display different message types to the user.
   * Usage:
   * <pre>
   * messages.info("#container", {
       *   title: "Info",
       *   body: "You can choose to have messages without Close functionality.",
       *   closeable: false,
       *   shadowed: false
       * });
   * </pre>
   */ var messages = {
        setup: function setup() {
            makeCloseable();
            makeFadeout();
        },
        makeCloseable: makeCloseable,
        makeFadeout: makeFadeout,
        template: MESSAGE_TEMPLATE,
        templateAlt: MESSAGE_WITHOUT_TITLE_TEMPLATE,
        createMessage: createMessageConstructor
    };
    function initCloseMessageBoxOnClickAndKeypress($message) {
        $message.on("click", ".aui-icon.icon-close", function(e) {
            (0, _jquery2.default)(e.target).closest(".aui-message").closeMessage();
        }).on("keydown", ".aui-icon.icon-close", function(e) {
            if (e.which === _keyCode2.default.ENTER || e.which === _keyCode2.default.SPACE) {
                (0, _jquery2.default)(e.target).closest(".aui-message").closeMessage();
                e.preventDefault(); // this is especially important when handling the space bar, as we don't want to page down
            }
        });
    }
    function insertMessageIntoContext($message, insertWhere, context) {
        if (insertWhere === "prepend") $message.prependTo(context);
        else $message.appendTo(context);
    }
    function renderMessageElement(templateString, options, type) {
        // Append the message using template
        var $message = (0, _jquery2.default)((0, _template2.default)(templateString).fill({
            type: type,
            closeable: options.closeable ? "closeable" : "",
            shadowed: options.shadowed ? "shadowed" : "",
            fadeout: options.fadeout ? "fadeout" : "",
            title: options.title || "",
            "body:html": options.body || ""
        }).toString());
        // Add ID if supplied
        if (options.id) {
            if (/[#\'\"\.\s]/g.test(options.id)) // reject IDs that don't comply with style guide (ie. they'll break stuff)
            logger.warn("Messages error: ID rejected, must not include spaces, hashes, dots or quotes.");
            else $message.attr("id", options.id);
        }
        return $message;
    }
    _jquery2.default.fn.closeMessage = function() {
        var $message = (0, _jquery2.default)(this);
        if ($message.hasClass("aui-message") && $message.hasClass("closeable")) {
            $message.stop(true); //Stop any running animation
            $message.trigger("messageClose", [
                this
            ]).remove(); //messageClose event Deprecated as of 5.3
            (0, _jquery2.default)(document).trigger("aui-message-close", [
                this
            ]); //must trigger on document since the element has been removed
        }
    };
    createMessageConstructor("generic"); //Deprecated Oct 2017
    createMessageConstructor("error");
    createMessageConstructor("warning");
    createMessageConstructor("info");
    createMessageConstructor("success");
    createMessageConstructor("hint"); //Deprecated Oct 2017
    (0, _skate2.default)("aui-message", {
        created: function created(element) {
            var body = element.innerHTML;
            var type = element.getAttribute("type") || "info";
            element.innerHTML = "";
            messages[type](element, {
                body: body,
                closeable: element.getAttribute("closeable"),
                delay: element.getAttribute("delay"),
                duration: element.getAttribute("duration"),
                fadeout: element.getAttribute("fadeout"),
                title: element.getAttribute("title")
            });
        }
    });
    (0, _jquery2.default)(function() {
        messages.setup();
    });
    deprecate.prop(messages, "makeCloseable", {
        extraInfo: 'Use the "closeable" option in the constructor instead. Docs: https://docs.atlassian.com/aui/latest/docs/messages.html'
    });
    deprecate.prop(messages, "createMessage", {
        extraInfo: "Use the provided convenience methods instead e.g. messages.info(). Docs: https://docs.atlassian.com/aui/latest/docs/messages.html"
    });
    deprecate.prop(messages, "makeFadeout", {
        extraInfo: 'Use the "fadeout" option in the constructor instead. Docs: https://docs.atlassian.com/aui/latest/docs/messages.html'
    });
    deprecate.prop(messages, "generic", {
        extraInfo: "use the messages.info() method instead. Docs: https://docs.atlassian.com/aui/latest/docs/messages.html"
    });
    deprecate.prop(messages, "hint", {
        extraInfo: "use the messages.info() method instead. Docs: https://docs.atlassian.com/aui/latest/docs/messages.html"
    });
    // Exporting
    // ---------
    (0, _globalize2.default)("messages", messages);
    exports.default = messages;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/navigation.js
(typeof window === "undefined" ? $parcel$global : window).__c4bf0135de94f554dfd06da5aa73ceee = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    __fa714f1b12d7502957e4e0b6196321bf;
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _skate = __0ac9a2c09f995a9c0a478af8742f59b7;
    var _skate2 = _interopRequireDefault(_skate);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _widget = __d2e8fc66dac2ecebdc205fcab991f687;
    var _widget2 = _interopRequireDefault(_widget);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Navigation (".aui-nav" elements).
   *
   * @param {(string|HtmlElement|jQuery)} selector - An expression
   *     representing a single .aui-nav element; you may also pass an expression
   *     for a descendent element, in which case the closest containing
   *     .aui-nav element is used.
   * @constructor
   */ function Navigation(selector) {
        this.$el = (0, _jquery2.default)(selector).closest(".aui-nav");
        // If there are multiple objects, initialise them separately
        if (this.$el.length > 1) return this.$el.map(function(idx, elm) {
            return new Navigation(elm);
        })[0];
        // If already initialised, return existing object
        if (this.$el.data("aui-navigation")) return this.$el.data("aui-navigation");
        this.$el.data("aui-navigation", this);
        this.$treeParent = this.$el.parent("li[aria-expanded]");
        this.$subtreeToggleIcon = this.$treeParent.children(".aui-nav-subtree-toggle").children("span.aui-icon");
        // Hide extra items under a 'More...' link
        this.hideMoreItems();
        // Add child-selected class to relevant attributes
        this.$el.children("li:has(.aui-nav-selected)").addClass("aui-nav-child-selected");
        // Auto-expand if child is selected
        var $selected = this.$el.children(".aui-nav-selected");
        $selected.parents(".aui-nav > [aria-expanded=false]").add($selected.filter("[aria-expanded=false]")).each(function() {
            var nav = navigationWidget((0, _jquery2.default)(this).children(".aui-nav"));
            nav.expand();
        });
        // Toggle expand on click
        this.$el.find("> li[aria-expanded] > .aui-nav-subtree-toggle").on("click", function() {
            var nav = navigationWidget((0, _jquery2.default)(this).siblings(".aui-nav"));
            nav.toggle();
        });
        return this;
    }
    Navigation.prototype.isNested = function() {
        return this.$treeParent.length === 1;
    };
    Navigation.prototype.isCollapsed = function() {
        return this.$treeParent.attr("aria-expanded") === "false";
    };
    Navigation.prototype.expand = function() {
        this.$treeParent.attr("aria-expanded", "true");
        this.$subtreeToggleIcon.removeClass("aui-iconfont-collapsed").addClass("aui-iconfont-expanded");
        this.hideMoreItems();
        return this;
    };
    Navigation.prototype.collapse = function() {
        this.$treeParent.attr("aria-expanded", "false");
        this.$subtreeToggleIcon.removeClass("aui-iconfont-expanded").addClass("aui-iconfont-collapsed");
        return this;
    };
    Navigation.prototype.toggle = function() {
        if (this.isCollapsed()) this.expand();
        else this.collapse();
        return this;
    };
    Navigation.prototype.hideMoreItems = function() {
        if (this.$el.is(".aui-nav:not([aria-expanded=false]) [data-more]")) {
            var moreText = this.$el.attr("data-more") || AJS.I18n.getText("aui.words.moreitem");
            var limit = Math.abs(parseInt(this.$el.attr("data-more-limit"))) || 5;
            var $listElements = this.$el.children("li");
            // Only add 'More...' if there is more than one element to hide and there are no selected elements
            var lessThanTwoToHide = $listElements.length <= limit + 1;
            var selectedElementPresent = $listElements.filter(".aui-nav-selected").length;
            var alreadyInitialised = $listElements.filter(".aui-nav-more").length;
            if (lessThanTwoToHide || selectedElementPresent || alreadyInitialised) return this;
            (0, _jquery2.default)("<li>", {
                "class": "aui-nav-more",
                "aria-hidden": "true"
            }).append((0, _jquery2.default)("<a>", {
                "href": "#",
                "class": "aui-nav-item",
                "text": moreText,
                "click": function click(e) {
                    e.preventDefault();
                    (0, _jquery2.default)(this).parent().remove();
                }
            })).insertAfter($listElements.eq(limit - 1));
        }
        return this;
    };
    var navigationWidget = (0, _widget2.default)("navigation", Navigation);
    // Initialise nav elements
    (0, _skate2.default)("aui-nav", {
        type: _skate2.default.type.CLASSNAME,
        attached: function attached(element) {
            new Navigation(element);
        },
        detached: function detached(element) {
            (0, _jquery2.default)(element).removeData();
        }
    });
    (0, _globalize2.default)("navigation", navigationWidget);
    exports.default = navigationWidget;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/on-text-resize.js
(typeof window === "undefined" ? $parcel$global : window).__9a2cde50c39116ec3f36bd040c98b8ba = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function onTextResize(f) {
        if (typeof f === "function") {
            if (onTextResize["on-text-resize"]) onTextResize["on-text-resize"].push(function(emsize) {
                f(emsize);
            });
            else {
                var em = (0, _jquery2.default)("<div></div>");
                em.css({
                    width: "1em",
                    height: "1em",
                    position: "absolute",
                    top: "-9999em",
                    left: "-9999em"
                });
                (0, _jquery2.default)("body").append(em);
                em.size = em.width();
                setInterval(function() {
                    if (em.size !== em.width()) {
                        em.size = em.width();
                        for(var i = 0, ii = onTextResize["on-text-resize"].length; i < ii; i++)onTextResize["on-text-resize"][i](em.size);
                    }
                }, 0);
                onTextResize.em = em;
                onTextResize["on-text-resize"] = [
                    function(emsize) {
                        f(emsize);
                    }
                ];
            }
        }
    }
    (0, _globalize2.default)("onTextResize", onTextResize);
    exports.default = onTextResize;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/params.js
(typeof window === "undefined" ? $parcel$global : window).__c23baf055e78d2723c930e9c96b28df7 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    exports.default = (0, _globalize2.default)("params", {});
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/populate-parameters.js
(typeof window === "undefined" ? $parcel$global : window).__4b56bdd4ac2dc9a48c4021c75605fddc = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _params = __c23baf055e78d2723c930e9c96b28df7;
    var _params2 = _interopRequireDefault(_params);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function populateParameters(parameters) {
        if (!parameters) parameters = _params2.default;
        (0, _jquery2.default)(".parameters input").each(function() {
            var value1 = this.value;
            var id = this.title || this.id;
            if ((0, _jquery2.default)(this).hasClass("list")) {
                if (parameters[id]) parameters[id].push(value1);
                else parameters[id] = [
                    value1
                ];
            } else parameters[id] = value1.match(/^(tru|fals)e$/i) ? value1.toLowerCase() === "true" : value1;
        });
    }
    (0, _globalize2.default)("populateParameters", populateParameters);
    exports.default = populateParameters;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/prevent-default.js
(typeof window === "undefined" ? $parcel$global : window).__a584720a962e883eb5e2b13671bdda8a = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Calls e.preventDefault. This is designed for event handlers that only need to prevent the default browser
   * action, eg:
   *
   *     $(".my-class").click(AJS.preventDefault)
   *
   * @param {jQuery.Event} e jQuery event.
   *
   * @returns {undefined}
   */ function preventDefault(e) {
        e.preventDefault();
    }
    (0, _globalize2.default)("preventDefault", preventDefault);
    exports.default = preventDefault;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/header.js
(typeof window === "undefined" ? $parcel$global : window).__93911bf5ed7c76934f3ee65b5a1419d0 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _createHeader = __455206c30630fecc55c648cca374a3ea;
    var _createHeader2 = _interopRequireDefault(_createHeader);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var deprecate = _interopRequireWildcard(_deprecation);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function findAndCreateHeaders() {
        (0, _jquery2.default)(".aui-header").each(function() {
            (0, _createHeader2.default)(this);
        });
    }
    (0, _jquery2.default)(findAndCreateHeaders);
    var responsiveheader = {};
    responsiveheader.setup = deprecate.fn(findAndCreateHeaders, "responsiveheader.setup", {
        removeInVersion: "8.0.0",
        sinceVersion: "5.8.0",
        extraInfo: "No need to manually initialise anymore as this is now a web component."
    });
    (0, _globalize2.default)("responsiveheader", responsiveheader);
    exports.default = responsiveheader;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/set-current.js
(typeof window === "undefined" ? $parcel$global : window).__431b66a1af03006f0f9f80a87c27d7d2 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Shortcut function adds or removes 'current' classname to an element based on a passed boolean.
   *
   * @param {String | Element} element The element or an ID to show or hide.
   * @param {boolean} show True to add 'current' class, false to remove.
   *
   * @returns {undefined}
   */ function setCurrent(element, current) {
        if (!(element = (0, _jquery2.default)(element))) return;
        if (current) element.addClass("current");
        else element.removeClass("current");
    }
    var setCurrent = (0, _deprecation.fn)(setCurrent, "setCurrent", {
        sinceVersion: "5.9.0",
        extraInfo: "No alternative will be provided. Use jQuery.addClass() / removeClass() instead."
    });
    (0, _globalize2.default)("setCurrent", setCurrent);
    exports.default = setCurrent;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/set-visible.js
(typeof window === "undefined" ? $parcel$global : window).__dffa429b520ea33a9faa1c8cd7c396da = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Shortcut function adds or removes 'hidden' classname to an element based on a passed boolean.
   *
   * @param {String | Element} element The element or an ID to show or hide.
   * @param {boolean} show true to show, false to hide.
   *
   * @returns {undefined}
   */ function setVisible(element, show) {
        if (!(element = (0, _jquery2.default)(element))) return;
        (0, _jquery2.default)(element).each(function() {
            var isHidden = (0, _jquery2.default)(this).hasClass("hidden");
            if (isHidden && show) (0, _jquery2.default)(this).removeClass("hidden");
            else if (!isHidden && !show) (0, _jquery2.default)(this).addClass("hidden");
        });
    }
    var setVisible = (0, _deprecation.fn)(setVisible, "setVisible", {
        sinceVersion: "5.9.0",
        extraInfo: "No alternative will be provided. Use jQuery.addClass() / removeClass() instead."
    });
    (0, _globalize2.default)("setVisible", setVisible);
    exports.default = setVisible;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/stop-event.js
(typeof window === "undefined" ? $parcel$global : window).__a8d5b960b1ce79629376dc694c7ea1f0 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Prevent further handling of an event. Returns false, which you should use as the return value of your event handler:
   * return stopEvent(e);
   *
   * @param {jQuery.Event} e jQuery event
   *
   * @returns {Boolean}
   */ function stopEvent(e) {
        e.stopPropagation();
        return false; // required for JWebUnit pop-up links to work properly
    }
    var stopEvent = (0, _deprecation.fn)(stopEvent, "stopEvent", {
        alternativeName: "preventDefault()",
        sinceVersion: "5.8.0"
    });
    (0, _globalize2.default)("stopEvent", stopEvent);
    exports.default = stopEvent;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/tabs.js
(typeof window === "undefined" ? $parcel$global : window).__5445bbb57d3600b27c6fd8e7cdd87f54 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    __c6b5725916d210b9653318d2ea2472cb;
    var _log = __c1e961001275c079e48525ad3a48c8c2;
    var logger = _interopRequireWildcard(_log);
    var _debounce = __ee62e24d4acb40214d4f9e21b1a58bfc;
    var _debounce2 = _interopRequireDefault(_debounce);
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _addId = __3b7b37131a17b9c12e44694d7b12c1e2;
    var _addId2 = _interopRequireDefault(_addId);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _isClipped = __9c7e09af5e0b55833c235e1d20ff8617;
    var _isClipped2 = _interopRequireDefault(_isClipped);
    var _skate = __0ac9a2c09f995a9c0a478af8742f59b7;
    var _skate2 = _interopRequireDefault(_skate);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    var template = window.skateTemplateHtml;
    var REGEX = /#.*/;
    var STORAGE_PREFIX = "_internal-aui-tabs-";
    var RESPONSIVE_OPT_IN_SELECTOR = '.aui-tabs.horizontal-tabs[data-aui-responsive]:not([data-aui-responsive="false"]), aui-tabs[responsive]:not([responsive="false"])';
    function enhanceTabLink(link) {
        var $thisLink = (0, _jquery2.default)(link);
        var targetPane = $thisLink.attr("href");
        (0, _addId2.default)($thisLink);
        $thisLink.attr("role", "tab");
        (0, _jquery2.default)(targetPane).attr("aria-labelledby", $thisLink.attr("id"));
        if ($thisLink.parent().hasClass("active-tab")) $thisLink.attr("aria-selected", "true");
        else $thisLink.attr("aria-selected", "false");
    }
    var ResponsiveAdapter = {
        totalTabsWidth: function totalTabsWidth($visibleTabs, $dropdown) {
            var totalVisibleTabsWidth = this.totalVisibleTabWidth($visibleTabs);
            var totalDropdownTabsWidth = 0;
            $dropdown.find("li").each(function(index, tab) {
                totalDropdownTabsWidth += parseInt(tab.getAttribute("data-aui-tab-width"));
            });
            return totalVisibleTabsWidth + totalDropdownTabsWidth;
        },
        totalVisibleTabWidth: function totalVisibleTabWidth($tabs) {
            var totalWidth = 0;
            $tabs.each(function(index, tab) {
                totalWidth += (0, _jquery2.default)(tab).outerWidth();
            });
            return totalWidth;
        },
        removeResponsiveDropdown: function removeResponsiveDropdown($dropdown, $dropdownTriggerTab) {
            $dropdown.remove();
            $dropdownTriggerTab.remove();
        },
        createResponsiveDropdownTrigger: function createResponsiveDropdownTrigger($tabsMenu, id) {
            var triggerMarkup = '<li class="menu-item aui-tabs-responsive-trigger-item"><a class="aui-dropdown2-trigger aui-tabs-responsive-trigger aui-dropdown2-trigger-arrowless" id="aui-tabs-responsive-trigger-' + id + '" aria-haspopup="true" aria-controls="aui-tabs-responsive-dropdown-' + id + '" href="aui-tabs-responsive-dropdown-' + id + '">...</a>' + "</li>";
            $tabsMenu.append(triggerMarkup);
            var $trigger = $tabsMenu.find(".aui-tabs-responsive-trigger-item");
            return $trigger;
        },
        createResponsiveDropdown: function createResponsiveDropdown($tabsContainer, id) {
            var dropdownMarkup = '<div class="aui-dropdown2 aui-style-default aui-tabs-responsive-dropdown" id="aui-tabs-responsive-dropdown-' + id + '">' + "<ul>" + "</ul>" + "</div>";
            $tabsContainer.append(dropdownMarkup);
            var $dropdown = $tabsContainer.find("#aui-tabs-responsive-dropdown-" + id);
            return $dropdown;
        },
        findNewVisibleTabs: function findNewVisibleTabs(tabs, parentWidth, dropdownTriggerTabWidth) {
            function hasMoreSpace(currentTotalTabWidth, dropdownTriggerTabWidth, parentWidth) {
                return currentTotalTabWidth + dropdownTriggerTabWidth <= parentWidth;
            }
            var currentTotalTabWidth = 0;
            for(var i = 0; hasMoreSpace(currentTotalTabWidth, dropdownTriggerTabWidth, parentWidth) && i < tabs.length; i++){
                var $tab = (0, _jquery2.default)(tabs[i]);
                var tabWidth = $tab.outerWidth(true);
                currentTotalTabWidth += tabWidth;
            }
            // i should now be at the tab index after the last visible tab because of the loop so we minus 1 to get the new visible tabs
            return tabs.slice(0, i - 1);
        },
        moveVisibleTabs: function moveVisibleTabs(oldVisibleTabs, $tabsParent, $dropdownTriggerTab) {
            var dropdownId = $dropdownTriggerTab.find("a").attr("aria-controls");
            var $dropdown = (0, _jquery2.default)("#" + dropdownId);
            var newVisibleTabs = this.findNewVisibleTabs(oldVisibleTabs, $tabsParent.outerWidth(), $dropdownTriggerTab.parent().outerWidth(true));
            var lastTabIndex = newVisibleTabs.length - 1;
            for(var j = oldVisibleTabs.length - 1; j >= lastTabIndex; j--){
                var $tab = (0, _jquery2.default)(oldVisibleTabs[j]);
                this.moveTabToResponsiveDropdown($tab, $dropdown, $dropdownTriggerTab);
            }
            return (0, _jquery2.default)(newVisibleTabs);
        },
        moveTabToResponsiveDropdown: function moveTabToResponsiveDropdown($tab, $dropdown, $dropdownTriggerTab) {
            var $tabLink = $tab.find("a");
            $tab.attr("data-aui-tab-width", $tab.outerWidth(true));
            $tabLink.addClass("aui-dropdown2-radio aui-tabs-responsive-item");
            if ($tab.hasClass("active-tab")) {
                $tabLink.addClass("aui-dropdown2-checked");
                $dropdownTriggerTab.addClass("active-tab");
            }
            $dropdown.find("ul").prepend($tab);
        },
        moveInvisibleTabs: function moveInvisibleTabs(tabsInDropdown, remainingSpace, $dropdownTriggerTab) {
            function hasMoreSpace(remainingSpace) {
                return remainingSpace > 0;
            }
            for(var i = 0; hasMoreSpace(remainingSpace) && i < tabsInDropdown.length; i++){
                var $tab = (0, _jquery2.default)(tabsInDropdown[i]);
                var tabInDropdownWidth = parseInt($tab.attr("data-aui-tab-width"), 10);
                var shouldMoveTabOut = tabInDropdownWidth < remainingSpace;
                if (shouldMoveTabOut) this.moveTabOutOfDropdown($tab, $dropdownTriggerTab);
                remainingSpace -= tabInDropdownWidth;
            }
        },
        moveTabOutOfDropdown: function moveTabOutOfDropdown($tab, $dropdownTriggerTab) {
            var isTabInDropdownActive = $tab.find("a").hasClass("aui-dropdown2-checked");
            if (isTabInDropdownActive) {
                $tab.addClass("active-tab");
                $dropdownTriggerTab.removeClass("active-tab");
            }
            $tab.children("a").removeClass("aui-dropdown2-radio aui-tabs-responsive-item aui-dropdown2-checked");
            $dropdownTriggerTab.before($tab);
        }
    };
    // this function is run by jquery .each() where 'this' is the current tabs container
    function calculateResponsiveTabs(tabsContainer, index) {
        var $tabsContainer = (0, _jquery2.default)(tabsContainer);
        var $tabsMenu = $tabsContainer.find(".tabs-menu").first();
        var $visibleTabs = $tabsMenu.find("li:not(.aui-tabs-responsive-trigger-item)");
        var $dropdownTriggerTab = $tabsMenu.find(".aui-tabs-responsive-trigger").parent();
        var $dropdownTrigger = $dropdownTriggerTab.find("a");
        var dropdownId = $dropdownTrigger.attr("aria-controls");
        var $dropdown = (0, _jquery2.default)(document).find("#" + dropdownId).attr("aria-checked", false);
        var isResponsive = $dropdown.length > 0;
        var totalTabsWidth = ResponsiveAdapter.totalTabsWidth($visibleTabs, $dropdown);
        var needsResponsive = totalTabsWidth > $tabsContainer.outerWidth();
        if (!isResponsive && needsResponsive) {
            $dropdownTriggerTab = ResponsiveAdapter.createResponsiveDropdownTrigger($tabsMenu, index);
            $dropdown = ResponsiveAdapter.createResponsiveDropdown($tabsContainer, index);
        }
        // reset id's in case tabs have changed DOM order
        $dropdownTrigger.attr("aria-controls", "aui-tabs-responsive-dropdown-" + index);
        $dropdownTrigger.attr("id", "aui-tabs-responsive-trigger-" + index);
        $dropdownTrigger.attr("href", "aui-tabs-responsive-trigger-" + index);
        $dropdown.attr("id", "aui-tabs-responsive-dropdown-" + index);
        if (needsResponsive) {
            var $newVisibleTabs = ResponsiveAdapter.moveVisibleTabs($visibleTabs.toArray(), $tabsContainer, $dropdownTriggerTab);
            var visibleTabWidth = ResponsiveAdapter.totalVisibleTabWidth($newVisibleTabs);
            var remainingSpace = $tabsContainer.outerWidth() - visibleTabWidth - $dropdownTriggerTab.outerWidth(true);
            var hasSpace = remainingSpace > 0;
            if (hasSpace) {
                var $tabsInDropdown = $dropdown.find("li");
                ResponsiveAdapter.moveInvisibleTabs($tabsInDropdown.toArray(), remainingSpace, $dropdownTriggerTab);
            }
            $dropdown.on("click", "a", handleTabClick);
            /* Workaround for bug in Edge where the dom is just not being re-rendered properly
          It is only triggered for certain widths. Simply taking the element out of the DOM
          and placing it back in causes the browser to re-render, hiding the issue.
          added from AUI-4098 and to be revisited in AUI-4117*/ if ($tabsMenu.is(":visible")) $tabsMenu.hide().show();
        }
        if (isResponsive && !needsResponsive) {
            $dropdown.find("li").each(function() {
                ResponsiveAdapter.moveTabOutOfDropdown((0, _jquery2.default)(this), $dropdownTriggerTab);
            });
            ResponsiveAdapter.removeResponsiveDropdown($dropdown, $dropdownTriggerTab);
        }
    }
    function switchToTab(tab) {
        var $tab = (0, _jquery2.default)(tab);
        // This probably isn't needed anymore. Remove once confirmed.
        if ($tab.hasClass("aui-tabs-responsive-trigger")) return;
        var $pane = (0, _jquery2.default)($tab.attr("href").match(REGEX)[0]);
        $pane.addClass("active-pane").attr("aria-hidden", "false").siblings(".tabs-pane").removeClass("active-pane").attr("aria-hidden", "true");
        var $dropdownTriggerTab = $tab.parents(".aui-tabs").find(".aui-tabs-responsive-trigger-item a");
        var dropdownId = $dropdownTriggerTab.attr("aria-controls");
        var $dropdown = (0, _jquery2.default)(document).find("#" + dropdownId);
        $dropdown.find("li a").attr("aria-checked", false).removeClass("checked aui-dropdown2-checked");
        $dropdown.find("li").removeClass("active-tab");
        $tab.parent("li.menu-item").addClass("active-tab").siblings(".menu-item").removeClass("active-tab");
        if ($tab.hasClass("aui-tabs-responsive-item")) {
            var $visibleTabs = $pane.parent(".aui-tabs").find("li.menu-item:not(.aui-tabs-responsive-trigger-item)");
            $visibleTabs.removeClass("active-tab");
            $visibleTabs.find("a").removeClass("checked").removeAttr("aria-checked");
        }
        if ($tab.hasClass("aui-tabs-responsive-item")) $pane.parent(".aui-tabs").find("li.menu-item.aui-tabs-responsive-trigger-item").addClass("active-tab");
        $tab.closest(".tabs-menu").find("a").attr("aria-selected", "false");
        $tab.attr("aria-selected", "true");
        $tab.trigger("tabSelect", {
            tab: $tab,
            pane: $pane
        });
    }
    function isPersistentTabGroup($tabGroup) {
        // Tab group persistent attribute exists and is not false
        return $tabGroup.attr("data-aui-persist") !== undefined && $tabGroup.attr("data-aui-persist") !== "false";
    }
    function createPersistentKey($tabGroup) {
        var tabGroupId = $tabGroup.attr("id");
        var value1 = $tabGroup.attr("data-aui-persist");
        return STORAGE_PREFIX + (tabGroupId ? tabGroupId : "") + (value1 && value1 !== "true" ? "-" + value1 : "");
    }
    /* eslint max-depth: 1 */ function updateTabsFromLocalStorage($tabGroups) {
        for(var i = 0, ii = $tabGroups.length; i < ii; i++){
            var $tabGroup = $tabGroups.eq(i);
            var tabs = $tabGroups.get(i);
            if (isPersistentTabGroup($tabGroup) && window.localStorage) {
                var tabGroupId = $tabGroup.attr("id");
                if (tabGroupId) {
                    var persistentTabId = window.localStorage.getItem(createPersistentKey($tabGroup));
                    if (persistentTabId) {
                        var anchor = tabs.querySelector('a[href$="' + persistentTabId + '"]');
                        if (anchor) switchToTab(anchor);
                    }
                } else logger.warn("A tab group must specify an id attribute if it specifies data-aui-persist.");
            }
        }
    }
    function updateLocalStorageEntry($tab) {
        var $tabGroup = $tab.closest(".aui-tabs");
        var tabGroupId = $tabGroup.attr("id");
        if (tabGroupId) {
            var tabId = $tab.attr("href");
            if (tabId) window.localStorage.setItem(createPersistentKey($tabGroup), tabId);
        } else logger.warn("A tab group must specify an id attribute if it specifies data-aui-persist.");
    }
    function handleTabClick(e) {
        tabs.change((0, _jquery2.default)(e.target).closest("a"));
        if (e) e.preventDefault();
    }
    function responsiveResizeHandler(tabs) {
        tabs.forEach(function(tab, index) {
            calculateResponsiveTabs(tab, index);
        });
    }
    // Initialisation
    // --------------
    function getTabs() {
        return (0, _jquery2.default)(".aui-tabs:not(.aui-tabs-disabled)");
    }
    function getResponsiveTabs() {
        return (0, _jquery2.default)(RESPONSIVE_OPT_IN_SELECTOR).toArray();
    }
    function initWindow() {
        var debounced = (0, _debounce2.default)(responsiveResizeHandler, 200);
        var responsive = getResponsiveTabs();
        responsiveResizeHandler(responsive);
        (0, _jquery2.default)(window).resize(function() {
            debounced(responsive);
        });
    }
    function initTab(tab) {
        var $tab = (0, _jquery2.default)(tab);
        tab.setAttribute("role", "application");
        if (!$tab.data("aui-tab-events-bound")) {
            var $tabMenu = $tab.children("ul.tabs-menu");
            // ARIA setup
            $tabMenu.attr("role", "tablist");
            // ignore the LIs so tab count is announced correctly
            $tabMenu.children("li").attr("role", "presentation");
            $tabMenu.find("> .menu-item a").each(function() {
                enhanceTabLink(this);
            });
            // Set up click event for tabs
            $tabMenu.on("click", "a", handleTabClick);
            $tab.data("aui-tab-events-bound", true);
            initPanes(tab);
        }
    }
    function initTabs() {
        var tabs = getTabs();
        tabs.each(function() {
            initTab(this);
        });
        updateTabsFromLocalStorage(tabs);
    }
    function initPane(pane) {
        pane.setAttribute("role", "tabpanel");
        pane.setAttribute("aria-hidden", (0, _jquery2.default)(pane).hasClass("active-pane") ? "false" : "true");
    }
    function initPanes(tab) {
        [].slice.call(tab.querySelectorAll(".tabs-pane")).forEach(initPane);
    }
    function initVerticalTabs() {
        // Vertical tab truncation setup (adds title if clipped)
        (0, _jquery2.default)(".aui-tabs.vertical-tabs").find("a").each(function() {
            var thisTab = (0, _jquery2.default)(this);
            // don't override existing titles
            if (!thisTab.attr("title")) // if text has been truncated, add title
            {
                if ((0, _isClipped2.default)(thisTab)) thisTab.attr("title", thisTab.text());
            }
        });
    }
    var tabs = {
        setup: function setup() {
            initWindow();
            initTabs();
            initVerticalTabs();
        },
        change: function change(a) {
            var $a = (0, _jquery2.default)(a);
            var $tabGroup = $a.closest(".aui-tabs");
            switchToTab($a);
            if (isPersistentTabGroup($tabGroup) && window.localStorage) updateLocalStorageEntry($a);
        }
    };
    (0, _jquery2.default)(tabs.setup);
    // Web Components
    // --------------
    function findComponent(element) {
        return (0, _jquery2.default)(element).closest("aui-tabs").get(0);
    }
    function findPanes(tabs) {
        return tabs.querySelectorAll("aui-tabs-pane");
    }
    function findTabs(tabs) {
        return tabs.querySelectorAll("li[is=aui-tabs-tab]");
    }
    (0, _skate2.default)("aui-tabs", {
        created: function created(element) {
            (0, _jquery2.default)(element).addClass("aui-tabs horizontal-tabs");
            // We must initialise here so that the old code still works since
            // the lifecycle of the sub-components setup the markup so that it
            // can be processed by the old logic.
            _skate2.default.init(element);
            // Use the old logic to initialise the tabs.
            initTab(element);
        },
        template: template('<ul class="tabs-menu">', '<content select="li[is=aui-tabs-tab]"></content>', "</ul>", '<content select="aui-tabs-pane"></content>'),
        prototype: {
            select: function select(element) {
                var index = (0, _jquery2.default)(findPanes(this)).index(element);
                if (index > -1) tabs.change(findTabs(this)[index].children[0]);
                return this;
            }
        }
    });
    var Tab = (0, _skate2.default)("aui-tabs-tab", {
        extends: "li",
        created: function created(element) {
            (0, _jquery2.default)(element).addClass("menu-item");
        },
        template: template('<a href="#">', "<strong>", "<content></content>", "</strong>", "</a>")
    });
    (0, _skate2.default)("aui-tabs-pane", {
        attached: function attached(element) {
            var $component = (0, _jquery2.default)(findComponent(element));
            var $element = (0, _jquery2.default)(element);
            var index = $component.find("aui-tabs-pane").index($element);
            var tab = new Tab();
            var $tab = (0, _jquery2.default)(tab);
            $element.addClass("tabs-pane");
            tab.firstChild.setAttribute("href", "#" + element.id);
            template.wrap(tab).textContent = $element.attr("title");
            if (index === 0) $element.addClass("active-pane");
            if ($element.hasClass("active-pane")) $tab.addClass("active-tab");
            $element.siblings("ul").append(tab);
        },
        template: template("<content></content>")
    });
    (0, _globalize2.default)("tabs", tabs);
    exports.default = tabs;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/toggle-class-name.js
(typeof window === "undefined" ? $parcel$global : window).__97fd8c5dbf4d1f7c9b4a87c771da01b2 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _deprecation = __921ad9514d56376fef992861d9ec0f51;
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Shortcut function to toggle class name of an element.
   *
   * @param {String | Element} element The element or an ID to toggle class name on.
   * @param {String} className The class name to remove or add.
   *
   * @returns {undefined}
   */ function toggleClassName(element, className) {
        if (!(element = (0, _jquery2.default)(element))) return;
        element.toggleClass(className);
    }
    var toggleClassName = (0, _deprecation.fn)(toggleClassName, "toggleClassName", {
        sinceVersion: "5.8.0"
    });
    (0, _globalize2.default)("toggleClassName", toggleClassName);
    exports.default = toggleClassName;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/to-init.js
(typeof window === "undefined" ? $parcel$global : window).__1cae1aed8bcde6374a43f4fbc85335de = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _log = __c1e961001275c079e48525ad3a48c8c2;
    var logger = _interopRequireWildcard(_log);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /**
   * Adds functions to the list of methods to be run on initialisation. Wraps
   * error handling around the provided function so its failure won't prevent
   * other init functions running.
   *
   * @param {Function} func Function to be call on initialisation.
   *
   * @return {Object}
   */ function toInit(func) {
        (0, _jquery2.default)(function() {
            try {
                func.apply(this, arguments);
            } catch (ex) {
                logger.log("Failed to run init function: " + ex + "\n" + func.toString());
            }
        });
        return this;
    }
    (0, _globalize2.default)("toInit", toInit);
    exports.default = toInit;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/unbind-text-resize.js
(typeof window === "undefined" ? $parcel$global : window).__f3d381aba64bcc0398067b5549b26ea5 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _onTextResize = __9a2cde50c39116ec3f36bd040c98b8ba;
    var _onTextResize2 = _interopRequireDefault(_onTextResize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function unbindTextResize(f) {
        for(var i = 0, ii = _onTextResize2.default["on-text-resize"].length; i < ii; i++){
            if (_onTextResize2.default["on-text-resize"][i] === f) return _onTextResize2.default["on-text-resize"].splice(i, 1);
        }
    }
    (0, _globalize2.default)("unbindTextResize", unbindTextResize);
    exports.default = unbindTextResize;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/jquery/jquery.hotkeys.js
(typeof window === "undefined" ? $parcel$global : window).__a4d3347ab21a296e8efc8837d81d6a6d = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    /*
   * Modified by Atlassian to allow chaining of keys
   *
   * jQuery Hotkeys Plugin
   * Copyright 2010, John Resig
   * Dual licensed under the MIT or GPL Version 2 licenses.
   *
   * Based upon the plugin by Tzury Bar Yochay:
   * http://github.com/tzuryby/hotkeys
   *
   * Original idea by:
   * Binny V A, http://www.openjs.com/scripts/events/keyboard_shortcuts/
  */ (function(jQuery1) {
        jQuery1.hotkeys = {
            version: "0.8",
            specialKeys: {
                8: "backspace",
                9: "tab",
                13: "return",
                16: "shift",
                17: "ctrl",
                18: "alt",
                19: "pause",
                20: "capslock",
                27: "esc",
                32: "space",
                33: "pageup",
                34: "pagedown",
                35: "end",
                36: "home",
                37: "left",
                38: "up",
                39: "right",
                40: "down",
                45: "insert",
                46: "del",
                91: "meta",
                96: "0",
                97: "1",
                98: "2",
                99: "3",
                100: "4",
                101: "5",
                102: "6",
                103: "7",
                104: "8",
                105: "9",
                106: "*",
                107: "+",
                109: "-",
                110: ".",
                111: "/",
                112: "f1",
                113: "f2",
                114: "f3",
                115: "f4",
                116: "f5",
                117: "f6",
                118: "f7",
                119: "f8",
                120: "f9",
                121: "f10",
                122: "f11",
                123: "f12",
                144: "numlock",
                145: "scroll",
                188: ",",
                190: ".",
                191: "/",
                224: "meta",
                219: "[",
                221: "]"
            },
            // These only work under Mac Gecko when using keypress (see http://unixpapa.com/js/key.html).
            keypressKeys: [
                "<",
                ">",
                "?"
            ],
            shiftNums: {
                "`": "~",
                "1": "!",
                "2": "@",
                "3": "#",
                "4": "$",
                "5": "%",
                "6": "^",
                "7": "&",
                "8": "*",
                "9": "(",
                "0": ")",
                "-": "_",
                "=": "+",
                ";": ":",
                "'": '"',
                ",": "<",
                ".": ">",
                "/": "?",
                "\\": "|"
            }
        };
        jQuery1.each(jQuery1.hotkeys.keypressKeys, function(_, key) {
            jQuery1.hotkeys.shiftNums[key] = key;
        });
        function TimedNumber(timer) {
            this.num = 0;
            this.timer = timer > 0 ? timer : false;
        }
        TimedNumber.prototype.val = function() {
            return this.num;
        };
        TimedNumber.prototype.inc = function() {
            if (this.timer) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(jQuery1.proxy(TimedNumber.prototype.reset, this), this.timer);
            }
            this.num++;
        };
        TimedNumber.prototype.reset = function() {
            if (this.timer) clearTimeout(this.timeout);
            this.num = 0;
        };
        function keyHandler(handleObj) {
            // Only care when a possible input has been specified
            if (!(jQuery1.isPlainObject(handleObj.data) || jQuery1.isArray(handleObj.data) || typeof handleObj.data === "string")) return;
            var origHandler = handleObj.handler, options = {
                timer: 700,
                combo: []
            };
            (function(data1) {
                if (typeof data1 === "string") options.combo = [
                    data1
                ];
                else if (jQuery1.isArray(data1)) options.combo = data1;
                else jQuery1.extend(options, data1);
                options.combo = jQuery1.map(options.combo, function(key) {
                    return key.toLowerCase();
                });
            })(handleObj.data);
            handleObj.index = new TimedNumber(options.timer);
            handleObj.handler = function(event) {
                // Don't fire in text-accepting inputs that we didn't directly bind to
                // important to note that jQuery.fn.prop is only available on jquery 1.6+
                if (this !== event.target && (/textarea|select|input/i.test(event.target.nodeName) || jQuery1(event.target).prop("contenteditable") === "true")) return;
                // Keypress represents characters, not special keys
                var special = event.type !== "keypress" ? jQuery1.hotkeys.specialKeys[event.which] : null, character = String.fromCharCode(event.which).toLowerCase(), key, modif = "", possible = {};
                // check combinations (alt|ctrl|shift+anything)
                if (event.altKey && special !== "alt") modif += "alt+";
                if (event.ctrlKey && special !== "ctrl") modif += "ctrl+";
                // TODO: Need to make sure this works consistently across platforms
                if (event.metaKey && !event.ctrlKey && special !== "meta") modif += "meta+";
                if (event.shiftKey && special !== "shift") modif += "shift+";
                // Under Chrome and Safari, meta's keycode == '['s charcode
                // Even if they did type this key combo we could not use it because it is browser back in Chrome/Safari on OS X
                if (event.metaKey && character === "[") character = null;
                if (special) possible[modif + special] = true;
                if (character) possible[modif + character] = true;
                // "$" can be specified as "shift+4" or "$"
                if (/shift+/.test(modif)) possible[modif.replace("shift+", "") + jQuery1.hotkeys.shiftNums[special || character]] = true;
                var index = handleObj.index, combo = options.combo;
                if (pressed(combo[index.val()], possible)) {
                    if (index.val() === combo.length - 1) {
                        index.reset();
                        return origHandler.apply(this, arguments);
                    } else index.inc();
                } else {
                    index.reset();
                    // For mutli-key combinations, we might have restarted the key sequence.
                    if (pressed(combo[0], possible)) index.inc();
                }
            };
        }
        function pressed(key, possible) {
            var keys = key.split(" ");
            for(var i = 0, len = keys.length; i < len; i++){
                if (possible[keys[i]]) return true;
            }
            return false;
        }
        jQuery1.each([
            "keydown",
            "keyup",
            "keypress"
        ], function() {
            jQuery1.event.special[this] = {
                add: keyHandler
            };
        });
    })(jQuery);
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/when-i-type.js
(typeof window === "undefined" ? $parcel$global : window).__7d940ebf0cb26eeeabccc2272b0a4c34 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    __a4d3347ab21a296e8efc8837d81d6a6d;
    __25e29eb27170014b389726db2d540673;
    var _log = __c1e961001275c079e48525ad3a48c8c2;
    var logger = _interopRequireWildcard(_log);
    var _dialog = __bc50e12d2af94e34822ae0035ae0e67f;
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _browser = __7a2976c482edfafd9b5879a49ffe0535;
    var _keyCode = __e246bf93af36eb4453f35afeb1c302d9;
    var _keyCode2 = _interopRequireDefault(_keyCode);
    var _underscore = __59c1c30030f41c99b6757d449d9a3a7b;
    var _underscore2 = _interopRequireDefault(_underscore);
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var isMac = navigator.platform.indexOf("Mac") !== -1;
    var isSafari = navigator.userAgent.indexOf("Safari") !== -1;
    var multiCharRegex = /^(backspace|tab|r(ight|eturn)|s(hift|pace|croll)|c(trl|apslock)|alt|pa(use|ge(up|down))|e(sc|nd)|home|left|up|d(el|own)|insert|f\d\d?|numlock|meta)/i;
    /**
   * Trigger native click event.
   * @param $el
   */ var triggerClickEvent = function triggerClickEvent($el) {
        var element = $el[0];
        // if we find the element and Native MouseEvents are available, change it!
        if (element && "MouseEvent" in window) {
            // Native event bubbles are compatible with Synthetic Event from React
            var event = void 0;
            var bubbles = true;
            var cancelable = true;
            if ((0, _browser.supportsNewMouseEvent)()) event = new MouseEvent("click", {
                bubbles: bubbles,
                cancelable: cancelable
            });
            else {
                // `document.createEvent` is deprecated and may be removed by some browsers in future
                // (https://developer.mozilla.org/en-US/docs/Web/API/Document/createEvent).
                // As of 2016-12-28, all browsers still support `document.createEvent`
                event = document.createEvent("MouseEvent");
                event.initEvent("click", bubbles, cancelable);
            }
            element.dispatchEvent(event);
        } else // otherwise just use the original jquery code.
        $el.trigger("click");
    };
    /**
   * Keyboard commands with syntactic sugar.
   *
   * <strong>Usage:</strong>
   * <pre>
   * whenIType("gh").or("gd").goTo("/secure/Dashboard.jspa");
   * whenIType("c").click("#create_link");
   * </pre>
   *
   * @param keys - Key combinations, modifier keys are "+" deliminated. e.g "ctrl+b"
   */ function whenIType(keys) {
        var boundKeyCombos = [];
        var executor = _jquery2.default.Callbacks();
        function keypressHandler(e) {
            if (!_dialog.popup.current && executor) executor.fire(e);
        }
        function defaultPreventionHandler(e) {
            e.preventDefault();
        }
        // Bind an arbitrary set of keys by calling bindKeyCombo on each triggering key combo.
        // A string like "abc 123" means (a then b then c) OR (1 then 2 then 3). abc is one key combo, 123 is another.
        function bindKeys(keys) {
            var keyCombos = keys && keys.split ? _jquery2.default.trim(keys).split(" ") : [
                keys
            ];
            keyCombos.forEach(function(keyCombo) {
                bindKeyCombo(keyCombo);
            });
        }
        function hasUnprintables(keysArr) {
            // a bit of a heuristic, but works for everything we have. Only the unprintable characters are represented with > 1-character names.
            var i = keysArr.length;
            while(i--){
                if (keysArr[i].length > 1 && keysArr[i] !== "space") return true;
            }
            return false;
        }
        // bind a single key combo to this handler
        // A string like "abc 123" means (a then b then c) OR (1 then 2 then 3). abc is one key combo, 123 is another.
        function bindKeyCombo(keyCombo) {
            var keysArr = keyCombo instanceof Array ? keyCombo : keyComboArrayFromString(keyCombo.toString());
            var eventType = hasUnprintables(keysArr) ? "keydown" : "keypress";
            boundKeyCombos.push(keysArr);
            (0, _jquery2.default)(document).bind(eventType, keysArr, keypressHandler);
            // Override browser/plugins
            (0, _jquery2.default)(document).bind(eventType + " keyup", keysArr, defaultPreventionHandler);
        }
        // parse out an array of (modifier+key) presses from a single string
        // e.g. "12ctrl+3" becomes [ "1", "2", "ctrl+3" ]
        function keyComboArrayFromString(keyString) {
            var keysArr = [];
            var currModifiers = "";
            while(keyString.length){
                var modifierMatch = keyString.match(/^(ctrl|meta|shift|alt)\+/i);
                var multiCharMatch = keyString.match(multiCharRegex);
                if (modifierMatch) {
                    currModifiers += modifierMatch[0];
                    keyString = keyString.substring(modifierMatch[0].length);
                } else if (multiCharMatch) {
                    keysArr.push(currModifiers + multiCharMatch[0]);
                    keyString = keyString.substring(multiCharMatch[0].length);
                    currModifiers = "";
                } else {
                    keysArr.push(currModifiers + keyString[0]);
                    keyString = keyString.substring(1);
                    currModifiers = "";
                }
            }
            return keysArr;
        }
        function addShortcutsToTitle(selector) {
            var elem = (0, _jquery2.default)(selector);
            var title = elem.attr("title") || "";
            var keyCombos = boundKeyCombos.slice();
            var existingCombos = elem.data("boundKeyCombos") || [];
            var shortcutInstructions = elem.data("kbShortcutAppended") || "";
            var isFirst = !shortcutInstructions;
            var originalTitle = isFirst ? title : title.substring(0, title.length - shortcutInstructions.length);
            while(keyCombos.length){
                var keyCombo = keyCombos.shift();
                var comboAlreadyExists = existingCombos.some(function(existingCombo) {
                    return _underscore2.default.isEqual(keyCombo, existingCombo);
                });
                if (!comboAlreadyExists) {
                    shortcutInstructions = appendKeyComboInstructions(keyCombo.slice(), shortcutInstructions, isFirst);
                    isFirst = false;
                }
            }
            if (isMac) shortcutInstructions = shortcutInstructions.replace(/Meta/ig, "\u2318") //Apple cmd key
            .replace(/Shift/ig, "\u21E7"); //Apple Shift symbol
            elem.attr("title", originalTitle + shortcutInstructions);
            elem.data("kbShortcutAppended", shortcutInstructions);
            elem.data("boundKeyCombos", existingCombos.concat(boundKeyCombos));
        }
        function removeShortcutsFromTitle(selector) {
            var elem = (0, _jquery2.default)(selector);
            var shortcuts = elem.data("kbShortcutAppended");
            if (!shortcuts) return;
            var title = elem.attr("title");
            elem.attr("title", title.replace(shortcuts, ""));
            elem.removeData("kbShortcutAppended");
            elem.removeData("boundKeyCombos");
        }
        //
        function appendKeyComboInstructions(keyCombo, title, isFirst) {
            if (isFirst) title += " (" + AJS.I18n.getText("aui.keyboard.shortcut.type.x", keyCombo.shift());
            else {
                title = title.replace(/\)$/, "");
                title += AJS.I18n.getText("aui.keyboard.shortcut.or.x", keyCombo.shift());
            }
            keyCombo.forEach(function(key) {
                title += " " + AJS.I18n.getText("aui.keyboard.shortcut.then.x", key);
            });
            title += ")";
            return title;
        }
        bindKeys(keys);
        return whenIType.makeShortcut({
            executor: executor,
            bindKeys: bindKeys,
            addShortcutsToTitle: addShortcutsToTitle,
            removeShortcutsFromTitle: removeShortcutsFromTitle,
            keypressHandler: keypressHandler,
            defaultPreventionHandler: defaultPreventionHandler
        });
    }
    whenIType.makeShortcut = function(options) {
        var executor = options.executor;
        var bindKeys = options.bindKeys;
        var addShortcutsToTitle = options.addShortcutsToTitle;
        var removeShortcutsFromTitle = options.removeShortcutsFromTitle;
        var keypressHandler = options.keypressHandler;
        var defaultPreventionHandler = options.defaultPreventionHandler;
        var selectorsWithTitlesModified = [];
        function makeMoveToFunction(getNewFocus) {
            return function(selector, options) {
                options = options || {};
                var focusedClass = options.focusedClass || "focused";
                var wrapAround = options.hasOwnProperty("wrapAround") ? options.wrapAround : true;
                var escToCancel = options.hasOwnProperty("escToCancel") ? options.escToCancel : true;
                executor.add(function() {
                    var $items = (0, _jquery2.default)(selector);
                    var $focusedElem = $items.filter("." + focusedClass);
                    var moveToOptions = $focusedElem.length === 0 ? undefined : {
                        transition: true
                    };
                    if (escToCancel) (0, _jquery2.default)(document).one("keydown", function(e) {
                        if (e.keyCode === _keyCode2.default.ESCAPE && $focusedElem) $focusedElem.removeClass(focusedClass);
                    });
                    if ($focusedElem.length) $focusedElem.removeClass(focusedClass);
                    $focusedElem = getNewFocus($focusedElem, $items, wrapAround);
                    if ($focusedElem && $focusedElem.length > 0) {
                        $focusedElem.addClass(focusedClass);
                        $focusedElem.moveTo(moveToOptions);
                        if ($focusedElem.is("a")) $focusedElem.focus();
                        else $focusedElem.find("a:first").focus();
                    }
                });
                return this;
            };
        }
        return {
            /**
           * Scrolls to and adds <em>focused</em> class to the next item in the jQuery collection
           *
           * @method moveToNextItem
           * @param selector
           * @param options
           * @return {Object}
           */ moveToNextItem: makeMoveToFunction(function($focusedElem, $items, wrapAround) {
                var index;
                if (wrapAround && $focusedElem.length === 0) return $items.eq(0);
                else {
                    index = _jquery2.default.inArray($focusedElem.get(0), $items);
                    if (index < $items.length - 1) {
                        index = index + 1;
                        return $items.eq(index);
                    } else if (wrapAround) return $items.eq(0);
                }
                return $focusedElem;
            }),
            /**
           * Scrolls to and adds <em>focused</em> class to the previous item in the jQuery collection
           *
           * @method moveToPrevItem
           * @param selector
           * @param focusedClass
           * @return {Object}
           */ moveToPrevItem: makeMoveToFunction(function($focusedElem, $items, wrapAround) {
                var index;
                if (wrapAround && $focusedElem.length === 0) return $items.filter(":last");
                else {
                    index = _jquery2.default.inArray($focusedElem.get(0), $items);
                    if (index > 0) {
                        index = index - 1;
                        return $items.eq(index);
                    } else if (wrapAround) return $items.filter(":last");
                }
                return $focusedElem;
            }),
            /**
           * Clicks the element specified by the <em>selector</em> argument.
           *
           * @method click
           * @param selector - jQuery selector for element
           * @return {Object}
           */ click: function click(selector) {
                selectorsWithTitlesModified.push(selector);
                addShortcutsToTitle(selector);
                executor.add(function() {
                    var $el = (0, _jquery2.default)(selector);
                    triggerClickEvent($el);
                });
                return this;
            },
            /**
           * Navigates to specified <em>location</em>
           *
           * @method goTo
           * @param {String} location - http location
           * @return {Object}
           */ goTo: function goTo(location) {
                executor.add(function() {
                    window.location.href = location;
                });
                return this;
            },
            /**
           * navigates browser window to link href
           *
           * @method followLink
           * @param selector - jQuery selector for element
           * @return {Object}
           */ followLink: function followLink(selector) {
                selectorsWithTitlesModified.push(selector);
                addShortcutsToTitle(selector);
                executor.add(function() {
                    var elem = (0, _jquery2.default)(selector)[0];
                    if (elem && ({
                        "a": true,
                        "link": true
                    })[elem.nodeName.toLowerCase()]) window.location.href = elem.href;
                });
                return this;
            },
            /**
           * Executes function
           *
           * @method execute
           * @param {function} func
           * @return {Object}
           */ execute: function execute(func) {
                var self = this;
                executor.add(function() {
                    func.apply(self, arguments);
                });
                return this;
            },
            /**
           * @deprecated This implementation is uncool. Kept around to satisfy Confluence plugin devs in the short term.
           *
           * Executes the javascript provided by the shortcut plugin point _immediately_.
           *
           * @method evaluate
           * @param {Function} command - the function provided by the shortcut key plugin point
           */ evaluate: function evaluate(command) {
                command.call(this);
            },
            /**
           * Scrolls to element if out of view, then clicks it.
           *
           * @method moveToAndClick
           * @param selector - jQuery selector for element
           * @return {Object}
           */ moveToAndClick: function moveToAndClick(selector) {
                selectorsWithTitlesModified.push(selector);
                addShortcutsToTitle(selector);
                executor.add(function() {
                    var $el = (0, _jquery2.default)(selector);
                    if ($el.length > 0) {
                        triggerClickEvent($el);
                        $el.moveTo();
                    }
                });
                return this;
            },
            /**
           * Scrolls to element if out of view, then focuses it
           *
           * @method moveToAndFocus
           * @param selector - jQuery selector for element
           * @return {Object}
           */ moveToAndFocus: function moveToAndFocus(selector) {
                selectorsWithTitlesModified.push(selector);
                addShortcutsToTitle(selector);
                executor.add(function(e) {
                    var $elem = (0, _jquery2.default)(selector);
                    if ($elem.length > 0) {
                        $elem.focus();
                        if ($elem.moveTo) $elem.moveTo();
                        if ($elem.is(":input")) e.preventDefault();
                    }
                });
                return this;
            },
            /**
           * Binds additional keyboard controls
           *
           * @method or
           * @param {String} keys - keys to bind
           * @return {Object}
           */ or: function or(keys) {
                bindKeys(keys);
                return this;
            },
            /**
           * Unbinds shortcut keys
           *
           * @method unbind
           */ unbind: function unbind() {
                (0, _jquery2.default)(document).unbind("keydown keypress", keypressHandler).unbind("keydown keypress keyup", defaultPreventionHandler);
                for(var i = 0, len = selectorsWithTitlesModified.length; i < len; i++)removeShortcutsFromTitle(selectorsWithTitlesModified[i]);
                selectorsWithTitlesModified = [];
            }
        };
    };
    /**
   * Creates keyboard commands and their actions from json data. Format looks like:
   *
   * <pre>
   * [
   *   {
   *        "keys":[["g", "d"]],
   *        "context":"global",
   *        "op":"followLink",
   *        "param":"#home_link"
   *    },
   *    {
   *        "keys":[["g", "i"]],
   *        "context":"global",
   *        "op":"followLink",
   *        "param":"#find_link"
   *    },
   *    {
   *        "keys":[["/"]],
   *        "context":"global",
   *        "op":"moveToAndFocus",
   *        "param":"#quickSearchInput"
   *    },
   *    {
   *        "keys":[["c"]],
   *        "context":"global",
   *        "op":"moveToAndClick",
   *        "param":"#create_link"
   *    }
   * ]
   * </pre>
   *
   * @method fromJSON
   * @static
   * @param json
   */ whenIType.fromJSON = function(json, switchCtrlToMetaOnMac) {
        var shortcuts = [];
        if (json) _jquery2.default.each(json, function(i, item) {
            var operation = item.op;
            var param = item.param;
            var params = void 0;
            if (operation === "execute" || operation === "evaluate") // need to turn function string into function object
            params = [
                new Function(param)
            ];
            else if (/^\[[^\]\[]*,[^\]\[]*\]$/.test(param)) {
                // pass in an array to send multiple params
                try {
                    params = JSON.parse(param);
                } catch (e) {
                    logger.error("When using a parameter array, array must be in strict JSON format: " + param);
                }
                if (!_jquery2.default.isArray(params)) logger.error("Badly formatted shortcut parameter. String or JSON Array of parameters required: " + param);
            } else params = [
                param
            ];
            _jquery2.default.each(item.keys, function() {
                var shortcutList = this;
                if (switchCtrlToMetaOnMac && isMac) shortcutList = _jquery2.default.map(shortcutList, function(shortcutString) {
                    return shortcutString.replace(/ctrl/i, "meta");
                });
                var newShortcut = whenIType(shortcutList);
                newShortcut[operation].apply(newShortcut, params);
                shortcuts.push(newShortcut);
            });
        });
        return shortcuts;
    };
    // Trigger this event on an iframe if you want its keypress events to be propagated (Events to work in iframes).
    (0, _jquery2.default)(document).bind("iframeAppended", function(e, iframe) {
        (0, _jquery2.default)(iframe).load(function() {
            var target = (0, _jquery2.default)(iframe).contents();
            target.bind("keyup keydown keypress", function(e) {
                // safari propagates keypress events from iframes
                if (isSafari && e.type === "keypress") return;
                if (!(0, _jquery2.default)(e.target).is(":input")) _jquery2.default.event.trigger(e, arguments, document, true // Use the capturing phase to preserve original event.target.
                );
            });
        });
    });
    (0, _globalize2.default)("whenIType", whenIType);
    exports.default = whenIType;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/version.js
(typeof window === "undefined" ? $parcel$global : window).__d55b17f777e9bed0264078626d52c7fc = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    // @note: this value is set via webpack and gulp
    // eslint-disable-next-line
    var version = "7.9.9";
    (0, _globalize2.default)("version", version);
    exports.default = version;
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui/setup.js
(typeof window === "undefined" ? $parcel$global : window).__03a8c5deff7e97eaf9953f7f46c1ca0e = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    var _jquery = __700a145ba3db9966cc95664c892049f8;
    var _jquery2 = _interopRequireDefault(_jquery);
    var _globalize = __28c84e7bb75f6c3b0ba124d57bd69571;
    var _globalize2 = _interopRequireDefault(_globalize);
    var _populateParameters = __4b56bdd4ac2dc9a48c4021c75605fddc;
    var _populateParameters2 = _interopRequireDefault(_populateParameters);
    var _version = __d55b17f777e9bed0264078626d52c7fc;
    var _version2 = _interopRequireDefault(_version);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    // Set the version.
    // Global setup that used to be in the main AJS namespace file.
    (0, _jquery2.default)(function() {
        var $body = (0, _jquery2.default)("body");
        if (!$body.data("auiVersion")) $body.attr("data-aui-version", _version2.default);
        (0, _populateParameters2.default)();
    });
    // Setting Traditional to handle our default param serialisation.
    // See http://api.jquery.com/jQuery.param/ for more information.
    _jquery2.default.ajaxSettings.traditional = true;
    (0, _globalize2.default)("$", _jquery2.default);
    return module.exports;
}).call($4159b701ce296ce4$exports);
// src/js/aui.js
(typeof window === "undefined" ? $parcel$global : window).__cbdea6f64be74d158976dc964c162445 = (function() {
    var module = {
        exports: {}
    };
    var exports = module.exports;
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    __b95257c5ba3aaa36d3a5493aa734a2d7;
    __4aa3faf3e1a039ca7e641017624fd4d6;
    __be0f3ffb01e9197c7ddcba01a61a66ce;
    __25e29eb27170014b389726db2d540673;
    __333ca678b27b3f668a8ab6b3ea8ee781;
    __bc50e12d2af94e34822ae0035ae0e67f;
    __51139989be9b25b15c1774d709ce985b;
    __f3ccb1e110c37fc6c95e5fa43d2c3f4f;
    __8741535334cf9725b62821139abd6dba;
    __c1e961001275c079e48525ad3a48c8c2;
    __4c4f13d92d5dcb8f12059ce701946463;
    __d985b91328862a9b5001134fdbcdc855;
    __3b7b37131a17b9c12e44694d7b12c1e2;
    __40ab0ec9dde6fa5e8252e2a0ff1128be;
    __0bbb661b86f4b304c81cc691259d70c9;
    __e7d0e8462b4386c30e9bcd3ad0a49ad3;
    __52a74afd29a9ba78099fd55036d7da10;
    __314cfd19ff44fc21aa5412fc0dd1f9c1;
    __d2e2813117e78f01f4e5be88e6b92a17;
    __63997c0b88d4f299b5d69bd1c1668c63;
    __358322a372d0f4ddd93ba2e992bb9c50;
    __48697fd7ae587e40e44fef53ab10460c;
    __57b6a2051b8779488be56ba67bc3c21c;
    __0601db35e0320a246a2e95c4a20b98b4;
    __f65d8c24422fc9cfa97e7b7162425c04;
    __d31562b45156ec0db003c1af006240d5;
    __fa714f1b12d7502957e4e0b6196321bf;
    __a0ab588de7b0759818853425dc8ad2f2;
    __b47fe435d7d231cd9ccf33cd539d9888;
    __3e63601581c20cf62a12c1c11776baa0;
    __b25d88f7d8f364347fd8fafd71054d2b;
    __b4529c3c44b8657454bfd27f30c89b5c;
    __9c7e09af5e0b55833c235e1d20ff8617;
    __3dba0a8df57d5c27ea6aae5ec8bcb981;
    __e246bf93af36eb4453f35afeb1c302d9;
    __3ada4a8272640e5242be87f12c7e0fdf;
    __390cf96dd9cd56462d8fa8c8e223fa6a;
    __4416794d9d63726eadee43839f3abf71;
    __c4bf0135de94f554dfd06da5aa73ceee;
    __9a2cde50c39116ec3f36bd040c98b8ba;
    __4b56bdd4ac2dc9a48c4021c75605fddc;
    __a584720a962e883eb5e2b13671bdda8a;
    __93911bf5ed7c76934f3ee65b5a1419d0;
    __431b66a1af03006f0f9f80a87c27d7d2;
    __dffa429b520ea33a9faa1c8cd7c396da;
    __a8d5b960b1ce79629376dc694c7ea1f0;
    __5445bbb57d3600b27c6fd8e7cdd87f54;
    __43d4585c6a21591b4ceac1b326c09405;
    __97fd8c5dbf4d1f7c9b4a87c771da01b2;
    __1cae1aed8bcde6374a43f4fbc85335de;
    __f3d381aba64bcc0398067b5549b26ea5;
    __7d940ebf0cb26eeeabccc2272b0a4c34;
    __03a8c5deff7e97eaf9953f7f46c1ca0e;
    exports.default = window.AJS;
    // Fancy File Input is required by the refapp and assumed to be bundled in AUI.
    // It's exposed as a web resource in the plugin.
    // We might want to consider not bundling it.
    module.exports = exports["default"];
    return module.exports;
}).call($4159b701ce296ce4$exports);



})();
//# sourceMappingURL=ajs.js.map
